"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9329],{

/***/ 72943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useElementSize; },
/* harmony export */   "_": function() { return /* binding */ getElementScrollableHeight; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var constants_generator_dimensions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21960);
/* harmony import */ var resize_observer_polyfill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91033);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56093);




var getElementScrollableHeight = function(element) {
    return Math.max(element.scrollTop, element.offsetTop) - constants_generator_dimensions__WEBPACK_IMPORTED_MODULE_1__/* ["default"].TOP_BAR_HEIGHT */ .Z.TOP_BAR_HEIGHT;
};
function useElementSize(element) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}), elementSize = ref[0], setElementSize = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ((0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .isServerSide */ .s$)()) {
            return false;
        }
        var ro = new resize_observer_polyfill__WEBPACK_IMPORTED_MODULE_2__["default"](function(entries) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var entry = _step.value;
                    var cr = entry.contentRect;
                    setElementSize({
                        scrollableWidth: cr.width,
                        scrollableHeight: cr.height
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        ro.observe(element);
        return function() {
            return ro.disconnect();
        };
    }, []);
    return elementSize;
}


/***/ }),

/***/ 25289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65832);
/* harmony import */ var constants_dynamic_asset_by_param__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93879);
/* harmony import */ var _constants_query_params__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54224);
/* harmony import */ var _constants_query_params__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_constants_query_params__WEBPACK_IMPORTED_MODULE_2__);




/* harmony default export */ __webpack_exports__["Z"] = ({
    assetQuality: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Asset Quality",
        options: [
            {
                value: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_3__.AUTO,
                text: "Auto"
            },
            {
                value: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_3__.BEST,
                text: "Best"
            },
            {
                value: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_3__.GOOD,
                text: "Good"
            },
            {
                value: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_3__.ECO,
                text: "Eco"
            },
            {
                value: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_3__.LOW,
                text: "Low"
            }
        ]
    },
    useDynamicAsset: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Use dynamic asset (when available)"
    },
    dynamicAssetParamPath: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Use image from parameter",
        labelDescription: "Image (?".concat(_constants_query_params__WEBPACK_IMPORTED_MODULE_2__.DYNAMIC_ASSET_PARAM, "=xxxxx) from param will build Cloudinary url under the selected path below and replaces the default image."),
        options: constants_dynamic_asset_by_param__WEBPACK_IMPORTED_MODULE_1__/* .DYNAMIC_ASSET_PARAM_PATHS */ .Y
    },
    hideControls: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Hide controls (video only)"
    },
    useWindowMask: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Use window mask"
    },
    minHeight: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Min height"
    }
});


/***/ }),

/***/ 13225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_video_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39832);


/* harmony default export */ __webpack_exports__["Z"] = ({
    image: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Image",
        fields: {
            src: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [
                    "static/img/templates/long-template/boards/"
                ],
                label: "Select an Image"
            },
            alt: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            },
            isDecorative: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                label: "Decorative image(no alt)"
            },
            href: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Href"
            }
        }
    },
    video: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Video",
        fields: {
            src: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.CLOUDINARY_VIDEO_PICKER,
                label: "Video",
                videoType: constants_video_types__WEBPACK_IMPORTED_MODULE_1__/* .PARAGRAPH_AND_ASSET_VIDEOS */ .rB
            },
            ariaLabel: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Video description (accessibility)",
                translatable: true
            },
            loop: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                label: "Loop"
            },
            playWhenVisible: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                label: "Play Only When Visible"
            },
            disableAutoplay: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                label: "Disable Autoplay (Autoplay will be disabled only if controls aren't hidden)"
            }
        }
    }
});


/***/ }),

/***/ 93494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14759);


/* harmony default export */ __webpack_exports__["Z"] = ({
    poster: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
        defaultImagesKeys: [],
        label: "Select an image placeholder",
        labelDescription: "Image should keep youtube video aspect ratio (default 16:9)"
    },
    alt: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Description (alt)",
        translatable: true
    },
    videoId: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Youtube Video ID"
    },
    playButtonColor: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Play Button Color",
        possibleColors: Object.keys(_constants__WEBPACK_IMPORTED_MODULE_1__/* .buttonThemes */ .l)
    },
    playButtonSize: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Play Button Size",
        options: [
            {
                value: _constants__WEBPACK_IMPORTED_MODULE_1__.MD,
                text: "Medium"
            },
            {
                value: _constants__WEBPACK_IMPORTED_MODULE_1__.LG,
                text: "Large"
            }
        ]
    },
    showShadow: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Show shadow"
    }
});


/***/ }),

/***/ 67998:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    BASE_MENU_WIDTH: 350,
    DEVELOPERS_MENU_WIDTH: 300
});


/***/ }),

/***/ 81338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ asset; }
/* harmony export */ });
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_video_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39832);


var asset = {
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Asset",
    fields: {
        shadow: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
            label: "Shadow Frame"
        },
        convertGifToVideo: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
            label: "Convert gif to video"
        },
        side: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
            label: "Asset Location",
            options: [
                "left",
                "right"
            ]
        },
        image: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
            label: "Image",
            fields: {
                src: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
                    defaultImagesKeys: [
                        "static/img/templates/long-template/boards/"
                    ],
                    label: "Select an Image"
                },
                alt: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                    label: "Image description (alt)"
                },
                href: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                    label: "Href"
                }
            }
        },
        video: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
            label: "Add a Video",
            fields: {
                src: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.CLOUDINARY_VIDEO_PICKER,
                    label: "Video",
                    videoType: constants_video_types__WEBPACK_IMPORTED_MODULE_1__/* .PARAGRAPH_AND_ASSET_VIDEOS */ .rB
                },
                loop: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                    label: "Loop",
                    options: [
                        "Yes",
                        "No"
                    ]
                },
                playWhenVisible: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                    label: "Play Only When Visible",
                    options: [
                        "Yes",
                        "No"
                    ]
                }
            }
        }
    }
};


/***/ }),

/***/ 9329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DynamicTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/templates/base-template.js + 69 modules
var base_template = __webpack_require__(14148);
// EXTERNAL MODULE: ./contexts/segment-context.js
var segment_context = __webpack_require__(39944);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
;// CONCATENATED MODULE: ./components/enhancements/error-wrapper/error-state-constants.js
var ERROR_GROUPS = {
    SEGMENT_LAYOUT: "segment_layout"
};

// EXTERNAL MODULE: ./utils/dynamicPage.js
var dynamicPage = __webpack_require__(34949);
// EXTERNAL MODULE: ./node_modules/react-error-boundary/dist/react-error-boundary.umd.js
var react_error_boundary_umd = __webpack_require__(35800);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./contexts/preview-base-segment-context.js + 4 modules
var preview_base_segment_context = __webpack_require__(70349);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./segments/desktop/index.js + 19 modules
var desktop = __webpack_require__(29107);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./utils/math.js
var math = __webpack_require__(70942);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/templates/dynamic-template/segments-layout-list/base-layout-segment/base-layout-segment-component.scss.js



var triangleHeightFactor = Math.sin((0,math/* toRadians */.Yr)(8));
var StyledBaseLayoutSegmentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1v1kdfp0"
})("&.ease-in{opacity:0;&.ease-in-animation{animation:fade-in 0.5s ease-in forwards;.segment-wrapper{animation:slide-in 0.8s ease-in;}}.segment-wrapper{transform:none;}}&.sticky{position:sticky;top:", function(param) {
    var stickyTopOffset = param.stickyTopOffset;
    return stickyTopOffset || 0;
}, ";z-index:", z_index/* ALWAYS_ON_TOP */.OL, ";}.triangle{position:absolute;z-index:2;pointer-events:none;&.top{width:0;height:0;border-right:100vw solid transparent;// the 0.05 addition solves a number rounding bug resulting in a 1px white line displayed  \n      margin-top:-", 100 * triangleHeightFactor - 0.05, "vw;}&.bottom{width:0;height:0;border-left:100vw solid transparent;}}@keyframes fade-in{0%{opacity:0;}100%{opacity:1;}}@keyframes slide-in{0%{transform:translateY(40px);}100%{transform:translateY(0px);}}");

;// CONCATENATED MODULE: ./components/templates/dynamic-template/segments-layout-list/base-layout-segment/base-layout-segment-component.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}














var PERCENTAGE_REGEX = /^\d+(\.\d+)?%$/;
var getGradientThemeStyles = function() {
    var gradientColors = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var _getTheme, _gradientColors_;
    return {
        background: "linear-gradient(180deg, ".concat(gradientColors.map(function(param) {
            var color = param.color;
            var _getTheme;
            var backgroundColor = (_getTheme = (0,segments_service/* getTheme */.gh)(color)) === null || _getTheme === void 0 ? void 0 : _getTheme.background;
            return backgroundColor ? "".concat((0,general/* hexToRgba */.a7)(backgroundColor, 1)) : "";
        }).join(", "), ")"),
        color: (_getTheme = (0,segments_service/* getTheme */.gh)((_gradientColors_ = gradientColors[0]) === null || _gradientColors_ === void 0 ? void 0 : _gradientColors_.color)) === null || _getTheme === void 0 ? void 0 : _getTheme.color
    };
};
var BaseLayoutSegmentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseLayoutSegmentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseLayoutSegmentComponent);
    function BaseLayoutSegmentComponent(props) {
        (0,_class_call_check/* default */.Z)(this, BaseLayoutSegmentComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onVisibilityChange", function(isVisible) {
            var _props = _this.props, index = _props.index, segment = _props.segment;
            var visibilityEvent = isVisible ? bigbrain_event_types.SEGMENT_VISIBLE_IN_VIEWPORT : bigbrain_event_types.SEGMENT_NOT_VISIBLE_IN_VIEWPORT;
            var ref = segment.props.visibilitySensorProps || {}, visibilityOffset = ref.visibilityOffset, useInfinitely = ref.useInfinitely;
            !useInfinitely && isVisible && _this.setState({
                isInView: true
            });
            useInfinitely && _this.setState({
                isInView: isVisible
            });
            (0,bigbrain_service.trackEvent)(visibilityEvent, {
                kind: segment.type,
                info1: visibilityOffset,
                info2: window.scrollY,
                placement: index
            });
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getOffset", function(offset) {
            var isOffsetInPercentages = PERCENTAGE_REGEX.test(offset);
            if (!(0,general/* isServerSide */.s$)() && isOffsetInPercentages) {
                return parseInt(offset) / 100 * window.innerHeight;
            }
            return parseInt(offset);
        });
        _this.state = {
            isInView: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(BaseLayoutSegmentComponent, [
        {
            key: "getSegmentComponent",
            value: function getSegmentComponent() {
                var _Segments_segment_type;
                var segment = this.props.segment;
                var segmentComponent = (_Segments_segment_type = desktop/* default */.Z[segment.type]) === null || _Segments_segment_type === void 0 ? void 0 : _Segments_segment_type.component;
                if (!segmentComponent) {
                    (0,bigbrain_service.trackEvent)(bigbrain_event_types.SEGMENT_LAYOUT_NOT_FOUND, {
                        kind: segment.type
                    });
                    return false;
                }
                return segmentComponent;
            }
        },
        {
            key: "getHtmlComponentElementFromDom",
            value: function getHtmlComponentElementFromDom() {
                var baseLayoutComponentClassName = this.getBaseLayoutComponentClassName();
                var ssrComponent = document.querySelector(".".concat(baseLayoutComponentClassName));
                return ssrComponent ? ssrComponent.innerHTML : null;
            }
        },
        {
            key: "getSegmentStyle",
            value: function getSegmentStyle(segmentProps) {
                var paddingTop = segmentProps.paddingTop, paddingBottom = segmentProps.paddingBottom, segmentMinHeight = segmentProps.segmentMinHeight;
                var theme = segmentProps.theme, gradientTheme = segmentProps.gradientTheme, mobilePaddingTop = segmentProps.mobilePaddingTop, mobilePaddingBottom = segmentProps.mobilePaddingBottom, baseLayoutStyleProps = segmentProps.baseLayoutStyleProps;
                var isMobileOrTabletBrowser = this.props.isMobileOrTabletBrowser;
                var themeStyles = (gradientTheme === null || gradientTheme === void 0 ? void 0 : gradientTheme.length) ? getGradientThemeStyles(gradientTheme) : segments_service/* themes */.np[theme];
                if (isMobileOrTabletBrowser) {
                    paddingTop = mobilePaddingTop || paddingTop;
                    paddingBottom = mobilePaddingBottom || paddingBottom;
                }
                return _object_spread_props(_object_spread({}, themeStyles, baseLayoutStyleProps), {
                    paddingTop: paddingTop,
                    paddingBottom: paddingBottom,
                    minHeight: segmentMinHeight
                });
            }
        },
        {
            key: "getBaseLayoutComponentClassName",
            value: function getBaseLayoutComponentClassName() {
                var index = this.props.index;
                return "base-layout-segment-component-".concat(index);
            }
        },
        {
            key: "getTriangleBorderStyle",
            value: function getTriangleBorderStyle(triangle) {
                var color = colors/* default */.Z[triangle === null || triangle === void 0 ? void 0 : triangle.color] || colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME];
                return "".concat(100 * triangleHeightFactor, "vw solid ").concat(color);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, segment = _props.segment, isUserLoggedIn = _props.isUserLoggedIn, extraProps = _props.extraProps, isMobileBrowser = _props.isMobileBrowser, dynamicProps = _props.dynamicProps;
                var isInView = this.state.isInView;
                if (!segment) return null;
                var _segment_props = segment.props, segmentId = _segment_props.segmentId, hideOnMobile = _segment_props.hideOnMobile, topTriangle = _segment_props.topTriangle, bottomTriangle = _segment_props.bottomTriangle, visibilitySensorProps = _segment_props.visibilitySensorProps, sticky = _segment_props.sticky, restSegmentProps = _object_without_properties(_segment_props, [
                    "segmentId",
                    "hideOnMobile",
                    "topTriangle",
                    "bottomTriangle",
                    "visibilitySensorProps",
                    "sticky"
                ]);
                var ref = sticky || {}, isSticky = ref.isSticky, stickyTopOffset = ref.stickyTopOffset;
                var ref1 = visibilitySensorProps || {}, useVisibilitySensor = ref1.useVisibilitySensor, visibilityOffset = ref1.visibilityOffset, easeInEffect = ref1.easeInEffect;
                if (hideOnMobile && isMobileBrowser) return null; // this segment needs to be hidden in mobile views
                var SegmentComponent = this.getSegmentComponent();
                if (!SegmentComponent) return null;
                var SegmentComponentWithGenericConfig = (0,generic_config_context/* withGenericConfig */.P)(SegmentComponent);
                var segmentStyle = this.getSegmentStyle(segment.props);
                var topTriangleBorderBottom = this.getTriangleBorderStyle(topTriangle);
                var bottomTriangleBorderTop = this.getTriangleBorderStyle(bottomTriangle);
                var parsedVisibilityOffset = this.getOffset(visibilityOffset);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                    offset: {
                        bottom: parsedVisibilityOffset || 0,
                        top: parsedVisibilityOffset || 0
                    },
                    partialVisibility: true,
                    onChange: this.onVisibilityChange,
                    active: !!useVisibilitySensor,
                    scrollCheck: !!useVisibilitySensor,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBaseLayoutSegmentComponent, {
                        stickyTopOffset: isSticky && stickyTopOffset,
                        id: segmentId,
                        className: classnames_default()("base-layout-segment-component", {
                            "sticky": !!isSticky
                        }, {
                            "ease-in": easeInEffect
                        }, {
                            "ease-in-animation": isInView && easeInEffect
                        }, this.getBaseLayoutComponentClassName()),
                        style: segmentStyle,
                        children: [
                            (topTriangle === null || topTriangle === void 0 ? void 0 : topTriangle.isVisible) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("triangle", "top", "bottom-left-corner"),
                                style: {
                                    borderBottom: topTriangleBorderBottom
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "segment-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SegmentComponentWithGenericConfig, _object_spread_props(_object_spread({}, extraProps, restSegmentProps), {
                                    dynamicProps: dynamicProps,
                                    isUserLoggedIn: isUserLoggedIn,
                                    segmentType: segment.type,
                                    isInView: isInView
                                }))
                            }),
                            (bottomTriangle === null || bottomTriangle === void 0 ? void 0 : bottomTriangle.isVisible) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("triangle", "bottom", "top-right-corner"),
                                style: {
                                    borderTop: bottomTriangleBorderTop
                                }
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return BaseLayoutSegmentComponent;
}(react.PureComponent);
BaseLayoutSegmentComponent.defaultProps = {
    extraProps: {}
};
var BaseLayoutSegmentComponentContainer = function(props) {
    var Component = props.isPreview ? (0,preview_base_segment_context/* withPreviewBaseSegment */.I)(BaseLayoutSegmentComponent) : (0,generic_config_context/* withGenericConfig */.P)(BaseLayoutSegmentComponent);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _object_spread({}, props));
};
/* harmony default export */ var base_layout_segment_component = (BaseLayoutSegmentComponentContainer);

;// CONCATENATED MODULE: ./client/services/hooks/use-is-mounted.js

var useIsMounted = function() {
    var ref = (0,react.useState)(false), isMounted = ref[0], setIsMounted = ref[1];
    (0,react.useEffect)(function() {
        setIsMounted(true);
    }, []);
    return isMounted;
};
/* harmony default export */ var use_is_mounted = (useIsMounted);

;// CONCATENATED MODULE: ./components/templates/dynamic-template/segments-layout-list/canvas/canvas.scss.js


var StyledCanvas = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ewmxhcj0"
})("position:absolute;left:50%;transform:translateX(-50%);z-index:", z_index/* REACT_CANVAS */.FJ, ";&.ssr{z-index:", z_index/* SSR_CANVAS */.Qm, ";}&.preview{z-index:", z_index/* CANVAS_PREVIEW */.zi, ";}");

;// CONCATENATED MODULE: ./components/templates/dynamic-template/segments-layout-list/canvas/canvas.js






var Canvas = function(props) {
    var shapeSegments = props.shapeSegments, isPreview = props.isPreview, rootEl = props.rootEl;
    // This is used for re-rendering the canvas-component div
    // Since server renders it with "ssr" class
    // Then when client hydrates the new DOM, it does not
    // re-evaluate the new classes
    // isMounted is running only on client! (using useEffect)
    var isMounted = use_is_mounted();
    var getCanvasComponent = (0,react.useCallback)(function() {
        var sortedShapes = shapeSegments.sort(function(a, b) {
            var _b_props, _a_props;
            var bZindex = parseFloat(b === null || b === void 0 ? void 0 : (_b_props = b.props) === null || _b_props === void 0 ? void 0 : _b_props.zIndex) || 0;
            var aZindex = parseFloat(a === null || a === void 0 ? void 0 : (_a_props = a.props) === null || _a_props === void 0 ? void 0 : _a_props.zIndex) || 0;
            return aZindex - bZindex;
        });
        if ((0,general/* isServerSide */.s$)()) {
            // Render different canvas component on SSR
            // Used only for first fold, to avoid flickering effects
            // Temp. commented out until memory leaks are solved on server side
            // const SsrCanvas = require("./ssr-canvas").default;
            // return <SsrCanvas shapeSegments={sortedShapes} />;
            return null;
        } else {
            if (!rootEl) return null;
            var ReactCanvas = (__webpack_require__(46254)/* ["default"] */ .Z);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactCanvas, {
                shapeSegments: sortedShapes,
                isPreview: isPreview,
                rootEl: rootEl
            });
        }
    }, [
        shapeSegments,
        isPreview,
        rootEl
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCanvas, {
        className: classnames_default()("canvas-component", {
            ssr: (0,general/* isServerSide */.s$)(),
            preview: isPreview
        }),
        children: getCanvasComponent()
    }, "canvas_".concat((0,general/* isServerSide */.s$)() ? "server" : "client", "_").concat(isMounted));
};
/* harmony default export */ var canvas = (Canvas);

// EXTERNAL MODULE: ./components/templates/dynamic-template/dynamic-template-service.js
var dynamic_template_service = __webpack_require__(87210);
;// CONCATENATED MODULE: ./components/templates/dynamic-template/segments-layout-list/segments-layout-list-component.js












var SegmentsLayoutListComponent = function(props) {
    var segments = props.segments;
    var components = (0,react.useMemo)(function() {
        return segments.filter(function(segment) {
            return !(0,dynamic_template_service/* isShapeComponent */.VC)(segment.family);
        });
    }, [
        segments
    ]);
    var shapes = (0,react.useMemo)(function() {
        return segments.filter(function(segment) {
            return (0,dynamic_template_service/* isShapeComponent */.VC)(segment.family);
        });
    }, [
        segments
    ]);
    var mainContentComponents = (0,react.useMemo)(function() {
        return segments.filter(function(segment) {
            return (0,dynamic_template_service/* isMainContentComponent */.WC)(segment.type);
        });
    }, [
        segments
    ]);
    var withHeaderComponent = (0,react.useMemo)(function() {
        var firstComponentName = components.length > 0 ? components[0].type : "";
        return (0,dynamic_template_service/* isHeaderComponent */.kr)(firstComponentName);
    }, [
        components
    ]);
    var withFooterComponent = (0,react.useMemo)(function() {
        var lastComponentName = components.length > 0 ? components[components.length - 1].type : "";
        return (0,dynamic_template_service/* isFooterComponent */.LS)(lastComponentName);
    }, [
        components
    ]);
    var getSegmentNumber = function(index) {
        return withHeaderComponent ? index : index + 1;
    };
    var myErrorHandler = function(error, info, segment) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.CLIENT_ERROR_STATE_CAUGHT, {
            placement: ERROR_GROUPS.SEGMENT_LAYOUT,
            info1: segment === null || segment === void 0 ? void 0 : segment.type,
            info2: JSON.stringify((error === null || error === void 0 ? void 0 : error.message) || {}).substring(0, 500),
            info3: JSON.stringify((info === null || info === void 0 ? void 0 : info.componentStack) || {}).substring(0, 500),
            data: segment === null || segment === void 0 ? void 0 : segment.props
        });
    };
    var renderSegment = function(segment, index) {
        var isUserLoggedIn = props.isUserLoggedIn, extraProps = props.extraProps, segmentComponents = props.segmentComponents, isPreview = props.isPreview, isMobile = props.isMobile, dynamicData = props.dynamicData;
        var segmentComponent = segmentComponents[index];
        var segmentType = segment === null || segment === void 0 ? void 0 : segment.type;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(segment_context/* SegmentContext.Provider */.k.Provider, {
            value: {
                isFirstSegment: (mainContentComponents === null || mainContentComponents === void 0 ? void 0 : mainContentComponents[0]) === segment,
                segmentNumber: getSegmentNumber(index),
                segmentType: segmentType
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_error_boundary_umd.ErrorBoundary, {
                FallbackComponent: function() {
                    return null;
                },
                onError: function(error, info) {
                    return myErrorHandler(error, info, segment);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_layout_segment_component, {
                    dynamicProps: (0,dynamicPage/* getDynamicPropsBySegmentLayoutId */.Fb)(dynamicData, segment.id),
                    isMobile: isMobile,
                    isPreview: isPreview,
                    index: index,
                    extraProps: extraProps,
                    segment: segment,
                    isUserLoggedIn: isUserLoggedIn,
                    segmentComponent: segmentComponent
                })
            })
        }, index);
    };
    var renderHeaderIfNeeded = function() {
        if (!withHeaderComponent) return null;
        var headerIndex = 0;
        return renderSegment(components[headerIndex], headerIndex);
    };
    var renderFooterIfNeeded = function() {
        if (!withFooterComponent) return null;
        var footerIndex = components.length - 1;
        return renderSegment(components[footerIndex], footerIndex);
    };
    var renderCanvasIfNeeded = function() {
        var isPreview = props.isPreview, rootEl = props.rootEl;
        if (shapes.length === 0) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(canvas, {
            shapeSegments: shapes,
            isPreview: isPreview,
            rootEl: rootEl
        });
    };
    var renderMainSegments = function() {
        return segments.map(function(s, index) {
            if (!(0,dynamic_template_service/* isHeaderComponent */.kr)(s.type) && !(0,dynamic_template_service/* isFooterComponent */.LS)(s.type) && !(0,dynamic_template_service/* isShapeComponent */.VC)(s.family)) {
                return renderSegment(s, index);
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            renderHeaderIfNeeded(),
            renderCanvasIfNeeded(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: element_ids/* MAIN_ID */.k,
                children: renderMainSegments()
            }),
            renderFooterIfNeeded()
        ]
    });
};
/* harmony default export */ var segments_layout_list_component = (SegmentsLayoutListComponent);

// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./components/pages/developers/documentation/base-documentation-menu/constants.js
var constants = __webpack_require__(67998);
;// CONCATENATED MODULE: ./components/templates/dynamic-template/dynamic-template.scss.js



var GRID_COLUMNS_WIDTH = "".concat(constants/* default.DEVELOPERS_MENU_WIDTH */.Z.DEVELOPERS_MENU_WIDTH, "px auto ").concat(constants/* default.DEVELOPERS_MENU_WIDTH */.Z.DEVELOPERS_MENU_WIDTH, "px");
var StyledDynamicTemplate = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ephfv7d0"
})("&.developers-center-template{.full-paragraph-wrapper{margin:0 !important;}@media (min-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){main{display:grid;grid-template-columns:", GRID_COLUMNS_WIDTH, ";}}}");

;// CONCATENATED MODULE: ./components/templates/dynamic-template/dynamic-template.js




function dynamic_template_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function dynamic_template_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            dynamic_template_define_property(target, key, source[key]);
        });
    }
    return target;
}
function dynamic_template_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function dynamic_template_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        dynamic_template_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var DynamicTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(DynamicTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(DynamicTemplate);
    function DynamicTemplate(props) {
        (0,_class_call_check/* default */.Z)(this, DynamicTemplate);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            rootEl: null
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(DynamicTemplate, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var rootEl = this.state.rootEl;
                var _props = this.props, pageConfig = _props.pageConfig, segmentComponents = _props.segmentComponents, isPreview = _props.isPreview, exitPopup = _props.exitPopup, dynamicData = _props.dynamicData;
                var segments = pageConfig.segments, isMobile = pageConfig.isMobile, templateClassName = pageConfig.templateClassName, exitPopupConfig = pageConfig.exitPopupConfig;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(base_template/* default */.Z, dynamic_template_object_spread_props(dynamic_template_object_spread({}, this.props, pageConfig), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDynamicTemplate, {
                        ref: function(el) {
                            return _this.setState({
                                rootEl: el
                            });
                        },
                        className: classnames_default()("dynamic-template", templateClassName),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(segments_layout_list_component, {
                                isMobile: isMobile,
                                isPreview: isPreview,
                                segments: segments,
                                dynamicData: dynamicData,
                                segmentComponents: segmentComponents,
                                rootEl: rootEl
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                                exitPopup: exitPopup,
                                exitPopupConfig: exitPopupConfig
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return DynamicTemplate;
}(react.PureComponent);

DynamicTemplate.defaultProps = {
    exitPopup: true,
    segmentComponents: []
};


/***/ }),

/***/ 19174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZG": function() { return /* binding */ getShapeProps; },
/* harmony export */   "ol": function() { return /* binding */ CANVAS_FULL_WIDTH; }
/* harmony export */ });
/* unused harmony exports CANVAS_SIDE_OFFSET, SSR_CANVAS_FULL_HEIGHT, getKonvaElement */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var segments_desktop_shape__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20655);
/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12573);
/* harmony import */ var konva__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20185);
/* harmony import */ var konva__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(konva__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var constants_vp_sizes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(698);
/* harmony import */ var constants_align_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79409);
/* harmony import */ var constants_align_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(constants_align_types__WEBPACK_IMPORTED_MODULE_4__);

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





// The base of the canvas is 1440 and is considered as middle
// For larger screen we give extra 500px on each side
var CANVAS_SIDE_OFFSET = 1000;
var CANVAS_FULL_WIDTH = constants_vp_sizes__WEBPACK_IMPORTED_MODULE_3__/* .MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */ .Ld + CANVAS_SIDE_OFFSET;
var SSR_CANVAS_FULL_HEIGHT = 2000;
var getKonvaElement = function(segmentType) {
    var _obj;
    return (_obj = {}, _define_property(_obj, Shapes.RectangleShapeComponent.type, Konva.Rect), _define_property(_obj, Shapes.StarShapeComponent.type, Konva.Star), _obj)[segmentType];
};
// Used to put left/right aligned items in the center of 1440
var getExtraXOffset = function(align) {
    return align === constants_align_types__WEBPACK_IMPORTED_MODULE_4__.ALIGN_TYPES.CENTER ? 0 : CANVAS_SIDE_OFFSET / 2;
};
var getShapeProps = function(segmentProps, segmentType) {
    var extraProps = {};
    var align = segmentProps.align;
    var fill = styles_colors__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[segmentProps.fill];
    var stroke = styles_colors__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[segmentProps.stroke];
    var shadowColor = styles_colors__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[segmentProps.shadowColor];
    var y = parseFloat(segmentProps.y) || 0;
    var x = parseFloat(segmentProps.x) || 0;
    var scale = parseFloat(segmentProps.scale) || 1;
    var cornerRadius = parseFloat(segmentProps.cornerRadius) || 0;
    var rotation = parseFloat(segmentProps.rotation) || 0;
    var strokeWidth = parseFloat(segmentProps.strokeWidth) || 0;
    var opacity = parseFloat(segmentProps.opacity) || 1;
    var shadowBlur = parseFloat(segmentProps.shadowBlur) || 0;
    var shadowOffsetX = parseFloat(segmentProps.shadowOffsetX) || 0;
    var shadowOffsetY = parseFloat(segmentProps.shadowOffsetY) || 0;
    // Star props
    if (segmentType === segments_desktop_shape__WEBPACK_IMPORTED_MODULE_0__/* ["default"].StarShapeComponent.type */ .Z.StarShapeComponent.type) {
        extraProps = _object_spread_props(_object_spread({}, extraProps), {
            numPoints: parseInt(segmentProps.numPoints) || 4,
            innerRadius: parseInt(segmentProps.innerRadius) || 100,
            outerRadius: parseInt(segmentProps.outerRadius) || 35
        });
    }
    // Ring props
    if (segmentType === segments_desktop_shape__WEBPACK_IMPORTED_MODULE_0__/* ["default"].RingShapeComponent.type */ .Z.RingShapeComponent.type) {
        extraProps = _object_spread_props(_object_spread({}, extraProps), {
            innerRadius: parseInt(segmentProps.innerRadius) || 100,
            outerRadius: parseInt(segmentProps.outerRadius) || 35
        });
    }
    // Hotdog and Rectangle props
    var width = 100;
    if ([
        segments_desktop_shape__WEBPACK_IMPORTED_MODULE_0__/* ["default"].HotdogShapeComponent.type */ .Z.HotdogShapeComponent.type,
        segments_desktop_shape__WEBPACK_IMPORTED_MODULE_0__/* ["default"].RectangleShapeComponent.type */ .Z.RectangleShapeComponent.type
    ].includes(segmentType)) {
        extraProps = _object_spread_props(_object_spread({}, extraProps), {
            width: parseInt(segmentProps.width) || 100
        });
    }
    var _obj;
    var _align = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, constants_align_types__WEBPACK_IMPORTED_MODULE_4__.ALIGN_TYPES.RIGHT, {
        relativeX: CANVAS_FULL_WIDTH,
        xDirectionFactor: -1
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, constants_align_types__WEBPACK_IMPORTED_MODULE_4__.ALIGN_TYPES.CENTER, {
        relativeX: CANVAS_FULL_WIDTH / 2,
        xDirectionFactor: -1
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, constants_align_types__WEBPACK_IMPORTED_MODULE_4__.ALIGN_TYPES.LEFT, {
        relativeX: 0,
        xDirectionFactor: 1
    }), _obj)[align], relativeX = _align.relativeX, xDirectionFactor = _align.xDirectionFactor;
    return _object_spread({
        height: 100,
        width: width,
        x: relativeX + (x + getExtraXOffset(align)) * xDirectionFactor,
        y: y,
        scale: {
            x: scale,
            y: scale
        },
        cornerRadius: cornerRadius,
        rotation: rotation,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        opacity: opacity,
        shadowColor: shadowColor,
        shadowBlur: shadowBlur,
        shadowOffsetX: shadowOffsetX,
        shadowOffsetY: shadowOffsetY
    }, extraProps);
};


/***/ }),

/***/ 46254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_konva__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79566);
/* harmony import */ var segments_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29107);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19174);
/* harmony import */ var client_services_hooks_use_element_size__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72943);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var ReactCanvas = function(props) {
    var shapeSegments = props.shapeSegments, isPreview = props.isPreview, rootEl = props.rootEl;
    var scrollableHeight = (0,client_services_hooks_use_element_size__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(rootEl).scrollableHeight;
    // Stage - is a div wrapper
    // Layer - is an actual 2d canvas element, so you can have several layers inside the stage
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_konva__WEBPACK_IMPORTED_MODULE_1__/* .Stage */ .Hf, {
        width: _helpers__WEBPACK_IMPORTED_MODULE_3__/* .CANVAS_FULL_WIDTH */ .ol,
        height: scrollableHeight,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_konva__WEBPACK_IMPORTED_MODULE_1__/* .Layer */ .mh, {
            children: shapeSegments.map(function(segment) {
                var Component = segments_desktop__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[segment.type].component;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, _object_spread_props(_object_spread({}, segment.props), {
                    windowHeight: scrollableHeight,
                    isPreview: isPreview
                }));
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReactCanvas);


/***/ }),

/***/ 64265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nz": function() { return /* binding */ CUSTOMER_KEY_OSCAR; },
/* harmony export */   "bd": function() { return /* binding */ CUSTOMER_KEY_ZIPPO; },
/* harmony export */   "iV": function() { return /* binding */ CUSTOMER_KEY_THE_STUDENT_HOTEL; },
/* harmony export */   "tx": function() { return /* binding */ CUSTOMER_KEY_TELEFONICA; },
/* harmony export */   "vK": function() { return /* binding */ CUSTOMER_KEY_NISSAN; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var CUSTOMER_KEY_OSCAR = "oscar";
var CUSTOMER_KEY_THE_STUDENT_HOTEL = "theStudentHotel";
var CUSTOMER_KEY_TELEFONICA = "telefonica";
var CUSTOMER_KEY_ZIPPO = "zippo";
var CUSTOMER_KEY_NISSAN = "nissan";
var _obj;
/* harmony default export */ __webpack_exports__["ZP"] = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, CUSTOMER_KEY_OSCAR, {
    companyName: "Oscar",
    name: "Stefana Muller",
    jobDescription: "Senior Director, CTO Product and Program Office",
    quote: "monday.com Work OS saves us about 1,850 hrs of staff time and somewhere in the range of $50,000 a month."
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, CUSTOMER_KEY_THE_STUDENT_HOTEL, {
    companyName: "The Student Hotel",
    name: "Charlie MacGregor",
    jobDescription: "Founder & CEO",
    quote: "Now that we have monday.com Work OS as the backbone of our organization I feel that I have an overview I can trust."
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, CUSTOMER_KEY_TELEFONICA, {
    companyName: "Telefonica",
    name: "Tye Rapley-Hawkins",
    jobDescription: "Head of Delivery",
    quote: "With monday.com, we’re 30% more efficient at delivering hundreds of campaigns seen by millions of customers."
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, CUSTOMER_KEY_ZIPPO, {
    companyName: "Zippo",
    name: "Chris Funk",
    jobDescription: "Director of Product Innovation",
    quote: "monday.com Work OS has enabled our group to launch more product categories and expand into more markets in way less time."
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, CUSTOMER_KEY_NISSAN, {
    companyName: "Nissan",
    name: "Kenny Wallace",
    jobDescription: "Vendor Tooling Engineer, Nissan North America",
    quote: "monday.com has given me the confidence because when I walk into the room I know that when upper management asks for a certain piece of information I’m able to quickly provide it for them."
}), _obj);


/***/ }),

/***/ 93879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ DYNAMIC_ASSET_PARAM_PATHS; }
/* harmony export */ });
var YEAR_IN_REVIEW_2020 = "year-in-review/2020";
var DYNAMIC_ASSET_PARAM_PATHS = [
    {
        value: YEAR_IN_REVIEW_2020,
        text: "Year In Review 2020"
    }
];


/***/ }),

/***/ 21960:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    TOP_BAR_HEIGHT: 72,
    EDIT_SEGMENT_BAR_HEIGHT: 72
});


/***/ }),

/***/ 39832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bX": function() { return /* binding */ FULL_PAGE_BACKGROUND_VIDEOS; },
/* harmony export */   "rB": function() { return /* binding */ PARAGRAPH_AND_ASSET_VIDEOS; },
/* harmony export */   "u6": function() { return /* binding */ FULL_HEIGHT_VIDEOS; }
/* harmony export */ });
var FULL_PAGE_BACKGROUND_VIDEOS = "background-videos";
var FULL_HEIGHT_VIDEOS = "full-height-videos";
var PARAGRAPH_AND_ASSET_VIDEOS = "paragraph-and-asset-videos";


/***/ }),

/***/ 42711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_segments_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(861);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(273);




/* harmony default export */ __webpack_exports__["Z"] = ({
    gradientTheme: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Override gradient theme color",
        maxLimit: 3,
        nestedConfig: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
            fields: {
                color: {
                    label: "Color",
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                    possibleColors: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(segments_segments_service__WEBPACK_IMPORTED_MODULE_1__/* .BACKGROUND_COLOR_OPTIONS */ .L6).concat([
                        styles_color_consts__WEBPACK_IMPORTED_MODULE_3__.MIDNIGHT_PURPLE_COLOR,
                        styles_color_consts__WEBPACK_IMPORTED_MODULE_3__.INDIGO_BLUE_COLOR,
                        styles_color_consts__WEBPACK_IMPORTED_MODULE_3__.AMETHYST_PURPLE_COLOR,
                        styles_color_consts__WEBPACK_IMPORTED_MODULE_3__.SAPPHIRE_PURPLE_COLOR,
                        styles_color_consts__WEBPACK_IMPORTED_MODULE_3__.DEEP_NAVY_BLUE_COLOR
                    ])
                }
            }
        }
    }
});


/***/ }),

/***/ 4065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ asset; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var fields_config = __webpack_require__(13225);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/parallax-video-asset/parallax-video-asset-config.js
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var video = fields_config/* default.video */.Z.video;
var topic = full_paragraph_fields_config/* default.topic */.Z.topic, buttonConfig = full_paragraph_fields_config/* default.buttonConfig */.Z.buttonConfig, mobileTextAlign = full_paragraph_fields_config/* default.mobileTextAlign */.Z.mobileTextAlign, textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, restOfConfig = _object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "topic",
    "buttonConfig",
    "mobileTextAlign",
    "textAlign",
    "textColor"
]);
/* harmony default export */ var parallax_video_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Parallax Video",
    fields: {
        asset: video,
        scrollThreshold: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Parallax scroll threshold"
        },
        marginBetweenSections: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Margin between sections"
        },
        leftColumn: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Left column",
            maxLimit: 3,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: restOfConfig
            }
        },
        rightColumn: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Right column",
            maxLimit: 3,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: restOfConfig
            }
        },
        columnMarginLeft: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Column margin left"
        },
        columnMarginRight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Column margin right"
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/parallax-video-asset/parallax-video-asset-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var parallax_video_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        fullParagraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph Advanced Config",
            fields: advanced_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/parallax-video-asset/index.js

var ParallaxVideoAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4449).then(__webpack_require__.bind(__webpack_require__, 4449));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4449)
            ];
        }
    }
});


/* harmony default export */ var parallax_video_asset = ({
    ParallaxVideoAssetComponent: ParallaxVideoAssetComponent,
    ParallaxVideoAssetConfig: parallax_video_asset_config,
    ParallaxVideoAssetAdvancedConfig: parallax_video_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/fade-in-asset/fade-in-asset-config.js
function fade_in_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fade_in_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fade_in_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function fade_in_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function fade_in_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        fade_in_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var fade_in_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Fade In",
    fields: fade_in_asset_config_object_spread_props(fade_in_asset_config_object_spread({}, theme_config/* default */.Z), {
        backgroundAsset: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Background image",
            fields: fields_config/* default */.Z
        },
        fadeInAsset: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Fade-in image",
            fields: fade_in_asset_config_object_spread({
                height: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Height"
                }
            }, fields_config/* default */.Z)
        }
    })
});

// EXTERNAL MODULE: ./components/core/asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(25289);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/fade-in-asset/fade-in-asset-advanced-config.js
function fade_in_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fade_in_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fade_in_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function fade_in_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function fade_in_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        fade_in_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var fade_in_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: fade_in_asset_advanced_config_object_spread_props(fade_in_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        startingPosition: {
            label: "Starting asset Y position (default is 0)",
            type: template_field_type.FIELD_TYPES.TEXT
        },
        animationDuration: {
            label: "Animation duration (in seconds)",
            type: template_field_type.FIELD_TYPES.TEXT
        },
        advancedAssetConfig: {
            label: "Advanced asset config",
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: advanced_field_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/fade-in-asset/index.js

var FadeInAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8285).then(__webpack_require__.bind(__webpack_require__, 88285));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88285)
            ];
        }
    }
});


/* harmony default export */ var fade_in_asset = ({
    FadeInAssetComponent: FadeInAssetComponent,
    FadeInAssetConfig: fade_in_asset_config,
    FadeInAssetAdvancedConfig: fade_in_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/logos/components/logos-title/fields-config.js
var logos_title_fields_config = __webpack_require__(74606);
// EXTERNAL MODULE: ./segments/desktop/core-components/logos/fields-config.js
var logos_fields_config = __webpack_require__(97909);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/video-background-asset/video-background-asset-config.js
function video_background_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function video_background_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            video_background_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function video_background_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function video_background_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        video_background_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






/* harmony default export */ var video_background_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Video Background",
    fields: video_background_asset_config_object_spread_props(video_background_asset_config_object_spread({}, theme_config/* default */.Z), {
        isCentrilizeContent: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Centrilize Content"
        },
        fullParagraphConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragrapph",
            fields: video_background_asset_config_object_spread({}, full_paragraph_fields_config/* default */.Z)
        },
        assetConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Asset",
            fields: video_background_asset_config_object_spread({}, fields_config/* default */.Z)
        },
        addDarkOverlay: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Add Dark Overlay On Video"
        },
        hideBlackBars: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Hide Black Bars"
        },
        logosProps: {
            type: template_field_type.FIELD_TYPES.CONDITIONAL_NESTED,
            label: "Add logos",
            conditionalKeyName: "useLogos",
            options: [
                {
                    text: "Yes",
                    fieldsConfig: video_background_asset_config_object_spread_props(video_background_asset_config_object_spread({}, logos_title_fields_config/* default */.Z), {
                        logos: {
                            type: template_field_type.FIELD_TYPES.NESTED,
                            label: "Logos",
                            fields: logos_fields_config/* default */.Z
                        }
                    })
                }
            ]
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/logos/advanced-fields-config.js
var logos_advanced_fields_config = __webpack_require__(53315);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/video-background-asset/video-background-asset-advanced-config.js
function video_background_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function video_background_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            video_background_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function video_background_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function video_background_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        video_background_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var video_background_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: video_background_asset_advanced_config_object_spread_props(video_background_asset_advanced_config_object_spread({
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        },
        segmentHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Segment Height"
        },
        segmentMinHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Segment Min Height"
        },
        segmentMaxHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Segment Max Height"
        },
        videoPlayerWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Video Player Width"
        },
        videoPlayerMinWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Video Player Min Width"
        },
        videoPlayerHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Video Player Height"
        },
        videoPlayerPositionTop: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Video Player Position Top"
        },
        videoPlayerPositionLeft: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Video Player Position Left"
        },
        logosBottomMargin: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Logos Bottom Margin"
        }
    }, shared_advanced_fields_config/* default */.Z), {
        paragraphAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph Advanced Props",
            fields: video_background_asset_advanced_config_object_spread_props(video_background_asset_advanced_config_object_spread({}, advanced_fields_config/* default */.Z), {
                marginTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Margin Top"
                }
            })
        },
        topLogosAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos Advanced Props",
            fields: {
                textAndLogosMargin: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Space between text and logo"
                },
                logosAdvancedProps: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Logos Advanced Props",
                    fields: logos_advanced_fields_config/* default */.Z
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/video-background-asset/index.js



var VideoBackgroundAssetComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9112), __webpack_require__.e(9754)]).then(__webpack_require__.bind(__webpack_require__, 94929));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94929)
            ];
        }
    }
});
/* harmony default export */ var video_background_asset = ({
    VideoBackgroundAssetComponent: VideoBackgroundAssetComponent,
    VideoBackgroundAssetConfig: video_background_asset_config,
    VideoBackgroundAssetAdvancedConfig: video_background_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/fields-config.js
var carousel_fields_config = __webpack_require__(33751);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/carousel-asset/carousel-asset-config.js
function carousel_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function carousel_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carousel_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var carousel_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Carousel",
    fields: carousel_asset_config_object_spread({
        disableCenterModeStyle: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Disable center mode style"
        },
        imageHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Images height"
        },
        horizontalPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Images horizontal padding"
        },
        transitionSpeed: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Slides transition speed (in miliseconds)"
        }
    }, carousel_fields_config/* default */.Z)
});

// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/advanced-fields-config.js
var carousel_advanced_fields_config = __webpack_require__(1270);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/carousel-asset/carousel-asset-advanced-config.js
function carousel_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function carousel_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carousel_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var carousel_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: carousel_asset_advanced_config_object_spread({}, carousel_advanced_fields_config/* default */.Z, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/carousel-asset/index.js



var CarouselAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4387).then(__webpack_require__.bind(__webpack_require__, 64387));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64387)
            ];
        }
    }
});
/* harmony default export */ var carousel_asset = ({
    CarouselAssetComponent: CarouselAssetComponent,
    CarouselAssetConfig: carousel_asset_config,
    CarouselAssetAdvancedConfig: carousel_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tags-grid/fields-config.js
var selectable_tags_grid_fields_config = __webpack_require__(1117);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/vertical-tags-with-images-asset/vertical-tags-with-images-asset-config.js
function vertical_tags_with_images_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function vertical_tags_with_images_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            vertical_tags_with_images_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}




/* harmony default export */ var vertical_tags_with_images_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Vertical Tags with images",
    fields: vertical_tags_with_images_asset_config_object_spread({
        paragraphText: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Fold paragraph",
            fields: vertical_tags_with_images_asset_config_object_spread({}, full_paragraph_fields_config/* default */.Z)
        },
        firstStateText: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "First state paragraph",
            fields: vertical_tags_with_images_asset_config_object_spread({}, full_paragraph_fields_config/* default */.Z)
        }
    }, selectable_tags_grid_fields_config/* default */.Z)
});

// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tags-grid/advanced-field-config.js
var selectable_tags_grid_advanced_field_config = __webpack_require__(33129);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var title_advanced_field_config = __webpack_require__(95760);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/advanced-fields-config.js
var paragraph_advanced_fields_config = __webpack_require__(50342);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/vertical-tags-with-images-asset/vertical-tags-with-images-asset-advanced-config.js
function vertical_tags_with_images_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function vertical_tags_with_images_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            vertical_tags_with_images_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function vertical_tags_with_images_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function vertical_tags_with_images_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        vertical_tags_with_images_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





/* harmony default export */ var vertical_tags_with_images_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: vertical_tags_with_images_asset_advanced_config_object_spread_props(vertical_tags_with_images_asset_advanced_config_object_spread({
        withFirstStateArrow: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Show first state arrow"
        },
        paragraphTagsPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Padding between Text and Tags"
        }
    }, selectable_tags_grid_advanced_field_config/* default */.Z, shared_advanced_fields_config/* default */.Z, paragraph_advanced_fields_config/* default */.Z), {
        titleWidth: title_advanced_field_config/* default.titleWidth */.Z.titleWidth
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/vertical-tags-with-images-asset/index.js



var VerticalTagsWithImagesAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5187).then(__webpack_require__.bind(__webpack_require__, 35187));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35187)
            ];
        }
    }
});
/* harmony default export */ var vertical_tags_with_images_asset = ({
    VerticalTagsWithImagesAssetComponent: VerticalTagsWithImagesAssetComponent,
    VerticalTagsWithImagesAssetConfig: vertical_tags_with_images_asset_config,
    VerticalTagsWithImagesAssetAdvancedConfig: vertical_tags_with_images_asset_advanced_config
});

// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/images-carousel-with-tags-grid-asset/images-carousel-with-tags-grid-asset-config.js
function images_carousel_with_tags_grid_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function images_carousel_with_tags_grid_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            images_carousel_with_tags_grid_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}





/* harmony default export */ var images_carousel_with_tags_grid_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Images Carousel With Tags Grid",
    fields: images_carousel_with_tags_grid_asset_config_object_spread({
        paragraphText: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: images_carousel_with_tags_grid_asset_config_object_spread({}, full_paragraph_fields_config/* default */.Z)
        },
        defaultImage: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Default image",
            fields: images_carousel_with_tags_grid_asset_config_object_spread({}, fields_config/* default.image.fields */.Z.image.fields)
        },
        showDefaultInGallery: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Show default image in gallery"
        },
        tagsAlign: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Tags Align",
            options: [
                {
                    value: align_types.ALIGN_TYPES.LEFT,
                    text: align_types.ALIGN_LABELS.LEFT
                },
                {
                    value: align_types.ALIGN_TYPES.CENTER,
                    text: align_types.ALIGN_LABELS.CENTER
                },
                {
                    value: align_types.ALIGN_TYPES.RIGHT,
                    text: align_types.ALIGN_LABELS.RIGHT
                }
            ]
        }
    }, selectable_tags_grid_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/images-carousel-with-tags-grid-asset/images-carousel-with-tags-grid-asset-advanced-config.js
function images_carousel_with_tags_grid_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function images_carousel_with_tags_grid_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            images_carousel_with_tags_grid_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function images_carousel_with_tags_grid_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function images_carousel_with_tags_grid_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        images_carousel_with_tags_grid_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





/* harmony default export */ var images_carousel_with_tags_grid_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: images_carousel_with_tags_grid_asset_advanced_config_object_spread_props(images_carousel_with_tags_grid_asset_advanced_config_object_spread({
        paragraphTagsPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Padding between Text and Tags"
        }
    }, selectable_tags_grid_advanced_field_config/* default */.Z, shared_advanced_fields_config/* default */.Z, paragraph_advanced_fields_config/* default */.Z), {
        titleWidth: title_advanced_field_config/* default.titleWidth */.Z.titleWidth
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/images-carousel-with-tags-grid-asset/index.js



var ImagesCarouselWithTagsGridAssetComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4222), __webpack_require__.e(1059)]).then(__webpack_require__.bind(__webpack_require__, 71059));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71059)
            ];
        }
    }
});
/* harmony default export */ var images_carousel_with_tags_grid_asset = ({
    ImagesCarouselWithTagsGridAssetComponent: ImagesCarouselWithTagsGridAssetComponent,
    ImagesCarouselWithTagsGridAssetConfig: images_carousel_with_tags_grid_asset_config,
    ImagesCarouselWithTagsGridAssetAdvancedConfig: images_carousel_with_tags_grid_asset_advanced_config
});

// EXTERNAL MODULE: ./components/core/youtube-video-with-poster/fields-config.js
var youtube_video_with_poster_fields_config = __webpack_require__(93494);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/embedded-youtube-asset/embedded-youtube-asset-config.js
function embedded_youtube_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function embedded_youtube_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            embedded_youtube_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function embedded_youtube_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function embedded_youtube_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        embedded_youtube_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var embedded_youtube_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Embedded Youtube",
    fields: embedded_youtube_asset_config_object_spread_props(embedded_youtube_asset_config_object_spread({}, theme_config/* default */.Z, youtube_video_with_poster_fields_config/* default */.Z), {
        fullWidth: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Disable maximum width limitation (1440px)"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/embedded-youtube-asset/embedded-youtube-asset-advanced-config.js
function embedded_youtube_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function embedded_youtube_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            embedded_youtube_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function embedded_youtube_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function embedded_youtube_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        embedded_youtube_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var embedded_youtube_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: embedded_youtube_asset_advanced_config_object_spread_props(embedded_youtube_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        width: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Asset width in desktop"
        },
        mobileWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Asset width in mobile"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/embedded-youtube-asset/index.js



var EmbeddedYoutubeAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1977).then(__webpack_require__.bind(__webpack_require__, 11977));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11977)
            ];
        }
    }
});
/* harmony default export */ var embedded_youtube_asset = ({
    EmbeddedYoutubeAssetComponent: EmbeddedYoutubeAssetComponent,
    EmbeddedYoutubeAssetConfig: embedded_youtube_asset_config,
    EmbeddedYoutubeAssetAdvancedConfig: embedded_youtube_asset_advanced_config
});

// EXTERNAL MODULE: ./constants/video-types.js
var video_types = __webpack_require__(39832);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/youtube-video-asset/youtube-video-asset-config.js
function youtube_video_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function youtube_video_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            youtube_video_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function youtube_video_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function youtube_video_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        youtube_video_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var youtube_video_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Youtube Video Popup",
    fields: youtube_video_asset_config_object_spread_props(youtube_video_asset_config_object_spread({}, theme_config/* default */.Z), {
        backgroundImg: {
            type: template_field_type.FIELD_TYPES.GALLERY,
            defaultImagesKeys: [],
            label: "Select an image placeholder"
        },
        alt: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Description (alt)",
            translatable: true
        },
        videoPlaceholder: {
            type: template_field_type.FIELD_TYPES.CLOUDINARY_VIDEO_PICKER,
            label: "Video placeholder",
            labelDescription: "Using this will override the image placeholder",
            videoType: video_types/* PARAGRAPH_AND_ASSET_VIDEOS */.rB
        },
        videoId: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Video ID"
        }
    })
});

// EXTERNAL MODULE: ./constants/cloudinary-asset-qualities.js
var cloudinary_asset_qualities = __webpack_require__(65832);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/youtube-video-asset/youtube-video-asset-advanced-config.js
function youtube_video_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function youtube_video_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            youtube_video_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function youtube_video_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function youtube_video_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        youtube_video_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var youtube_video_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: youtube_video_asset_advanced_config_object_spread_props(youtube_video_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        assetQuality: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Asset Quality",
            options: [
                {
                    value: cloudinary_asset_qualities.AUTO,
                    text: "Auto"
                },
                {
                    value: cloudinary_asset_qualities.BEST,
                    text: "Best"
                },
                {
                    value: cloudinary_asset_qualities.GOOD,
                    text: "Good"
                },
                {
                    value: cloudinary_asset_qualities.ECO,
                    text: "Eco"
                },
                {
                    value: cloudinary_asset_qualities.LOW,
                    text: "Low"
                }
            ]
        },
        width: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Asset width in desktop (% only)"
        },
        mobileWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Asset width in mobile (% only)"
        },
        fullWidth: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Disable maximum width limitation (1440px)"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/youtube-video-asset/index.js



var YoutubeVideoAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9313).then(__webpack_require__.bind(__webpack_require__, 49313));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49313)
            ];
        }
    }
});
/* harmony default export */ var youtube_video_asset = ({
    YoutubeVideoAssetComponent: YoutubeVideoAssetComponent,
    YoutubeVideoAssetConfig: youtube_video_asset_config,
    YoutubeVideoAssetAdvancedConfig: youtube_video_asset_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/regular-asset/regular-asset-config.js
function regular_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function regular_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            regular_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function regular_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function regular_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        regular_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var regular_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Regular",
    fields: regular_asset_config_object_spread_props(regular_asset_config_object_spread({}, theme_config/* default */.Z), {
        position: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Position",
            options: [
                "left",
                "center",
                "right"
            ]
        },
        asset: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Asset",
            fields: fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/regular-asset/regular-asset-advanced-config.js
function regular_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function regular_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            regular_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function regular_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function regular_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        regular_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var regular_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: regular_asset_advanced_config_object_spread_props(regular_asset_advanced_config_object_spread(regular_asset_advanced_config_object_spread_props(regular_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        width: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Asset width in desktop (% only)"
        },
        mobileWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Asset width in mobile (% only)"
        }
    }), advanced_field_config/* default */.Z), {
        fullWidth: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Disable maximum width limitation (1440px)"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/regular-asset/index.js

var RegularAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8181).then(__webpack_require__.bind(__webpack_require__, 98181));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98181)
            ];
        }
    }
});


/* harmony default export */ var regular_asset = ({
    RegularAssetComponent: RegularAssetComponent,
    RegularAssetConfig: regular_asset_config,
    RegularAssetAdvancedConfig: regular_asset_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/index.js
// plop_marker:layouts_import









/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    ParallaxVideoAsset: parallax_video_asset,
    FadeInAsset: fade_in_asset,
    VideoBackgroundAsset: video_background_asset,
    CarouselAsset: carousel_asset,
    VerticalTagsWithImagesAsset: vertical_tags_with_images_asset,
    ImagesCarouselWithTagsGridAsset: images_carousel_with_tags_grid_asset,
    EmbeddedYoutubeAsset: embedded_youtube_asset,
    YoutubeVideoAsset: youtube_video_asset,
    RegularAsset: regular_asset
});

;// CONCATENATED MODULE: ./segments/desktop/asset/index.js

var ParallaxVideoAsset = layouts.ParallaxVideoAsset, FadeInAsset = layouts.FadeInAsset, VideoBackgroundAsset = layouts.VideoBackgroundAsset, CarouselAsset = layouts.CarouselAsset, VerticalTagsWithImagesAsset = layouts.VerticalTagsWithImagesAsset, ImagesCarouselWithTagsGridAsset = layouts.ImagesCarouselWithTagsGridAsset, EmbeddedYoutubeAsset = layouts.EmbeddedYoutubeAsset, YoutubeVideoAsset = layouts.YoutubeVideoAsset, RegularAsset = layouts.RegularAsset;
/* harmony default export */ var asset = ({
    // plop_marker:segment_index_add_layout
    ParallaxVideoAssetComponent: {
        type: "ParallaxVideoAssetComponent",
        title: "Parallax Video",
        imgSrc: "/static/img/segments/layouts/parallax-video-asset.png",
        config: ParallaxVideoAsset.ParallaxVideoAssetConfig,
        advancedConfig: ParallaxVideoAsset.ParallaxVideoAssetAdvancedConfig,
        component: ParallaxVideoAsset.ParallaxVideoAssetComponent
    },
    FadeInAssetComponent: {
        type: "FadeInAssetComponent",
        title: "Fade In",
        imgSrc: "/static/img/segments/layouts/fade-in-asset.png",
        config: FadeInAsset.FadeInAssetConfig,
        advancedConfig: FadeInAsset.FadeInAssetAdvancedConfig,
        component: FadeInAsset.FadeInAssetComponent
    },
    VideoBackgroundAssetComponent: {
        type: "VideoBackgroundAssetComponent",
        title: "Video Background",
        imgSrc: "/static/img/segments/layouts/video-background-asset.png",
        config: VideoBackgroundAsset.VideoBackgroundAssetConfig,
        advancedConfig: VideoBackgroundAsset.VideoBackgroundAssetAdvancedConfig,
        component: VideoBackgroundAsset.VideoBackgroundAssetComponent
    },
    CarouselAssetComponent: {
        type: "CarouselAssetComponent",
        title: "Carousel",
        imgSrc: "/static/img/segments/layouts/carousel-asset.png",
        config: CarouselAsset.CarouselAssetConfig,
        advancedConfig: CarouselAsset.CarouselAssetAdvancedConfig,
        component: CarouselAsset.CarouselAssetComponent
    },
    VerticalTagsWithImagesAssetComponent: {
        type: "VerticalTagsWithImagesAssetComponent",
        title: "Vertical Tags With Images",
        imgSrc: "/static/img/segments/layouts/vertical-tags-with-images-asset.png",
        config: VerticalTagsWithImagesAsset.VerticalTagsWithImagesAssetConfig,
        advancedConfig: VerticalTagsWithImagesAsset.VerticalTagsWithImagesAssetAdvancedConfig,
        component: VerticalTagsWithImagesAsset.VerticalTagsWithImagesAssetComponent
    },
    ImagesCarouselWithTagsGridAssetComponent: {
        type: "ImagesCarouselWithTagsGridAssetComponent",
        title: "Images Carousel With Tags Grid",
        imgSrc: "/static/img/segments/layouts/images-carousel-with-tags-grid-asset.png",
        config: ImagesCarouselWithTagsGridAsset.ImagesCarouselWithTagsGridAssetConfig,
        advancedConfig: ImagesCarouselWithTagsGridAsset.ImagesCarouselWithTagsGridAssetAdvancedConfig,
        component: ImagesCarouselWithTagsGridAsset.ImagesCarouselWithTagsGridAssetComponent
    },
    EmbeddedYoutubeAssetComponent: {
        type: "EmbeddedYoutubeAssetComponent",
        title: "Embedded Youtube",
        imgSrc: "/static/img/segments/layouts/embedded-youtube-asset.png",
        config: EmbeddedYoutubeAsset.EmbeddedYoutubeAssetConfig,
        advancedConfig: EmbeddedYoutubeAsset.EmbeddedYoutubeAssetAdvancedConfig,
        component: EmbeddedYoutubeAsset.EmbeddedYoutubeAssetComponent
    },
    YoutubeVideoAssetComponent: {
        type: "YoutubeVideoAssetComponent",
        title: "Youtube Video Popup",
        imgSrc: "/static/img/segments/layouts/youtube-video-asset.png",
        config: YoutubeVideoAsset.YoutubeVideoAssetConfig,
        advancedConfig: YoutubeVideoAsset.YoutubeVideoAssetAdvancedConfig,
        component: YoutubeVideoAsset.YoutubeVideoAssetComponent
    },
    RegularAssetComponent: {
        type: "RegularAssetComponent",
        title: "Regular",
        imgSrc: "/static/img/segments/layouts/regular-asset.png",
        config: RegularAsset.RegularAssetConfig,
        advancedConfig: RegularAsset.RegularAssetAdvancedConfig,
        component: RegularAsset.RegularAssetComponent
    }
});


/***/ }),

/***/ 24646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ blog; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
;// CONCATENATED MODULE: ./segments/desktop/blog/layouts/rich-text-blog/rich-text-blog-config.js

/* harmony default export */ var rich_text_blog_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Rich Text",
    fields: {
        body: {
            type: template_field_type.FIELD_TYPES.RICH_TEXT,
            label: "Body"
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
;// CONCATENATED MODULE: ./segments/desktop/blog/layouts/rich-text-blog/rich-text-blog-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var rich_text_blog_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        width: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Blog width in desktop (% only)"
        },
        align: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Alignment",
            options: [
                {
                    value: align_types.ALIGN_TYPES.LEFT,
                    text: align_types.ALIGN_LABELS.LEFT
                },
                {
                    value: align_types.ALIGN_TYPES.CENTER,
                    text: align_types.ALIGN_LABELS.CENTER
                },
                {
                    value: align_types.ALIGN_TYPES.RIGHT,
                    text: align_types.ALIGN_LABELS.RIGHT
                }
            ]
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/blog/layouts/rich-text-blog/index.js



var RichTextBlogComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1905).then(__webpack_require__.bind(__webpack_require__, 41905));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41905)
            ];
        }
    }
});
/* harmony default export */ var rich_text_blog = ({
    RichTextBlogComponent: RichTextBlogComponent,
    RichTextBlogConfig: rich_text_blog_config,
    RichTextBlogAdvancedConfig: rich_text_blog_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/blog/layouts/index.js
// plop_marker:layouts_import

/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    RichTextBlog: rich_text_blog
});

;// CONCATENATED MODULE: ./segments/desktop/blog/index.js

var RichTextBlog = layouts.RichTextBlog;
/* harmony default export */ var blog = ({
    // plop_marker:segment_index_add_layout
    RichTextBlogComponent: {
        type: "RichTextBlogComponent",
        title: "Rich Text",
        imgSrc: "/static/img/segments/layouts/rich-text-blog.png",
        config: RichTextBlog.RichTextBlogConfig,
        advancedConfig: RichTextBlog.RichTextBlogAdvancedConfig,
        component: RichTextBlog.RichTextBlogComponent
    }
});


/***/ }),

/***/ 3993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ desktop_button; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/fields-config.js + 5 modules
var fields_config = __webpack_require__(75629);
;// CONCATENATED MODULE: ./segments/desktop/button/layouts/basic-button/basic-button-config.js


/* harmony default export */ var basic_button_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Basic Button",
    description: "Mind tests on signup form component",
    fields: {
        textAlign: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Button Align",
            options: [
                {
                    value: "left",
                    text: "Left"
                },
                {
                    value: "center",
                    text: "Center"
                },
                {
                    value: "right",
                    text: "Right"
                }
            ]
        },
        buttonConfig: fields_config/* default */.Z
    }
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/button/layouts/basic-button/basic-button-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var basic_button_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/button/layouts/basic-button/index.js



var BasicButtonComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6988).then(__webpack_require__.bind(__webpack_require__, 16988));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16988)
            ];
        }
    }
});
/* harmony default export */ var basic_button = ({
    BasicButtonComponent: BasicButtonComponent,
    BasicButtonConfig: basic_button_config,
    BasicButtonAdvancedConfig: basic_button_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/button/layouts/index.js
// plop_marker:layouts_import

/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    BasicButton: basic_button
});

;// CONCATENATED MODULE: ./segments/desktop/button/index.js

var BasicButton = layouts.BasicButton;
/* harmony default export */ var desktop_button = ({
    // plop_marker:segment_index_add_layout
    BasicButtonComponent: {
        type: "BasicButtonComponent",
        title: "Basic",
        imgSrc: "/static/img/segments/layouts/basic-button.png",
        config: BasicButton.BasicButtonConfig,
        advancedConfig: BasicButton.BasicButtonAdvancedConfig,
        component: BasicButton.BasicButtonComponent
    }
});


/***/ }),

/***/ 5616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ careers; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
;// CONCATENATED MODULE: ./segments/desktop/careers/layouts/search-bar-careers/search-bar-careers-config.js

/* harmony default export */ var search_bar_careers_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "First Fold",
    fields: {}
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/careers/layouts/search-bar-careers/search-bar-careers-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var search_bar_careers_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/careers/layouts/search-bar-careers/index.js



var SearchBarCareersComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3714), __webpack_require__.e(9432), __webpack_require__.e(1036), __webpack_require__.e(9949), __webpack_require__.e(945), __webpack_require__.e(5114)]).then(__webpack_require__.bind(__webpack_require__, 75114));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75114)
            ];
        }
    }
});
/* harmony default export */ var search_bar_careers = ({
    SearchBarCareersComponent: SearchBarCareersComponent,
    SearchBarCareersConfig: search_bar_careers_config,
    SearchBarCareersAdvancedConfig: search_bar_careers_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/careers/layouts/index.js
// plop_marker:layouts_import

/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    SearchBarCareers: search_bar_careers
});

;// CONCATENATED MODULE: ./segments/desktop/careers/index.js

var SearchBarCareers = layouts.SearchBarCareers;
/* harmony default export */ var careers = ({
    // plop_marker:segment_index_add_layout
    SearchBarCareersComponent: {
        type: "SearchBarCareersComponent",
        title: "Search Bar Careers",
        imgSrc: "/static/img/segments/layouts/search-bar-careers.png",
        config: SearchBarCareers.SearchBarCareersConfig,
        advancedConfig: SearchBarCareers.SearchBarCareersAdvancedConfig,
        component: SearchBarCareers.SearchBarCareersComponent
    }
});


/***/ }),

/***/ 55209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13225);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ __webpack_exports__["Z"] = ({
    tabs: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Tabs",
        maxLimit: 5,
        nestedConfig: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
            fields: {
                label: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                    label: "Tab Label",
                    translatable: true
                },
                isMainTab: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                    label: "Main Work-OS tab"
                },
                color: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                    label: "Color"
                },
                tabImage: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
                    defaultImagesKeys: [
                        "static/img/templates/long-template/boards/"
                    ],
                    label: "Tab image"
                },
                tabImageSelected: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
                    defaultImagesKeys: [
                        "static/img/templates/long-template/boards/"
                    ],
                    label: "Tab Hover image"
                },
                asset: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
                    label: "Asset",
                    fields: _object_spread({}, components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)
                }
            }
        }
    }
});


/***/ }),

/***/ 61204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Bullets",
    fields: {
        bulletTextSize: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
            label: "Bullet text size",
            options: [
                {
                    value: "0.8125rem",
                    text: "13px"
                },
                {
                    value: "0.875rem",
                    text: "14px"
                },
                {
                    value: "1rem",
                    text: "16px"
                }
            ]
        },
        bulletsDirection: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
            label: "Bullets direction",
            options: [
                {
                    value: "row",
                    text: "Row"
                },
                {
                    value: "column",
                    text: "Column"
                }
            ]
        },
        bulletsColor: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
            label: "Bullets color"
        },
        checkColor: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
            label: "Check color"
        },
        bullets: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Bullets",
            nestedConfig: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
                fields: {
                    bulletText: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                        label: "Text",
                        translatable: true
                    },
                    href: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                        label: "Href"
                    },
                    openInNewTab: {
                        type: "boolean",
                        label: "Should Open In New Tab"
                    }
                }
            }
        }
    }
});


/***/ }),

/***/ 24662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    tagImg: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Image Tag",
        fields: {
            src: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select a Tag Image"
            }
        }
    },
    link: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Link"
    },
    tagText: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Tag Text",
        translatable: true
    }
});


/***/ }),

/***/ 75629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ button_fields_config; }
});

// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/fields-config.js
var fields_config = __webpack_require__(64054);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/fields-config.js
var secondary_button_fields_config = __webpack_require__(54237);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/fields-config.js
var signup_button_fields_config = __webpack_require__(96587);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/two-link-buttons-button/fields-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var two_link_buttons_button_fields_config = ({
    swapButtonsOrder: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Swap buttons order"
    },
    secondaryButtonConfig: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Secondary Button",
        fields: _object_spread({}, secondary_button_fields_config/* default */.Z)
    },
    regularButtonConfig: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Regular Button",
        fields: _object_spread({}, fields_config/* default */.Z)
    }
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/signup-combo-buttons-button/fields-config.js
function fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var signup_combo_buttons_button_fields_config = ({
    signupButtonConfig: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Signup Button",
        fields: fields_config_object_spread({}, signup_button_fields_config/* default */.Z)
    },
    secondaryButtonConfig: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Secondary Button",
        fields: fields_config_object_spread({}, secondary_button_fields_config/* default */.Z)
    },
    swapButtonsOrder: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Swap buttons order"
    }
});

// EXTERNAL MODULE: ./segments/button-service.js
var button_service = __webpack_require__(93833);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/email-button/fields-config.js


/* harmony default export */ var email_button_fields_config = ({
    buttonColor: {
        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
        label: "Color",
        possibleColors: button_service/* buttonColors */.Is
    },
    buttonText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Text",
        translatable: true
    }
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/subscribe-button/fields-config.js
function subscribe_button_fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function subscribe_button_fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            subscribe_button_fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}

/* harmony default export */ var subscribe_button_fields_config = (subscribe_button_fields_config_object_spread({}, email_button_fields_config));

// EXTERNAL MODULE: ./segments/desktop/core-components/button/youtube-popup-button/fields-config.js
var youtube_popup_button_fields_config = __webpack_require__(6690);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/signup-and-youtube-combo-button/fields-config.js
function signup_and_youtube_combo_button_fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function signup_and_youtube_combo_button_fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            signup_and_youtube_combo_button_fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var signup_and_youtube_combo_button_fields_config = ({
    signupButtonConfig: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Signup Button",
        fields: signup_and_youtube_combo_button_fields_config_object_spread({}, signup_button_fields_config/* default */.Z)
    },
    youtubePopupButtonConfig: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Youtube Button",
        fields: signup_and_youtube_combo_button_fields_config_object_spread({}, youtube_popup_button_fields_config/* default */.Z)
    }
});

// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/fields-config.js










/* harmony default export */ var button_fields_config = ({
    type: template_field_type.FIELD_TYPES.CONDITIONAL_NESTED,
    label: "Button",
    conditionalKeyName: "buttonType",
    options: [
        {
            text: button_consts/* REGULAR_BUTTON_TYPE */.ys,
            fieldsConfig: fields_config/* default */.Z,
            type: template_field_type.FIELD_TYPES.NESTED
        },
        {
            text: button_consts/* SECONDARY_BUTTON_TYPE */.jE,
            fieldsConfig: secondary_button_fields_config/* default */.Z,
            type: template_field_type.FIELD_TYPES.NESTED
        },
        {
            text: button_consts/* SIGNUP_BUTTON_TYPE */.ge,
            fieldsConfig: signup_button_fields_config/* default */.Z,
            type: template_field_type.FIELD_TYPES.NESTED
        },
        {
            text: button_consts/* TWO_LINK_BUTTONS_TYPE */.Q_,
            fieldsConfig: two_link_buttons_button_fields_config,
            type: template_field_type.FIELD_TYPES.NESTED
        },
        {
            text: button_consts/* SIGNUP_COMBO_BUTTONS_TYPE */.ae,
            fieldsConfig: signup_combo_buttons_button_fields_config,
            type: template_field_type.FIELD_TYPES.NESTED
        },
        {
            text: button_consts/* SUBSCRIBE_BUTTON_TYPE */.$j,
            fieldsConfig: subscribe_button_fields_config,
            type: template_field_type.FIELD_TYPES.NESTED
        },
        {
            text: button_consts/* YOUTUBE_POPUP_LINK_TYPE */.F9,
            fieldsConfig: youtube_popup_button_fields_config/* default */.Z,
            type: template_field_type.FIELD_TYPES.NESTED
        },
        {
            text: button_consts/* SIGNUP_AND_YOUTUBE_COMBO_BUTTONS_TYPE */.iF,
            fieldsConfig: signup_and_youtube_combo_button_fields_config,
            type: template_field_type.FIELD_TYPES.NESTED
        }
    ]
});


/***/ }),

/***/ 1270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    itemScale: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Item scale"
    },
    defaultIndex: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Default slide index"
    },
    swipeToSlide: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Swipe to slide"
    },
    pauseOnFocus: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Pause on focus"
    },
    showFocusEffect: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Show focus effect"
    },
    lazyLoad: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Lazy load slides"
    }
});


/***/ }),

/***/ 33751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13225);


/* harmony default export */ __webpack_exports__["Z"] = ({
    autoplay: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Autoplay"
    },
    centerPadding: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Center padding (in center mode)"
    },
    pauseOnHover: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Pause on hover (if auto play is enabled)"
    },
    autoplaySpeed: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Autoplay speed (in miliseconds)"
    },
    infinite: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Slide inifinitely"
    },
    slidesToShow: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Slides to show"
    },
    easing: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Animation ease function",
        options: [
            {
                value: "cubic",
                text: "Cubic"
            },
            {
                value: "linear",
                text: "Linear"
            },
            {
                value: "ease",
                text: "Ease"
            },
            {
                value: "ease-in",
                text: "Ease in"
            },
            {
                value: "ease-out",
                text: "Ease out"
            },
            {
                value: "ease-in-out",
                text: "Ease in out"
            }
        ]
    },
    defaultImage: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Default image",
        fields: components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"].image.fields */ .Z.image.fields
    },
    slides: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Slides",
        nestedConfig: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
            fields: {
                asset: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
                    label: "Asset",
                    fields: components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
                }
            }
        }
    }
});


/***/ }),

/***/ 55782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24586);


/* harmony default export */ __webpack_exports__["Z"] = ({
    fullParagraph: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Full Paragraph",
        fields: segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
    },
    backgroundImage: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Background Image",
        fields: {
            src: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                getFullUrl: true
            },
            alt: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Image description (Don't fill if image is a decorative image)",
                translatable: true
            }
        }
    }
});


/***/ }),

/***/ 47285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var segments_desktop_core_components_title_advanced_field_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95760);
/* harmony import */ var segments_desktop_core_components_paragraph_advanced_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50342);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var segments_core_configs_advanced_theme_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42711);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, segments_desktop_core_components_title_advanced_field_config__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, segments_desktop_core_components_paragraph_advanced_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, segments_core_configs_advanced_theme_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z), {
    topicBottomMargin: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_2__.FIELD_TYPES.TEXT,
        label: "Margin between topic and paragraph (defaults: text - 16px | image - 40px)"
    },
    spaceFromParagraph: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_2__.FIELD_TYPES.TEXT,
        label: "Margin between title and text (px)"
    },
    buttonTopMargin: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_2__.FIELD_TYPES.TEXT,
        label: "Margin above button (default 32px)"
    }
}));


/***/ }),

/***/ 24586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_button_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75629);
/* harmony import */ var segments_desktop_core_components_title_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65621);
/* harmony import */ var segments_desktop_core_components_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49496);
/* harmony import */ var components_templates_generator_config_components_asset_asset_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81338);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var image = components_templates_generator_config_components_asset_asset_config__WEBPACK_IMPORTED_MODULE_4__/* .asset.fields.image */ .p.fields.image;
/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({
    textAlign: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Desktop Text Align",
        options: [
            {
                value: "left",
                text: "Left"
            },
            {
                value: "center",
                text: "Center"
            },
            {
                value: "right",
                text: "Right"
            }
        ]
    },
    mobileTextAlign: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Mobile Text Align (if different)",
        options: [
            {
                value: "left",
                text: "Left"
            },
            {
                value: "center",
                text: "Center"
            },
            {
                value: "right",
                text: "Right"
            }
        ]
    },
    textColor: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Old text Color (Don't use - deprecating)",
        possibleColors: [
            "white",
            "black"
        ]
    },
    topic: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Topic",
        fields: {
            text: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Text",
                labelDescription: "Selecting an image would replace the text with it",
                translatable: true
            },
            color: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                label: "Text Color"
            },
            borderColor: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                label: "Border Color"
            },
            image: _object_spread_props(_object_spread({}, image), {
                fields: _object_spread_props(_object_spread({}, image.fields), {
                    height: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                        label: "Height"
                    }
                })
            }),
            allowTextAndImage: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                label: "Allow Text and Image"
            },
            gap: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Gap between image and text"
            }
        }
    }
}, segments_desktop_core_components_title_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, segments_desktop_core_components_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z), {
    buttonConfig: segments_desktop_core_components_button_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
}));


/***/ }),

/***/ 78739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    src: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
        defaultImagesKeys: [],
        label: "Select an Image"
    },
    alt: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Image description (alt)",
        translatable: true
    },
    isDecorative: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Decorative image(no alt)"
    },
    link: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Image link",
        fields: {
            href: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Image href"
            },
            isNewTab: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                label: "Open link in new tab"
            }
        }
    }
});


/***/ }),

/***/ 41667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_grid_image_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78739);
/* harmony import */ var segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75650);
/* harmony import */ var segments_desktop_core_components_button_regular_button_fields_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64054);
/* harmony import */ var segments_desktop_core_components_button_secondary_button_fields_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54237);
/* harmony import */ var segments_desktop_core_components_button_signup_button_fields_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96587);
/* harmony import */ var segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24586);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var restGridFields = _extends({}, _object_destructuring_empty(segments_desktop_core_components_grid_image_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z));
/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, restGridFields), {
    showParagraph: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Show paragraph"
    },
    fullParagraph: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Full Paragraph",
        fields: _object_spread_props(_object_spread({}, segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z), {
            buttonConfig: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.CONDITIONAL_NESTED,
                label: "Button",
                conditionalKeyName: "buttonType",
                options: [
                    {
                        text: segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_2__/* .REGULAR_BUTTON_TYPE */ .ys,
                        fieldsConfig: segments_desktop_core_components_button_regular_button_fields_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
                    },
                    {
                        text: segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_2__/* .SECONDARY_BUTTON_TYPE */ .jE,
                        fieldsConfig: segments_desktop_core_components_button_secondary_button_fields_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
                    },
                    {
                        text: segments_desktop_core_components_button_button_consts__WEBPACK_IMPORTED_MODULE_2__/* .SIGNUP_BUTTON_TYPE */ .ge,
                        fieldsConfig: segments_desktop_core_components_button_signup_button_fields_config__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z
                    }
                ]
            }
        })
    }
}));


/***/ }),

/***/ 32377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    height: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Height"
    },
    borderWidth: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Border Width"
    },
    borderColor: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Border Color"
    },
    hideScrolling: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Hide scrollbars"
    }
});


/***/ }),

/***/ 53315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    logosScale: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Logos scale"
    }
});


/***/ }),

/***/ 97909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_logos_logos_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83971);


/* harmony default export */ __webpack_exports__["Z"] = ({
    numberOfCompanies: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Number Of Companies",
        options: segments_desktop_core_components_logos_logos_const__WEBPACK_IMPORTED_MODULE_1__/* .SUPPORTED_LOGOS_NUMBER_OPTIONS */ .ly
    },
    companyField: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Company Field",
        options: segments_desktop_core_components_logos_logos_const__WEBPACK_IMPORTED_MODULE_1__/* .LOGO_COMPANY_FIELDS */ .QS
    },
    country: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Country",
        options: segments_desktop_core_components_logos_logos_const__WEBPACK_IMPORTED_MODULE_1__/* .LOGO_COMPANY_COUNTRIES */ .kZ
    },
    personalizeUsingVisitorCountry: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Personalize using visitor's country"
    },
    grayscale: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Color",
        options: [
            {
                value: true,
                text: "B&W"
            },
            {
                value: false,
                text: "Normal"
            }
        ]
    }
});


/***/ }),

/***/ 50342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77869);


/* harmony default export */ __webpack_exports__["Z"] = ({
    textSize: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Text Size",
        options: [
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM,
                text: "14px"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MS,
                text: "16px"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD,
                text: "18px (formerly 20px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG,
                text: "22px (formerly 24px)"
            }
        ]
    },
    textWidth: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Text width"
    },
    withDynamicParagraphTitle: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Dynamic paragraph Title"
    },
    withDynamicParagraphSubtitle: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Dynamic paragraph Subtitle"
    }
});


/***/ }),

/***/ 49496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_color_picker_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95947);
/* harmony import */ var constants_color_picker_constants__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(constants_color_picker_constants__WEBPACK_IMPORTED_MODULE_1__);


/* harmony default export */ __webpack_exports__["Z"] = ({
    body: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Text",
        textArea: true,
        rows: 5,
        translatable: true
    },
    bodyColor: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Text color",
        possibleColors: constants_color_picker_constants__WEBPACK_IMPORTED_MODULE_1__.textColorOptions
    }
});


/***/ }),

/***/ 81828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    name: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Name"
    },
    jobDescription: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Job Description",
        textArea: true,
        translatable: true
    },
    color: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Text Color"
    }
});


/***/ }),

/***/ 82778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_color_picker_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95947);
/* harmony import */ var _constants_color_picker_constants__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_constants_color_picker_constants__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13225);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ __webpack_exports__["Z"] = ({
    tagText: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Text",
        translatable: true
    },
    tagBackgroundColor: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Color",
        possibleColors: _constants_color_picker_constants__WEBPACK_IMPORTED_MODULE_1__.tagsSupportedColors
    },
    tagValue: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Key (DEPRECATED)",
        labelDescription: "Will be removed (copy to use case key)"
    },
    overridePageCluster: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.CLUSTERS,
        label: "Cluster key",
        labelDescription: "Key which represents the selected tag cluster"
    },
    overridePageSubCluster: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.SUB_CLUSTERS,
        label: "Use Case key",
        labelDescription: "Key which represents the selected tag use case"
    },
    galleryImage: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Gallery image",
        labelDescription: "Images carousel component related only",
        fields: _object_spread({}, components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].image.fields */ .Z.image.fields)
    },
    initiallySelected: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Initially selected"
    }
});


/***/ }),

/***/ 33129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_button_secondary_button_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54237);
/* harmony import */ var segments_desktop_core_components_button_youtube_popup_button_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6690);



/* harmony default export */ __webpack_exports__["Z"] = ({
    withSecondaryButton: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "With secondary button"
    },
    secondaryButtonConfig: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Secondary button",
        fields: segments_desktop_core_components_button_secondary_button_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
    },
    withYouTubeButton: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "With youtube button"
    },
    youTubeButtonConfig: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "YouTube button",
        fields: segments_desktop_core_components_button_youtube_popup_button_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
    },
    useMobileClusterTags: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Use mobile cluster tags"
    },
    sendClustersAsParams: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Send clusters as params"
    },
    clusterVariant: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Cluster variant (with_benefits / with_ready)"
    }
});


/***/ }),

/***/ 1117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_selectable_tag_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82778);
/* harmony import */ var segments_desktop_core_components_button_signup_button_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96587);
/* harmony import */ var segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60633);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z), {
    darkMode: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Dark mode"
    },
    width: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Max Width (%)"
    },
    gridSelectableTags: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Grid Selectable Tags",
        nestedConfig: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
            fields: _object_spread({}, segments_desktop_core_components_selectable_tag_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)
        }
    },
    buttonConfig: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Signup button config",
        fields: segments_desktop_core_components_button_signup_button_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
    },
    buttonTopMargin: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Margin above button (default 32px)"
    }
}));


/***/ }),

/***/ 77374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_side_by_side_text_and_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93097);


var background = segments_desktop_core_components_side_by_side_text_and_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"].background */ .Z.background;
/* harmony default export */ __webpack_exports__["Z"] = ({
    alignToLogo: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Align to logo (New)"
    },
    leftSizeWidth: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Override left side size"
    },
    rightSizeWidth: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Override right side size"
    },
    spaceBetweenTextAndAsset: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Horizontal space between 2 sides (desktop)"
    },
    mobileSpaceBetweenTextAndAsset: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Vertical space between 2 sides (tablet + mobile)"
    },
    background: background
});


/***/ }),

/***/ 91841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var segments_desktop_core_components_full_paragraph_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7484);
/* harmony import */ var constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65832);


/* harmony default export */ __webpack_exports__["Z"] = ({
    contentClassName: "",
    swapTextAndAssetPosition: false,
    leftSizeWidth: null,
    rightSizeWidth: null,
    background: {},
    fullParagraph: segments_desktop_core_components_full_paragraph_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    asset: {
        position: "center",
        fitToContainer: true,
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/text-and-asset/board-with-dragged-column-in-circle.png"
        }
    },
    assetQuality: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_1__.AUTO,
    withDynamicParagraphTitle: false,
    withDynamicParagraphSubtitle: false
});


/***/ }),

/***/ 93097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24586);
/* harmony import */ var segments_segments_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(861);
/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77869);
/* harmony import */ var components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13225);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var image = components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"].image */ .Z.image;
var src = image.fields.src;
var textColor = segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"].textColor */ .Z.textColor, selectedFullParagraphFields = _object_without_properties(segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, [
    "textColor"
]);
/* harmony default export */ __webpack_exports__["Z"] = ({
    swapTextAndAssetPosition: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Swap Text And Asset Position - Desktop"
    },
    mobileSwapTextAndAssetPosition: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Swap Form and Texts position - Mobile"
    },
    hideParagraph: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Hide paragraph"
    },
    paragraphVerticalAlignment: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Paragraph Vertical Alignment",
        options: [
            "top",
            "center",
            "bottom"
        ]
    },
    alignImageToScreenEdge: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Align Image To Screen Edge"
    },
    background: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Background",
        fields: {
            width: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
                label: "Width",
                options: [
                    "50%",
                    "75%",
                    "100%"
                ]
            },
            color: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                label: "Color",
                possibleColors: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .BACKGROUND_COLOR_OPTIONS */ .L6
            },
            verticalPadding: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Vertical Padding"
            },
            backgroundImage: _object_spread_props(_object_spread({}, image), {
                label: "Background image",
                fields: _object_spread_props(_object_spread({
                    backgroundPosition: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
                        label: "Background position",
                        options: [
                            "left",
                            "center",
                            "right"
                        ]
                    }
                }, image.fields), {
                    src: _object_spread_props(_object_spread({}, src), {
                        getFullUrl: true
                    })
                })
            })
        }
    },
    fullParagraph: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Full Paragraph",
        fields: selectedFullParagraphFields
    },
    titleSize: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Title Size",
        options: [
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_4__.XS,
                text: "22px (formerly 24px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_4__.SM,
                text: "28px (formerly 32px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_4__.MD,
                text: "36px (formerly 40px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_4__.LG,
                text: "44px (formerly 50px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_4__/* .LGR */ .Re,
                text: "54px (formerly 60px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_4__.XL,
                text: "64px (formerly 72px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_4__/* .XXL */ .T3,
                text: "72px (formerly 80px)"
            }
        ]
    },
    asset: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Asset",
        fields: _object_spread({
            position: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
                label: "Position",
                options: [
                    "top",
                    "center",
                    "bottom"
                ]
            },
            fitToContainer: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                label: "Fit to container"
            },
            assetHeight: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                label: "Height"
            }
        }, components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)
    }
});


/***/ }),

/***/ 25641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SideBySideTextAndAsset; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var desktop_constants = __webpack_require__(73759);
var constants_default = /*#__PURE__*/__webpack_require__.n(desktop_constants);
;// CONCATENATED MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset.scss.js




var HEADER_LOGO_HORIZONTAL_PADDING = "".concat(constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING, "px");
var BODY_HORIZONTAL_PADDING = "".concat((constants_default()).BODY_CONTENT_HORIZONTAL_PADDING, "px");
var StyledSideBySideTextAndAsset = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e43lgw60"
})("height:100%;display:flex;justify-content:center;.left-space{flex-grow:1;}.side-by-side-content{width:100%;padding:0 ", BODY_HORIZONTAL_PADDING, ";max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;flex-grow:1;position:relative;display:flex;align-items:center;gap:var(--space-between-text-and-asset);&.top{align-items:flex-start;}&.center{align-items:center;}&.bottom{align-items:flex-end;}&.is-swap{flex-direction:row-reverse;.full-paragraph-component-wrapper{padding:0 0 0 60px;}}&.align-to-logo{padding-left:", HEADER_LOGO_HORIZONTAL_PADDING, ";padding-right:", HEADER_LOGO_HORIZONTAL_PADDING, ";}.image-wrapper{position:relative;z-index:1;width:50%;}.full-paragraph-component-wrapper{position:relative;z-index:1;width:50%;&.sticky{position:sticky;align-self:flex-start;}}.image-wrapper.inside-parallax{width:100%;}.full-paragraph-component-wrapper{padding:0 60px 0 0;}.image-wrapper{overflow:hidden;display:flex;align-items:center;justify-content:center;&.with-shadow{", (0,desktop_constants.getComponentShadow)(), '}&.top{align-self:flex-start;}&.center{align-self:center;}&.bottom{align-self:flex-end;}.side-by-side-asset{height:100%;width:100%;&.ignore-parent-height{height:auto;}.picture-component{width:100%;height:100%;display:block;&:before{content:"";display:inline-block;height:100%;vertical-align:middle;}}.text-and-asset-image{max-width:100%;max-height:100%;width:auto;height:auto;display:inline-block;vertical-align:middle;position:relative;left:50%;transform:translateX(-50%);}}}&.add-live-board-experience{.image-wrapper{cursor:pointer;}}}.right-space{flex-grow:1;}@media (min-width:', vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){&.align-image-to-screen-edge{.side-by-side-content{max-width:unset;&:not(.is-swap){padding-right:0;}&.is-swap{padding-left:0;}.image-wrapper{.side-by-side-asset{.text-and-asset-image{width:100%;}}}}&:not(.is-swap){.left-space{min-width:calc((100vw - ", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px) / 2);}.right-space{display:none;}}&.is-swap{padding:0 96px 0 0;.left-space{display:none;}.right-space{min-width:calc((100vw - ", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px) / 2);}}}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.side-by-side-content,.side-by-side-content.is-swap{flex-direction:column;gap:var(--mobile-space-between-text-and-asset);&.is-mobile-swap{flex-direction:column-reverse;}&.is-full-width{padding-top:30px;padding-bottom:45px;}.full-paragraph-component-wrapper,.image-wrapper{width:100% !important;}.full-paragraph-component-wrapper{padding:0 60px 60px 60px;}.image-wrapper{height:initial;padding-bottom:16px;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){.side-by-side-content{padding:0;}.side-by-side-content,.side-by-side-content.is-swap{.full-paragraph-component-wrapper{padding:0 32px 40px 32px;}.image-wrapper{padding-left:32px !important;padding-right:32px !important;}}}.parallax-wrapper{width:50%;display:flex;flex-direction:column;}");

// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/default-props.js
var default_props = __webpack_require__(91841);
;// CONCATENATED MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var FULL_WIDTH = "100%";
var SideBySideTextAndAsset = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SideBySideTextAndAsset, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SideBySideTextAndAsset);
    function SideBySideTextAndAsset() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, SideBySideTextAndAsset);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "assetExist", function(asset) {
            var _asset_image, _asset_video;
            return (asset === null || asset === void 0 ? void 0 : (_asset_image = asset.image) === null || _asset_image === void 0 ? void 0 : _asset_image.src) || (asset === null || asset === void 0 ? void 0 : (_asset_video = asset.video) === null || _asset_video === void 0 ? void 0 : _asset_video.src);
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onVideoStart", function() {
            var _asset_video_src_formats, _asset_video_src, _asset_video;
            var asset = _this.props.asset;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.ASSET_COMPONENT_VIDEO_STARTED, {
                info1: asset === null || asset === void 0 ? void 0 : (_asset_video = asset.video) === null || _asset_video === void 0 ? void 0 : (_asset_video_src = _asset_video.src) === null || _asset_video_src === void 0 ? void 0 : (_asset_video_src_formats = _asset_video_src.formats) === null || _asset_video_src_formats === void 0 ? void 0 : _asset_video_src_formats[0]
            });
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderAsset", function(asset) {
            var _props = _this.props, ReplaceAssetComponent = _props.replaceAssetComponent, replaceAssetComponentProps = _props.replaceAssetComponentProps, assetQuality = _props.assetQuality, useDynamicAsset = _props.useDynamicAsset, hideControls = _props.hideControls, useWindowMask = _props.useWindowMask, dynamicAssetParamPath = _props.dynamicAssetParamPath;
            if (ReplaceAssetComponent) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplaceAssetComponent, _object_spread({}, replaceAssetComponentProps));
            }
            var fitToContainer = asset.fitToContainer, assetHeight = asset.assetHeight, assetRestProps = _object_without_properties(asset, [
                "fitToContainer",
                "assetHeight"
            ]);
            var assetClassName = classnames_default()("side-by-side-asset", {
                "ignore-parent-height": !fitToContainer
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread_props(_object_spread({}, assetRestProps), {
                assetQuality: assetQuality,
                useDynamicAsset: useDynamicAsset,
                hideControls: hideControls,
                useWindowMask: useWindowMask,
                dynamicAssetParamPath: dynamicAssetParamPath,
                convertGifToVideo: true,
                className: assetClassName,
                imageClassName: "text-and-asset-image",
                style: {
                    height: assetHeight
                },
                onStart: _this.onVideoStart
            }));
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getFullParagraphComponentStyle", function() {
            var _props = _this.props, leftSizeWidth = _props.leftSizeWidth, nestedBoardItems = _props.nestedBoardItems;
            var ref = nestedBoardItems !== null && nestedBoardItems !== void 0 ? nestedBoardItems : {}, fullParagraphMarginTop = ref.fullParagraphMarginTop, fullParagraphMarginBottom = ref.fullParagraphMarginBottom, fullParagraphDistanceFromTop = ref.fullParagraphDistanceFromTop, parallaxAsset = ref.parallaxAsset;
            var styleObj = {
                width: leftSizeWidth,
                marginTop: fullParagraphMarginTop,
                marginBottom: fullParagraphMarginBottom
            };
            if (_this.assetExist(parallaxAsset)) {
                styleObj = _object_spread_props(_object_spread({}, styleObj), {
                    top: fullParagraphDistanceFromTop
                });
            }
            return styleObj;
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getImageWrapperStyle", function() {
            var _props = _this.props, rightSizeWidth = _props.rightSizeWidth, allowImageOverflow = _props.allowImageOverflow;
            var style = {
                width: rightSizeWidth
            };
            if (allowImageOverflow) {
                style = _object_spread_props(_object_spread({}, style), {
                    overflow: "visible"
                });
            }
            return style;
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "openLiveBoardExperience", function() {
            var _props = _this.props, nestedBoardItems = _props.nestedBoardItems, openLiveBoard = _props.openLiveBoard;
            var ref = nestedBoardItems !== null && nestedBoardItems !== void 0 ? nestedBoardItems : {}, boardBannerText = ref.boardBannerText, embeddedBoardTitle = ref.embeddedBoardTitle, addSecondLiveBoardSignUpButton = ref.addSecondLiveBoardSignUpButton, liveBoardToolTipText = ref.liveBoardToolTipText;
            openLiveBoard({
                boardBannerText: boardBannerText,
                embeddedBoardTitle: embeddedBoardTitle,
                addSecondLiveBoardSignUpButton: addSecondLiveBoardSignUpButton,
                liveBoardToolTipText: liveBoardToolTipText
            });
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "imageClicked", function(index) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.LIVE_BOARD_PARALLAX_ASSET_CLICKED, {
                kind: index !== undefined ? index : null
            });
            _this.openLiveBoardExperience();
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getReplaceTextProps", function() {
            var _props = _this.props, bulletsConfig = _props.bulletsConfig, iconsConfig = _props.iconsConfig, titleSize = _props.titleSize, textSize = _props.textSize, spaceFromParagraph = _props.spaceFromParagraph, withDynamicParagraphTitle = _props.withDynamicParagraphTitle, withDynamicParagraphSubtitle = _props.withDynamicParagraphSubtitle, topicBottomMargin = _props.topicBottomMargin, buttonTopMargin = _props.buttonTopMargin;
            var replaceTextProps = {};
            if (bulletsConfig) replaceTextProps.bulletsConfig = bulletsConfig;
            if (iconsConfig) replaceTextProps.iconsConfig = iconsConfig;
            if (titleSize) replaceTextProps.titleSize = titleSize;
            if (textSize) replaceTextProps.textSize = textSize;
            if (spaceFromParagraph) replaceTextProps.spaceFromParagraph = spaceFromParagraph;
            if (withDynamicParagraphTitle) replaceTextProps.withDynamicParagraphTitle = withDynamicParagraphTitle;
            if (withDynamicParagraphSubtitle) replaceTextProps.withDynamicParagraphSubtitle = withDynamicParagraphSubtitle;
            if (topicBottomMargin) replaceTextProps.topicBottomMargin = topicBottomMargin;
            if (buttonTopMargin) replaceTextProps.buttonTopMargin = buttonTopMargin;
            return replaceTextProps;
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(SideBySideTextAndAsset, [
        {
            key: "getLeftSpaceStyle",
            value: function getLeftSpaceStyle() {
                var background = this.props.background;
                var color = background.color, width = background.width;
                if (!width) return {};
                var themeStyles = segments_service/* themes */.np[color];
                return _object_spread({}, themeStyles);
            }
        },
        {
            key: "getBackgroundStyle",
            value: function getBackgroundStyle() {
                var _props = this.props, background = _props.background, swapTextAndAssetPosition = _props.swapTextAndAssetPosition, spaceBetweenTextAndAsset = _props.spaceBetweenTextAndAsset;
                var width = background.width, color = background.color, verticalPadding = background.verticalPadding;
                var backgroundStyle = verticalPadding ? {
                    paddingBottom: verticalPadding,
                    paddingTop: verticalPadding
                } : {};
                var themeStyles = segments_service/* themes */.np[color];
                if (!width || !themeStyles) return backgroundStyle;
                var direction = swapTextAndAssetPosition ? "left" : "right";
                backgroundStyle = _object_spread_props(_object_spread({}, backgroundStyle), {
                    background: "linear-gradient(to ".concat(direction, ", ").concat(themeStyles.background, " ").concat(width, ", white 0)"),
                    color: themeStyles.color,
                    gap: spaceBetweenTextAndAsset
                });
                return backgroundStyle;
            }
        },
        {
            key: "getContentStyle",
            value: function getContentStyle() {
                var _props = this.props, spaceBetweenTextAndAsset = _props.spaceBetweenTextAndAsset, mobileSpaceBetweenTextAndAsset = _props.mobileSpaceBetweenTextAndAsset;
                var backgroundStyle = this.getBackgroundStyle();
                return _object_spread({
                    "--space-between-text-and-asset": spaceBetweenTextAndAsset,
                    "--mobile-space-between-text-and-asset": mobileSpaceBetweenTextAndAsset || 0
                }, backgroundStyle);
            }
        },
        {
            key: "getSideBySideComponentStyle",
            value: function getSideBySideComponentStyle() {
                var _background_backgroundImage;
                var background = this.props.background;
                var backgroundImage = background === null || background === void 0 ? void 0 : (_background_backgroundImage = background.backgroundImage) === null || _background_backgroundImage === void 0 ? void 0 : _background_backgroundImage.src;
                if (backgroundImage) {
                    var _background_backgroundImage1;
                    return {
                        background: "url(".concat(backgroundImage, ")"),
                        backgroundPosition: (background === null || background === void 0 ? void 0 : (_background_backgroundImage1 = background.backgroundImage) === null || _background_backgroundImage1 === void 0 ? void 0 : _background_backgroundImage1.backgroundPosition) || "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover"
                    };
                }
                return null;
            }
        },
        {
            key: "getRightSpaceStyle",
            value: function getRightSpaceStyle() {
                var background = this.props.background;
                var width = background.width, color = background.color;
                var themeStyles = segments_service/* themes */.np[color];
                if (!themeStyles) return {};
                return {
                    backgroundColor: width === FULL_WIDTH ? themeStyles.background : undefined
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, replaceTextComponent = _props.replaceTextComponent, replaceTextComponentProps = _props.replaceTextComponentProps, contentClassName = _props.contentClassName, fullParagraph = _props.fullParagraph, asset = _props.asset, swapTextAndAssetPosition = _props.swapTextAndAssetPosition, mobileSwapTextAndAssetPosition = _props.mobileSwapTextAndAssetPosition, background = _props.background, alignToLogo = _props.alignToLogo, paragraphVerticalAlignment = _props.paragraphVerticalAlignment, alignImageToScreenEdge = _props.alignImageToScreenEdge, hideParagraph = _props.hideParagraph, nestedBoardItems = _props.nestedBoardItems;
                var ref = nestedBoardItems !== null && nestedBoardItems !== void 0 ? nestedBoardItems : {}, addLiveBoardTextAndAsset = ref.addLiveBoardTextAndAsset, parallaxAsset = ref.parallaxAsset, gapBetweenAssets = ref.gapBetweenAssets;
                var parallaxAssetExists = this.assetExist(parallaxAsset);
                var leftSpaceStyle = swapTextAndAssetPosition ? this.getRightSpaceStyle() : this.getLeftSpaceStyle();
                var contentStyle = this.getContentStyle();
                var sideBySideComponentStyle = this.getSideBySideComponentStyle();
                var rightSpaceStyle = swapTextAndAssetPosition ? this.getLeftSpaceStyle() : this.getRightSpaceStyle();
                var ReplaceTextComponent = replaceTextComponent || full_paragraph/* default */.ZP;
                var width = background.width;
                var isFullWidth = width === FULL_WIDTH;
                var renderImage = function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("image-wrapper", asset === null || asset === void 0 ? void 0 : asset.position, (asset === null || asset === void 0 ? void 0 : asset.shadow) && "with-shadow", parallaxAssetExists && "inside-parallax"),
                        onClick: addLiveBoardTextAndAsset ? function() {
                            return _this.imageClicked(index);
                        } : null,
                        style: _this.getImageWrapperStyle(),
                        children: _this.renderAsset(image)
                    });
                };
                var assetsToRenderForParallax = [
                    asset,
                    parallaxAsset
                ];
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSideBySideTextAndAsset, {
                    className: classnames_default()("side-by-side-text-and-asset", {
                        "align-image-to-screen-edge": alignImageToScreenEdge,
                        "is-swap": swapTextAndAssetPosition,
                        "is-mobile-swap": mobileSwapTextAndAssetPosition
                    }),
                    style: sideBySideComponentStyle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "left-space",
                            style: leftSpaceStyle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("side-by-side-content", paragraphVerticalAlignment, contentClassName, {
                                "is-swap": swapTextAndAssetPosition,
                                "is-mobile-swap": mobileSwapTextAndAssetPosition,
                                "is-full-width": isFullWidth,
                                "align-to-logo": !!alignToLogo,
                                "no-text-component": hideParagraph,
                                "add-live-board-experience": addLiveBoardTextAndAsset
                            }),
                            style: contentStyle,
                            children: [
                                !hideParagraph && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("full-paragraph-component-wrapper", parallaxAssetExists && "sticky"),
                                    style: this.getFullParagraphComponentStyle(),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReplaceTextComponent, _object_spread_props(_object_spread({}, replaceTextComponentProps, fullParagraph, this.getReplaceTextProps()), {
                                        openLiveBoardExperience: addLiveBoardTextAndAsset ? this.openLiveBoardExperience : null
                                    }))
                                }),
                                parallaxAssetExists ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "parallax-wrapper",
                                    style: {
                                        gap: gapBetweenAssets
                                    },
                                    children: assetsToRenderForParallax.map(function(image, index) {
                                        return renderImage(image, index);
                                    })
                                }) : renderImage(asset)
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "right-space",
                            style: rightSpaceStyle
                        })
                    ]
                });
            }
        }
    ]);
    return SideBySideTextAndAsset;
}(react.PureComponent);

SideBySideTextAndAsset.defaultProps = default_props/* default */.Z;


/***/ }),

/***/ 73498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    tagsWidth: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Tags width (max 170px, min 140px)"
    },
    buttonConfig: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Signup Button",
        fields: {
            removeGradient: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                label: "Remove gradient"
            }
        }
    },
    showBorderInLightTheme: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Add tags border in white theme"
    },
    randomizeTags: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Randomize tags"
    }
});


/***/ }),

/***/ 22333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_button_signup_button_fields_config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96587);
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var signupWithsolutionAppReferenceId = segments_desktop_core_components_button_signup_button_fields_config_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].signupWithsolutionAppReferenceId */ .Z.signupWithsolutionAppReferenceId, signupClusterId = segments_desktop_core_components_button_signup_button_fields_config_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].signupClusterId */ .Z.signupClusterId, restSignupButtonConfig = _object_without_properties(segments_desktop_core_components_button_signup_button_fields_config_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, [
    "signupWithsolutionAppReferenceId",
    "signupClusterId"
]);
/* harmony default export */ __webpack_exports__["Z"] = ({
    theme: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Theme"
    },
    clusters: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Clusters",
        maxLimit: 9,
        nestedConfig: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
            fields: {
                text: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                    label: "Text",
                    translatable: true
                },
                image: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
                    label: "Image"
                },
                colorName: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                    label: "Color"
                },
                clusterId: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.CLUSTERS,
                    label: "Cluster Id"
                },
                useCaseId: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.SUB_CLUSTERS,
                    label: "Usecase Id"
                },
                initiallySelected: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                    label: "Initially selected"
                }
            }
        }
    },
    buttonConfig: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Signup button",
        fields: restSignupButtonConfig
    }
});


/***/ }),

/***/ 17702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_button_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75629);
/* harmony import */ var segments_desktop_core_components_title_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65621);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({
    textAlign: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Text Align",
        options: [
            {
                value: "left",
                text: "Left"
            },
            {
                value: "center",
                text: "Center"
            },
            {
                value: "right",
                text: "Right"
            }
        ]
    }
}, segments_desktop_core_components_title_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z), {
    textColor: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Text Color",
        possibleColors: [
            "brand-blue",
            "brand-pink",
            "brand-iris",
            "brand-green",
            "brand-red",
            "brand-purple"
        ]
    },
    buttonConfig: segments_desktop_core_components_button_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
}));


/***/ }),

/***/ 95760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77869);


/* harmony default export */ __webpack_exports__["Z"] = ({
    titleSize: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Title Size",
        options: [
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XS,
                text: "22px (formerly 24px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM,
                text: "28px (formerly 32px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD,
                text: "36px (formerly 40px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG,
                text: "44px (formerly 50px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .LGR */ .Re,
                text: "54px (formerly 60px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XL,
                text: "64px (formerly 72px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXL */ .T3,
                text: "72px (formerly 80px)"
            }
        ]
    },
    titleMinWidth: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Title min width"
    },
    titleWidth: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Title max width"
    }
});


/***/ }),

/***/ 65621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    title: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Title",
        textArea: true,
        translatable: true
    },
    titleColor: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Title color"
    }
});


/***/ }),

/***/ 17071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ embedded; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/whats-new-items-list-embedded/whats-new-items-list-embedded-config.js


var FILTERED_PRODUCTS = products/* PRODUCT_OPTIONS.slice */.ey.slice(0, 2);
/* harmony default export */ var whats_new_items_list_embedded_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Whats New Items List",
    fields: {
        productFilterValue: {
            label: "Product Filter Value",
            type: template_field_type.FIELD_TYPES.COMBO,
            options: FILTERED_PRODUCTS
        },
        hideProductFilter: {
            label: "Hide Product Filter",
            type: template_field_type.FIELD_TYPES.BOOLEAN
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/whats-new-items-list-embedded/whats-new-items-list-embedded-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var whats_new_items_list_embedded_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/whats-new-items-list-embedded/index.js

var WhatsNewItemsListEmbeddedComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3966), __webpack_require__.e(9832)]).then(__webpack_require__.bind(__webpack_require__, 12357));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12357)
            ];
        }
    }
});


/* harmony default export */ var whats_new_items_list_embedded = ({
    WhatsNewItemsListEmbeddedComponent: WhatsNewItemsListEmbeddedComponent,
    WhatsNewItemsListEmbeddedConfig: whats_new_items_list_embedded_config,
    WhatsNewItemsListEmbeddedAdvancedConfig: whats_new_items_list_embedded_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/markdown/fields-config.js

/* harmony default export */ var fields_config = ({
    input: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Markdown content",
        textArea: true,
        rows: 15
    }
});

;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/markdown-embedded/markdown-embedded-config.js
function markdown_embedded_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function markdown_embedded_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            markdown_embedded_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var markdown_embedded_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Markdown",
    fields: markdown_embedded_config_object_spread({}, fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/markdown-embedded/markdown-embedded-advanced-config.js
function markdown_embedded_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function markdown_embedded_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            markdown_embedded_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var markdown_embedded_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: markdown_embedded_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/markdown-embedded/index.js



var MarkdownEmbeddedComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8840).then(__webpack_require__.bind(__webpack_require__, 8840));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8840)
            ];
        }
    }
});
/* harmony default export */ var markdown_embedded = ({
    MarkdownEmbeddedComponent: MarkdownEmbeddedComponent,
    MarkdownEmbeddedConfig: markdown_embedded_config,
    MarkdownEmbeddedAdvancedConfig: markdown_embedded_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/index.js
// plop_marker:layouts_import


/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    WhatsNewItemsListEmbedded: whats_new_items_list_embedded,
    MarkdownEmbedded: markdown_embedded
});

;// CONCATENATED MODULE: ./segments/desktop/embedded/index.js

var WhatsNewItemsListEmbedded = layouts.WhatsNewItemsListEmbedded, MarkdownEmbedded = layouts.MarkdownEmbedded;
/* harmony default export */ var embedded = ({
    // plop_marker:segment_index_add_layout
    WhatsNewItemsListEmbeddedComponent: {
        type: "WhatsNewItemsListEmbeddedComponent",
        title: "Whats New Items List",
        imgSrc: "/static/img/segments/layouts/whats-new-items-list-embedded.png",
        config: WhatsNewItemsListEmbedded.WhatsNewItemsListEmbeddedConfig,
        advancedConfig: WhatsNewItemsListEmbedded.WhatsNewItemsListEmbeddedAdvancedConfig,
        component: WhatsNewItemsListEmbedded.WhatsNewItemsListEmbeddedComponent
    },
    MarkdownEmbeddedComponent: {
        type: "MarkdownEmbeddedComponent",
        title: "Markdown",
        imgSrc: "/static/img/segments/layouts/markdown-embedded.png",
        config: MarkdownEmbedded.MarkdownEmbeddedConfig,
        advancedConfig: MarkdownEmbedded.MarkdownEmbeddedAdvancedConfig,
        component: MarkdownEmbedded.MarkdownEmbeddedComponent
    }
});


/***/ }),

/***/ 26647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ enterprise; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var fields_config = __webpack_require__(24586);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/proof-and-badges-enterprise/proof-and-badges-enterprise-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var proof_and_badges_enterprise_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Proof And Badges",
    fields: _object_spread_props(_object_spread({}, theme_config/* default */.Z), {
        proofsSection: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Proofs Section",
            fields: {
                backgroundImage: {
                    type: template_field_type.FIELD_TYPES.GALLERY,
                    label: "Background Image"
                },
                proofs: {
                    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Proofs",
                    nestedConfig: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: _object_spread({}, fields_config/* default */.Z, advanced_fields_config/* default */.Z)
                    }
                }
            }
        },
        badgesSection: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Badges Section",
            fields: {
                badgesSections: {
                    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Badges Sections",
                    nestedConfig: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: {
                            icon: {
                                type: template_field_type.FIELD_TYPES.GALLERY,
                                label: "Icon"
                            },
                            title: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Title"
                            },
                            description: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Description"
                            },
                            badges: {
                                type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                                label: "Badges",
                                nestedConfig: {
                                    type: template_field_type.FIELD_TYPES.NESTED,
                                    fields: {
                                        badgeImage: {
                                            type: template_field_type.FIELD_TYPES.GALLERY,
                                            label: "Badge"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(77374);
;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/proof-and-badges-enterprise/proof-and-badges-enterprise-advanced-config.js
function proof_and_badges_enterprise_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function proof_and_badges_enterprise_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            proof_and_badges_enterprise_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function proof_and_badges_enterprise_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function proof_and_badges_enterprise_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        proof_and_badges_enterprise_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var proof_and_badges_enterprise_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: proof_and_badges_enterprise_advanced_config_object_spread_props(proof_and_badges_enterprise_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        sideBySideAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Side by side advanced props",
            fields: proof_and_badges_enterprise_advanced_config_object_spread({}, advanced_field_config/* default */.Z)
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/proof-and-badges-enterprise/index.js

var ProofAndBadgesEnterpriseComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8451).then(__webpack_require__.bind(__webpack_require__, 68451));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68451)
            ];
        }
    }
});


/* harmony default export */ var proof_and_badges_enterprise = ({
    ProofAndBadgesEnterpriseComponent: ProofAndBadgesEnterpriseComponent,
    ProofAndBadgesEnterpriseConfig: proof_and_badges_enterprise_config,
    ProofAndBadgesEnterpriseAdvancedConfig: proof_and_badges_enterprise_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/button-tag/fields-config.js
var button_tag_fields_config = __webpack_require__(24662);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var title_fields_config = __webpack_require__(65621);
;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/sales-phone-enterprise/sales-phone-enterprise-config.js
function sales_phone_enterprise_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sales_phone_enterprise_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sales_phone_enterprise_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function sales_phone_enterprise_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sales_phone_enterprise_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sales_phone_enterprise_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var sales_phone_enterprise_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Sales Phone (NOT DISPLAYED IN THE US)",
    fields: sales_phone_enterprise_config_object_spread_props(sales_phone_enterprise_config_object_spread({}, title_fields_config/* default */.Z), {
        phoneLinks: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Phone numbers",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: sales_phone_enterprise_config_object_spread({}, button_tag_fields_config/* default */.Z)
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/sales-phone-enterprise/sales-phone-enterprise-advanced-config.js
function sales_phone_enterprise_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sales_phone_enterprise_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sales_phone_enterprise_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var sales_phone_enterprise_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: sales_phone_enterprise_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/sales-phone-enterprise/index.js



var SalesPhoneEnterpriseComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7398).then(__webpack_require__.bind(__webpack_require__, 7398));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7398)
            ];
        }
    }
});
/* harmony default export */ var sales_phone_enterprise = ({
    SalesPhoneEnterpriseComponent: SalesPhoneEnterpriseComponent,
    SalesPhoneEnterpriseConfig: sales_phone_enterprise_config,
    SalesPhoneEnterpriseAdvancedConfig: sales_phone_enterprise_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/asymmetric-enterprise/asymmetric-enterprise-config.js
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}


var selectedFullParagraphFields = _extends({}, _object_destructuring_empty(fields_config/* default */.Z));
/* harmony default export */ var asymmetric_enterprise_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Asymmetric",
    fields: {
        topColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Top Color"
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: selectedFullParagraphFields
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/asymmetric-enterprise/asymmetric-enterprise-advanced-config.js
function asymmetric_enterprise_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function asymmetric_enterprise_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            asymmetric_enterprise_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var asymmetric_enterprise_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: asymmetric_enterprise_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/asymmetric-enterprise/index.js



var AsymmetricEnterpriseComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3640).then(__webpack_require__.bind(__webpack_require__, 43640));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43640)
            ];
        }
    }
});
/* harmony default export */ var asymmetric_enterprise = ({
    AsymmetricEnterpriseComponent: AsymmetricEnterpriseComponent,
    AsymmetricEnterpriseConfig: asymmetric_enterprise_config,
    AsymmetricEnterpriseAdvancedConfig: asymmetric_enterprise_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/index.js
// plop_marker:layouts_import



/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    ProofAndBadgesEnterprise: proof_and_badges_enterprise,
    SalesPhoneEnterprise: sales_phone_enterprise,
    AsymmetricEnterprise: asymmetric_enterprise
});

;// CONCATENATED MODULE: ./segments/desktop/enterprise/index.js

var ProofAndBadgesEnterprise = layouts.ProofAndBadgesEnterprise, SalesPhoneEnterprise = layouts.SalesPhoneEnterprise, AsymmetricEnterprise = layouts.AsymmetricEnterprise;
/* harmony default export */ var enterprise = ({
    // plop_marker:segment_index_add_layout
    ProofAndBadgesEnterpriseComponent: {
        type: "ProofAndBadgesEnterpriseComponent",
        title: "Proof And Badges",
        imgSrc: "/static/img/segments/layouts/proof-and-badges-enterprise.png",
        config: ProofAndBadgesEnterprise.ProofAndBadgesEnterpriseConfig,
        advancedConfig: ProofAndBadgesEnterprise.ProofAndBadgesEnterpriseAdvancedConfig,
        component: ProofAndBadgesEnterprise.ProofAndBadgesEnterpriseComponent
    },
    SalesPhoneEnterpriseComponent: {
        type: "SalesPhoneEnterpriseComponent",
        title: "Sales Phone",
        imgSrc: "/static/img/segments/layouts/sales-phone-enterprise.png",
        config: SalesPhoneEnterprise.SalesPhoneEnterpriseConfig,
        advancedConfig: SalesPhoneEnterprise.SalesPhoneEnterpriseAdvancedConfig,
        component: SalesPhoneEnterprise.SalesPhoneEnterpriseComponent
    },
    AsymmetricEnterpriseComponent: {
        type: "AsymmetricEnterpriseComponent",
        title: "Asymmetric",
        imgSrc: "/static/img/segments/layouts/asymmetric-enterprise.png",
        config: AsymmetricEnterprise.AsymmetricEnterpriseConfig,
        advancedConfig: AsymmetricEnterprise.AsymmetricEnterpriseAdvancedConfig,
        component: AsymmetricEnterprise.AsymmetricEnterpriseComponent
    }
});


/***/ }),

/***/ 91805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ desktop_form; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./client/services/hubspot-service/hubspot-constants.js
var hubspot_constants = __webpack_require__(22638);
// EXTERNAL MODULE: ./client/services/hubspot-service/contact-form-config.js + 1 modules
var contact_form_config = __webpack_require__(49228);
;// CONCATENATED MODULE: ./segments/desktop/core-components/hubspot-contact-form/fields-config.js



var CONTACT_SALES_TEXT = "Contact Sales (".concat(contact_form_config/* CONTACT_SALES_HUBSPOT_FORM_ID */.PD, ")");
var REQUEST_A_DEMO_TEXT = "Request a Demo (".concat(contact_form_config/* REQUEST_A_DEMO_HUBSPOT_FORM_ID */.pO, ")");
var REPORT_FORM_TEXT = "Download form (".concat(contact_form_config/* REPORT_FORM_ID */.F0, ")");
var NURTURE_CONTUCT_US_TEXT = "Nurture - contact us form (".concat(contact_form_config/* NURTURE_CONTACT_US_FORM_ID */.f, ")");
var EMAIL_ONLY_TEXT = "Email only - contact us form (".concat(contact_form_config/* EMAIL_ONLY_FORM_ID */.Qo, ")");
var EVENTS_TEXT = "Events - contact us form (".concat(contact_form_config/* EMAIL_ONLY_FORM_ID */.Qo, ")");
/* harmony default export */ var fields_config = ({
    formId: {
        type: template_field_type.FIELD_TYPES.COMBO,
        options: [
            {
                value: contact_form_config/* CONTACT_SALES_HUBSPOT_FORM_ID */.PD,
                text: CONTACT_SALES_TEXT
            },
            {
                value: contact_form_config/* REQUEST_A_DEMO_HUBSPOT_FORM_ID */.pO,
                text: REQUEST_A_DEMO_TEXT
            },
            {
                value: contact_form_config/* REPORT_FORM_ID */.F0,
                text: REPORT_FORM_TEXT
            },
            {
                value: contact_form_config/* NURTURE_CONTACT_US_FORM_ID */.f,
                text: NURTURE_CONTUCT_US_TEXT
            },
            {
                value: contact_form_config/* EMAIL_ONLY_FORM_ID */.Qo,
                text: EMAIL_ONLY_TEXT
            },
            {
                value: contact_form_config/* EVENTS_HUBSPOT_FORM_ID */.yF,
                text: EVENTS_TEXT
            }
        ],
        label: "Form ID"
    },
    source: {
        type: template_field_type.FIELD_TYPES.COMBO,
        label: "Lead Source",
        options: hubspot_constants/* leadSourceConfigList */.L_
    },
    formTitle: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Form Title"
    },
    formSubTitle: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Form SubTitle"
    },
    urlToRedirectAfterSubmission: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "URL to redirect after submission"
    },
    dontRenderPostFormSubmit: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Don't render post form submit"
    },
    splitForm: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Use split form (in test - don't use)"
    },
    timeoutForEnrichment: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Timeout for enrichment (in test - don't use)"
    },
    debounceTimeForEnrichment: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Debounce time for enrichment (in test - don't use)"
    }
});

// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var asset_fields_config = __webpack_require__(13225);
;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-on-dark-background-form/hubspot-on-dark-background-form-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var hubspot_on_dark_background_form_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Hubspot On Dark Background",
    fields: _object_spread_props(_object_spread({}, fields_config), {
        LeftSideContent: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Left Side Content",
            fields: {
                title: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Title"
                },
                subTitle: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Sub Title"
                },
                valuesList: {
                    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Values List",
                    nestedConfig: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: {
                            value: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Value"
                            }
                        }
                    }
                },
                sentenceAboveLogos: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Sentence Above Logos"
                },
                logos: {
                    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Logos",
                    nestedConfig: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: _object_spread({}, asset_fields_config/* default.image.fields */.Z.image.fields)
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-on-dark-background-form/hubspot-on-dark-background-form-advanced-config.js
function hubspot_on_dark_background_form_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_on_dark_background_form_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_on_dark_background_form_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var hubspot_on_dark_background_form_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: hubspot_on_dark_background_form_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-on-dark-background-form/index.js

var HubspotOnDarkBackgroundFormComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(7784), __webpack_require__.e(5157), __webpack_require__.e(493)]).then(__webpack_require__.bind(__webpack_require__, 40493));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40493)
            ];
        }
    }
});


/* harmony default export */ var hubspot_on_dark_background_form = ({
    HubspotOnDarkBackgroundFormComponent: HubspotOnDarkBackgroundFormComponent,
    HubspotOnDarkBackgroundFormConfig: hubspot_on_dark_background_form_config,
    HubspotOnDarkBackgroundFormAdvancedConfig: hubspot_on_dark_background_form_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/monday-form-form/monday-form-form-config.js

/* harmony default export */ var monday_form_form_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Monday Form",
    fields: {
        formId: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Monday form ID",
            labelDescription: "Monday form ID is the identifier you could find in the monday form url: https://forms.monday.com/forms/<formId>"
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/core-components/iframe/advanced-field-config.js
var advanced_field_config = __webpack_require__(32377);
;// CONCATENATED MODULE: ./segments/desktop/form/layouts/monday-form-form/monday-form-form-advanced-config.js
function monday_form_form_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function monday_form_form_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            monday_form_form_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var height = advanced_field_config/* default.height */.Z.height, otherIFrameAdvancedFieldsConfig = _object_without_properties(advanced_field_config/* default */.Z, [
    "height"
]);
/* harmony default export */ var monday_form_form_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: monday_form_form_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, otherIFrameAdvancedFieldsConfig)
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/monday-form-form/index.js



var MondayFormFormComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4314).then(__webpack_require__.bind(__webpack_require__, 84314));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84314)
            ];
        }
    }
});
/* harmony default export */ var monday_form_form = ({
    MondayFormFormComponent: MondayFormFormComponent,
    MondayFormFormConfig: monday_form_form_config,
    MondayFormFormAdvancedConfig: monday_form_form_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/logos/components/logos-title/fields-config.js
var logos_title_fields_config = __webpack_require__(74606);
// EXTERNAL MODULE: ./segments/desktop/core-components/logos/fields-config.js
var logos_fields_config = __webpack_require__(97909);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var title_advanced_field_config = __webpack_require__(95760);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/fields-config.js
var side_by_side_text_and_asset_fields_config = __webpack_require__(93097);
// EXTERNAL MODULE: ./constants/customer-quotes.js
var customer_quotes = __webpack_require__(64265);
;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-with-bullets-side-by-side-form/hubspot-with-bullets-side-by-side-form-config.js
function hubspot_with_bullets_side_by_side_form_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_with_bullets_side_by_side_form_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_with_bullets_side_by_side_form_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hubspot_with_bullets_side_by_side_form_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function hubspot_with_bullets_side_by_side_form_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        hubspot_with_bullets_side_by_side_form_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var titleSize = title_advanced_field_config/* default.titleSize */.Z.titleSize;
var swapTextAndAssetPosition = side_by_side_text_and_asset_fields_config/* default.swapTextAndAssetPosition */.Z.swapTextAndAssetPosition, mobileSwapTextAndAssetPosition = side_by_side_text_and_asset_fields_config/* default.mobileSwapTextAndAssetPosition */.Z.mobileSwapTextAndAssetPosition;
/* harmony default export */ var hubspot_with_bullets_side_by_side_form_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Hubspot With Bullets Side By Side",
    fields: hubspot_with_bullets_side_by_side_form_config_object_spread_props(hubspot_with_bullets_side_by_side_form_config_object_spread({}, fields_config), {
        swapTextAndAssetPosition: swapTextAndAssetPosition,
        mobileSwapTextAndAssetPosition: mobileSwapTextAndAssetPosition,
        title: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Title",
            translatable: true
        },
        titleSize: titleSize,
        benefits: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Benefits",
            maxLimit: 3,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    icon: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Icon"
                    },
                    title: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Title",
                        translatable: true
                    },
                    description: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Description",
                        translatable: true
                    }
                }
            }
        },
        hideSupportStatement: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Hide support statement"
        },
        customerQuoteKey: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Customer Quote",
            options: [
                {
                    value: customer_quotes/* CUSTOMER_KEY_OSCAR */.Nz,
                    text: "Oscar - Work OS saves time and money"
                },
                {
                    value: customer_quotes/* CUSTOMER_KEY_THE_STUDENT_HOTEL */.iV,
                    text: "The Student Hotel - Work OS provides a trustful overview"
                },
                {
                    value: customer_quotes/* CUSTOMER_KEY_TELEFONICA */.tx,
                    text: "Telefonica - 30% more efficient in campaign delivering"
                },
                {
                    value: customer_quotes/* CUSTOMER_KEY_ZIPPO */.bd,
                    text: "Zippo - launch projects and expand to new markets in less time"
                },
                {
                    value: customer_quotes/* CUSTOMER_KEY_NISSAN */.vK,
                    text: "Nissan - been given confidence to provide management information"
                }
            ]
        },
        logosTitle: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos title",
            fields: logos_title_fields_config/* default */.Z
        },
        logos: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos",
            fields: logos_fields_config/* default */.Z
        }
    })
});

// EXTERNAL MODULE: ./constants/sales/campaigns.js
var campaigns = __webpack_require__(44363);
;// CONCATENATED MODULE: ./segments/desktop/core-components/hubspot-contact-form/advanced-fields-config.js


/* harmony default export */ var advanced_fields_config = ({
    overrideCampaignId: {
        type: template_field_type.FIELD_TYPES.COMBO,
        options: [
            {
                value: campaigns/* IPO_CAMPAIGN_ID */.Q,
                text: "IPO promotion"
            },
            {
                value: campaigns/* GARTNER_CAMPAIGN_ID */.S,
                text: "Gartner campaign"
            }
        ],
        label: "Override campaign"
    },
    lastNameFirst: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Place Last Name before First Name"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-with-bullets-side-by-side-form/hubspot-with-bullets-side-by-side-form-advanced-config.js
function hubspot_with_bullets_side_by_side_form_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_with_bullets_side_by_side_form_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_with_bullets_side_by_side_form_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hubspot_with_bullets_side_by_side_form_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function hubspot_with_bullets_side_by_side_form_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        hubspot_with_bullets_side_by_side_form_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var hubspot_with_bullets_side_by_side_form_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: hubspot_with_bullets_side_by_side_form_advanced_config_object_spread_props(hubspot_with_bullets_side_by_side_form_advanced_config_object_spread(hubspot_with_bullets_side_by_side_form_advanced_config_object_spread_props(hubspot_with_bullets_side_by_side_form_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        }
    }), advanced_fields_config), {
        backgroundLayers: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Background layers",
            options: [
                {
                    value: 0,
                    text: "0"
                },
                {
                    value: 1,
                    text: "1"
                },
                {
                    value: 2,
                    text: "2"
                },
                {
                    value: 3,
                    text: "3"
                }
            ]
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-with-bullets-side-by-side-form/index.js



var HubspotWithBulletsSideBySideFormComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(9112), __webpack_require__.e(7784), __webpack_require__.e(5157), __webpack_require__.e(62)]).then(__webpack_require__.bind(__webpack_require__, 24155));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24155)
            ];
        }
    }
});
/* harmony default export */ var hubspot_with_bullets_side_by_side_form = ({
    HubspotWithBulletsSideBySideFormComponent: HubspotWithBulletsSideBySideFormComponent,
    HubspotWithBulletsSideBySideFormConfig: hubspot_with_bullets_side_by_side_form_config,
    HubspotWithBulletsSideBySideFormAdvancedConfig: hubspot_with_bullets_side_by_side_form_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
// EXTERNAL MODULE: ./segments/desktop/core-components/logos/logos-const.js
var logos_const = __webpack_require__(83971);
;// CONCATENATED MODULE: ./segments/desktop/core-components/paragraph-and-logos/fields-config.js




logos_fields_config/* default.numberOfCompanies.options */.Z.numberOfCompanies.options = logos_const/* SUPPORTED_LOGOS_NUMBER_FOR_NARROW_DISPLAY_OPTIONS */.WX; // override options
/* harmony default export */ var paragraph_and_logos_fields_config = ({
    fullParagraph: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Paragraph",
        fields: full_paragraph_fields_config/* default */.Z
    },
    logos: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Logos",
        fields: logos_fields_config/* default */.Z
    },
    marginBetweenParagraphAndLogos: {
        // Not in advanced since the import of advanced doesn't work well with nested
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Margin between paragraph and logos"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-and-logos-form/hubspot-and-logos-form-config.js
function hubspot_and_logos_form_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_and_logos_form_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_and_logos_form_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hubspot_and_logos_form_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function hubspot_and_logos_form_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        hubspot_and_logos_form_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var hubspot_and_logos_form_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Hubspot And Logos",
    fields: hubspot_and_logos_form_config_object_spread_props(hubspot_and_logos_form_config_object_spread({}, fields_config), {
        paragraphAndLogos: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph and Logos",
            fields: paragraph_and_logos_fields_config
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/logos/advanced-fields-config.js
var logos_advanced_fields_config = __webpack_require__(53315);
;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-and-logos-form/hubspot-and-logos-form-advanced-config.js
function hubspot_and_logos_form_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_and_logos_form_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_and_logos_form_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hubspot_and_logos_form_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function hubspot_and_logos_form_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        hubspot_and_logos_form_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var hubspot_and_logos_form_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: hubspot_and_logos_form_advanced_config_object_spread_props(hubspot_and_logos_form_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_fields_config), {
        logosAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos Advanced Props",
            fields: logos_advanced_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-and-logos-form/index.js



var HubspotAndLogosFormComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(9112), __webpack_require__.e(7784), __webpack_require__.e(5157), __webpack_require__.e(3882)]).then(__webpack_require__.bind(__webpack_require__, 80569));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80569)
            ];
        }
    }
});
/* harmony default export */ var hubspot_and_logos_form = ({
    HubspotAndLogosFormComponent: HubspotAndLogosFormComponent,
    HubspotAndLogosFormConfig: hubspot_and_logos_form_config,
    HubspotAndLogosFormAdvancedConfig: hubspot_and_logos_form_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/zendesk-side-by-side-form/zendesk-side-by-side-form-config.js
function zendesk_side_by_side_form_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = zendesk_side_by_side_form_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function zendesk_side_by_side_form_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var fullParagraph = side_by_side_text_and_asset_fields_config/* default.fullParagraph */.Z.fullParagraph, selectedSideBySideTextAndAssetFieldsConfig = zendesk_side_by_side_form_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "fullParagraph"
]);
/* harmony default export */ var zendesk_side_by_side_form_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Zendesk Side By Side",
    fields: selectedSideBySideTextAndAssetFieldsConfig
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/zendesk-side-by-side-form/zendesk-side-by-side-form-advanced-config.js
function zendesk_side_by_side_form_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function zendesk_side_by_side_form_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            zendesk_side_by_side_form_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var zendesk_side_by_side_form_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: zendesk_side_by_side_form_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/zendesk-side-by-side-form/index.js



var ZendeskSideBySideFormComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7784), __webpack_require__.e(4454)]).then(__webpack_require__.bind(__webpack_require__, 84454));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84454)
            ];
        }
    }
});
/* harmony default export */ var zendesk_side_by_side_form = ({
    ZendeskSideBySideFormComponent: ZendeskSideBySideFormComponent,
    ZendeskSideBySideFormConfig: zendesk_side_by_side_form_config,
    ZendeskSideBySideFormAdvancedConfig: zendesk_side_by_side_form_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/zendesk-form/zendesk-form-config.js

/* harmony default export */ var zendesk_form_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Zendesk",
    fields: {}
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/zendesk-form/zendesk-form-advanced-config.js
function zendesk_form_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function zendesk_form_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            zendesk_form_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var zendesk_form_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: zendesk_form_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/zendesk-form/index.js



var ZendeskFormComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7784), __webpack_require__.e(1441)]).then(__webpack_require__.bind(__webpack_require__, 11441));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11441)
            ];
        }
    }
});
/* harmony default export */ var zendesk_form = ({
    ZendeskFormComponent: ZendeskFormComponent,
    ZendeskFormConfig: zendesk_form_config,
    ZendeskFormAdvancedConfig: zendesk_form_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-side-by-side-form/hubspot-side-by-side-form-config.js
function hubspot_side_by_side_form_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_side_by_side_form_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_side_by_side_form_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hubspot_side_by_side_form_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = hubspot_side_by_side_form_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function hubspot_side_by_side_form_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var hubspot_side_by_side_form_config_fullParagraph = side_by_side_text_and_asset_fields_config/* default.fullParagraph */.Z.fullParagraph, hubspot_side_by_side_form_config_selectedSideBySideTextAndAssetFieldsConfig = hubspot_side_by_side_form_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "fullParagraph"
]);
/* harmony default export */ var hubspot_side_by_side_form_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Hubspot Form Side By Side",
    fields: hubspot_side_by_side_form_config_object_spread({}, fields_config, hubspot_side_by_side_form_config_selectedSideBySideTextAndAssetFieldsConfig)
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-side-by-side-form/hubspot-side-by-side-form-advanced-config.js
function hubspot_side_by_side_form_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_side_by_side_form_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_side_by_side_form_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hubspot_side_by_side_form_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function hubspot_side_by_side_form_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        hubspot_side_by_side_form_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var hubspot_side_by_side_form_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: hubspot_side_by_side_form_advanced_config_object_spread(hubspot_side_by_side_form_advanced_config_object_spread_props(hubspot_side_by_side_form_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        }
    }), advanced_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-side-by-side-form/index.js



var HubspotSideBySideFormComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(7784), __webpack_require__.e(5157), __webpack_require__.e(4420)]).then(__webpack_require__.bind(__webpack_require__, 34420));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34420)
            ];
        }
    }
});
/* harmony default export */ var hubspot_side_by_side_form = ({
    HubspotSideBySideFormComponent: HubspotSideBySideFormComponent,
    HubspotSideBySideFormConfig: hubspot_side_by_side_form_config,
    HubspotSideBySideFormAdvancedConfig: hubspot_side_by_side_form_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/index.js
// plop_marker:layouts_import







/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    HubspotOnDarkBackgroundForm: hubspot_on_dark_background_form,
    MondayFormForm: monday_form_form,
    HubspotWithBulletsSideBySideForm: hubspot_with_bullets_side_by_side_form,
    HubspotAndLogosForm: hubspot_and_logos_form,
    ZendeskSideBySideForm: zendesk_side_by_side_form,
    ZendeskForm: zendesk_form,
    HubspotSideBySideForm: hubspot_side_by_side_form
});

;// CONCATENATED MODULE: ./segments/desktop/form/index.js

var HubspotOnDarkBackgroundForm = layouts.HubspotOnDarkBackgroundForm, MondayFormForm = layouts.MondayFormForm, HubspotWithBulletsSideBySideForm = layouts.HubspotWithBulletsSideBySideForm, HubspotAndLogosForm = layouts.HubspotAndLogosForm, ZendeskSideBySideForm = layouts.ZendeskSideBySideForm, ZendeskForm = layouts.ZendeskForm, HubspotSideBySideForm = layouts.HubspotSideBySideForm;
/* harmony default export */ var desktop_form = ({
    // plop_marker:segment_index_add_layout
    HubspotOnDarkBackgroundFormComponent: {
        type: "HubspotOnDarkBackgroundFormComponent",
        title: "Hubspot On Dark Background",
        imgSrc: "/static/img/segments/layouts/hubspot-on-dark-background-form.png",
        config: HubspotOnDarkBackgroundForm.HubspotOnDarkBackgroundFormConfig,
        advancedConfig: HubspotOnDarkBackgroundForm.HubspotOnDarkBackgroundFormAdvancedConfig,
        component: HubspotOnDarkBackgroundForm.HubspotOnDarkBackgroundFormComponent
    },
    MondayFormFormComponent: {
        type: "MondayFormFormComponent",
        title: "Monday Form",
        imgSrc: "/static/img/segments/layouts/monday-form-form.png",
        config: MondayFormForm.MondayFormFormConfig,
        advancedConfig: MondayFormForm.MondayFormFormAdvancedConfig,
        component: MondayFormForm.MondayFormFormComponent
    },
    HubspotWithBulletsSideBySideFormComponent: {
        type: "HubspotWithBulletsSideBySideFormComponent",
        title: "Hubspot With Bullets Side By Side",
        imgSrc: "/static/img/segments/layouts/hubspot-with-bullets-side-by-side-form.png",
        config: HubspotWithBulletsSideBySideForm.HubspotWithBulletsSideBySideFormConfig,
        advancedConfig: HubspotWithBulletsSideBySideForm.HubspotWithBulletsSideBySideFormAdvancedConfig,
        component: HubspotWithBulletsSideBySideForm.HubspotWithBulletsSideBySideFormComponent
    },
    HubspotAndLogosFormComponent: {
        type: "HubspotAndLogosFormComponent",
        title: "Hubspot And Logos",
        imgSrc: "/static/img/segments/layouts/hubspot-and-logos-form.png",
        config: HubspotAndLogosForm.HubspotAndLogosFormConfig,
        advancedConfig: HubspotAndLogosForm.HubspotAndLogosFormAdvancedConfig,
        component: HubspotAndLogosForm.HubspotAndLogosFormComponent
    },
    ZendeskSideBySideFormComponent: {
        type: "ZendeskSideBySideFormComponent",
        title: "Zendesk Side By Side",
        imgSrc: "/static/img/segments/layouts/zendesk-side-by-side-form.png",
        config: ZendeskSideBySideForm.ZendeskSideBySideFormConfig,
        advancedConfig: ZendeskSideBySideForm.ZendeskSideBySideFormAdvancedConfig,
        component: ZendeskSideBySideForm.ZendeskSideBySideFormComponent
    },
    ZendeskFormComponent: {
        type: "ZendeskFormComponent",
        title: "Zendesk",
        imgSrc: "/static/img/segments/layouts/zendesk-form.png",
        config: ZendeskForm.ZendeskFormConfig,
        advancedConfig: ZendeskForm.ZendeskFormAdvancedConfig,
        component: ZendeskForm.ZendeskFormComponent
    },
    HubspotSideBySideFormComponent: {
        type: "HubspotSideBySideFormComponent",
        title: "Hubspot Side By Side",
        imgSrc: "/static/img/segments/layouts/hubspot-side-by-side-form.png",
        config: HubspotSideBySideForm.HubspotSideBySideFormConfig,
        advancedConfig: HubspotSideBySideForm.HubspotSideBySideFormAdvancedConfig,
        component: HubspotSideBySideForm.HubspotSideBySideFormComponent
    }
});


/***/ }),

/***/ 67986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ grid; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tag/fields-config.js
var fields_config = __webpack_require__(82778);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/carousel-selectable-product-cards-grid-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var galleryImage = fields_config/* default.galleryImage */.Z.galleryImage, initiallySelected = fields_config/* default.initiallySelected */.Z.initiallySelected, tagValue = fields_config/* default.tagValue */.Z.tagValue, tagBackgroundColor = fields_config/* default.tagBackgroundColor */.Z.tagBackgroundColor, tagConfig = _object_without_properties(fields_config/* default */.Z, [
    "galleryImage",
    "initiallySelected",
    "tagValue",
    "tagBackgroundColor"
]);
/* harmony default export */ var carousel_selectable_product_cards_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Carousel Selectable Product Cards",
    fields: _object_spread_props(_object_spread({}, theme_config/* default */.Z), {
        cards: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Cards",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                label: "Card tag",
                fields: {
                    tag: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: tagConfig
                    },
                    cardAsset: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Card Asset"
                    },
                    useCases: {
                        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                        label: "Use cases",
                        nestedConfig: {
                            type: template_field_type.FIELD_TYPES.NESTED,
                            fields: {
                                useCase: {
                                    type: template_field_type.FIELD_TYPES.TEXT,
                                    label: "Use cases"
                                }
                            }
                        }
                    },
                    productType: {
                        type: template_field_type.FIELD_TYPES.PRODUCTS,
                        label: "Product type"
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/carousel-selectable-product-cards-grid-advanced-config.js
function carousel_selectable_product_cards_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function carousel_selectable_product_cards_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carousel_selectable_product_cards_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function carousel_selectable_product_cards_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function carousel_selectable_product_cards_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        carousel_selectable_product_cards_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var autoPlay = {
    type: template_field_type.FIELD_TYPES.CONDITIONAL_NESTED,
    label: "Carousel auto play",
    conditionalKeyName: "enable",
    options: [
        {
            text: "True",
            fieldsConfig: {
                autoplaySpeed: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Auto play speed"
                },
                speed: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Transition speed"
                }
            }
        }
    ]
};
/* harmony default export */ var carousel_selectable_product_cards_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: carousel_selectable_product_cards_grid_advanced_config_object_spread_props(carousel_selectable_product_cards_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        autoPlay: autoPlay,
        defaultNumberOfCards: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Default number of cards"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/index.js

var CarouselSelectableProductCardsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2842).then(__webpack_require__.bind(__webpack_require__, 72842));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72842)
            ];
        }
    }
});


/* harmony default export */ var carousel_selectable_product_cards_grid = ({
    CarouselSelectableProductCardsGridComponent: CarouselSelectableProductCardsGridComponent,
    CarouselSelectableProductCardsGridConfig: carousel_selectable_product_cards_grid_config,
    CarouselSelectableProductCardsGridAdvancedConfig: carousel_selectable_product_cards_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/card-button/button-types.js
var button_types = __webpack_require__(96800);
// EXTERNAL MODULE: ./constants/video-types.js
var video_types = __webpack_require__(39832);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/background-image-cards-grid-config.js
function background_image_cards_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function background_image_cards_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            background_image_cards_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function background_image_cards_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function background_image_cards_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        background_image_cards_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function background_image_cards_grid_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = background_image_cards_grid_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function background_image_cards_grid_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var mobileTextAlign = full_paragraph_fields_config/* default.mobileTextAlign */.Z.mobileTextAlign, textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, topic = full_paragraph_fields_config/* default.topic */.Z.topic, buttonConfig = full_paragraph_fields_config/* default.buttonConfig */.Z.buttonConfig, resOfParagraphConfig = background_image_cards_grid_config_object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "mobileTextAlign",
    "textColor",
    "topic",
    "buttonConfig"
]);
var background_image_cards_grid_config_button = {
    type: template_field_type.FIELD_TYPES.CONDITIONAL_NESTED,
    label: "Button",
    conditionalKeyName: "buttonType",
    options: [
        {
            text: button_types/* ButtonTypes.PRODUCT_SIGNUP_AND_LEARN_MORE */.q.PRODUCT_SIGNUP_AND_LEARN_MORE,
            fieldsConfig: {
                productType: {
                    label: "Product",
                    type: template_field_type.FIELD_TYPES.PRODUCTS
                },
                buttonColor: {
                    label: "Button color",
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER
                },
                invert: {
                    label: "Invert",
                    type: template_field_type.FIELD_TYPES.BOOLEAN
                },
                withArrow: {
                    label: "With arrow",
                    type: template_field_type.FIELD_TYPES.BOOLEAN
                }
            },
            type: template_field_type.FIELD_TYPES.NESTED
        },
        {
            text: button_types/* ButtonTypes.LABEL */.q.LABEL,
            fieldsConfig: {
                text: {
                    label: "Text",
                    type: template_field_type.FIELD_TYPES.TEXT
                },
                borderColor: {
                    label: "Border color",
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER
                }
            },
            type: template_field_type.FIELD_TYPES.NESTED
        }
    ]
};
/* harmony default export */ var background_image_cards_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Background Image Cards",
    fields: background_image_cards_grid_config_object_spread_props(background_image_cards_grid_config_object_spread({}, theme_config/* default */.Z), {
        cardHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Card Height"
        },
        cardsGap: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Cards gap (default 12px)"
        },
        cards: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Cards",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    backgroundImage: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Fallback background image (if no video supplied)"
                    },
                    backgroundVideo: {
                        type: template_field_type.FIELD_TYPES.CLOUDINARY_VIDEO_PICKER,
                        label: "Background video (on hover)",
                        videoType: video_types/* PARAGRAPH_AND_ASSET_VIDEOS */.rB
                    },
                    mobileBackgroundImage: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Mobile image"
                    },
                    paragraph: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Paragraph",
                        fields: background_image_cards_grid_config_object_spread({
                            topic: background_image_cards_grid_config_object_spread_props(background_image_cards_grid_config_object_spread({}, topic), {
                                fields: {
                                    image: topic.fields.image
                                }
                            })
                        }, resOfParagraphConfig)
                    },
                    button: background_image_cards_grid_config_button
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/background-image-cards-grid-advanced-config.js
function background_image_cards_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function background_image_cards_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            background_image_cards_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function background_image_cards_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function background_image_cards_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        background_image_cards_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var background_image_cards_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: background_image_cards_grid_advanced_config_object_spread_props(background_image_cards_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        fullParagraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph Advanced Config",
            fields: background_image_cards_grid_advanced_config_object_spread_props(background_image_cards_grid_advanced_config_object_spread({}, advanced_fields_config/* default */.Z), {
                marginTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Margin from top"
                }
            })
        },
        horizontalPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Horizontal padding (For mobile)"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/index.js

var BackgroundImageCardsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9465).then(__webpack_require__.bind(__webpack_require__, 9465));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9465)
            ];
        }
    }
});


/* harmony default export */ var background_image_cards_grid = ({
    BackgroundImageCardsGridComponent: BackgroundImageCardsGridComponent,
    BackgroundImageCardsGridConfig: background_image_cards_grid_config,
    BackgroundImageCardsGridAdvancedConfig: background_image_cards_grid_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/animated-icons-grid/animated-icons-grid-config.js
function animated_icons_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function animated_icons_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            animated_icons_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function animated_icons_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function animated_icons_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        animated_icons_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var animated_icons_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Animated Icons",
    fields: animated_icons_grid_config_object_spread_props(animated_icons_grid_config_object_spread({}, theme_config/* default */.Z), {
        iconsArray: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Icons",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    iconAsset: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Icon",
                        defaultImagesKeys: []
                    },
                    animationDuration: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Animation duration (seconds)"
                    },
                    initialOffset: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Initial offset (px)"
                    }
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/animated-icons-grid/animated-icons-grid-advanced-config.js
function animated_icons_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function animated_icons_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            animated_icons_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var animated_icons_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: animated_icons_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/animated-icons-grid/index.js

var AnimatedIconsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8501).then(__webpack_require__.bind(__webpack_require__, 88501));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88501)
            ];
        }
    }
});


/* harmony default export */ var animated_icons_grid = ({
    AnimatedIconsGridComponent: AnimatedIconsGridComponent,
    AnimatedIconsGridConfig: animated_icons_grid_config,
    AnimatedIconsGridAdvancedConfig: animated_icons_grid_advanced_config
});

// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var asset_fields_config = __webpack_require__(13225);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/marquee-cards-grid/marquee-cards-grid-config.js
function marquee_cards_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function marquee_cards_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            marquee_cards_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function marquee_cards_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function marquee_cards_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        marquee_cards_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var marquee_cards_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Marquee Cards",
    fields: marquee_cards_grid_config_object_spread_props(marquee_cards_grid_config_object_spread({}, theme_config/* default */.Z), {
        cards: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Cards",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    cardAsset: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Card Asset"
                    },
                    cardLogoAsset: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Card Logo Asset"
                    },
                    titleText: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Title"
                    },
                    useCases: {
                        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                        label: "Use cases",
                        nestedConfig: {
                            type: template_field_type.FIELD_TYPES.NESTED,
                            fields: {
                                useCase: {
                                    type: template_field_type.FIELD_TYPES.TEXT,
                                    label: "Use cases"
                                }
                            }
                        }
                    },
                    productType: {
                        type: template_field_type.FIELD_TYPES.PRODUCTS,
                        label: "Product type"
                    }
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/marquee-cards-grid/marquee-cards-grid-advanced-config.js
function marquee_cards_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function marquee_cards_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            marquee_cards_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var marquee_cards_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: marquee_cards_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/marquee-cards-grid/index.js

var MarqueeCardsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2165).then(__webpack_require__.bind(__webpack_require__, 32165));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32165)
            ];
        }
    }
});


/* harmony default export */ var marquee_cards_grid = ({
    MarqueeCardsGridComponent: MarqueeCardsGridComponent,
    MarqueeCardsGridConfig: marquee_cards_grid_config,
    MarqueeCardsGridAdvancedConfig: marquee_cards_grid_advanced_config
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/hoverable-cards-grid/hoverable-cards-grid-config.js

function hoverable_cards_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hoverable_cards_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hoverable_cards_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hoverable_cards_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function hoverable_cards_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        hoverable_cards_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function hoverable_cards_grid_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = hoverable_cards_grid_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function hoverable_cards_grid_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, hoverable_cards_grid_config_mobileTextAlign = full_paragraph_fields_config/* default.mobileTextAlign */.Z.mobileTextAlign, titleButtonConfig = full_paragraph_fields_config/* default.buttonConfig */.Z.buttonConfig, titleColor = full_paragraph_fields_config/* default.titleColor */.Z.titleColor, hoverable_cards_grid_config_textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, bodyColor = full_paragraph_fields_config/* default.bodyColor */.Z.bodyColor, hoverable_cards_grid_config_topic = full_paragraph_fields_config/* default.topic */.Z.topic, hoverable_cards_grid_config_resOfParagraphConfig = hoverable_cards_grid_config_object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "textAlign",
    "mobileTextAlign",
    "buttonConfig",
    "titleColor",
    "textColor",
    "bodyColor",
    "topic"
]);
/* harmony default export */ var hoverable_cards_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Hoverable Cards",
    fields: hoverable_cards_grid_config_object_spread_props(hoverable_cards_grid_config_object_spread({}, theme_config/* default */.Z), {
        defaultHoveredCard: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Default hovered card"
        },
        defaultColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Card color",
            possibleColors: (0,_to_consumable_array/* default */.Z)(theme_config/* default.theme.possibleColors */.Z.theme.possibleColors).concat([
                color_consts.RACKLEY_BLUE
            ])
        },
        cards: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Cards",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    hoveredColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Hovered color",
                        possibleColors: (0,_to_consumable_array/* default */.Z)(theme_config/* default.theme.possibleColors */.Z.theme.possibleColors).concat([
                            color_consts.SPRING_GREEN,
                            color_consts.ROUGE_RED
                        ])
                    },
                    asset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Asset",
                        fields: asset_fields_config/* default */.Z
                    },
                    hoveredAsset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Hovered asset",
                        fields: asset_fields_config/* default */.Z
                    },
                    paragraph: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Paragraph",
                        fields: hoverable_cards_grid_config_resOfParagraphConfig
                    }
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/hoverable-cards-grid/hoverable-cards-grid-advanced-config.js
function hoverable_cards_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hoverable_cards_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hoverable_cards_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hoverable_cards_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function hoverable_cards_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        hoverable_cards_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function hoverable_cards_grid_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = hoverable_cards_grid_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function hoverable_cards_grid_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var buttonTopMargin = advanced_fields_config/* default.buttonTopMargin */.Z.buttonTopMargin, topicBottomMargin = advanced_fields_config/* default.topicBottomMargin */.Z.topicBottomMargin, textSize = advanced_fields_config/* default.textSize */.Z.textSize, restOfParagraphConfig = hoverable_cards_grid_advanced_config_object_without_properties(advanced_fields_config/* default */.Z, [
    "buttonTopMargin",
    "topicBottomMargin",
    "textSize"
]);
/* harmony default export */ var hoverable_cards_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: hoverable_cards_grid_advanced_config_object_spread_props(hoverable_cards_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        fullParagraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph Advanced Config",
            fields: hoverable_cards_grid_advanced_config_object_spread({}, restOfParagraphConfig)
        },
        textResizeConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Advanced Text Resize Config",
            fields: {
                resizeFactor: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Resize Factor",
                    default: 1
                },
                minimumFont: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Minimum title font",
                    default: 1
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/hoverable-cards-grid/index.js

var HoverableCardsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7790).then(__webpack_require__.bind(__webpack_require__, 17790));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17790)
            ];
        }
    }
});


/* harmony default export */ var hoverable_cards_grid = ({
    HoverableCardsGridComponent: HoverableCardsGridComponent,
    HoverableCardsGridConfig: hoverable_cards_grid_config,
    HoverableCardsGridAdvancedConfig: hoverable_cards_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var title_fields_config = __webpack_require__(65621);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/fields-config.js
var paragraph_fields_config = __webpack_require__(49496);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/marquee-grid/marquee-grid-config.js
function marquee_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function marquee_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            marquee_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function marquee_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function marquee_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        marquee_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var marquee_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Marquee",
    fields: marquee_grid_config_object_spread_props(marquee_grid_config_object_spread({}, theme_config/* default */.Z), {
        textBoxText: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Text Box Text"
        },
        titleConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Title Config",
            fields: marquee_grid_config_object_spread({}, title_fields_config/* default */.Z)
        },
        subTitleConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "subTitle config",
            fields: marquee_grid_config_object_spread({}, paragraph_fields_config/* default */.Z)
        },
        tagsLines: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tags Lines",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    items: {
                        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                        label: "Tags",
                        maxLimit: 15,
                        nestedConfig: {
                            type: template_field_type.FIELD_TYPES.NESTED,
                            fields: {
                                text: {
                                    type: template_field_type.FIELD_TYPES.TEXT,
                                    label: "Text",
                                    translatable: true
                                },
                                image: {
                                    type: template_field_type.FIELD_TYPES.GALLERY,
                                    label: "Image"
                                },
                                backgroundColor: {
                                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                                    label: "Background Color"
                                },
                                hoverTextAndBorderColor: {
                                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                                    label: "Hover Text Color"
                                },
                                selectedTextAndBorderColor: {
                                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                                    label: "Select Text Color"
                                }
                            }
                        }
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var advanced_field_config = __webpack_require__(95760);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/advanced-fields-config.js
var paragraph_advanced_fields_config = __webpack_require__(50342);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/marquee-grid/marquee-grid-advanced-config.js
function marquee_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function marquee_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            marquee_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function marquee_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function marquee_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        marquee_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var marquee_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: marquee_grid_advanced_config_object_spread_props(marquee_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        titleAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: marquee_grid_advanced_config_object_spread({}, advanced_field_config/* default */.Z)
        },
        subTitleAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: marquee_grid_advanced_config_object_spread({}, paragraph_advanced_fields_config/* default */.Z)
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/marquee-grid/index.js

var MarqueeGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1810).then(__webpack_require__.bind(__webpack_require__, 11810));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11810)
            ];
        }
    }
});


/* harmony default export */ var marquee_grid = ({
    MarqueeGridComponent: MarqueeGridComponent,
    MarqueeGridConfig: marquee_grid_config,
    MarqueeGridAdvancedConfig: marquee_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/badges-grid/default-props.js
var default_props = __webpack_require__(26455);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/badges-grid/badges-const.js
var badges_const = __webpack_require__(25627);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/badges-grid-config.js
function badges_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function badges_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            badges_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function badges_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function badges_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        badges_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var badges_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Badges",
    fields: badges_grid_config_object_spread_props(badges_grid_config_object_spread({}, theme_config/* default */.Z), {
        product: {
            type: template_field_type.FIELD_TYPES.PRODUCTS,
            label: "Product"
        },
        country: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Country",
            options: badges_const/* BADGES_COUNTRIES */.W
        },
        horizontalPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Horizontal padding",
            inputPlaceholder: default_props/* default.horizontalPadding */.Z.horizontalPadding
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/badges-grid-advanced-config.js
function badges_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function badges_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            badges_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var badges_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: badges_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/badges-grid/index.js



var BadgesGridComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9112), __webpack_require__.e(5024)]).then(__webpack_require__.bind(__webpack_require__, 69737));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69737)
            ];
        }
    }
});
/* harmony default export */ var badges_grid = ({
    BadgesGridComponent: BadgesGridComponent,
    BadgesGridConfig: badges_grid_config,
    BadgesGridAdvancedConfig: badges_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/grid-paragraph-with-image/fields-config.js
var grid_paragraph_with_image_fields_config = __webpack_require__(41667);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/sliding-card-grid-config.js

function sliding_card_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sliding_card_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sliding_card_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function sliding_card_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sliding_card_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sliding_card_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var sliding_card_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Sliding Card",
    fields: sliding_card_grid_config_object_spread_props(sliding_card_grid_config_object_spread({}, theme_config/* default */.Z), {
        cardsToShow: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Number of cards to show in view"
        },
        cardColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Card color",
            possibleColors: (0,_to_consumable_array/* default */.Z)(segments_service/* BACKGROUND_COLOR_OPTIONS */.L6).concat([
                "transparent"
            ])
        },
        cardInnerPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Card paragraph padding"
        },
        isFullScreen: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Is full screen"
        },
        borderColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Border color",
            possibleColors: (0,_to_consumable_array/* default */.Z)(segments_service/* BACKGROUND_COLOR_OPTIONS */.L6)
        },
        arrowsColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Arrows color"
        },
        cards: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Cards",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                label: "Sliding Card",
                fields: grid_paragraph_with_image_fields_config/* default */.Z
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/core-configs/advanced-theme-config.js
var advanced_theme_config = __webpack_require__(42711);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/sliding-card-grid-advanced-config.js
function sliding_card_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sliding_card_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sliding_card_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function sliding_card_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sliding_card_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sliding_card_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var sliding_card_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: sliding_card_grid_advanced_config_object_spread_props(sliding_card_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_theme_config/* default */.Z), {
        fullParagraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph Advanced Config",
            fields: advanced_fields_config/* default */.Z
        },
        desktopHorizontalPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Desktop Horizontal Padding"
        },
        borderOpacity: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Border opacity"
        },
        disableCardsHoverStyle: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Disable cards hover style"
        },
        slideBreakingPoints: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Slide Breaking Points",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    breakpoint: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Breakpoint"
                    },
                    slidesToShow: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Cards to show"
                    }
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/index.js



var SlidingCardGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6228).then(__webpack_require__.bind(__webpack_require__, 46228));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46228)
            ];
        }
    }
});
/* harmony default export */ var sliding_card_grid = ({
    SlidingCardGridComponent: SlidingCardGridComponent,
    SlidingCardGridConfig: sliding_card_grid_config,
    SlidingCardGridAdvancedConfig: sliding_card_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-grid-config.js
var flexible_cards_grid_config = __webpack_require__(73767);
// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/title-only-paragraph/title-only-paragraph-config.js
var title_only_paragraph_config = __webpack_require__(68566);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/press-grid/press-consts.js
var press_consts = __webpack_require__(6795);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/press-grid/press-grid-config.js
function press_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function press_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            press_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function press_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function press_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        press_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function press_grid_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = press_grid_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function press_grid_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var _FlexibleCardsGridConfig_fields = flexible_cards_grid_config/* default.fields */.Z.fields, gridItems = _FlexibleCardsGridConfig_fields.gridItems, resConfig = press_grid_config_object_without_properties(_FlexibleCardsGridConfig_fields, [
    "gridItems"
]);
var _TitleOnlyParagraphConfig_fields = title_only_paragraph_config/* default.fields */.Z.fields, theme = _TitleOnlyParagraphConfig_fields.theme, press_grid_config_buttonConfig = _TitleOnlyParagraphConfig_fields.buttonConfig, resTitleConfig = press_grid_config_object_without_properties(_TitleOnlyParagraphConfig_fields, [
    "theme",
    "buttonConfig"
]);
var titleSize = advanced_field_config/* default.titleSize */.Z.titleSize;
/* harmony default export */ var press_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Press Component",
    fields: press_grid_config_object_spread_props(press_grid_config_object_spread({
        location: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Location",
            options: [
                {
                    value: press_consts/* ISRAEL_LOCATION */.RE,
                    text: "Israel"
                },
                {
                    value: press_consts/* GLOBAL_LOCATION */.Q4,
                    text: "Global"
                }
            ]
        }
    }, resConfig), {
        titleConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Title Config",
            fields: press_grid_config_object_spread_props(press_grid_config_object_spread({}, resTitleConfig), {
                titleSize: titleSize
            })
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/press-grid/press-grid-advanced-config.js
function press_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function press_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            press_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var press_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: press_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/press-grid/index.js



var PressGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6608).then(__webpack_require__.bind(__webpack_require__, 16608));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16608)
            ];
        }
    }
});
/* harmony default export */ var press_grid = ({
    PressGridComponent: PressGridComponent,
    PressGridConfig: press_grid_config,
    PressGridAdvancedConfig: press_grid_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/connected-products-grid/connected-products-grid-config.js
function connected_products_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function connected_products_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            connected_products_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var connected_products_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Connected products",
    fields: {
        gridItems: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Grid Items",
            maxLimit: 4,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: connected_products_grid_config_object_spread({}, grid_paragraph_with_image_fields_config/* default */.Z)
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/connected-products-grid/connected-products-grid-advanced-config.js
function connected_products_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function connected_products_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            connected_products_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var connected_products_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: connected_products_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/connected-products-grid/index.js



var ConnectedProductsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3879).then(__webpack_require__.bind(__webpack_require__, 3879));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3879)
            ];
        }
    }
});
/* harmony default export */ var connected_products_grid = ({
    ConnectedProductsGridComponent: ConnectedProductsGridComponent,
    ConnectedProductsGridConfig: connected_products_grid_config,
    ConnectedProductsGridAdvancedConfig: connected_products_grid_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-grid-advanced-config.js
function flexible_cards_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function flexible_cards_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            flexible_cards_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var flexible_cards_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: flexible_cards_grid_advanced_config_object_spread({
        cancelMobileMarginTop: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Cancel Mobile Margin Top"
        }
    }, shared_advanced_fields_config/* default */.Z, advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/index.js



var FlexibleCardsGridComponent = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 38885));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38885)
            ];
        }
    }
});
/* harmony default export */ var flexible_cards_grid = ({
    FlexibleCardsGridComponent: FlexibleCardsGridComponent,
    FlexibleCardsGridConfig: flexible_cards_grid_config/* default */.Z,
    FlexibleCardsGridAdvancedConfig: flexible_cards_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/fields-config.js
var square_tags_fields_config = __webpack_require__(22333);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/square-tags-grid/square-tags-grid-config.js
function square_tags_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function square_tags_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            square_tags_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var square_tags_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Square Tags",
    fields: square_tags_grid_config_object_spread({}, square_tags_fields_config/* default */.Z)
});

// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/advanced-fields-config.js
var square_tags_advanced_fields_config = __webpack_require__(73498);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/square-tags-grid/square-tags-grid-advanced-config.js
function square_tags_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function square_tags_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            square_tags_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var square_tags_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: square_tags_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, square_tags_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/square-tags-grid/index.js



var SquareTagsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4913).then(__webpack_require__.bind(__webpack_require__, 74913));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74913)
            ];
        }
    }
});
/* harmony default export */ var square_tags_grid = ({
    SquareTagsGridComponent: SquareTagsGridComponent,
    SquareTagsGridConfig: square_tags_grid_config,
    SquareTagsGridAdvancedConfig: square_tags_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/fields-config.js + 5 modules
var button_fields_config = __webpack_require__(75629);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
;// CONCATENATED MODULE: ./segments/core-configs/products-config.js


/* harmony default export */ var products_config = ({
    productType: {
        type: template_field_type.FIELD_TYPES.COMBO,
        label: "Product type",
        options: products/* PRODUCT_TYPES */.Pm
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/product-cards-grid-config.js
function product_cards_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_cards_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_cards_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function product_cards_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_cards_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_cards_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var options = button_fields_config/* default.options */.Z.options;
var productCardButtonOptions = options.filter(function(option) {
    return [
        button_consts/* SIGNUP_BUTTON_TYPE */.ge,
        button_consts/* SIGNUP_COMBO_BUTTONS_TYPE */.ae,
        button_consts/* SECONDARY_BUTTON_TYPE */.jE
    ].includes(option.text);
});
/* harmony default export */ var product_cards_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Product Cards",
    fields: product_cards_grid_config_object_spread_props(product_cards_grid_config_object_spread({}, theme_config/* default */.Z), {
        cards: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Card Items",
            maxLimit: 5,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: product_cards_grid_config_object_spread_props(product_cards_grid_config_object_spread({}, products_config), {
                    isHighlighted: {
                        type: template_field_type.FIELD_TYPES.BOOLEAN,
                        label: "Is highlighted"
                    },
                    showOpen: {
                        type: template_field_type.FIELD_TYPES.BOOLEAN,
                        label: "Show card open in mobile version"
                    },
                    header: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Header",
                        fields: {
                            subtitleText: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Text",
                                translatable: true
                            },
                            mobileSubTitleText: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Mobile subtitle text",
                                translatable: true
                            }
                        }
                    },
                    body: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Body",
                        fields: {
                            bodyText: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Text",
                                translatable: true
                            }
                        }
                    },
                    showDivider: {
                        type: template_field_type.FIELD_TYPES.BOOLEAN,
                        label: "Show divider"
                    },
                    useCases: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Use cases",
                        fields: {
                            text: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Text",
                                translatable: true
                            },
                            list: {
                                type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                                label: "Use cases list",
                                maxLimit: 6,
                                nestedConfig: {
                                    type: template_field_type.FIELD_TYPES.NESTED,
                                    fields: {
                                        text: {
                                            type: template_field_type.FIELD_TYPES.TEXT,
                                            label: "Text",
                                            translatable: true
                                        }
                                    }
                                }
                            }
                        }
                    },
                    buttonConfig: {
                        type: template_field_type.FIELD_TYPES.CONDITIONAL_NESTED,
                        label: "Button",
                        conditionalKeyName: "buttonType",
                        options: productCardButtonOptions
                    },
                    isV2: {
                        type: template_field_type.FIELD_TYPES.BOOLEAN,
                        label: "Is V2"
                    }
                })
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/product-cards-grid-advanced-config.js
function product_cards_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_cards_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_cards_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var product_cards_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: product_cards_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/index.js



var ProductCardsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9185).then(__webpack_require__.bind(__webpack_require__, 79185));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79185)
            ];
        }
    }
});
/* harmony default export */ var product_cards_grid = ({
    ProductCardsGridComponent: ProductCardsGridComponent,
    ProductCardsGridConfig: product_cards_grid_config,
    ProductCardsGridAdvancedConfig: product_cards_grid_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/masonry-grid/masonry-grid-config.js
function masonry_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function masonry_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            masonry_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function masonry_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function masonry_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        masonry_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function masonry_grid_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = masonry_grid_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function masonry_grid_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var video = asset_fields_config/* default.video */.Z.video;
var _video_fields = video.fields, loop = _video_fields.loop, playWhenVisible = _video_fields.playWhenVisible, rest = masonry_grid_config_object_without_properties(_video_fields, [
    "loop",
    "playWhenVisible"
]);
/* harmony default export */ var masonry_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Masonry",
    fields: {
        assets: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Assets",
            maxLimit: 9,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    asset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Asset",
                        fields: masonry_grid_config_object_spread_props(masonry_grid_config_object_spread({}, asset_fields_config/* default */.Z), {
                            video: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Video",
                                fields: masonry_grid_config_object_spread_props(masonry_grid_config_object_spread({}, rest), {
                                    startAfter: {
                                        type: template_field_type.FIELD_TYPES.TEXT,
                                        label: "Start After"
                                    },
                                    poster: {
                                        type: template_field_type.FIELD_TYPES.GALLERY,
                                        label: "Select an poster"
                                    }
                                })
                            }
                        })
                    }
                }
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/masonry-grid/masonry-grid-advanced-config.js
function masonry_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function masonry_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            masonry_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function masonry_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function masonry_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        masonry_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var masonry_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: masonry_grid_advanced_config_object_spread_props(masonry_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/masonry-grid/index.js



var MasonryGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8890).then(__webpack_require__.bind(__webpack_require__, 68890));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68890)
            ];
        }
    }
});
/* harmony default export */ var masonry_grid = ({
    MasonryGridComponent: MasonryGridComponent,
    MasonryGridConfig: masonry_grid_config,
    MasonryGridAdvancedConfig: masonry_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/tag-items-grid/tag-items-grid-config.js + 1 modules
var tag_items_grid_config = __webpack_require__(48127);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/tag-items-grid/tag-items-grid-advanced-config.js
var tag_items_grid_advanced_config = __webpack_require__(14061);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/tag-items-grid/index.js



var TagItemsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7798).then(__webpack_require__.bind(__webpack_require__, 37798));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37798)
            ];
        }
    }
});
/* harmony default export */ var tag_items_grid = ({
    TagItemsGridComponent: TagItemsGridComponent,
    TagItemsGridConfig: tag_items_grid_config/* default */.Z,
    TagItemsGridAdvancedConfig: tag_items_grid_advanced_config/* default */.Z
});

// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/fields-config.js
var grid_image_fields_config = __webpack_require__(78739);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/icon-with-paragraph-grid/icon-with-paragraph-grid-config.js
function icon_with_paragraph_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function icon_with_paragraph_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            icon_with_paragraph_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function icon_with_paragraph_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function icon_with_paragraph_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        icon_with_paragraph_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function icon_with_paragraph_grid_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = icon_with_paragraph_grid_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function icon_with_paragraph_grid_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var icon_with_paragraph_grid_config_textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, icon_with_paragraph_grid_config_textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, selectedFullParagraphFields = icon_with_paragraph_grid_config_object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "textColor",
    "textAlign"
]);
/* harmony default export */ var icon_with_paragraph_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Icon With Paragraph",
    fields: {
        iconWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Icon width"
        },
        iconHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Icon height"
        },
        titleSize: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Title Size",
            options: [
                {
                    value: sizes.XS,
                    text: "24px"
                },
                {
                    value: sizes.SM,
                    text: "32px"
                },
                {
                    value: sizes.MD,
                    text: "40px"
                },
                {
                    value: sizes.LG,
                    text: "50px"
                },
                {
                    value: sizes/* LGR */.Re,
                    text: "60px"
                },
                {
                    value: sizes.XL,
                    text: "72px"
                },
                {
                    value: sizes/* XXL */.T3,
                    text: "80px"
                }
            ]
        },
        textSize: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Body Size",
            options: [
                {
                    value: sizes.MS,
                    text: "16px"
                },
                {
                    value: sizes.MD,
                    text: "20px"
                },
                {
                    value: sizes.LG,
                    text: "24px"
                }
            ]
        },
        imagesGap: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Images gap"
        },
        images: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Icons",
            maxLimit: 4,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: icon_with_paragraph_grid_config_object_spread_props(icon_with_paragraph_grid_config_object_spread({}, grid_image_fields_config/* default */.Z), {
                    fullParagraph: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Full Paragraph",
                        fields: selectedFullParagraphFields
                    }
                })
            }
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid-service.js
var images_grid_service = __webpack_require__(72898);
;// CONCATENATED MODULE: ./segments/desktop/core-components/images-grid/advanced-fields-config.js


var advanced_fields_config_textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign;

/* harmony default export */ var images_grid_advanced_fields_config = ({
    imagePosition: {
        type: template_field_type.FIELD_TYPES.COMBO,
        label: "Image Position",
        options: [
            {
                value: images_grid_service/* positionTypes.TOP_LEFT */.b.TOP_LEFT,
                text: "Top Left"
            },
            {
                value: images_grid_service/* positionTypes.TOP_CENTER */.b.TOP_CENTER,
                text: "Top Center"
            },
            {
                value: images_grid_service/* positionTypes.TOP_RIGHT */.b.TOP_RIGHT,
                text: "Top Right"
            },
            {
                value: images_grid_service/* positionTypes.CENTER_LEFT */.b.CENTER_LEFT,
                text: "Center Left"
            },
            {
                value: images_grid_service/* positionTypes.CENTER_CENTER */.b.CENTER_CENTER,
                text: "Center Center"
            },
            {
                value: images_grid_service/* positionTypes.CENTER_RIGHT */.b.CENTER_RIGHT,
                text: "Center Right"
            },
            {
                value: images_grid_service/* positionTypes.BOTTOM_LEFT */.b.BOTTOM_LEFT,
                text: "Bottom Left"
            },
            {
                value: images_grid_service/* positionTypes.BOTTOM_CENTER */.b.BOTTOM_CENTER,
                text: "Bottom Center"
            },
            {
                value: images_grid_service/* positionTypes.BOTTOM_RIGHT */.b.BOTTOM_RIGHT,
                text: "Bottom Right"
            }
        ]
    },
    textAlign: advanced_fields_config_textAlign
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/icon-with-paragraph-grid/icon-with-paragraph-grid-advanced-config.js
function icon_with_paragraph_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function icon_with_paragraph_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            icon_with_paragraph_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



var ref = icon_with_paragraph_grid_advanced_config_object_spread({}, images_grid_advanced_fields_config), imagePosition = ref.imagePosition, icon_with_paragraph_grid_advanced_config_textAlign = ref.textAlign;
/* harmony default export */ var icon_with_paragraph_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: icon_with_paragraph_grid_advanced_config_object_spread({
        imagePosition: imagePosition,
        textAlign: icon_with_paragraph_grid_advanced_config_textAlign,
        disableFixedWidth: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Disable auto width"
        }
    }, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/icon-with-paragraph-grid/index.js



var IconWithParagraphGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9515).then(__webpack_require__.bind(__webpack_require__, 9515));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9515)
            ];
        }
    }
});
/* harmony default export */ var icon_with_paragraph_grid = ({
    IconWithParagraphGridComponent: IconWithParagraphGridComponent,
    IconWithParagraphGridConfig: icon_with_paragraph_grid_config,
    IconWithParagraphGridAdvancedConfig: icon_with_paragraph_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tags-grid/fields-config.js
var selectable_tags_grid_fields_config = __webpack_require__(1117);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/fields-config.js
var carousel_fields_config = __webpack_require__(33751);
// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/selectable-tags-with-carousel-grid/selectable-tags-with-carousel-grid-config.js
function selectable_tags_with_carousel_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function selectable_tags_with_carousel_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            selectable_tags_with_carousel_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}




/* harmony default export */ var selectable_tags_with_carousel_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Tags With Carousel",
    fields: selectable_tags_with_carousel_grid_config_object_spread({
        tagsAlign: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Tags Align",
            options: [
                {
                    value: align_types.ALIGN_TYPES.LEFT,
                    text: align_types.ALIGN_LABELS.LEFT
                },
                {
                    value: align_types.ALIGN_TYPES.CENTER,
                    text: align_types.ALIGN_LABELS.CENTER
                },
                {
                    value: align_types.ALIGN_TYPES.RIGHT,
                    text: align_types.ALIGN_LABELS.RIGHT
                }
            ]
        }
    }, carousel_fields_config/* default */.Z, selectable_tags_grid_fields_config/* default */.Z)
});

// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/advanced-fields-config.js
var carousel_advanced_fields_config = __webpack_require__(1270);
// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tags-grid/advanced-field-config.js
var selectable_tags_grid_advanced_field_config = __webpack_require__(33129);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/selectable-tags-with-carousel-grid/selectable-tags-with-carousel-grid-advanced-config.js
function selectable_tags_with_carousel_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function selectable_tags_with_carousel_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            selectable_tags_with_carousel_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}




/* harmony default export */ var selectable_tags_with_carousel_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: selectable_tags_with_carousel_grid_advanced_config_object_spread({}, carousel_advanced_fields_config/* default */.Z, selectable_tags_grid_advanced_field_config/* default */.Z, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/selectable-tags-with-carousel-grid/index.js



var SelectableTagsWithCarouselGridComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4222), __webpack_require__.e(8393)]).then(__webpack_require__.bind(__webpack_require__, 88393));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88393)
            ];
        }
    }
});
/* harmony default export */ var selectable_tags_with_carousel_grid = ({
    SelectableTagsWithCarouselGridComponent: SelectableTagsWithCarouselGridComponent,
    SelectableTagsWithCarouselGridConfig: selectable_tags_with_carousel_grid_config,
    SelectableTagsWithCarouselGridAdvancedConfig: selectable_tags_with_carousel_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/constants.js
var constants = __webpack_require__(72606);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/blog-card-item/blog-card-item-footer/fields-config.js


/* harmony default export */ var blog_card_item_footer_fields_config = ({
    writerImageSrc: {
        type: template_field_type.FIELD_TYPES.GALLERY,
        defaultImagesKeys: [],
        label: "Select Writer Image (".concat(constants/* default.WRITER_AVATAR_IMAGE_WIDTH */.Z.WRITER_AVATAR_IMAGE_WIDTH, "x").concat(constants/* default.WRITER_AVATAR_IMAGE_HEIGHT */.Z.WRITER_AVATAR_IMAGE_HEIGHT, ")")
    },
    writerName: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Writer Name"
    },
    articleDate: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Article Date",
        translatable: true
    },
    minutesToRead: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Minutes",
        translatable: true
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/blog-card-item/fields-config.js
function fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function fields_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function fields_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        fields_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function fields_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = fields_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function fields_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var fields_config_link = grid_image_fields_config/* default.link */.Z.link, src = grid_image_fields_config/* default.src */.Z.src, restFieldsConfig = fields_config_object_without_properties(grid_image_fields_config/* default */.Z, [
    "link",
    "src"
]);
var newSrc = fields_config_object_spread_props(fields_config_object_spread({}, src), {
    label: "select an image (".concat(constants/* default.CARD_WIDTH */.Z.CARD_WIDTH, "X").concat(constants/* default.IMAGE_HEIGHT */.Z.IMAGE_HEIGHT, ")")
});
var selectedGridImageFieldsConfig = fields_config_object_spread({
    src: newSrc
}, restFieldsConfig);
/* harmony default export */ var blog_card_item_fields_config = (fields_config_object_spread_props(fields_config_object_spread({
    link: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Blog Link"
    },
    openInNewTab: {
        type: "boolean",
        label: "Should Open In New Tab"
    },
    image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Image",
        fields: fields_config_object_spread({}, selectedGridImageFieldsConfig)
    }
}, title_fields_config/* default */.Z), {
    footer: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Card Footer",
        fields: blog_card_item_footer_fields_config
    }
}));

// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/fields-config.js
var regular_button_fields_config = __webpack_require__(64054);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/fields-config.js
var secondary_button_fields_config = __webpack_require__(54237);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/fields-config.js
var signup_button_fields_config = __webpack_require__(96587);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/blog-cards-grid-config.js






/* harmony default export */ var blog_cards_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Blog Cards",
    fields: {
        gridItems: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Grid Items",
            maxLimit: 100,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: blog_card_item_fields_config
            }
        },
        buttonConfig: {
            type: template_field_type.FIELD_TYPES.CONDITIONAL_NESTED,
            label: "Button",
            conditionalKeyName: "buttonType",
            options: [
                {
                    text: button_consts/* REGULAR_BUTTON_TYPE */.ys,
                    fieldsConfig: regular_button_fields_config/* default */.Z
                },
                {
                    text: button_consts/* SECONDARY_BUTTON_TYPE */.jE,
                    fieldsConfig: secondary_button_fields_config/* default */.Z
                },
                {
                    text: button_consts/* SIGNUP_BUTTON_TYPE */.ge,
                    fieldsConfig: signup_button_fields_config/* default */.Z
                }
            ]
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/blog-cards-grid-advanced-config.js
function blog_cards_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function blog_cards_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            blog_cards_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function blog_cards_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function blog_cards_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        blog_cards_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var blog_cards_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: blog_cards_grid_advanced_config_object_spread_props(blog_cards_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        hideFooter: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Hide footer"
        },
        imageMaxHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Image Max Height"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/index.js

var BlogCardsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7373).then(__webpack_require__.bind(__webpack_require__, 97373));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97373)
            ];
        }
    }
});


/* harmony default export */ var blog_cards_grid = ({
    BlogCardsGridComponent: BlogCardsGridComponent,
    BlogCardsGridConfig: blog_cards_grid_config,
    BlogCardsGridAdvancedConfig: blog_cards_grid_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/button-image-tags-grid/components/button-image-tag/fields-config.js

/* harmony default export */ var button_image_tag_fields_config = ({
    tagImg: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Image Tag",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Tag Image"
            }
        }
    },
    link: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Link (New)"
    },
    tagText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tag Text",
        translatable: true
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/button-image-tags-grid/button-image-tags-grid-config.js
function button_image_tags_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function button_image_tags_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            button_image_tags_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var button_image_tags_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Button Image Tags",
    fields: {
        isOpenLinkInNewTab: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Open Link In New Tab"
        },
        gridButtonTags: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Grid Button Tags",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: button_image_tags_grid_config_object_spread({}, button_image_tag_fields_config)
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/button-image-tags-grid/button-image-tags-grid-advanced-config.js
function button_image_tags_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function button_image_tags_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            button_image_tags_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var button_image_tags_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: button_image_tags_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/button-image-tags-grid/index.js

var ButtonImageTagsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1396).then(__webpack_require__.bind(__webpack_require__, 1396));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1396)
            ];
        }
    }
});


/* harmony default export */ var button_image_tags_grid = ({
    ButtonImageTagsGridComponent: ButtonImageTagsGridComponent,
    ButtonImageTagsGridConfig: button_image_tags_grid_config,
    ButtonImageTagsGridAdvancedConfig: button_image_tags_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/button-tag/fields-config.js
var button_tag_fields_config = __webpack_require__(24662);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/button-tags-grid/button-tags-grid-config.js
function button_tags_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function button_tags_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            button_tags_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var button_tags_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Button Tags",
    fields: {
        isOpenLinkInNewTab: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Open Link In New Tab"
        },
        gridButtonTags: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Grid Button Tags",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: button_tags_grid_config_object_spread({}, button_tag_fields_config/* default */.Z)
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/button-tags-grid/button-tags-grid-advanced-config.js
function button_tags_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function button_tags_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            button_tags_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var button_tags_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: button_tags_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/button-tags-grid/index.js

var ButtonTagsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5408).then(__webpack_require__.bind(__webpack_require__, 15408));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15408)
            ];
        }
    }
});


/* harmony default export */ var button_tags_grid = ({
    ButtonTagsGridComponent: ButtonTagsGridComponent,
    ButtonTagsGridConfig: button_tags_grid_config,
    ButtonTagsGridAdvancedConfig: button_tags_grid_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/cards-grid/cards-grid-config.js
function cards_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function cards_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            cards_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var cards_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Cards",
    fields: {
        gridItems: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Grid Items",
            maxLimit: 3,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: cards_grid_config_object_spread({}, grid_paragraph_with_image_fields_config/* default */.Z)
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/cards-grid/cards-grid-advanced-config.js
function cards_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function cards_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            cards_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var cards_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: cards_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/cards-grid/index.js

var CardsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5485).then(__webpack_require__.bind(__webpack_require__, 85485));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85485)
            ];
        }
    }
});


/* harmony default export */ var cards_grid = ({
    CardsGridComponent: CardsGridComponent,
    CardsGridConfig: cards_grid_config,
    CardsGridAdvancedConfig: cards_grid_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-tag/components/tag/fields-config.js

/* harmony default export */ var tag_fields_config = ({
    color: {
        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
        label: "Color"
    },
    text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Text",
        translatable: true
    }
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-tag/fields-config.js
function grid_tag_fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function grid_tag_fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            grid_tag_fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function grid_tag_fields_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = grid_tag_fields_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function grid_tag_fields_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var fields_config_topic = full_paragraph_fields_config/* default.topic */.Z.topic, fields_config_buttonConfig = full_paragraph_fields_config/* default.buttonConfig */.Z.buttonConfig, fields_config_textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, fields_config_textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, selectedFullParagraphFieldsConfig = grid_tag_fields_config_object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "topic",
    "buttonConfig",
    "textAlign",
    "textColor"
]);
/* harmony default export */ var grid_tag_fields_config = ({
    tag: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tag",
        fields: grid_tag_fields_config_object_spread({}, tag_fields_config)
    },
    fullParagraph: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Full Paragraph",
        fields: grid_tag_fields_config_object_spread({}, selectedFullParagraphFieldsConfig)
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/tags-grid/tags-grid-config.js
function tags_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function tags_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            tags_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var tags_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Tags",
    fields: {
        gridItems: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Grid Items",
            maxLimit: 3,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: tags_grid_config_object_spread({}, grid_tag_fields_config)
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/tags-grid/tags-grid-advanced-config.js
function tags_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function tags_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            tags_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var tags_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: tags_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/tags-grid/index.js

var TagsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4115).then(__webpack_require__.bind(__webpack_require__, 84115));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84115)
            ];
        }
    }
});


/* harmony default export */ var tags_grid = ({
    TagsGridComponent: TagsGridComponent,
    TagsGridConfig: tags_grid_config,
    TagsGridAdvancedConfig: tags_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/selectable-tags-grid/selectable-tags-grid-config.js
var selectable_tags_grid_config = __webpack_require__(96817);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/selectable-tags-grid/selectable-tags-grid-advanced-config.js
function selectable_tags_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function selectable_tags_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            selectable_tags_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function selectable_tags_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function selectable_tags_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        selectable_tags_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var selectable_tags_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: selectable_tags_grid_advanced_config_object_spread_props(selectable_tags_grid_advanced_config_object_spread({}, selectable_tags_grid_advanced_field_config/* default */.Z, shared_advanced_fields_config/* default */.Z), {
        IsInCrmUseCasesTest: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Crm use case tags AB Test"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/selectable-tags-grid/index.js

var SelectableTagsGridComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4222), __webpack_require__.e(6747)]).then(__webpack_require__.bind(__webpack_require__, 66747));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66747)
            ];
        }
    }
});


/* harmony default export */ var selectable_tags_grid = ({
    SelectableTagsGridComponent: SelectableTagsGridComponent,
    SelectableTagsGridConfig: selectable_tags_grid_config/* default */.Z,
    SelectableTagsGridAdvancedConfig: selectable_tags_grid_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/image-with-paragraph-grid/image-with-paragraph-grid-config.js
function image_with_paragraph_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function image_with_paragraph_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            image_with_paragraph_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function image_with_paragraph_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function image_with_paragraph_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        image_with_paragraph_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function image_with_paragraph_grid_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = image_with_paragraph_grid_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function image_with_paragraph_grid_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var image_with_paragraph_grid_config_textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, image_with_paragraph_grid_config_textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, image_with_paragraph_grid_config_selectedFullParagraphFields = image_with_paragraph_grid_config_object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "textColor",
    "textAlign"
]);
/* harmony default export */ var image_with_paragraph_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Image With Paragraph",
    fields: image_with_paragraph_grid_config_object_spread_props(image_with_paragraph_grid_config_object_spread({}, theme_config/* default */.Z), {
        images: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Images",
            maxLimit: 4,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: image_with_paragraph_grid_config_object_spread_props(image_with_paragraph_grid_config_object_spread({}, grid_image_fields_config/* default */.Z), {
                    fullParagraph: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Full Paragraph",
                        fields: image_with_paragraph_grid_config_selectedFullParagraphFields
                    }
                })
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/image-with-paragraph-grid/image-with-paragraph-grid-advanced-config.js
function image_with_paragraph_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function image_with_paragraph_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            image_with_paragraph_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function image_with_paragraph_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function image_with_paragraph_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        image_with_paragraph_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var image_with_paragraph_grid_advanced_config_imagePosition = images_grid_advanced_fields_config.imagePosition, image_with_paragraph_grid_advanced_config_textAlign = images_grid_advanced_fields_config.textAlign;
/* harmony default export */ var image_with_paragraph_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: image_with_paragraph_grid_advanced_config_object_spread_props(image_with_paragraph_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_fields_config/* default */.Z), {
        imagePosition: image_with_paragraph_grid_advanced_config_imagePosition,
        alignButtons: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align buttons"
        },
        textAlign: image_with_paragraph_grid_advanced_config_textAlign
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/image-with-paragraph-grid/index.js

var ImageWithParagraphGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9063).then(__webpack_require__.bind(__webpack_require__, 69063));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69063)
            ];
        }
    }
});


/* harmony default export */ var image_with_paragraph_grid = ({
    ImageWithParagraphGridComponent: ImageWithParagraphGridComponent,
    ImageWithParagraphGridConfig: image_with_paragraph_grid_config,
    ImageWithParagraphGridAdvancedConfig: image_with_paragraph_grid_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/images-grid/fields-config.js


/* harmony default export */ var images_grid_fields_config = ({
    imagesGap: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Images gap"
    },
    images: {
        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Images",
        maxLimit: 12,
        nestedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: grid_image_fields_config/* default */.Z
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/only-image-grid/only-image-grid-config.js


/* harmony default export */ var only_image_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Only Image",
    fields: images_grid_fields_config
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/only-image-grid/only-image-grid-advanced-config.js
function only_image_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function only_image_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            only_image_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function only_image_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function only_image_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        only_image_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var only_image_grid_advanced_config_imagePosition = images_grid_advanced_fields_config.imagePosition;
/* harmony default export */ var only_image_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: only_image_grid_advanced_config_object_spread_props(only_image_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        imagePosition: only_image_grid_advanced_config_imagePosition
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/only-image-grid/index.js

var OnlyImageGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8672).then(__webpack_require__.bind(__webpack_require__, 28672));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28672)
            ];
        }
    }
});


/* harmony default export */ var only_image_grid = ({
    OnlyImageGridComponent: OnlyImageGridComponent,
    OnlyImageGridConfig: only_image_grid_config,
    OnlyImageGridAdvancedConfig: only_image_grid_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/index.js
// plop_marker:layouts_import

























/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    CarouselSelectableProductCardsGrid: carousel_selectable_product_cards_grid,
    BackgroundImageCardsGrid: background_image_cards_grid,
    AnimatedIconsGrid: animated_icons_grid,
    MarqueeCardsGrid: marquee_cards_grid,
    HoverableCardsGrid: hoverable_cards_grid,
    MarqueeGrid: marquee_grid,
    BadgesGrid: badges_grid,
    SlidingCardGrid: sliding_card_grid,
    PressGrid: press_grid,
    ConnectedProductsGrid: connected_products_grid,
    FlexibleCardsGrid: flexible_cards_grid,
    SquareTagsGrid: square_tags_grid,
    ProductCardsGrid: product_cards_grid,
    MasonryGrid: masonry_grid,
    TagItemsGrid: tag_items_grid,
    IconWithParagraphGrid: icon_with_paragraph_grid,
    SelectableTagsWithCarouselGrid: selectable_tags_with_carousel_grid,
    BlogCardsGrid: blog_cards_grid,
    ButtonImageTagsGrid: button_image_tags_grid,
    ButtonTagsGrid: button_tags_grid,
    CardsGrid: cards_grid,
    TagsGrid: tags_grid,
    SelectableTagsGrid: selectable_tags_grid,
    ImageWithParagraphGrid: image_with_paragraph_grid,
    OnlyImageGrid: only_image_grid
});

;// CONCATENATED MODULE: ./segments/desktop/grid/index.js

var CarouselSelectableProductCardsGrid = layouts.CarouselSelectableProductCardsGrid, BackgroundImageCardsGrid = layouts.BackgroundImageCardsGrid, AnimatedIconsGrid = layouts.AnimatedIconsGrid, MarqueeCardsGrid = layouts.MarqueeCardsGrid, HoverableCardsGrid = layouts.HoverableCardsGrid, MarqueeGrid = layouts.MarqueeGrid, BadgesGrid = layouts.BadgesGrid, SlidingCardGrid = layouts.SlidingCardGrid, ConnectedProductsGrid = layouts.ConnectedProductsGrid, FlexibleCardsGrid = layouts.FlexibleCardsGrid, SquareTagsGrid = layouts.SquareTagsGrid, ProductCardsGrid = layouts.ProductCardsGrid, MasonryGrid = layouts.MasonryGrid, TagItemsGrid = layouts.TagItemsGrid, IconWithParagraphGrid = layouts.IconWithParagraphGrid, SelectableTagsWithCarouselGrid = layouts.SelectableTagsWithCarouselGrid, BlogCardsGrid = layouts.BlogCardsGrid, ButtonImageTagsGrid = layouts.ButtonImageTagsGrid, ButtonTagsGrid = layouts.ButtonTagsGrid, CardsGrid = layouts.CardsGrid, TagsGrid = layouts.TagsGrid, SelectableTagsGrid = layouts.SelectableTagsGrid, ImageWithParagraphGrid = layouts.ImageWithParagraphGrid, OnlyImageGrid = layouts.OnlyImageGrid, PressGrid = layouts.PressGrid;
/* harmony default export */ var grid = ({
    // plop_marker:segment_index_add_layout
    CarouselSelectableProductCardsGridComponent: {
        type: "CarouselSelectableProductCardsGridComponent",
        title: "Carousel Selectable Product Cards",
        imgSrc: "/static/img/segments/layouts/carousel-selectable-product-cards-grid.png",
        config: CarouselSelectableProductCardsGrid.CarouselSelectableProductCardsGridConfig,
        advancedConfig: CarouselSelectableProductCardsGrid.CarouselSelectableProductCardsGridAdvancedConfig,
        component: CarouselSelectableProductCardsGrid.CarouselSelectableProductCardsGridComponent
    },
    BackgroundImageCardsGridComponent: {
        type: "BackgroundImageCardsGridComponent",
        title: "Background Image Cards",
        imgSrc: "/static/img/segments/layouts/background-image-cards-grid.png",
        config: BackgroundImageCardsGrid.BackgroundImageCardsGridConfig,
        advancedConfig: BackgroundImageCardsGrid.BackgroundImageCardsGridAdvancedConfig,
        component: BackgroundImageCardsGrid.BackgroundImageCardsGridComponent
    },
    AnimatedIconsGridComponent: {
        type: "AnimatedIconsGridComponent",
        title: "Animated Icons",
        imgSrc: "/static/img/segments/layouts/animated-icons-grid.png",
        config: AnimatedIconsGrid.AnimatedIconsGridConfig,
        advancedConfig: AnimatedIconsGrid.AnimatedIconsGridAdvancedConfig,
        component: AnimatedIconsGrid.AnimatedIconsGridComponent
    },
    MarqueeCardsGridComponent: {
        type: "MarqueeCardsGridComponent",
        title: "Marquee Cards",
        imgSrc: "/static/img/segments/layouts/marquee-cards-grid.png",
        config: MarqueeCardsGrid.MarqueeCardsGridConfig,
        advancedConfig: MarqueeCardsGrid.MarqueeCardsGridAdvancedConfig,
        component: MarqueeCardsGrid.MarqueeCardsGridComponent
    },
    HoverableCardsGridComponent: {
        type: "HoverableCardsGridComponent",
        title: "Hoverable Cards",
        imgSrc: "/static/img/segments/layouts/hoverable-cards-grid.png",
        config: HoverableCardsGrid.HoverableCardsGridConfig,
        advancedConfig: HoverableCardsGrid.HoverableCardsGridAdvancedConfig,
        component: HoverableCardsGrid.HoverableCardsGridComponent
    },
    MarqueeGridComponent: {
        type: "MarqueeGridComponent",
        title: "Marquee",
        imgSrc: "/static/img/segments/layouts/marquee-grid.png",
        config: MarqueeGrid.MarqueeGridConfig,
        advancedConfig: MarqueeGrid.MarqueeGridAdvancedConfig,
        component: MarqueeGrid.MarqueeGridComponent
    },
    BadgesGridComponent: {
        type: "BadgesGridComponent",
        title: "Badges",
        imgSrc: "/static/img/segments/layouts/badges-grid.png",
        config: BadgesGrid.BadgesGridConfig,
        advancedConfig: BadgesGrid.BadgesGridAdvancedConfig,
        component: BadgesGrid.BadgesGridComponent
    },
    SlidingCardGridComponent: {
        type: "SlidingCardGridComponent",
        title: "Sliding Card",
        imgSrc: "/static/img/segments/layouts/sliding-card-grid.png",
        config: SlidingCardGrid.SlidingCardGridConfig,
        advancedConfig: SlidingCardGrid.SlidingCardGridAdvancedConfig,
        component: SlidingCardGrid.SlidingCardGridComponent
    },
    PressGridComponent: {
        type: "PressGridComponent",
        title: "Press",
        imgSrc: "/static/img/segments/layouts/press-grid.png",
        config: PressGrid.PressGridConfig,
        advancedConfig: PressGrid.PressGridAdvancedConfig,
        component: PressGrid.PressGridComponent
    },
    ConnectedProductsGridComponent: {
        type: "ConnectedProductsGridComponent",
        title: "Connected Products",
        imgSrc: "/static/img/segments/layouts/connected-products-grid.png",
        config: ConnectedProductsGrid.ConnectedProductsGridConfig,
        advancedConfig: ConnectedProductsGrid.ConnectedProductsGridAdvancedConfig,
        component: ConnectedProductsGrid.ConnectedProductsGridComponent
    },
    FlexibleCardsGridComponent: {
        type: "FlexibleCardsGridComponent",
        title: "Flexible Cards",
        imgSrc: "/static/img/segments/layouts/flexible-cards-grid.png",
        config: FlexibleCardsGrid.FlexibleCardsGridConfig,
        advancedConfig: FlexibleCardsGrid.FlexibleCardsGridAdvancedConfig,
        component: FlexibleCardsGrid.FlexibleCardsGridComponent
    },
    SquareTagsGridComponent: {
        type: "SquareTagsGridComponent",
        title: "Square Tags",
        imgSrc: "/static/img/segments/layouts/square-tags-grid.png",
        config: SquareTagsGrid.SquareTagsGridConfig,
        advancedConfig: SquareTagsGrid.SquareTagsGridAdvancedConfig,
        component: SquareTagsGrid.SquareTagsGridComponent
    },
    ProductCardsGridComponent: {
        type: "ProductCardsGridComponent",
        title: "Product Cards",
        imgSrc: "/static/img/segments/layouts/product-cards-grid.png",
        config: ProductCardsGrid.ProductCardsGridConfig,
        advancedConfig: ProductCardsGrid.ProductCardsGridAdvancedConfig,
        component: ProductCardsGrid.ProductCardsGridComponent
    },
    MasonryGridComponent: {
        type: "MasonryGridComponent",
        title: "Masonry",
        imgSrc: "/static/img/segments/layouts/masonry-grid.png",
        config: MasonryGrid.MasonryGridConfig,
        advancedConfig: MasonryGrid.MasonryGridAdvancedConfig,
        component: MasonryGrid.MasonryGridComponent
    },
    TagItemsGridComponent: {
        type: "TagItemsGridComponent",
        title: "Tag Items",
        imgSrc: "/static/img/segments/layouts/tag-items-grid.png",
        config: TagItemsGrid.TagItemsGridConfig,
        advancedConfig: TagItemsGrid.TagItemsGridAdvancedConfig,
        component: TagItemsGrid.TagItemsGridComponent
    },
    IconWithParagraphGridComponent: {
        type: "IconWithParagraphGridComponent",
        title: "Icon With Paragraph",
        imgSrc: "/static/img/segments/layouts/icon-with-paragraph-grid.png",
        config: IconWithParagraphGrid.IconWithParagraphGridConfig,
        advancedConfig: IconWithParagraphGrid.IconWithParagraphGridAdvancedConfig,
        component: IconWithParagraphGrid.IconWithParagraphGridComponent
    },
    SelectableTagsWithCarouselGridComponent: {
        type: "SelectableTagsWithCarouselGridComponent",
        title: "Selectable Tags With Carousel",
        imgSrc: "/static/img/segments/layouts/selectable-tags-with-carousel-grid.png",
        config: SelectableTagsWithCarouselGrid.SelectableTagsWithCarouselGridConfig,
        advancedConfig: SelectableTagsWithCarouselGrid.SelectableTagsWithCarouselGridAdvancedConfig,
        component: SelectableTagsWithCarouselGrid.SelectableTagsWithCarouselGridComponent
    },
    BlogCardsGridComponent: {
        type: "BlogCardsGridComponent",
        title: "Blog Cards",
        imgSrc: "/static/img/segments/layouts/blog-cards-grid.png",
        config: BlogCardsGrid.BlogCardsGridConfig,
        advancedConfig: BlogCardsGrid.BlogCardsGridAdvancedConfig,
        component: BlogCardsGrid.BlogCardsGridComponent
    },
    ButtonImageTagsGridComponent: {
        type: "ButtonImageTagsGridComponent",
        title: "Button Image Tags",
        imgSrc: "/static/img/segments/layouts/button-image-tags-grid.png",
        config: ButtonImageTagsGrid.ButtonImageTagsGridConfig,
        advancedConfig: ButtonImageTagsGrid.ButtonImageTagsGridAdvancedConfig,
        component: ButtonImageTagsGrid.ButtonImageTagsGridComponent
    },
    ButtonTagsGridComponent: {
        type: "ButtonTagsGridComponent",
        title: "Button Tags",
        imgSrc: "/static/img/segments/layouts/button-tags-grid.png",
        config: ButtonTagsGrid.ButtonTagsGridConfig,
        advancedConfig: ButtonTagsGrid.ButtonTagsGridAdvancedConfig,
        component: ButtonTagsGrid.ButtonTagsGridComponent
    },
    CardsGridComponent: {
        type: "CardsGridComponent",
        title: "Cards",
        imgSrc: "/static/img/segments/layouts/cards-grid.png",
        config: CardsGrid.CardsGridConfig,
        advancedConfig: CardsGrid.CardsGridAdvancedConfig,
        component: CardsGrid.CardsGridComponent
    },
    TagsGridComponent: {
        type: "TagsGridComponent",
        title: "Tags",
        imgSrc: "/static/img/segments/layouts/tags-grid.png",
        config: TagsGrid.TagsGridConfig,
        advancedConfig: TagsGrid.TagsGridAdvancedConfig,
        component: TagsGrid.TagsGridComponent
    },
    SelectableTagsGridComponent: {
        type: "SelectableTagsGridComponent",
        title: "Selectable Tags Grid",
        imgSrc: "/static/img/segments/layouts/selectable-tags-grid.png",
        config: SelectableTagsGrid.SelectableTagsGridConfig,
        advancedConfig: SelectableTagsGrid.SelectableTagsGridAdvancedConfig,
        component: SelectableTagsGrid.SelectableTagsGridComponent
    },
    ImageWithParagraphGridComponent: {
        type: "ImageWithParagraphGridComponent",
        title: "Image With Paragraph",
        imgSrc: "/static/img/segments/layouts/image-with-paragraph-grid.png",
        config: ImageWithParagraphGrid.ImageWithParagraphGridConfig,
        advancedConfig: ImageWithParagraphGrid.ImageWithParagraphGridAdvancedConfig,
        component: ImageWithParagraphGrid.ImageWithParagraphGridComponent
    },
    OnlyImageGridComponent: {
        type: "OnlyImageGridComponent",
        title: "Only Image",
        imgSrc: "/static/img/segments/layouts/only-image-grid.png",
        config: OnlyImageGrid.OnlyImageGridConfig,
        advancedConfig: OnlyImageGrid.OnlyImageGridAdvancedConfig,
        component: OnlyImageGrid.OnlyImageGridComponent
    }
});


/***/ }),

/***/ 96800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ ButtonTypes; }
/* harmony export */ });
var ButtonTypes = {
    LABEL: "Label",
    PRODUCT_SIGNUP_AND_LEARN_MORE: "Product signup and learn more"
};


/***/ }),

/***/ 25627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ BADGES_PER_PRODUCT_BY_COUNTRY; },
/* harmony export */   "W": function() { return /* binding */ BADGES_COUNTRIES; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var constants_products__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84074);


/* BADGES */ var usersLoveUs = {
    name: "Users love us",
    url: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/badges/users-love-us_1_1.png"
};
var leaderMidMarketSpring23 = {
    name: "Leader mid-market spring 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/v1689246883/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/CRM_Leader_Mid-Market_Leader.png"
};
var leaderEnterpriseSpring23 = {
    name: "Leader enterprise spring 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/v1689246883/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/EmailTracking_Leader_Enterprise_Leader.png"
};
var leaderSmallBusinessSpring23 = {
    name: "Leader small business spring 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/v1689246883/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/SalesEnablement_Leader_Small-Business_Leader.png"
};
var leaderOfSpring23 = {
    name: "Leader spring 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/EmailTracking_Leader_Leader.png"
};
var momentumLeaderSpring23 = {
    name: "Momentum leader spring 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/SalesEnablement_MomentumLeader_Leader.png"
};
var top100FastestGrowingProduct = {
    name: "Top 100 fastest growing product",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/Frame_6.png"
};
var top100HighestSatisfactionProduct = {
    name: "Top 100 highest satisfaction product",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/Frame_5.png"
};
var top50SmallBusinessProduct = {
    name: "Top 50 small business product",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/Frame_3.png"
};
var top100SoftwareProduct = {
    name: "Top 100 software product",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/Frame_4.png"
};
var top50SalesProduct = {
    name: "Top 50 sales product",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/Frame_2.png"
};
var crmUsersLoveAll = {
    name: "Users love us",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Individual%20badges/Group_2.png"
};
var bestUsabilitySmallBusinessSpring23 = {
    name: "Best usability small business spring 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/best_usability_small_spring23.png"
};
var leaderAnzSpring23 = {
    name: "Leader ANZ spring 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Leader_ANZ_spring23.png"
};
var leaderAsiaPacificSpring23 = {
    name: "Leader Asia Pacific spring 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Leader_asaia_pasific_spring23.png"
};
var leaderAsiaSpring23 = {
    name: "Leader Asia spring 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/DafnaGlik/CRM%20LP%20assets/Leader_Asia_spring23.png"
};
var bestEstRoiEnterpriseFall2023 = {
    name: "Best estimated ROI enterprise fall 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/G2%20Fall%202023/WorkManagement_BestEstRoi_Fall_2023.png"
};
var easiestSetupEnterpriseFall2023 = {
    name: "Easiest setup enterprise fall 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/G2%20Fall%202023/WorkManagement_EasiestSetup_Fall_2023.png"
};
var momentumLeaderFall2023 = {
    name: "Momentum leader fall 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/G2%20Fall%202023/WorkManagement_MomentumLeader_Fall_2023.png"
};
var bestUsabilityFall2023 = {
    name: "Best usability fall 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/G2%20Fall%202023/WorkManagement_BestUsability_Fall_2023.png"
};
var bestRelationshipFall2023 = {
    name: "Best relationship fall 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/G2%20Fall%202023/WorkManagement_BestRelationship_Fall_2023.png"
};
var fastestImplementationEnterpriseFall2023 = {
    name: "Fastest implementation enterprise fall 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/G2%20Fall%202023/WorkManagement_FastestImplementation_Fall_2023.png"
};
var leaderFall2023 = {
    name: "Leader fall 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/G2%20Fall%202023/WorkManagement_Leader_Fall_2023.png"
};
var bestResultsEnterpriseFall2023 = {
    name: "Best results enterprise fall 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/G2%20Fall%202023/WorkManagement_BestResults_Fall_2023.png"
};
var highPerformerEnterpriseWinter2023 = {
    name: "High performer enterprise winter 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/G2%20Badges/2023%20Winter/CRM_HighPerformer_Enterprise_HighPerformer.png"
};
var leaderEuropeWinter2023 = {
    name: "Leader Europe winter 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/G2%20Badges/2023%20Winter/CRM_Leader_Europe_Leader.png"
};
var leaderMidMarketWinter2023 = {
    name: "Leader mid-market winter 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/G2%20Badges/2023%20Winter/CRM_Leader_Mid-Market_Leader.png"
};
var leaderSmallBusinessWinter2023 = {
    name: "Leader small business winter 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/G2%20Badges/2023%20Winter/CRM_Leader_Small-Business_Leader.png"
};
var momentumLeaderWinter2023 = {
    name: "Momentum leader winter 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/G2%20Badges/2023%20Winter/CRM_MomentumLeader_Leader.png"
};
var bestUsabilitySmallBusinessWinter2023 = {
    name: "Best usability small business winter 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/G2%20Badges/2023%20Winter/SalesEnablement_BestUsability_Small-Business_Total.png"
};
var leaderEnterpriseWinter2023 = {
    name: "Leader enterprise winter 2023",
    url: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/G2%20Badges/2023%20Winter/EmailTracking_Leader_Enterprise_Leader.png"
};
/* BADGES PER PRODUCT PER COUNTRY */ var BADGES_WORK_MANAGEMENT_GENRAL = [
    easiestSetupEnterpriseFall2023,
    bestResultsEnterpriseFall2023,
    bestUsabilityFall2023,
    momentumLeaderFall2023,
    usersLoveUs,
    leaderFall2023,
    bestRelationshipFall2023,
    fastestImplementationEnterpriseFall2023,
    bestEstRoiEnterpriseFall2023
];
var BADGES_CRM_GENERAL = [
    leaderMidMarketSpring23,
    leaderEnterpriseSpring23,
    leaderSmallBusinessSpring23,
    leaderOfSpring23,
    momentumLeaderSpring23,
    crmUsersLoveAll,
    top100FastestGrowingProduct,
    top100HighestSatisfactionProduct,
    top50SmallBusinessProduct,
    top100SoftwareProduct,
    top50SalesProduct
];
var BADGES_CRM_JAPAN = [
    leaderMidMarketSpring23,
    leaderEnterpriseSpring23,
    leaderSmallBusinessSpring23,
    leaderOfSpring23,
    momentumLeaderSpring23,
    crmUsersLoveAll,
    top50SalesProduct,
    bestUsabilitySmallBusinessSpring23,
    leaderAnzSpring23,
    leaderAsiaPacificSpring23,
    leaderAsiaSpring23
];
var BADGES_CRM_FRANCE = [
    top50SalesProduct,
    top100SoftwareProduct,
    bestUsabilitySmallBusinessWinter2023,
    highPerformerEnterpriseWinter2023,
    top100HighestSatisfactionProduct,
    crmUsersLoveAll,
    leaderMidMarketWinter2023,
    leaderSmallBusinessWinter2023,
    momentumLeaderWinter2023,
    leaderEuropeWinter2023,
    leaderEnterpriseWinter2023
];
/* EXPORTS */ var BADGES_COUNTRIES = {
    GENERAL: "General (default)",
    JAPAN: "Japan",
    FRANCE: "France"
};
var _obj, _obj1;
var BADGES_PER_PRODUCT_BY_COUNTRY = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_products__WEBPACK_IMPORTED_MODULE_0__/* .WORK_MANAGEMENT_PRODUCT_ID */ .py, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, BADGES_COUNTRIES.GENERAL, BADGES_WORK_MANAGEMENT_GENRAL)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_products__WEBPACK_IMPORTED_MODULE_0__/* .CRM_PRODUCT_ID */ .$, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BADGES_COUNTRIES.GENERAL, BADGES_CRM_GENERAL), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BADGES_COUNTRIES.JAPAN, BADGES_CRM_JAPAN), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, BADGES_COUNTRIES.FRANCE, BADGES_CRM_FRANCE), _obj)), _obj1);


/***/ }),

/***/ 26455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_products__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84074);

/* harmony default export */ __webpack_exports__["Z"] = ({
    product: constants_products__WEBPACK_IMPORTED_MODULE_0__/* .WORK_MANAGEMENT_PRODUCT_ID */ .py,
    horizontalPadding: "250px"
});


/***/ }),

/***/ 72606:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    CARD_WIDTH: 390,
    IMAGE_HEIGHT: 188,
    WRITER_AVATAR_IMAGE_HEIGHT: 40,
    WRITER_AVATAR_IMAGE_WIDTH: 40
});


/***/ }),

/***/ 73767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_grid_paragraph_with_image_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41667);
/* harmony import */ var segments_segments_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(861);
/* harmony import */ var segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60633);
/* harmony import */ var constants_align_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79409);
/* harmony import */ var constants_align_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(constants_align_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13225);
/* harmony import */ var segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24586);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(273);
/* harmony import */ var _flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71021);

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var image = components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_5__/* ["default"].image */ .Z.image;
var src = image.fields.src;
var mobileImage = _object_spread_props(_object_spread({}, image), {
    label: "Mobile image"
});
var backgroundImage = _object_spread_props(_object_spread({}, image), {
    label: "Card background image",
    fields: _object_spread_props(_object_spread({
        backgroundPosition: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
            label: "Background position",
            options: [
                "left",
                "center",
                "right"
            ]
        }
    }, image.fields), {
        src: _object_spread_props(_object_spread({}, src), {
            getFullUrl: true
        })
    })
});
var backSideBackgroundImage = _object_spread_props(_object_spread({}, image), {
    label: "Card back side background image",
    fields: _object_spread_props(_object_spread({
        backgroundPosition: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
            label: "Background position",
            options: [
                "left",
                "center",
                "right"
            ]
        }
    }, image.fields), {
        src: _object_spread_props(_object_spread({}, src), {
            getFullUrl: true
        })
    })
});
/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Cards",
    fields: _object_spread_props(_object_spread({}, segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z), {
        borderColor: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
            label: "Border color",
            possibleColors: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .BACKGROUND_COLOR_OPTIONS */ .L6).concat([
                styles_color_consts__WEBPACK_IMPORTED_MODULE_9__.GAINSBORO_COLOR_NAME
            ])
        },
        shadowCards: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
            label: "Add shadow to all cards"
        },
        removeShadowOnHover: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
            label: "Remove shadow on hover"
        },
        gridAlignment: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
            label: "Grid alignment",
            options: [
                constants_align_types__WEBPACK_IMPORTED_MODULE_4__.ALIGN_TYPES.LEFT,
                constants_align_types__WEBPACK_IMPORTED_MODULE_4__.ALIGN_TYPES.CENTER,
                constants_align_types__WEBPACK_IMPORTED_MODULE_4__.ALIGN_TYPES.RIGHT
            ]
        },
        innerPadding: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
            label: "Inner padding"
        },
        gridItems: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Grid Items",
            nestedConfig: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
                fields: _object_spread_props(_object_spread({
                    cardColor: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                        label: "Card color",
                        possibleColors: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .BACKGROUND_COLOR_OPTIONS */ .L6).concat([
                            styles_color_consts__WEBPACK_IMPORTED_MODULE_9__.TRANSPARENT_COLOR_NAME
                        ])
                    },
                    backgroundImage: backgroundImage,
                    cardNumOfColumnsWidth: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
                        label: "Card width",
                        options: [
                            {
                                text: "25% (recommended image width: ".concat(_flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .COLUMN_WIDTH */ .p, "px)"),
                                value: 1
                            },
                            {
                                text: "33% (recommended image width: ".concat(_flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .COLUMN_WIDTH */ .p * 1.33 + _flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .MARGIN_BETWEEN_CARDS */ .K, "px)"),
                                value: 1.33
                            },
                            {
                                text: "33% - small version (recommended image width: ".concat(_flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .COLUMN_WIDTH */ .p * 1.2 + _flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .MARGIN_BETWEEN_CARDS */ .K, "px)"),
                                value: 1.2
                            },
                            {
                                text: "50% (recommended image width: ".concat(_flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .COLUMN_WIDTH */ .p * 2 + _flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .MARGIN_BETWEEN_CARDS */ .K, "px)"),
                                value: 2
                            },
                            {
                                text: "66% (recommended image width: ".concat(_flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .COLUMN_WIDTH */ .p * 2.66 + _flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .MARGIN_BETWEEN_CARDS */ .K, "px)"),
                                value: 2.66
                            },
                            {
                                text: "75% (recommended image width: ".concat(_flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .COLUMN_WIDTH */ .p * 3 + _flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .MARGIN_BETWEEN_CARDS */ .K * 2, "px)"),
                                value: 3
                            },
                            {
                                text: "100% (recommended image width: ".concat(_flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .COLUMN_WIDTH */ .p * 4 + _flexible_cards_consts__WEBPACK_IMPORTED_MODULE_7__/* .MARGIN_BETWEEN_CARDS */ .K * 3, "px)"),
                                value: 4
                            }
                        ]
                    },
                    paragraphVerticalColoredLineColor: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                        label: "Paragraph vertical colored line color",
                        possibleColors: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .BACKGROUND_COLOR_OPTIONS */ .L6
                    }
                }, segments_desktop_core_components_grid_paragraph_with_image_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
                    mobileImage: mobileImage,
                    cardTagText: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                        label: "Card tag text"
                    },
                    cardTagColor: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                        label: "Card tag color",
                        possibleColors: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .BACKGROUND_COLOR_OPTIONS */ .L6
                    },
                    addBackLayerContent: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                        label: "Add background content"
                    },
                    footer: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
                        label: "Footer",
                        fields: {
                            showFooter: {
                                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                                label: "Show footer"
                            },
                            image: {
                                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
                                label: "Footer image"
                            },
                            imageWidth: {
                                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                                label: "Footer image width"
                            },
                            text: {
                                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                                label: "Footer text",
                                textArea: true,
                                rows: 5
                            }
                        }
                    },
                    cardBackLayerContent: {
                        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
                        label: "Card back layer content",
                        fields: {
                            contentVerticalAlignment: {
                                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
                                label: "Content Vertical Alignment",
                                options: [
                                    "top",
                                    "center",
                                    "bottom"
                                ]
                            },
                            backSideBackgroundImage: backSideBackgroundImage,
                            backLayerFullParagraph: {
                                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
                                label: "Full paragraph",
                                fields: _object_spread({}, segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)
                            }
                        }
                    }
                })
            }
        }
    })
});


/***/ }),

/***/ 6795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nc": function() { return /* binding */ cardsProps; },
/* harmony export */   "Q4": function() { return /* binding */ GLOBAL_LOCATION; },
/* harmony export */   "RE": function() { return /* binding */ ISRAEL_LOCATION; },
/* harmony export */   "dP": function() { return /* binding */ israelGridItems; },
/* harmony export */   "mz": function() { return /* binding */ globalGridItems; }
/* harmony export */ });
/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77869);

var ISRAEL_LOCATION = "israel";
var GLOBAL_LOCATION = "global";
var cardsProps = {
    shadowCards: true,
    removeShadowOnHover: false,
    gridAlignment: "center",
    titleSize: constants_sizes__WEBPACK_IMPORTED_MODULE_0__.XS
};
var israelGridItems = [
    {
        cardNumOfColumnsWidth: 1.2,
        height: 300,
        width: 300,
        fullParagraph: {
            topic: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/small%20logos/Fast_company_logo_small.png"
                }
            },
            title: "<b>With apps for forms and whiteboards, monday.com is building a suite</b>",
            body: ""
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Fast_company_thumbnail.png",
        mobileImage: {
            src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Fast_company_thumbnail.png"
        },
        link: {
            href: "https://www.fastcompany.com/90724310/monday-com-workforms-canvas"
        }
    },
    {
        cardNumOfColumnsWidth: 1.2,
        height: 300,
        width: 300,
        fullParagraph: {
            topic: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/small%20logos/Protocol_logo_small.png"
                }
            },
            title: "<b>Why monday thinks it can win the future of work</b>",
            body: ""
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Protocol_thumbnail.png",
        mobileImage: {
            src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Protocol_thumbnail.png"
        },
        link: {
            href: "https://www.protocol.com/workplace/monday-app-ipo"
        }
    },
    {
        cardNumOfColumnsWidth: 1.2,
        height: 300,
        width: 300,
        fullParagraph: {
            topic: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/small%20logos/Maariv_logo_small.png"
                }
            },
            title: "<b>monday.com is the 5th Best Place to work in Israel - Dun's 100</b>",
            body: ""
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Maariv_thumbnail.png",
        mobileImage: {
            src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Maariv_thumbnail.png"
        },
        link: {
            href: "https://www.maariv.co.il/business/tech/Article-958561"
        }
    }
];
var globalGridItems = [
    {
        cardNumOfColumnsWidth: 1.2,
        height: 300,
        width: 300,
        fullParagraph: {
            topic: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/small%20logos/Fast_company_logo_small.png"
                }
            },
            title: "<b>With apps for forms and whiteboards, monday.com is building a suite</b>",
            body: ""
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Fast_company_thumbnail.png",
        mobileImage: {
            src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Fast_company_thumbnail.png"
        },
        link: {
            href: "https://www.fastcompany.com/90724310/monday-com-workforms-canvas"
        }
    },
    {
        cardNumOfColumnsWidth: 1.2,
        height: 300,
        width: 300,
        fullParagraph: {
            topic: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/small%20logos/Protocol_logo_small.png"
                }
            },
            title: "<b>Why monday thinks it can win the future of work</b>",
            body: ""
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Protocol_thumbnail.png",
        mobileImage: {
            src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Protocol_thumbnail.png"
        },
        link: {
            href: "https://www.protocol.com/workplace/monday-app-ipo"
        }
    },
    {
        cardNumOfColumnsWidth: 1.2,
        height: 300,
        width: 300,
        fullParagraph: {
            topic: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/small%20logos/Great_placel_logo_small.png"
                }
            },
            title: "<b>Great place to work certified</b>",
            body: ""
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Great_place_to_work_thumbnail.png",
        mobileImage: {
            src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Great_place_to_work_thumbnail.png"
        },
        link: {
            href: "https://www.maariv.co.il/business/tech/Article-958561"
        }
    }
];


/***/ }),

/***/ 96817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_selectable_tags_grid_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1117);


/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Selectable tags layout",
    fields: segments_desktop_core_components_selectable_tags_grid_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
});


/***/ }),

/***/ 14061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_shared_advanced_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69223);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(_object_spread({
        width: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
            label: "Max Width (%)"
        }
    }, segments_desktop_shared_advanced_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
        noImageWidth: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
            label: "No Image Width"
        },
        tagTextSize: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
            label: "Tag Text Size"
        }
    })
});


/***/ }),

/***/ 48127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tag_items_grid_config; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
;// CONCATENATED MODULE: ./segments/desktop/core-components/tag/fields-config.js

/* harmony default export */ var fields_config = ({
    tagText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Text",
        translatable: true
    },
    tagIconsrc: {
        type: template_field_type.FIELD_TYPES.GALLERY,
        label: "Select an Image"
    },
    href: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Href"
    },
    openInNewTab: {
        type: "boolean",
        label: "Should Open In New Tab"
    }
});

// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/color-picker-constants.js
var color_picker_constants = __webpack_require__(95947);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/tag-items-grid/tag-items-grid-config.js

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





/* harmony default export */ var tag_items_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Tags Grid",
    fields: _object_spread_props(_object_spread({}, theme_config/* default */.Z), {
        gridTagsBackgroundColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Tags background color",
            possibleColors: (0,_to_consumable_array/* default */.Z)(color_picker_constants.newBrandColors).concat([
                color_consts.TRANSPARENT_COLOR_NAME
            ])
        },
        gridTagsImageHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tag images height"
        },
        gridTags: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tag",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: _object_spread({}, fields_config)
            }
        }
    })
});


/***/ }),

/***/ 40216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ homepage_first_fold; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var fields_config = __webpack_require__(13225);
// EXTERNAL MODULE: ./components/core/asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(25289);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/platform-interactive-experience-homepage-first-fold/platform-interactive-experience-homepage-first-fold-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






/* harmony default export */ var platform_interactive_experience_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Platform Interactive Experience",
    fields: _object_spread_props(_object_spread({}, theme_config/* default */.Z), {
        backgroundImage: {
            type: template_field_type.FIELD_TYPES.GALLERY,
            label: "Background Image"
        },
        backgroundSize: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Background Size"
        },
        glowImage: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Glow Image",
            fields: {
                src: {
                    type: template_field_type.FIELD_TYPES.GALLERY,
                    label: "Image"
                },
                width: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Width"
                },
                positionTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Position Top"
                },
                positionLeft: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Position Left"
                }
            }
        },
        interactions: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Interactions",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    label: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Label"
                    },
                    icon: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Icon"
                    },
                    image: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Image",
                        fields: {
                            src: {
                                type: template_field_type.FIELD_TYPES.GALLERY,
                                label: "Image"
                            },
                            width: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Width"
                            }
                        }
                    },
                    actionAsset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Action asset",
                        fields: _object_spread({}, fields_config/* default */.Z, advanced_field_config/* default */.Z)
                    },
                    position: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Position",
                        fields: {
                            top: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Top"
                            },
                            left: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Left"
                            }
                        }
                    },
                    secondaryPosition: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Secondary Position (optional)",
                        fields: {
                            top: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Top"
                            },
                            left: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Left"
                            }
                        }
                    },
                    content: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Content",
                        fields: _object_spread({}, full_paragraph_fields_config/* default */.Z, advanced_fields_config/* default */.Z)
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/platform-interactive-experience-homepage-first-fold/platform-interactive-experience-homepage-first-fold-advanced-config.js
function platform_interactive_experience_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function platform_interactive_experience_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            platform_interactive_experience_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function platform_interactive_experience_homepage_first_fold_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function platform_interactive_experience_homepage_first_fold_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        platform_interactive_experience_homepage_first_fold_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var platform_interactive_experience_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: platform_interactive_experience_homepage_first_fold_advanced_config_object_spread_props(platform_interactive_experience_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        segmentHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Segment Height"
        },
        segmentMaxHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Segment Max Height"
        },
        rippleEffectAnimationDuration: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Ripple Effect Animation Duration (s)"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/platform-interactive-experience-homepage-first-fold/index.js

var PlatformInteractiveExperienceHomepageFirstFoldComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7407).then(__webpack_require__.bind(__webpack_require__, 7407));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7407)
            ];
        }
    }
});


/* harmony default export */ var platform_interactive_experience_homepage_first_fold = ({
    PlatformInteractiveExperienceHomepageFirstFoldComponent: PlatformInteractiveExperienceHomepageFirstFoldComponent,
    PlatformInteractiveExperienceHomepageFirstFoldConfig: platform_interactive_experience_homepage_first_fold_config,
    PlatformInteractiveExperienceHomepageFirstFoldAdvancedConfig: platform_interactive_experience_homepage_first_fold_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var title_fields_config = __webpack_require__(65621);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/fields-config.js
var paragraph_fields_config = __webpack_require__(49496);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/tags-by-product-homepage-first-fold/tags-by-product-homepage-first-fold-config.js
function tags_by_product_homepage_first_fold_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function tags_by_product_homepage_first_fold_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            tags_by_product_homepage_first_fold_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function tags_by_product_homepage_first_fold_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function tags_by_product_homepage_first_fold_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        tags_by_product_homepage_first_fold_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var restOfTitleConfig = _extends({}, _object_destructuring_empty(title_fields_config/* default */.Z));
var restOfParagraphConfig = _extends({}, _object_destructuring_empty(paragraph_fields_config/* default */.Z));
var textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, mobileTextAlign = full_paragraph_fields_config/* default.mobileTextAlign */.Z.mobileTextAlign, textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, topic = full_paragraph_fields_config/* default.topic */.Z.topic, tags_by_product_homepage_first_fold_config_button = full_paragraph_fields_config/* default.buttonConfig */.Z.buttonConfig, restFullParagraphFieldsConfig = _object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "textAlign",
    "mobileTextAlign",
    "textColor",
    "topic",
    "buttonConfig"
]);
/* harmony default export */ var tags_by_product_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Tags By Product",
    fields: tags_by_product_homepage_first_fold_config_object_spread_props(tags_by_product_homepage_first_fold_config_object_spread({}, theme_config/* default */.Z), {
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full paragraph",
            fields: restFullParagraphFieldsConfig
        },
        subTitle: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Sub title",
            fields: title_fields_config/* default */.Z
        },
        tabsPaddingTop: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tabs padding top"
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    productType: {
                        type: template_field_type.FIELD_TYPES.PRODUCTS,
                        label: "Product type"
                    },
                    title: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab title",
                        fields: tags_by_product_homepage_first_fold_config_object_spread({
                            productImage: {
                                type: template_field_type.FIELD_TYPES.GALLERY,
                                label: "Product logo image"
                            },
                            selectedProductImage: {
                                type: template_field_type.FIELD_TYPES.GALLERY,
                                label: "Selected product logo image"
                            }
                        }, restOfTitleConfig, restOfParagraphConfig)
                    },
                    tabContent: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab content",
                        fields: {
                            clusters: {
                                type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                                label: "Clusters",
                                maxLimit: 9,
                                nestedConfig: {
                                    type: template_field_type.FIELD_TYPES.NESTED,
                                    fields: {
                                        text: {
                                            type: template_field_type.FIELD_TYPES.TEXT,
                                            label: "Text",
                                            translatable: true
                                        },
                                        image: {
                                            type: template_field_type.FIELD_TYPES.GALLERY,
                                            label: "Image"
                                        },
                                        colorName: {
                                            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                                            label: "Color"
                                        },
                                        clusterId: {
                                            type: template_field_type.FIELD_TYPES.CLUSTERS,
                                            label: "Cluster Id"
                                        },
                                        useCaseId: {
                                            type: template_field_type.FIELD_TYPES.SUB_CLUSTERS,
                                            label: "Usecase Id"
                                        },
                                        initiallySelected: {
                                            type: template_field_type.FIELD_TYPES.BOOLEAN,
                                            label: "Initially selected"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        progressbarColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Progress Bar Color"
        },
        isV2: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Is V2"
        },
        excludeFromWMHighIntentExperienceTest: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Exclude from WN high intent test (don't use)"
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var title_advanced_field_config = __webpack_require__(95760);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/tags-by-product-homepage-first-fold/tags-by-product-homepage-first-fold-advanced-config.js
function tags_by_product_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function tags_by_product_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            tags_by_product_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function tags_by_product_homepage_first_fold_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = tags_by_product_homepage_first_fold_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function tags_by_product_homepage_first_fold_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var topicBottomMargin = advanced_fields_config/* default.topicBottomMargin */.Z.topicBottomMargin, buttonTopMargin = advanced_fields_config/* default.buttonTopMargin */.Z.buttonTopMargin, restOfParagraphAdvancedConfig = tags_by_product_homepage_first_fold_advanced_config_object_without_properties(advanced_fields_config/* default */.Z, [
    "topicBottomMargin",
    "buttonTopMargin"
]);
/* harmony default export */ var tags_by_product_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: tags_by_product_homepage_first_fold_advanced_config_object_spread({
        fullParagraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: restOfParagraphAdvancedConfig
        },
        subTitleAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Sub title",
            fields: title_advanced_field_config/* default */.Z
        }
    }, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/tags-by-product-homepage-first-fold/index.js

var TagsByProductHomepageFirstFoldComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4069), __webpack_require__.e(4864), __webpack_require__.e(2948), __webpack_require__.e(3744)]).then(__webpack_require__.bind(__webpack_require__, 43744));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43744)
            ];
        }
    }
});


/* harmony default export */ var tags_by_product_homepage_first_fold = ({
    TagsByProductHomepageFirstFoldComponent: TagsByProductHomepageFirstFoldComponent,
    TagsByProductHomepageFirstFoldConfig: tags_by_product_homepage_first_fold_config,
    TagsByProductHomepageFirstFoldAdvancedConfig: tags_by_product_homepage_first_fold_advanced_config
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-config.js
var full_with_bullets_paragraph_config = __webpack_require__(87313);
// EXTERNAL MODULE: ./constants/color-picker-constants.js
var color_picker_constants = __webpack_require__(95947);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/products-by-use-cases-homepage-first-fold/products-by-use-cases-homepage-first-fold-config.js

function products_by_use_cases_homepage_first_fold_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function products_by_use_cases_homepage_first_fold_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            products_by_use_cases_homepage_first_fold_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function products_by_use_cases_homepage_first_fold_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function products_by_use_cases_homepage_first_fold_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        products_by_use_cases_homepage_first_fold_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function products_by_use_cases_homepage_first_fold_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = products_by_use_cases_homepage_first_fold_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function products_by_use_cases_homepage_first_fold_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var _FullWithBulletsParagraphConfig_fields = full_with_bullets_paragraph_config/* default.fields */.Z.fields, products_by_use_cases_homepage_first_fold_config_topic = _FullWithBulletsParagraphConfig_fields.topic, buttonConfig = _FullWithBulletsParagraphConfig_fields.buttonConfig, body = _FullWithBulletsParagraphConfig_fields.body, theme = _FullWithBulletsParagraphConfig_fields.theme, products_by_use_cases_homepage_first_fold_config_mobileTextAlign = _FullWithBulletsParagraphConfig_fields.mobileTextAlign, bodyColor = _FullWithBulletsParagraphConfig_fields.bodyColor, titleColor = _FullWithBulletsParagraphConfig_fields.titleColor, bulletsConfig = _FullWithBulletsParagraphConfig_fields.bulletsConfig, restOfFullWithBulletsParagraphConfigFields = products_by_use_cases_homepage_first_fold_config_object_without_properties(_FullWithBulletsParagraphConfig_fields, [
    "topic",
    "buttonConfig",
    "body",
    "theme",
    "mobileTextAlign",
    "bodyColor",
    "titleColor",
    "bulletsConfig"
]);
/* harmony default export */ var products_by_use_cases_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Products By Use Cases",
    fields: {
        horizontalPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Products horizontal padding"
        },
        tagsTitle: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tags title",
            textArea: true,
            translatable: true
        },
        sideBarTitle: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Use cases side bar title",
            textArea: true,
            translatable: true
        },
        useCases: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Use cases",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tag: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: {
                            text: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Tag text",
                                translatable: true
                            },
                            color: {
                                type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                                label: "Tag Color",
                                possibleColors: (0,_to_consumable_array/* default */.Z)(color_picker_constants.newBrandColors).concat([
                                    "orange"
                                ])
                            }
                        }
                    },
                    clusterId: {
                        type: template_field_type.FIELD_TYPES.CLUSTERS,
                        label: "Cluster Id"
                    },
                    product: {
                        label: "Product",
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: products_by_use_cases_homepage_first_fold_config_object_spread_props(products_by_use_cases_homepage_first_fold_config_object_spread({}, restOfFullWithBulletsParagraphConfigFields), {
                            productType: {
                                type: template_field_type.FIELD_TYPES.PRODUCTS,
                                label: "Product type"
                            },
                            bulletsConfig: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Product use cases",
                                fields: {
                                    bullets: bulletsConfig.fields.bullets
                                }
                            },
                            asset: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Asset",
                                fields: fields_config/* default */.Z
                            }
                        })
                    }
                }
            }
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-advanced-config.js
var full_with_bullets_paragraph_advanced_config = __webpack_require__(29737);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/products-by-use-cases-homepage-first-fold/products-by-use-cases-homepage-first-fold-advanced-config.js
function products_by_use_cases_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function products_by_use_cases_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            products_by_use_cases_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function products_by_use_cases_homepage_first_fold_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function products_by_use_cases_homepage_first_fold_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        products_by_use_cases_homepage_first_fold_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function products_by_use_cases_homepage_first_fold_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = products_by_use_cases_homepage_first_fold_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function products_by_use_cases_homepage_first_fold_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var products_by_use_cases_homepage_first_fold_advanced_config_bulletsConfig = full_with_bullets_paragraph_config/* default.fields.bulletsConfig */.Z.fields.bulletsConfig;
var _FullWithBulletsParagraphAdvancedConfig_fields = full_with_bullets_paragraph_advanced_config/* default.fields */.Z.fields, topTriangle = _FullWithBulletsParagraphAdvancedConfig_fields.topTriangle, bottomTriangle = _FullWithBulletsParagraphAdvancedConfig_fields.bottomTriangle, segmentId = _FullWithBulletsParagraphAdvancedConfig_fields.segmentId, segmentMinHeight = _FullWithBulletsParagraphAdvancedConfig_fields.segmentMinHeight, restOfParagraph = products_by_use_cases_homepage_first_fold_advanced_config_object_without_properties(_FullWithBulletsParagraphAdvancedConfig_fields, [
    "topTriangle",
    "bottomTriangle",
    "segmentId",
    "segmentMinHeight"
]);
/* harmony default export */ var products_by_use_cases_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: products_by_use_cases_homepage_first_fold_advanced_config_object_spread_props(products_by_use_cases_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        parallaxSpeed: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Parallax speed"
        },
        tagsTitleAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Tags title",
            fields: title_advanced_field_config/* default */.Z
        },
        tagsVerticalPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tags vertical padding"
        },
        hidePanel: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Hide upper tags panel"
        },
        tagsFontSize: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Tags text size",
            options: [
                {
                    value: "0.8125rem",
                    text: "13px"
                },
                {
                    value: "0.875rem",
                    text: "14px"
                }
            ]
        },
        productAdvanceConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Product advanced config",
            fields: {
                productDetailsVerticalPadding: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Product details left padding"
                },
                useCasesAdvancedConfig: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Product use cases",
                    fields: {
                        horizontalPadding: {
                            type: template_field_type.FIELD_TYPES.TEXT,
                            label: "Horizontal padding"
                        },
                        productParagraph: {
                            type: template_field_type.FIELD_TYPES.NESTED,
                            label: "Product paragraph",
                            fields: restOfParagraph
                        },
                        bulletTextSize: products_by_use_cases_homepage_first_fold_advanced_config_bulletsConfig.fields.bulletTextSize
                    }
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/products-by-use-cases-homepage-first-fold/index.js



var ProductsByUseCasesHomepageFirstFoldComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2160).then(__webpack_require__.bind(__webpack_require__, 12160));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12160)
            ];
        }
    }
});
/* harmony default export */ var products_by_use_cases_homepage_first_fold = ({
    ProductsByUseCasesHomepageFirstFoldComponent: ProductsByUseCasesHomepageFirstFoldComponent,
    ProductsByUseCasesHomepageFirstFoldConfig: products_by_use_cases_homepage_first_fold_config,
    ProductsByUseCasesHomepageFirstFoldAdvancedConfig: products_by_use_cases_homepage_first_fold_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/fields-config.js
var signup_button_fields_config = __webpack_require__(96587);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/advanced-fields-config.js
var paragraph_advanced_fields_config = __webpack_require__(50342);
// EXTERNAL MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-products-homepage-first-fold/consts.js + 3 modules
var consts = __webpack_require__(78679);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-products-homepage-first-fold/monday-products-homepage-first-fold-config.js
function monday_products_homepage_first_fold_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = monday_products_homepage_first_fold_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function monday_products_homepage_first_fold_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var signupWithsolutionAppReferenceId = signup_button_fields_config/* default.signupWithsolutionAppReferenceId */.Z.signupWithsolutionAppReferenceId, signupClusterId = signup_button_fields_config/* default.signupClusterId */.Z.signupClusterId, restSignupButtonConfig = monday_products_homepage_first_fold_config_object_without_properties(signup_button_fields_config/* default */.Z, [
    "signupWithsolutionAppReferenceId",
    "signupClusterId"
]);
var textSize = paragraph_advanced_fields_config/* default.textSize */.Z.textSize;
/* harmony default export */ var monday_products_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Monday Products",
    fields: {
        version: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Version",
            options: [
                {
                    value: consts/* HOSPITAL */.Lj,
                    text: "Hospital"
                },
                {
                    value: consts/* APPS */.ei,
                    text: "Apps"
                },
                {
                    value: consts/* ILLUSTRATIVE */.kr,
                    text: "Illustrative"
                }
            ]
        },
        isV2: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Is V2"
        },
        checkBoxInsteadOfModal: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Checkbox Instead Of Modal"
        },
        removeCheckbox: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Remove checkbox"
        },
        setCardImageAsBackground: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Set Card Image As Background"
        },
        idealForAndImage: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Ideal For And Image"
        },
        IdealForInBottomPart: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Add Ideal For In Card Bottom Part"
        },
        scaleWhenSelecting: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Scale When Selecting A Card"
        },
        removeSignupButton: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Remove Sign Up Button"
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full paragraph",
            fields: full_paragraph_fields_config/* default */.Z
        },
        subTitle: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Sub title",
            fields: title_fields_config/* default */.Z
        },
        buttonConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Signup button",
            fields: restSignupButtonConfig
        },
        distanceOfBottomPartFromTop: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Distance of bottom part from top when hovered"
        },
        cardWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Card Width"
        },
        logoWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Logo Width"
        },
        cardBackSidePaddingTop: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Card Back Side Padding Top"
        },
        departmentsHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Departments Height"
        },
        departmentsTitle: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Departments title"
        },
        cancelFlip: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Cancel Flip"
        },
        products: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Products",
            maxLimit: 3,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    productType: {
                        type: template_field_type.FIELD_TYPES.COMBO,
                        label: "Product type",
                        options: products/* PRODUCT_OPTIONS */.ey
                    },
                    text: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Card Text",
                        translatable: true,
                        textArea: true
                    },
                    modalTitle: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Product modal title",
                        translatable: true,
                        textArea: true
                    },
                    modalSubTitle: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Product modal subtitle",
                        translatable: true,
                        textArea: true
                    },
                    textSize: textSize,
                    marginAboveCardText: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Margin Above Card Text"
                    },
                    marginUnderCardText: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Margin Under Card Text"
                    },
                    logoImage: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Product Logo Image"
                    },
                    productImage: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Product Image"
                    },
                    logoImageV2: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Product Logo Image V2 (also in modal)"
                    },
                    productImageV2: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Product Image V2"
                    },
                    cardBackImagev3: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "V3 Card Back Image"
                    },
                    productModalImage: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "V3 Product Modal Image"
                    },
                    backgroundColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Color"
                    },
                    cardMainColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Card Main Color"
                    },
                    cardButtonColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Card Main CTA Button Color"
                    },
                    useCasesTagesTextColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Use Cases Tags Text Color"
                    },
                    useCasesTagsBackgroundColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Use Cases Tags Background Color"
                    },
                    bottomPartBackgroundColorV2: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Bottom Part Background Color V2"
                    },
                    cardBackBackgroundColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "V3 Back color"
                    },
                    departments: {
                        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                        label: "Departments",
                        maxLimit: 10,
                        nestedConfig: {
                            type: template_field_type.FIELD_TYPES.NESTED,
                            fields: {
                                text: {
                                    type: template_field_type.FIELD_TYPES.TEXT,
                                    label: "Text",
                                    translatable: true
                                }
                            }
                        }
                    },
                    useCases: {
                        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                        label: "Use Cases",
                        maxLimit: 10,
                        nestedConfig: {
                            type: template_field_type.FIELD_TYPES.NESTED,
                            fields: {
                                text: {
                                    type: template_field_type.FIELD_TYPES.TEXT,
                                    label: "Text",
                                    translatable: true
                                }
                            }
                        }
                    },
                    preSelect: {
                        type: template_field_type.FIELD_TYPES.BOOLEAN,
                        label: "Pre Select Card"
                    }
                }
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-products-homepage-first-fold/monday-products-homepage-first-fold-advanced-config.js
function monday_products_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function monday_products_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            monday_products_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function monday_products_homepage_first_fold_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function monday_products_homepage_first_fold_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        monday_products_homepage_first_fold_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var monday_products_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: monday_products_homepage_first_fold_advanced_config_object_spread_props(monday_products_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        fullParagraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: advanced_fields_config/* default */.Z
        },
        subTitleAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Sub title",
            fields: title_advanced_field_config/* default */.Z
        },
        marginAboveCards: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Margin Above Cards",
            translatable: true
        },
        marginBelowCards: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Margin Below Cards",
            translatable: true
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-products-homepage-first-fold/index.js



var MondayProductsHomepageFirstFoldComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6115).then(__webpack_require__.bind(__webpack_require__, 45866));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45866)
            ];
        }
    }
});
/* harmony default export */ var monday_products_homepage_first_fold = ({
    MondayProductsHomepageFirstFoldComponent: MondayProductsHomepageFirstFoldComponent,
    MondayProductsHomepageFirstFoldConfig: monday_products_homepage_first_fold_config,
    MondayProductsHomepageFirstFoldAdvancedConfig: monday_products_homepage_first_fold_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/selectable-tags-grid/selectable-tags-grid-config.js
var selectable_tags_grid_config = __webpack_require__(96817);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/full-paragraph-and-tags-homepage-first-fold/full-paragraph-and-tags-homepage-first-fold-config.js
function full_paragraph_and_tags_homepage_first_fold_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function full_paragraph_and_tags_homepage_first_fold_config_extends() {
    full_paragraph_and_tags_homepage_first_fold_config_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return full_paragraph_and_tags_homepage_first_fold_config_extends.apply(this, arguments);
}
function full_paragraph_and_tags_homepage_first_fold_config_object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function full_paragraph_and_tags_homepage_first_fold_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            full_paragraph_and_tags_homepage_first_fold_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function full_paragraph_and_tags_homepage_first_fold_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function full_paragraph_and_tags_homepage_first_fold_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        full_paragraph_and_tags_homepage_first_fold_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function full_paragraph_and_tags_homepage_first_fold_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = full_paragraph_and_tags_homepage_first_fold_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function full_paragraph_and_tags_homepage_first_fold_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var full_paragraph_and_tags_homepage_first_fold_config_textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, selectedFullParagraphFields = full_paragraph_and_tags_homepage_first_fold_config_object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "textColor"
]);
var selectedSelectableTagsTagsFieldsConfig = full_paragraph_and_tags_homepage_first_fold_config_extends({}, full_paragraph_and_tags_homepage_first_fold_config_object_destructuring_empty(selectable_tags_grid_config/* default */.Z));
/* harmony default export */ var full_paragraph_and_tags_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Full Paragraph And Tags",
    fields: full_paragraph_and_tags_homepage_first_fold_config_object_spread_props(full_paragraph_and_tags_homepage_first_fold_config_object_spread({}, theme_config/* default */.Z), {
        marginAboveTags: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Margin between paragraph and tags"
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: selectedFullParagraphFields
        },
        selectableTags: selectedSelectableTagsTagsFieldsConfig
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tags-grid/advanced-field-config.js
var selectable_tags_grid_advanced_field_config = __webpack_require__(33129);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/full-paragraph-and-tags-homepage-first-fold/full-paragraph-and-tags-homepage-first-fold-advanced-config.js
function full_paragraph_and_tags_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function full_paragraph_and_tags_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            full_paragraph_and_tags_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function full_paragraph_and_tags_homepage_first_fold_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function full_paragraph_and_tags_homepage_first_fold_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        full_paragraph_and_tags_homepage_first_fold_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var full_paragraph_and_tags_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: full_paragraph_and_tags_homepage_first_fold_advanced_config_object_spread_props(full_paragraph_and_tags_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full paragraph",
            fields: full_paragraph_and_tags_homepage_first_fold_advanced_config_object_spread({}, advanced_fields_config/* default */.Z)
        },
        selectableTags: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Selectable tags",
            fields: full_paragraph_and_tags_homepage_first_fold_advanced_config_object_spread({}, selectable_tags_grid_advanced_field_config/* default */.Z)
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/full-paragraph-and-tags-homepage-first-fold/index.js



var FullParagraphAndTagsHomepageFirstFoldComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4222), __webpack_require__.e(9340)]).then(__webpack_require__.bind(__webpack_require__, 29340));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29340)
            ];
        }
    }
});
/* harmony default export */ var full_paragraph_and_tags_homepage_first_fold = ({
    FullParagraphAndTagsHomepageFirstFoldComponent: FullParagraphAndTagsHomepageFirstFoldComponent,
    FullParagraphAndTagsHomepageFirstFoldConfig: full_paragraph_and_tags_homepage_first_fold_config,
    FullParagraphAndTagsHomepageFirstFoldAdvancedConfig: full_paragraph_and_tags_homepage_first_fold_advanced_config
});

// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./segments/button-service.js
var button_service = __webpack_require__(93833);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/live-board-homepage-first-fold/live-board-homepage-first-fold-config.js

function live_board_homepage_first_fold_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function live_board_homepage_first_fold_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            live_board_homepage_first_fold_config_define_property(target, key, source[key]);
        });
    }
    return target;
}





/* harmony default export */ var live_board_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Live Board",
    fields: {
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme",
            possibleColors: (0,_to_consumable_array/* default */.Z)(segments_service/* BACKGROUND_COLOR_OPTIONS */.L6).concat([
                segments_service/* SPACE_BLUE_THEME_ID */.r8
            ])
        },
        nestedBoardItems: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Embedded Board",
            fields: {
                boardBannerText: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Board Banner Text",
                    translatable: true
                },
                embeddedBoardTitle: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Embedded Board Title",
                    translatable: true
                },
                addSecondLiveBoardSignUpButton: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Add second sign up button in the live board"
                }
            }
        },
        circleConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Circle",
            fields: {
                circleTitle: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: " Title",
                    translatable: true
                },
                circleTitleColor: {
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                    label: "Title Color"
                },
                circleTitleSize: live_board_homepage_first_fold_config_object_spread({}, title_advanced_field_config/* default.titleSize */.Z.titleSize),
                circleText: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Circle Text",
                    translatable: true
                },
                circleTextColor: {
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                    label: "Circle Text Color"
                },
                circleColor: {
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                    label: "Circle Color"
                },
                buttonText: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Circle Button Text",
                    translatable: true
                },
                buttonColor: {
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                    label: "Circle Button Color",
                    possibleColors: button_service/* buttonColors */.Is
                }
            }
        },
        backgroundImage: {
            type: template_field_type.FIELD_TYPES.GALLERY,
            label: "Background Image"
        },
        boardImage: {
            type: template_field_type.FIELD_TYPES.GALLERY,
            label: "Board Image"
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/live-board-homepage-first-fold/live-board-homepage-first-fold-advanced-config.js
function live_board_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function live_board_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            live_board_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var live_board_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: live_board_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/live-board-homepage-first-fold/index.js



var LiveBoardHomepageFirstFoldComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 437).then(__webpack_require__.bind(__webpack_require__, 40437));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40437)
            ];
        }
    }
});
/* harmony default export */ var live_board_homepage_first_fold = ({
    LiveBoardHomepageFirstFoldComponent: LiveBoardHomepageFirstFoldComponent,
    LiveBoardHomepageFirstFoldConfig: live_board_homepage_first_fold_config,
    LiveBoardHomepageFirstFoldAdvancedConfig: live_board_homepage_first_fold_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/sign-up-with-products-cards-homepage-first-fold/sign-up-with-products-cards-homepage-first-fold-config.js



/* harmony default export */ var sign_up_with_products_cards_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Sign Up With Products Cards",
    fields: {
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme",
            possibleColors: [
                segments_service/* SIGN_UP_WITH_PRODUCTS_BACKGROUND_ID */.JB
            ]
        },
        defaultActiveProduct: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Default active product",
            options: products/* PRODUCT_OPTIONS */.ey
        },
        skipButtonText: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Skip button CTA"
        },
        continueButtonText: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Continue button CTA"
        },
        titleWithProduct: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Title when product type exist"
        },
        subTitle: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Subtitle when product type exist"
        },
        titleWithoutProduct: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Title when product type doesnt's exist"
        },
        textUnderButtons: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Text under button"
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/sign-up-with-products-cards-homepage-first-fold/sign-up-with-products-cards-homepage-first-fold-advanced-config.js
function sign_up_with_products_cards_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sign_up_with_products_cards_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sign_up_with_products_cards_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var sign_up_with_products_cards_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: sign_up_with_products_cards_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/sign-up-with-products-cards-homepage-first-fold/index.js



var SignUpWithProductsCardsHomepageFirstFoldComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1492).then(__webpack_require__.bind(__webpack_require__, 1492));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1492)
            ];
        }
    }
});
/* harmony default export */ var sign_up_with_products_cards_homepage_first_fold = ({
    SignUpWithProductsCardsHomepageFirstFoldComponent: SignUpWithProductsCardsHomepageFirstFoldComponent,
    SignUpWithProductsCardsHomepageFirstFoldConfig: sign_up_with_products_cards_homepage_first_fold_config,
    SignUpWithProductsCardsHomepageFirstFoldAdvancedConfig: sign_up_with_products_cards_homepage_first_fold_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/welcome-back-homepage-first-fold/welcome-back-homepage-first-fold-config.js


/* harmony default export */ var welcome_back_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Welcome Back",
    fields: {
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme",
            possibleColors: [
                segments_service/* SPACE_BLUE_GRADIANT_THEME_ID */.I7,
                segments_service/* SPACE_BLUE_THEME_ID */.r8
            ]
        },
        introText: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Intro text"
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/welcome-back-homepage-first-fold/welcome-back-homepage-first-fold-advanced-config.js
function welcome_back_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function welcome_back_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            welcome_back_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var welcome_back_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: welcome_back_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/welcome-back-homepage-first-fold/index.js



var WelcomeBackHomepageFirstFoldComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4885), __webpack_require__.e(7912)]).then(__webpack_require__.bind(__webpack_require__, 77912));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77912)
            ];
        }
    }
});
/* harmony default export */ var welcome_back_homepage_first_fold = ({
    WelcomeBackHomepageFirstFoldComponent: WelcomeBackHomepageFirstFoldComponent,
    WelcomeBackHomepageFirstFoldConfig: welcome_back_homepage_first_fold_config,
    WelcomeBackHomepageFirstFoldAdvancedConfig: welcome_back_homepage_first_fold_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/fields-config.js
var square_tags_fields_config = __webpack_require__(22333);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-universe-homepage-first-fold/palette-schemes.js
var palette_schemes = __webpack_require__(81122);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-universe-homepage-first-fold/monday-universe-homepage-first-fold-config.js
function monday_universe_homepage_first_fold_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function monday_universe_homepage_first_fold_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            monday_universe_homepage_first_fold_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function monday_universe_homepage_first_fold_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function monday_universe_homepage_first_fold_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        monday_universe_homepage_first_fold_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function monday_universe_homepage_first_fold_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = monday_universe_homepage_first_fold_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function monday_universe_homepage_first_fold_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var monday_universe_homepage_first_fold_config_textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, monday_universe_homepage_first_fold_config_mobileTextAlign = full_paragraph_fields_config/* default.mobileTextAlign */.Z.mobileTextAlign, monday_universe_homepage_first_fold_config_textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, monday_universe_homepage_first_fold_config_topic = full_paragraph_fields_config/* default.topic */.Z.topic, monday_universe_homepage_first_fold_config_button = full_paragraph_fields_config/* default.buttonConfig */.Z.buttonConfig, monday_universe_homepage_first_fold_config_restFullParagraphFieldsConfig = monday_universe_homepage_first_fold_config_object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "textAlign",
    "mobileTextAlign",
    "textColor",
    "topic",
    "buttonConfig"
]);
var monday_universe_homepage_first_fold_config_theme = square_tags_fields_config/* default.theme */.Z.theme, restSquareTagsFieldsConfig = monday_universe_homepage_first_fold_config_object_without_properties(square_tags_fields_config/* default */.Z, [
    "theme"
]);
/* harmony default export */ var monday_universe_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Monday Universe",
    fields: monday_universe_homepage_first_fold_config_object_spread_props(monday_universe_homepage_first_fold_config_object_spread({
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme",
            possibleColors: [
                segments_service/* SPACE_BLUE_GRADIANT_THEME_ID */.I7,
                segments_service/* BRAND_DARK_COLOR_THEME_ID */.qp,
                color_consts.CRM_DARKER_TINT_02,
                color_consts.BRAND_BLACK_BACKGROUND_COLOR,
                color_consts.WHITE_COLOR_NAME,
                color_consts.BRAND_DARK_COLOR,
                color_consts.BRAND_AND_WORK_MANAGEMENT_DARKER_TINT_02,
                color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01
            ]
        },
        pallet: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Color Palette",
            options: [
                {
                    value: palette_schemes/* PALLET_VALUES.CRM_WHITE */.n.CRM_WHITE,
                    text: "CRM palette - for ".concat(color_consts.WHITE_COLOR_NAME, " background")
                },
                {
                    value: palette_schemes/* PALLET_VALUES.CRM_GREEN */.n.CRM_GREEN,
                    text: "CRM palette - for ".concat(color_consts.CRM_DARKER_TINT_02, " background")
                },
                {
                    value: palette_schemes/* PALLET_VALUES.DEV_WHITE */.n.DEV_WHITE,
                    text: "Dev palette - for ".concat(color_consts.WHITE_COLOR_NAME, " background")
                },
                {
                    value: palette_schemes/* PALLET_VALUES.DEV_BLACK */.n.DEV_BLACK,
                    text: "Dev palette - for ".concat(color_consts.BRAND_BLACK_BACKGROUND_COLOR, " background")
                },
                {
                    value: palette_schemes/* PALLET_VALUES.WM_WHITE */.n.WM_WHITE,
                    text: "WM palette - for ".concat(color_consts.WHITE_COLOR_NAME, " / ").concat(color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01, " background")
                },
                {
                    value: palette_schemes/* PALLET_VALUES.WM_BLACK */.n.WM_BLACK,
                    text: "WM palette - for ".concat(color_consts.BRAND_BLACK_BACKGROUND_COLOR, " / ").concat(color_consts.BRAND_DARK_COLOR, " background")
                },
                {
                    value: palette_schemes/* PALLET_VALUES.WM_PURPLE */.n.WM_PURPLE,
                    text: "WM palette - for ".concat(color_consts.BRAND_AND_WORK_MANAGEMENT_DARKER_TINT_02, " background")
                },
                {
                    value: palette_schemes/* PALLET_VALUES.DEV_OLD */.n.DEV_OLD,
                    text: "Dev palette - old for ".concat(color_consts.BRAND_DARK_COLOR, " background")
                }
            ]
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full paragraph",
            fields: monday_universe_homepage_first_fold_config_restFullParagraphFieldsConfig
        },
        subTitle: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Sub title",
            fields: title_fields_config/* default */.Z
        }
    }, restSquareTagsFieldsConfig), {
        lines: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Lines",
            maxLimit: 3,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    start: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Start point",
                        fields: {
                            top: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Top"
                            },
                            left: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Left"
                            }
                        }
                    },
                    end: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "End point",
                        fields: {
                            top: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Top"
                            },
                            left: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Left"
                            }
                        }
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/advanced-fields-config.js
var square_tags_advanced_fields_config = __webpack_require__(73498);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-universe-homepage-first-fold/monday-universe-homepage-first-fold-advanced-config.js
function monday_universe_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function monday_universe_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            monday_universe_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function monday_universe_homepage_first_fold_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = monday_universe_homepage_first_fold_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function monday_universe_homepage_first_fold_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var monday_universe_homepage_first_fold_advanced_config_topicBottomMargin = advanced_fields_config/* default.topicBottomMargin */.Z.topicBottomMargin, monday_universe_homepage_first_fold_advanced_config_buttonTopMargin = advanced_fields_config/* default.buttonTopMargin */.Z.buttonTopMargin, monday_universe_homepage_first_fold_advanced_config_restOfParagraphAdvancedConfig = monday_universe_homepage_first_fold_advanced_config_object_without_properties(advanced_fields_config/* default */.Z, [
    "topicBottomMargin",
    "buttonTopMargin"
]);
var monday_universe_homepage_first_fold_advanced_config_topTriangle = shared_advanced_fields_config/* default.topTriangle */.Z.topTriangle, monday_universe_homepage_first_fold_advanced_config_bottomTriangle = shared_advanced_fields_config/* default.bottomTriangle */.Z.bottomTriangle, restOfSharedFieldConfig = monday_universe_homepage_first_fold_advanced_config_object_without_properties(shared_advanced_fields_config/* default */.Z, [
    "topTriangle",
    "bottomTriangle"
]);
/* harmony default export */ var monday_universe_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: monday_universe_homepage_first_fold_advanced_config_object_spread({
        fullParagraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: monday_universe_homepage_first_fold_advanced_config_restOfParagraphAdvancedConfig
        },
        subTitleAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Sub title",
            fields: title_advanced_field_config/* default */.Z
        },
        squareTagsMarginTop: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tags margin top"
        }
    }, square_tags_advanced_fields_config/* default */.Z, restOfSharedFieldConfig)
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-universe-homepage-first-fold/index.js



var MondayUniverseHomepageFirstFoldComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6515).then(__webpack_require__.bind(__webpack_require__, 96515));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96515)
            ];
        }
    }
});
/* harmony default export */ var monday_universe_homepage_first_fold = ({
    MondayUniverseHomepageFirstFoldComponent: MondayUniverseHomepageFirstFoldComponent,
    MondayUniverseHomepageFirstFoldConfig: monday_universe_homepage_first_fold_config,
    MondayUniverseHomepageFirstFoldAdvancedConfig: monday_universe_homepage_first_fold_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/button/fields-config.js + 5 modules
var button_fields_config = __webpack_require__(75629);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/scroll-parallax-homepage-first-fold/scroll-parallax-homepage-first-fold-config.js
function scroll_parallax_homepage_first_fold_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function scroll_parallax_homepage_first_fold_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            scroll_parallax_homepage_first_fold_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function scroll_parallax_homepage_first_fold_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function scroll_parallax_homepage_first_fold_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        scroll_parallax_homepage_first_fold_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function scroll_parallax_homepage_first_fold_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = scroll_parallax_homepage_first_fold_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function scroll_parallax_homepage_first_fold_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var scroll_parallax_homepage_first_fold_config_image = fields_config/* default.image */.Z.image, video = fields_config/* default.video */.Z.video;
var _video_fields = video.fields, playWhenVisible = _video_fields.playWhenVisible, loop = _video_fields.loop, videoOtherFields = scroll_parallax_homepage_first_fold_config_object_without_properties(_video_fields, [
    "playWhenVisible",
    "loop"
]);
var parallaxParagraphButtonConfig = scroll_parallax_homepage_first_fold_config_object_spread_props(scroll_parallax_homepage_first_fold_config_object_spread({}, button_fields_config/* default */.Z), {
    options: [
        {
            text: button_consts/* SIGNUP_BUTTON_TYPE */.ge,
            fieldsConfig: scroll_parallax_homepage_first_fold_config_object_spread_props(scroll_parallax_homepage_first_fold_config_object_spread({}, signup_button_fields_config/* default */.Z), {
                invert: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Invert  color"
                },
                buttonSize: {
                    type: template_field_type.FIELD_TYPES.COMBO,
                    label: "Size",
                    options: [
                        {
                            value: button_component.SM,
                            text: "Small"
                        },
                        {
                            value: button_component.MD,
                            text: "Medium"
                        }
                    ]
                }
            }),
            type: template_field_type.FIELD_TYPES.NESTED
        }
    ]
});
/* harmony default export */ var scroll_parallax_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Scroll Parallax",
    fields: {
        backgroundColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Background Color"
        },
        paragraphs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Paragraphs",
            maxLimit: 3,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    title: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Title",
                        translatable: true
                    },
                    description: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Description",
                        translatable: true
                    },
                    avatarSrc: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Avatar",
                        defaultImagesKeys: []
                    },
                    avatarAlt: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Avatar alt text",
                        translatable: true
                    },
                    testimonial: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Testimonial",
                        translatable: true
                    },
                    name: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Name"
                    },
                    jobTitle: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Job title",
                        translatable: true
                    },
                    companyName: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Company name"
                    },
                    buttonConfig: parallaxParagraphButtonConfig
                }
            }
        },
        topAsset: scroll_parallax_homepage_first_fold_config_object_spread_props(scroll_parallax_homepage_first_fold_config_object_spread({}, scroll_parallax_homepage_first_fold_config_image), {
            label: "Top asset"
        }),
        bottomAsset: scroll_parallax_homepage_first_fold_config_object_spread_props(scroll_parallax_homepage_first_fold_config_object_spread({}, video), {
            label: "Bottom asset",
            fields: videoOtherFields
        })
    }
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/scroll-parallax-homepage-first-fold/scroll-parallax-homepage-first-fold-advanced-config.js
function scroll_parallax_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function scroll_parallax_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            scroll_parallax_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function scroll_parallax_homepage_first_fold_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function scroll_parallax_homepage_first_fold_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        scroll_parallax_homepage_first_fold_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var scroll_parallax_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: scroll_parallax_homepage_first_fold_advanced_config_object_spread_props(scroll_parallax_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/scroll-parallax-homepage-first-fold/index.js



var ScrollParallaxHomepageFirstFoldComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9774), __webpack_require__.e(3614), __webpack_require__.e(4617)]).then(__webpack_require__.bind(__webpack_require__, 74617));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74617)
            ];
        }
    }
});
/* harmony default export */ var scroll_parallax_homepage_first_fold = ({
    ScrollParallaxHomepageFirstFoldComponent: ScrollParallaxHomepageFirstFoldComponent,
    ScrollParallaxHomepageFirstFoldConfig: scroll_parallax_homepage_first_fold_config,
    ScrollParallaxHomepageFirstFoldAdvancedConfig: scroll_parallax_homepage_first_fold_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/logos/layouts/top-logos/top-logos-config.js
var top_logos_config = __webpack_require__(63625);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-with-top-cta-homepage-first-fold/globe-with-top-cta-homepage-first-fold-config.js
function globe_with_top_cta_homepage_first_fold_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function globe_with_top_cta_homepage_first_fold_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            globe_with_top_cta_homepage_first_fold_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var globe_with_top_cta_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Globe With Top Cta",
    fields: {
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: full_paragraph_fields_config/* default */.Z
        },
        logos: globe_with_top_cta_homepage_first_fold_config_object_spread({}, top_logos_config/* default */.Z)
    }
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-with-top-cta-homepage-first-fold/globe-with-top-cta-homepage-first-fold-advanced-config.js
function globe_with_top_cta_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function globe_with_top_cta_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            globe_with_top_cta_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var globe_with_top_cta_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: globe_with_top_cta_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-with-top-cta-homepage-first-fold/index.js



var GlobeWithTopCtaHomepageFirstFoldComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9112), __webpack_require__.e(6331)]).then(__webpack_require__.bind(__webpack_require__, 28723));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28723)
            ];
        }
    }
});
/* harmony default export */ var globe_with_top_cta_homepage_first_fold = ({
    GlobeWithTopCtaHomepageFirstFoldComponent: GlobeWithTopCtaHomepageFirstFoldComponent,
    GlobeWithTopCtaHomepageFirstFoldConfig: globe_with_top_cta_homepage_first_fold_config,
    GlobeWithTopCtaHomepageFirstFoldAdvancedConfig: globe_with_top_cta_homepage_first_fold_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/fields-config.js
var side_by_side_text_and_asset_fields_config = __webpack_require__(93097);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-homepage-first-fold/globe-homepage-first-fold-config.js
function globe_homepage_first_fold_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = globe_homepage_first_fold_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function globe_homepage_first_fold_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var background = side_by_side_text_and_asset_fields_config/* default.background */.Z.background, selectedSideBySideTextAndAssetFieldsConfig = globe_homepage_first_fold_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "background"
]);
/* harmony default export */ var globe_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Globe",
    fields: selectedSideBySideTextAndAssetFieldsConfig
});

// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-homepage-first-fold/globe-homepage-first-fold-advanced-config.js
function globe_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function globe_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            globe_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function globe_homepage_first_fold_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function globe_homepage_first_fold_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        globe_homepage_first_fold_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var globe_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: globe_homepage_first_fold_advanced_config_object_spread_props(globe_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        titleSize: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Title Size",
            options: [
                {
                    value: sizes.XS,
                    text: "24px"
                },
                {
                    value: sizes.SM,
                    text: "32px"
                },
                {
                    value: sizes.MD,
                    text: "40px"
                },
                {
                    value: sizes.LG,
                    text: "50px"
                },
                {
                    value: sizes/* LGR */.Re,
                    text: "60px"
                },
                {
                    value: sizes.XL,
                    text: "72px"
                }
            ]
        },
        height: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Height"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-homepage-first-fold/index.js



var GlobeHomepageFirstFoldComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7528).then(__webpack_require__.bind(__webpack_require__, 47528));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47528)
            ];
        }
    }
});
/* harmony default export */ var globe_homepage_first_fold = ({
    GlobeHomepageFirstFoldComponent: GlobeHomepageFirstFoldComponent,
    GlobeHomepageFirstFoldConfig: globe_homepage_first_fold_config,
    GlobeHomepageFirstFoldAdvancedConfig: globe_homepage_first_fold_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/animating-board-homepage-first-fold/animating-board-homepage-first-fold-config.js

/* harmony default export */ var animating_board_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Animating Board",
    fields: {
        title: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Title",
            textArea: true,
            translatable: true
        },
        body: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Body",
            textArea: true,
            rows: 5,
            translatable: true
        },
        videoId: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Video Id"
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/animating-board-homepage-first-fold/animating-board-homepage-first-fold-advanced-config.js
function animating_board_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function animating_board_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            animating_board_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var animating_board_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: animating_board_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/animating-board-homepage-first-fold/index.js



var AnimatingBoardHomepageFirstFoldComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4729), __webpack_require__.e(5478)]).then(__webpack_require__.bind(__webpack_require__, 45478));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45478)
            ];
        }
    }
});
/* harmony default export */ var animating_board_homepage_first_fold = ({
    AnimatingBoardHomepageFirstFoldComponent: AnimatingBoardHomepageFirstFoldComponent,
    AnimatingBoardHomepageFirstFoldConfig: animating_board_homepage_first_fold_config,
    AnimatingBoardHomepageFirstFoldAdvancedConfig: animating_board_homepage_first_fold_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/index.js
// plop_marker:layouts_import













/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    PlatformInteractiveExperienceHomepageFirstFold: platform_interactive_experience_homepage_first_fold,
    TagsByProductHomepageFirstFold: tags_by_product_homepage_first_fold,
    ProductsByUseCasesHomepageFirstFold: products_by_use_cases_homepage_first_fold,
    MondayProductsHomepageFirstFold: monday_products_homepage_first_fold,
    FullParagraphAndTagsHomepageFirstFold: full_paragraph_and_tags_homepage_first_fold,
    LiveBoardHomepageFirstFold: live_board_homepage_first_fold,
    SignUpWithProductsCardsHomepageFirstFold: sign_up_with_products_cards_homepage_first_fold,
    WelcomeBackHomepageFirstFold: welcome_back_homepage_first_fold,
    MondayUniverseHomepageFirstFold: monday_universe_homepage_first_fold,
    ScrollParallaxHomepageFirstFold: scroll_parallax_homepage_first_fold,
    GlobeWithTopCtaHomepageFirstFold: globe_with_top_cta_homepage_first_fold,
    GlobeHomepageFirstFold: globe_homepage_first_fold,
    AnimatingBoardHomepageFirstFold: animating_board_homepage_first_fold
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/index.js

var PlatformInteractiveExperienceHomepageFirstFold = layouts.PlatformInteractiveExperienceHomepageFirstFold, TagsByProductHomepageFirstFold = layouts.TagsByProductHomepageFirstFold, ProductsByUseCasesHomepageFirstFold = layouts.ProductsByUseCasesHomepageFirstFold, MondayProductsHomepageFirstFold = layouts.MondayProductsHomepageFirstFold, FullParagraphAndTagsHomepageFirstFold = layouts.FullParagraphAndTagsHomepageFirstFold, LiveBoardHomepageFirstFold = layouts.LiveBoardHomepageFirstFold, SignUpWithProductsCardsHomepageFirstFold = layouts.SignUpWithProductsCardsHomepageFirstFold, WelcomeBackHomepageFirstFold = layouts.WelcomeBackHomepageFirstFold, MondayUniverseHomepageFirstFold = layouts.MondayUniverseHomepageFirstFold, ScrollParallaxHomepageFirstFold = layouts.ScrollParallaxHomepageFirstFold, GlobeWithTopCtaHomepageFirstFold = layouts.GlobeWithTopCtaHomepageFirstFold, GlobeHomepageFirstFold = layouts.GlobeHomepageFirstFold, AnimatingBoardHomepageFirstFold = layouts.AnimatingBoardHomepageFirstFold;
/* harmony default export */ var homepage_first_fold = ({
    // plop_marker:segment_index_add_layout
    PlatformInteractiveExperienceHomepageFirstFoldComponent: {
        type: "PlatformInteractiveExperienceHomepageFirstFoldComponent",
        title: "Platform Interactive Experience",
        imgSrc: "/static/img/segments/layouts/platform-interactive-experience-homepage-first-fold.png",
        config: PlatformInteractiveExperienceHomepageFirstFold.PlatformInteractiveExperienceHomepageFirstFoldConfig,
        advancedConfig: PlatformInteractiveExperienceHomepageFirstFold.PlatformInteractiveExperienceHomepageFirstFoldAdvancedConfig,
        component: PlatformInteractiveExperienceHomepageFirstFold.PlatformInteractiveExperienceHomepageFirstFoldComponent
    },
    TagsByProductHomepageFirstFoldComponent: {
        type: "TagsByProductHomepageFirstFoldComponent",
        title: "Tags By Product",
        imgSrc: "/static/img/segments/layouts/tags-by-product-homepage-first-fold.png",
        config: TagsByProductHomepageFirstFold.TagsByProductHomepageFirstFoldConfig,
        advancedConfig: TagsByProductHomepageFirstFold.TagsByProductHomepageFirstFoldAdvancedConfig,
        component: TagsByProductHomepageFirstFold.TagsByProductHomepageFirstFoldComponent
    },
    ProductsByUseCasesHomepageFirstFoldComponent: {
        type: "ProductsByUseCasesHomepageFirstFoldComponent",
        title: "Products By Use Cases",
        imgSrc: "/static/img/segments/layouts/products-by-use-cases-homepage-first-fold.png",
        config: ProductsByUseCasesHomepageFirstFold.ProductsByUseCasesHomepageFirstFoldConfig,
        advancedConfig: ProductsByUseCasesHomepageFirstFold.ProductsByUseCasesHomepageFirstFoldAdvancedConfig,
        component: ProductsByUseCasesHomepageFirstFold.ProductsByUseCasesHomepageFirstFoldComponent
    },
    MondayProductsHomepageFirstFoldComponent: {
        type: "MondayProductsHomepageFirstFoldComponent",
        title: "Monday Products",
        imgSrc: "/static/img/segments/layouts/monday-products-homepage-first-fold.png",
        config: MondayProductsHomepageFirstFold.MondayProductsHomepageFirstFoldConfig,
        advancedConfig: MondayProductsHomepageFirstFold.MondayProductsHomepageFirstFoldAdvancedConfig,
        component: MondayProductsHomepageFirstFold.MondayProductsHomepageFirstFoldComponent
    },
    FullParagraphAndTagsHomepageFirstFoldComponent: {
        type: "FullParagraphAndTagsHomepageFirstFoldComponent",
        title: "Full Paragraph And Tags",
        imgSrc: "/static/img/segments/layouts/full-paragraph-and-tags-homepage-first-fold.png",
        config: FullParagraphAndTagsHomepageFirstFold.FullParagraphAndTagsHomepageFirstFoldConfig,
        advancedConfig: FullParagraphAndTagsHomepageFirstFold.FullParagraphAndTagsHomepageFirstFoldAdvancedConfig,
        component: FullParagraphAndTagsHomepageFirstFold.FullParagraphAndTagsHomepageFirstFoldComponent
    },
    LiveBoardHomepageFirstFoldComponent: {
        type: "LiveBoardHomepageFirstFoldComponent",
        title: "Live Board",
        imgSrc: "/static/img/segments/layouts/live-board-homepage-first-fold.png",
        config: LiveBoardHomepageFirstFold.LiveBoardHomepageFirstFoldConfig,
        advancedConfig: LiveBoardHomepageFirstFold.LiveBoardHomepageFirstFoldAdvancedConfig,
        component: LiveBoardHomepageFirstFold.LiveBoardHomepageFirstFoldComponent
    },
    SignUpWithProductsCardsHomepageFirstFoldComponent: {
        type: "SignUpWithProductsCardsHomepageFirstFoldComponent",
        title: "Sign Up With Products Cards",
        imgSrc: "/static/img/segments/layouts/sign-up-with-products-cards-homepage-first-fold.png",
        config: SignUpWithProductsCardsHomepageFirstFold.SignUpWithProductsCardsHomepageFirstFoldConfig,
        advancedConfig: SignUpWithProductsCardsHomepageFirstFold.SignUpWithProductsCardsHomepageFirstFoldAdvancedConfig,
        component: SignUpWithProductsCardsHomepageFirstFold.SignUpWithProductsCardsHomepageFirstFoldComponent
    },
    WelcomeBackHomepageFirstFoldComponent: {
        type: "WelcomeBackHomepageFirstFoldComponent",
        title: "Welcome Back",
        imgSrc: "/static/img/segments/layouts/welcome-back-homepage-first-fold.png",
        config: WelcomeBackHomepageFirstFold.WelcomeBackHomepageFirstFoldConfig,
        advancedConfig: WelcomeBackHomepageFirstFold.WelcomeBackHomepageFirstFoldAdvancedConfig,
        component: WelcomeBackHomepageFirstFold.WelcomeBackHomepageFirstFoldComponent
    },
    MondayUniverseHomepageFirstFoldComponent: {
        type: "MondayUniverseHomepageFirstFoldComponent",
        title: "Monday Universe",
        imgSrc: "/static/img/segments/layouts/monday-universe-homepage-first-fold.png",
        config: MondayUniverseHomepageFirstFold.MondayUniverseHomepageFirstFoldConfig,
        advancedConfig: MondayUniverseHomepageFirstFold.MondayUniverseHomepageFirstFoldAdvancedConfig,
        component: MondayUniverseHomepageFirstFold.MondayUniverseHomepageFirstFoldComponent
    },
    GlobeWithTopCtaHomepageFirstFoldComponent: {
        type: "GlobeWithTopCtaHomepageFirstFoldComponent",
        title: "Globe With Top Cta",
        imgSrc: "/static/img/segments/layouts/globe-with-top-cta-homepage-first-fold.png",
        config: GlobeWithTopCtaHomepageFirstFold.GlobeWithTopCtaHomepageFirstFoldConfig,
        advancedConfig: GlobeWithTopCtaHomepageFirstFold.GlobeWithTopCtaHomepageFirstFoldAdvancedConfig,
        component: GlobeWithTopCtaHomepageFirstFold.GlobeWithTopCtaHomepageFirstFoldComponent
    },
    GlobeHomepageFirstFoldComponent: {
        type: "GlobeHomepageFirstFoldComponent",
        title: "Globe",
        imgSrc: "/static/img/segments/layouts/globe-homepage-first-fold.png",
        config: GlobeHomepageFirstFold.GlobeHomepageFirstFoldConfig,
        advancedConfig: GlobeHomepageFirstFold.GlobeHomepageFirstFoldAdvancedConfig,
        component: GlobeHomepageFirstFold.GlobeHomepageFirstFoldComponent
    },
    AnimatingBoardHomepageFirstFoldComponent: {
        type: "AnimatingBoardHomepageFirstFoldComponent",
        title: "Animating Board",
        imgSrc: "/static/img/segments/layouts/animating-board-homepage-first-fold.png",
        config: AnimatingBoardHomepageFirstFold.AnimatingBoardHomepageFirstFoldConfig,
        advancedConfig: AnimatingBoardHomepageFirstFold.AnimatingBoardHomepageFirstFoldAdvancedConfig,
        component: AnimatingBoardHomepageFirstFold.AnimatingBoardHomepageFirstFoldComponent
    },
    ScrollParallaxHomepageFirstFoldComponent: {
        type: "ScrollParallaxHomepageFirstFoldComponent",
        title: "Scroll Parallax",
        imgSrc: "/static/img/segments/layouts/scroll-parallax-homepage-first-fold.png",
        config: ScrollParallaxHomepageFirstFold.ScrollParallaxHomepageFirstFoldConfig,
        advancedConfig: ScrollParallaxHomepageFirstFold.ScrollParallaxHomepageFirstFoldAdvancedConfig,
        component: ScrollParallaxHomepageFirstFold.ScrollParallaxHomepageFirstFoldComponent
    }
});


/***/ }),

/***/ 78679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ei": function() { return /* binding */ APPS; },
  "Lj": function() { return /* binding */ HOSPITAL; },
  "kr": function() { return /* binding */ ILLUSTRATIVE; },
  "$s": function() { return /* binding */ cookieValues; },
  "uK": function() { return /* binding */ getViIcon; },
  "Oh": function() { return /* binding */ procuctIdToCluster; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./static/svg/crm-vi1.svg
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgCrmVi1 = function SvgCrmVi1(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        viewBox: "0 0 18 18"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#006278",
        fillRule: "evenodd",
        d: "M17.087 8.543A8.544 8.544 0 1 1 0 8.543a8.544 8.544 0 0 1 17.087 0m-8.544 7.044a7.044 7.044 0 1 0 0-14.087 7.044 7.044 0 0 0 0 14.087m3.412-9.683a.75.75 0 0 1 .142 1.05l-3.919 5.14-2.558-3.07a.75.75 0 1 1 1.152-.96l1.354 1.624 2.778-3.643a.75.75 0 0 1 1.05-.141",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ var crm_vi1 = (SvgCrmVi1);

;// CONCATENATED MODULE: ./static/svg/dev-vi1.svg
var dev_vi1_path;
function dev_vi1_extends() {
    dev_vi1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return dev_vi1_extends.apply(this, arguments);
}

var SvgDevVi1 = function SvgDevVi1(props) {
    return /*#__PURE__*/ react.createElement("svg", dev_vi1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        viewBox: "0 0 18 18"
    }, props), dev_vi1_path || (dev_vi1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#025231",
        fillRule: "evenodd",
        d: "M17.087 8.543A8.544 8.544 0 1 1 0 8.543a8.544 8.544 0 0 1 17.087 0m-8.544 7.044a7.044 7.044 0 1 0 0-14.087 7.044 7.044 0 0 0 0 14.087m3.412-9.683a.75.75 0 0 1 .142 1.05l-3.919 5.14-2.558-3.07a.75.75 0 1 1 1.152-.96l1.354 1.624 2.778-3.643a.75.75 0 0 1 1.05-.141",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ var dev_vi1 = (SvgDevVi1);

;// CONCATENATED MODULE: ./static/svg/wm-vi1.svg
var wm_vi1_path;
function wm_vi1_extends() {
    wm_vi1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return wm_vi1_extends.apply(this, arguments);
}

var SvgWmVi1 = function SvgWmVi1(props) {
    return /*#__PURE__*/ react.createElement("svg", wm_vi1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        viewBox: "0 0 18 18"
    }, props), wm_vi1_path || (wm_vi1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#311CAC",
        fillRule: "evenodd",
        d: "M17.087 8.543A8.544 8.544 0 1 1 0 8.543a8.544 8.544 0 0 1 17.087 0m-8.544 7.044a7.044 7.044 0 1 0 0-14.087 7.044 7.044 0 0 0 0 14.087m3.412-9.683a.75.75 0 0 1 .142 1.05l-3.919 5.14-2.558-3.07a.75.75 0 1 1 1.152-.96l1.354 1.624 2.778-3.643a.75.75 0 0 1 1.05-.141",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ var wm_vi1 = (SvgWmVi1);

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-products-homepage-first-fold/consts.js








var _obj;
var cookieValues = (_obj = {}, (0,_define_property/* default */.Z)(_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, [
    {
        key: cookies.INSTALL_PRODUCTS_FLOW,
        value: false
    }
]), (0,_define_property/* default */.Z)(_obj, products/* CRM_PRODUCT_ID */.$, [
    {
        key: cookies.CRM_BIG_SIGNUP_MODAL_FOR_PRODUCTS_AB_TEST,
        value: "new_with_big_signup_modal_for_products"
    },
    {
        key: cookies.INSTALL_PRODUCTS_FLOW,
        value: true
    }
]), (0,_define_property/* default */.Z)(_obj, products/* DEV_PRODUCT_ID */.xi, [
    {
        key: cookies.DEV_BIG_SIGNUP_MODAL_FOR_PRODUCTS_AB_TEST,
        value: "new_with_big_signup_modal_for_products"
    },
    {
        key: cookies.INSTALL_PRODUCTS_FLOW,
        value: true
    }
]), (0,_define_property/* default */.Z)(_obj, "".concat(products/* CRM_PRODUCT_ID */.$, "_").concat(products/* WORK_MANAGEMENT_PRODUCT_ID */.py), [
    {
        key: cookies.INSTALL_PRODUCTS_FLOW,
        value: true
    }
]), (0,_define_property/* default */.Z)(_obj, "".concat(products/* DEV_PRODUCT_ID */.xi, "_").concat(products/* WORK_MANAGEMENT_PRODUCT_ID */.py), [
    {
        key: cookies.INSTALL_PRODUCTS_FLOW,
        value: true
    }
]), (0,_define_property/* default */.Z)(_obj, "".concat(products/* CRM_PRODUCT_ID */.$, "_").concat(products/* DEV_PRODUCT_ID */.xi), [
    {
        key: cookies.INSTALL_PRODUCTS_FLOW,
        value: true
    }
]), _obj);
var _obj1;
var procuctIdToCluster = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, products/* CRM_PRODUCT_ID */.$, clusters.CRM), (0,_define_property/* default */.Z)(_obj1, products/* DEV_PRODUCT_ID */.xi, clusters.SOFTWARE), _obj1);
var getViIcon = function(productId) {
    var _obj;
    var ViMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, products/* CRM_PRODUCT_ID */.$, /*#__PURE__*/ (0,jsx_runtime.jsx)(crm_vi1, {})), (0,_define_property/* default */.Z)(_obj, products/* DEV_PRODUCT_ID */.xi, /*#__PURE__*/ (0,jsx_runtime.jsx)(dev_vi1, {})), (0,_define_property/* default */.Z)(_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, /*#__PURE__*/ (0,jsx_runtime.jsx)(wm_vi1, {})), _obj);
    return Object.keys(ViMap).includes(productId) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "vi-sign",
        children: ViMap[productId]
    }) : null;
};
var HOSPITAL = "Hospital";
var APPS = "Apps";
var ILLUSTRATIVE = "Illustrative";


/***/ }),

/***/ 81122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ PALLET_VALUES; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(273);


var PALLET_VALUES = {
    CRM_GREEN: "CRM_GREEN",
    DEV_BLACK: "DEV_BLACK",
    WM_PURPLE: "WM_PURPLE",
    CRM_WHITE: "CRM_WHITE",
    DEV_WHITE: "DEV_WHITE",
    WM_WHITE: "WM_WHITE",
    WM_BLACK: "WM_BLACK",
    DEV_OLD: "DEV_OLD"
};
var _obj;
/* harmony default export */ __webpack_exports__["Z"] = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PALLET_VALUES.CRM_GREEN, {
    tagScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_DARK_TINT_01,
        borderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_PRIMARY_COLOR,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_PRIMARY_COLOR
    },
    checkboxScheme: {
        selectedBorderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        checkColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_PRIMARY_COLOR
    },
    textScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        selectedColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PALLET_VALUES.DEV_BLACK, {
    tagScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_DARK_COLOR,
        borderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.PROJECTS_PRIMARY_COLOR,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.PROJECTS_DARK_TINT_01
    },
    checkboxScheme: {
        selectedBorderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        checkColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.PROJECTS_DARK_TINT_01
    },
    textScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        selectedColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PALLET_VALUES.WM_PURPLE, {
    tagScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_AND_WORK_MANAGEMENT_DARK_TINT_01,
        borderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_AND_WORK_MANAGEMENT_LIGHT_TINT_02,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORK_OS_IRIS_COLOR_NAME
    },
    checkboxScheme: {
        selectedBorderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        checkColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORK_OS_IRIS_COLOR_NAME
    },
    textScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        selectedColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PALLET_VALUES.WM_WHITE, {
    tagScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_AND_WORK_MANAGEMENT_LIGHT_TINT_02,
        borderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_AND_WORK_MANAGEMENT_DARK_TINT_01,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_AND_WORK_MANAGEMENT_LIGHT_TINT_02
    },
    checkboxScheme: {
        selectedBorderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        checkColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME
    },
    textScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR,
        selectedColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR,
        color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PALLET_VALUES.CRM_WHITE, {
    tagScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_LIGHTER_TINT_01,
        borderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_DARK_TINT_01,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_PRIMARY_COLOR
    },
    checkboxScheme: {
        selectedBorderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        checkColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_DARKER_TINT_02,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME
    },
    textScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR,
        selectedColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR,
        color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PALLET_VALUES.DEV_WHITE, {
    tagScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.PROJECTS_LIGHTER_TINT_01,
        borderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.PROJECTS_PRIMARY_COLOR,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.PROJECTS_DARK_TINT_01
    },
    checkboxScheme: {
        selectedBorderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        checkColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.PROJECTS_DARK_TINT_01,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME
    },
    textScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR,
        selectedColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PALLET_VALUES.WM_BLACK, {
    tagScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_AND_WORK_MANAGEMENT_DARKER_TINT_02,
        borderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.UI_BORDER_LIGHT_COLOR_NAME,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR
    },
    checkboxScheme: {
        selectedBorderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        checkColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR
    },
    textScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        selectedColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PALLET_VALUES.DEV_OLD, {
    tagScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_GREEN_DARK_TINT_01,
        borderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DEV_PRIMARY_COLOR,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DEV_PRIMARY_COLOR
    },
    checkboxScheme: {
        selectedBorderColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR,
        checkColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR,
        selectedBackgroundColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DEV_PRIMARY_COLOR
    },
    textScheme: {
        hoverColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
        selectedColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_BACKGROUND_COLOR,
        color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME
    }
}), _obj);


/***/ }),

/***/ 27044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ iframe; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./client/services/hubspot-service/hubspot-constants.js
var hubspot_constants = __webpack_require__(22638);
;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/side-by-side-hubspot-form/components/fields-config.js


/* harmony default export */ var fields_config = ({
    source: {
        type: template_field_type.FIELD_TYPES.COMBO,
        label: "Lead Source",
        options: hubspot_constants/* leadSourceConfigList */.L_
    },
    withPrivacyNotice: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "With Privacy Notice"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/hubspot-dynamic-form-iframe/hubspot-dynamic-form-iframe-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var hubspot_dynamic_form_iframe_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Hubspot Dynamic Form",
    fields: _object_spread({
        formId: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Form ID"
        },
        formWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Form Width (specify units: px/%)"
        }
    }, fields_config)
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/hubspot-dynamic-form-iframe/hubspot-dynamic-form-iframe-advanced-config.js
function hubspot_dynamic_form_iframe_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_dynamic_form_iframe_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_dynamic_form_iframe_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var hubspot_dynamic_form_iframe_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(hubspot_dynamic_form_iframe_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        formMinHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Min Form Height"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/hubspot-dynamic-form-iframe/index.js

var HubspotDynamicFormIframeComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(571), __webpack_require__.e(5990), __webpack_require__.e(9419), __webpack_require__.e(1547)]).then(__webpack_require__.bind(__webpack_require__, 81547));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81547)
            ];
        }
    }
});


/* harmony default export */ var hubspot_dynamic_form_iframe = ({
    HubspotDynamicFormIframeComponent: HubspotDynamicFormIframeComponent,
    HubspotDynamicFormIframeConfig: hubspot_dynamic_form_iframe_config,
    HubspotDynamicFormIframeAdvancedConfig: hubspot_dynamic_form_iframe_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/embedded-board/fields-config.js

/* harmony default export */ var embedded_board_fields_config = ({
    sharableLink: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Shareable link",
        labelDescription: "Copy link from board share inside the monday platform"
    },
    boardIdAndToken: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Board id and token",
        labelDescription: "Old prop please use 'sharable link' instead - this will be deleted soon"
    },
    tooltipText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tooltip text",
        translatable: true
    }
});

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/embedded-board-iframe/embedded-board-iframe-config.js
function embedded_board_iframe_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function embedded_board_iframe_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            embedded_board_iframe_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, topic = full_paragraph_fields_config/* default.topic */.Z.topic, buttonConfig = full_paragraph_fields_config/* default.buttonConfig */.Z.buttonConfig, selectedFullParagraphFields = _object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "textColor",
    "textAlign",
    "topic",
    "buttonConfig"
]);
/* harmony default export */ var embedded_board_iframe_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Embedded Board",
    fields: embedded_board_iframe_config_object_spread({
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: selectedFullParagraphFields
        }
    }, embedded_board_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/embedded-board-iframe/embedded-board-iframe-advanced-config.js
function embedded_board_iframe_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function embedded_board_iframe_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            embedded_board_iframe_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var embedded_board_iframe_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: embedded_board_iframe_advanced_config_object_spread({
        embeddedBoardHeight: {
            type: "text",
            label: "Board Height"
        },
        embeddedBoardWidth: {
            type: "text",
            label: "Board Width"
        }
    }, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/embedded-board-iframe/index.js



var EmbeddedBoardIframeComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3341).then(__webpack_require__.bind(__webpack_require__, 33341));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33341)
            ];
        }
    }
});
/* harmony default export */ var embedded_board_iframe = ({
    EmbeddedBoardIframeComponent: EmbeddedBoardIframeComponent,
    EmbeddedBoardIframeConfig: embedded_board_iframe_config,
    EmbeddedBoardIframeAdvancedConfig: embedded_board_iframe_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/fields-config.js
var side_by_side_text_and_asset_fields_config = __webpack_require__(93097);
;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/side-by-side-hubspot-form/side-by-side-hubspot-form-config.js
function side_by_side_hubspot_form_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_hubspot_form_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_hubspot_form_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_hubspot_form_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_hubspot_form_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_hubspot_form_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_hubspot_form_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_hubspot_form_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_hubspot_form_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var _asset = side_by_side_text_and_asset_fields_config/* default.asset */.Z.asset, position = _asset.fields.position, restOfAssetFields = side_by_side_hubspot_form_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default.asset.fields */.Z.asset.fields, [
    "position"
]), restOfAssetConfig = side_by_side_hubspot_form_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default.asset */.Z.asset, [
    "fields"
]), selectedSideBySideTextAndAssetFieldsConfig = side_by_side_hubspot_form_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "asset"
]);
/* harmony default export */ var side_by_side_hubspot_form_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side Hubspot",
    fields: side_by_side_hubspot_form_config_object_spread_props(side_by_side_hubspot_form_config_object_spread({
        formId: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Form ID"
        }
    }, fields_config, selectedSideBySideTextAndAssetFieldsConfig), {
        asset: side_by_side_hubspot_form_config_object_spread({
            fields: side_by_side_hubspot_form_config_object_spread({}, restOfAssetFields)
        }, restOfAssetConfig)
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/side-by-side-hubspot-form/side-by-side-hubspot-form-advanced-config.js
function side_by_side_hubspot_form_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_hubspot_form_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_hubspot_form_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_hubspot_form_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_hubspot_form_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_hubspot_form_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var side_by_side_hubspot_form_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_hubspot_form_advanced_config_object_spread_props(side_by_side_hubspot_form_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        },
        formMinHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Min Form Height"
        },
        assetAndParagraphGap: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Asset And Paragraph Gap"
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: advanced_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/side-by-side-hubspot-form/index.js



var SideBySideHubspotFormComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(571), __webpack_require__.e(5990), __webpack_require__.e(9419), __webpack_require__.e(1230)]).then(__webpack_require__.bind(__webpack_require__, 31230));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31230)
            ];
        }
    }
});
/* harmony default export */ var side_by_side_hubspot_form = ({
    SideBySideHubspotFormComponent: SideBySideHubspotFormComponent,
    SideBySideHubspotFormConfig: side_by_side_hubspot_form_config,
    SideBySideHubspotFormAdvancedConfig: side_by_side_hubspot_form_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/iframe/fields-config.js

/* harmony default export */ var iframe_fields_config = ({
    src: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Iframe URL"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/iframe-dynamic-width-iframe/iframe-dynamic-width-iframe-config.js
function iframe_dynamic_width_iframe_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function iframe_dynamic_width_iframe_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            iframe_dynamic_width_iframe_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function iframe_dynamic_width_iframe_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function iframe_dynamic_width_iframe_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        iframe_dynamic_width_iframe_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var iframe_dynamic_width_iframe_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Basic Iframe",
    fields: iframe_dynamic_width_iframe_config_object_spread_props(iframe_dynamic_width_iframe_config_object_spread({}, iframe_fields_config), {
        width: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Width"
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/iframe/advanced-field-config.js
var advanced_field_config = __webpack_require__(32377);
;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/iframe-dynamic-width-iframe/iframe-dynamic-width-iframe-advanced-config.js
function iframe_dynamic_width_iframe_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function iframe_dynamic_width_iframe_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            iframe_dynamic_width_iframe_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function iframe_dynamic_width_iframe_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function iframe_dynamic_width_iframe_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        iframe_dynamic_width_iframe_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function iframe_dynamic_width_iframe_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = iframe_dynamic_width_iframe_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function iframe_dynamic_width_iframe_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var borderWidth = advanced_field_config/* default.borderWidth */.Z.borderWidth, borderColor = advanced_field_config/* default.borderColor */.Z.borderColor, selectedAdvancedConfig = iframe_dynamic_width_iframe_advanced_config_object_without_properties(advanced_field_config/* default */.Z, [
    "borderWidth",
    "borderColor"
]); //	border is hidden for now, will show if needed
/* harmony default export */ var iframe_dynamic_width_iframe_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: iframe_dynamic_width_iframe_advanced_config_object_spread_props(iframe_dynamic_width_iframe_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, selectedAdvancedConfig), {
        maxWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            lable: "Max Width"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/iframe-dynamic-width-iframe/index.js



var IframeDynamicWidthIframeComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2281).then(__webpack_require__.bind(__webpack_require__, 62281));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62281)
            ];
        }
    }
});
/* harmony default export */ var iframe_dynamic_width_iframe = ({
    IframeDynamicWidthIframeComponent: IframeDynamicWidthIframeComponent,
    IframeDynamicWidthIframeConfig: iframe_dynamic_width_iframe_config,
    IframeDynamicWidthIframeAdvancedConfig: iframe_dynamic_width_iframe_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/index.js
// plop_marker:layouts_import




/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    HubspotDynamicFormIframe: hubspot_dynamic_form_iframe,
    EmbeddedBoardIframe: embedded_board_iframe,
    SideBySideHubspotForm: side_by_side_hubspot_form,
    IframeDynamicWidthIframe: iframe_dynamic_width_iframe
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/index.js

var HubspotDynamicFormIframe = layouts.HubspotDynamicFormIframe, EmbeddedBoardIframe = layouts.EmbeddedBoardIframe, SideBySideHubspotForm = layouts.SideBySideHubspotForm, IframeDynamicWidthIframe = layouts.IframeDynamicWidthIframe;
/* harmony default export */ var iframe = ({
    // plop_marker:segment_index_add_layout
    HubspotDynamicFormIframeComponent: {
        type: "HubspotDynamicFormIframeComponent",
        title: "Hubspot Dynamic Form",
        imgSrc: "/static/img/segments/layouts/hubspot-dynamic-form-iframe.png",
        config: HubspotDynamicFormIframe.HubspotDynamicFormIframeConfig,
        advancedConfig: HubspotDynamicFormIframe.HubspotDynamicFormIframeAdvancedConfig,
        component: HubspotDynamicFormIframe.HubspotDynamicFormIframeComponent
    },
    EmbeddedBoardIframeComponent: {
        type: "EmbeddedBoardIframeComponent",
        title: "Embedded Board",
        imgSrc: "/static/img/segments/layouts/embedded-board-iframe.png",
        config: EmbeddedBoardIframe.EmbeddedBoardIframeConfig,
        advancedConfig: EmbeddedBoardIframe.EmbeddedBoardIframeAdvancedConfig,
        component: EmbeddedBoardIframe.EmbeddedBoardIframeComponent
    },
    SideBySideHubspotFormComponent: {
        type: "SideBySideHubspotFormComponent",
        title: "Hubspot old form (Use only in case of custom form id)",
        imgSrc: "/static/img/segments/layouts/side-by-side-hubspot-form.png",
        config: SideBySideHubspotForm.SideBySideHubspotFormConfig,
        advancedConfig: SideBySideHubspotForm.SideBySideHubspotFormAdvancedConfig,
        component: SideBySideHubspotForm.SideBySideHubspotFormComponent
    },
    IframeDynamicWidthIframeComponent: {
        type: "IframeDynamicWidthIframeComponent",
        title: "Basic Iframe",
        imgSrc: "/static/img/segments/layouts/iframe-dynamic-width-iframe.png",
        config: IframeDynamicWidthIframe.IframeDynamicWidthIframeConfig,
        advancedConfig: IframeDynamicWidthIframe.IframeDynamicWidthIframeAdvancedConfig,
        component: IframeDynamicWidthIframe.IframeDynamicWidthIframeComponent
    }
});


/***/ }),

/***/ 29107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ desktop; }
});

// EXTERNAL MODULE: ./segments/desktop/templates/index.js + 10 modules
var templates = __webpack_require__(34102);
// EXTERNAL MODULE: ./segments/desktop/shape/index.js + 17 modules
var shape = __webpack_require__(20655);
// EXTERNAL MODULE: ./segments/desktop/pricing/index.js
var pricing = __webpack_require__(49643);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var fields_config = __webpack_require__(65621);
;// CONCATENATED MODULE: ./segments/desktop/customer-success/layouts/simpo-customer-success/simpo-customer-success-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var simpo_customer_success_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Simpo",
    fields: _object_spread({}, fields_config/* default */.Z, theme_config/* default */.Z)
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var advanced_field_config = __webpack_require__(95760);
;// CONCATENATED MODULE: ./segments/desktop/customer-success/layouts/simpo-customer-success/simpo-customer-success-advanced-config.js
function simpo_customer_success_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function simpo_customer_success_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            simpo_customer_success_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var simpo_customer_success_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: simpo_customer_success_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/customer-success/layouts/simpo-customer-success/index.js



var SimpoCustomerSuccessComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4230).then(__webpack_require__.bind(__webpack_require__, 94230));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94230)
            ];
        }
    }
});
/* harmony default export */ var simpo_customer_success = ({
    SimpoCustomerSuccessComponent: SimpoCustomerSuccessComponent,
    SimpoCustomerSuccessConfig: simpo_customer_success_config,
    SimpoCustomerSuccessAdvancedConfig: simpo_customer_success_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/customer-success/layouts/index.js
// plop_marker:layouts_import

/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    SimpoCustomerSuccess: simpo_customer_success
});

;// CONCATENATED MODULE: ./segments/desktop/customer-success/index.js

var SimpoCustomerSuccess = layouts.SimpoCustomerSuccess;
/* harmony default export */ var customer_success = ({
    // plop_marker:segment_index_add_layout
    SimpoCustomerSuccessComponent: {
        type: "SimpoCustomerSuccessComponent",
        title: "Simpo",
        imgSrc: "/static/img/segments/layouts/simpo-customer-success.png",
        config: SimpoCustomerSuccess.SimpoCustomerSuccessConfig,
        advancedConfig: SimpoCustomerSuccess.SimpoCustomerSuccessAdvancedConfig,
        component: SimpoCustomerSuccess.SimpoCustomerSuccessComponent
    }
});

// EXTERNAL MODULE: ./segments/desktop/form/index.js + 25 modules
var desktop_form = __webpack_require__(91805);
// EXTERNAL MODULE: ./segments/desktop/blog/index.js + 4 modules
var blog = __webpack_require__(24646);
// EXTERNAL MODULE: ./segments/desktop/iframe/index.js + 16 modules
var iframe = __webpack_require__(27044);
;// CONCATENATED MODULE: ./segments/desktop/static/layouts/developers-apps-menu-static/developers-apps-menu-static-config.js

/* harmony default export */ var developers_apps_menu_static_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Developers Apps Menu",
    fields: {}
});

;// CONCATENATED MODULE: ./segments/desktop/static/layouts/developers-apps-menu-static/developers-apps-menu-static-advanced-config.js
function developers_apps_menu_static_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function developers_apps_menu_static_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            developers_apps_menu_static_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var developers_apps_menu_static_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: developers_apps_menu_static_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/static/layouts/developers-apps-menu-static/index.js

var DevelopersAppsMenuStaticComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9300).then(__webpack_require__.bind(__webpack_require__, 59300));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59300)
            ];
        }
    }
});


/* harmony default export */ var developers_apps_menu_static = ({
    DevelopersAppsMenuStaticComponent: DevelopersAppsMenuStaticComponent,
    DevelopersAppsMenuStaticConfig: developers_apps_menu_static_config,
    DevelopersAppsMenuStaticAdvancedConfig: developers_apps_menu_static_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/static/layouts/index.js
// plop_marker:layouts_import

/* harmony default export */ var static_layouts = ({
    // plop_marker:layouts_add_layout
    DevelopersAppsMenuStatic: developers_apps_menu_static
});

;// CONCATENATED MODULE: ./segments/desktop/static/index.js

var DevelopersAppsMenuStatic = static_layouts.DevelopersAppsMenuStatic;
/* harmony default export */ var desktop_static = ({
    // plop_marker:segment_index_add_layout
    DevelopersAppsMenuStaticComponent: {
        type: "DevelopersAppsMenuStaticComponent",
        title: "Developers Apps Menu",
        imgSrc: "/static/img/segments/layouts/developers-apps-menu-static.png",
        config: DevelopersAppsMenuStatic.DevelopersAppsMenuStaticConfig,
        advancedConfig: DevelopersAppsMenuStatic.DevelopersAppsMenuStaticAdvancedConfig,
        component: DevelopersAppsMenuStatic.DevelopersAppsMenuStaticComponent
    }
});

// EXTERNAL MODULE: ./segments/desktop/embedded/index.js + 8 modules
var embedded = __webpack_require__(17071);
// EXTERNAL MODULE: ./segments/desktop/banner/index.js + 8 modules
var banner = __webpack_require__(57095);
// EXTERNAL MODULE: ./segments/desktop/homepage-first-fold/index.js + 40 modules
var homepage_first_fold = __webpack_require__(40216);
// EXTERNAL MODULE: ./segments/desktop/integrations/index.js + 7 modules
var integrations = __webpack_require__(17082);
// EXTERNAL MODULE: ./segments/desktop/button/index.js + 4 modules
var desktop_button = __webpack_require__(3993);
// EXTERNAL MODULE: ./segments/desktop/enterprise/index.js + 10 modules
var enterprise = __webpack_require__(26647);
// EXTERNAL MODULE: ./segments/desktop/asset/index.js + 28 modules
var asset = __webpack_require__(4065);
// EXTERNAL MODULE: ./segments/desktop/security/index.js + 4 modules
var security = __webpack_require__(71380);
// EXTERNAL MODULE: ./segments/desktop/tabs/index.js + 70 modules
var tabs = __webpack_require__(87918);
// EXTERNAL MODULE: ./segments/desktop/header/index.js + 19 modules
var header = __webpack_require__(35471);
// EXTERNAL MODULE: ./segments/desktop/careers/index.js + 4 modules
var careers = __webpack_require__(5616);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-background-text-and-asset/fields-config.js
var full_background_text_and_asset_fields_config = __webpack_require__(55782);
;// CONCATENATED MODULE: ./segments/core-configs/topbar-config.js

/* harmony default export */ var topbar_config = ({
    topbar: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Top Bar",
        fields: {
            showMenu: {
                type: template_field_type.FIELD_TYPES.BOOLEAN,
                label: "Show Menu"
            },
            shortHeader: {
                type: template_field_type.FIELD_TYPES.BOOLEAN,
                label: "Short Header"
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/hero/layouts/full-background-hero/full-background-hero-config.js
function full_background_hero_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function full_background_hero_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            full_background_hero_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var full_background_hero_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Full Background",
    fields: _object_spread_props(full_background_hero_config_object_spread({}, topbar_config), {
        textAndAsset: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Text And Asset",
            fields: full_background_text_and_asset_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/hero/layouts/full-background-hero/index.js


var FullBackgroundHeroComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1882), __webpack_require__.e(6807)]).then(__webpack_require__.bind(__webpack_require__, 68706));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68706)
            ];
        }
    }
});
/* harmony default export */ var full_background_hero = ({
    FullBackgroundHeroComponent: FullBackgroundHeroComponent,
    FullBackgroundHeroConfig: full_background_hero_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/fields-config.js
var side_by_side_text_and_asset_fields_config = __webpack_require__(93097);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
;// CONCATENATED MODULE: ./segments/desktop/hero/layouts/side-by-side-with-background-hero/side-by-side-with-background-hero-config.js
function side_by_side_with_background_hero_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_with_background_hero_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_with_background_hero_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_with_background_hero_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_with_background_hero_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_with_background_hero_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var swapTextAndAssetPosition = side_by_side_text_and_asset_fields_config/* default.swapTextAndAssetPosition */.Z.swapTextAndAssetPosition, background = side_by_side_text_and_asset_fields_config/* default.background */.Z.background, selectedSideBySideTextAndAssetFieldsConfig = _object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "swapTextAndAssetPosition",
    "background"
]);
/* harmony default export */ var side_by_side_with_background_hero_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side With Background",
    fields: side_by_side_with_background_hero_config_object_spread_props(side_by_side_with_background_hero_config_object_spread({}, topbar_config), {
        textAndAsset: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Text And Asset",
            fields: side_by_side_with_background_hero_config_object_spread({
                background: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Background",
                    fields: {
                        color: {
                            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                            label: "Color",
                            possibleColors: segments_service/* BACKGROUND_COLOR_OPTIONS */.L6
                        }
                    }
                }
            }, selectedSideBySideTextAndAssetFieldsConfig)
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/hero/layouts/side-by-side-with-background-hero/index.js


var SideBySideWithBackgroundHeroComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1882), __webpack_require__.e(1851)]).then(__webpack_require__.bind(__webpack_require__, 14414));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14414)
            ];
        }
    }
});
/* harmony default export */ var side_by_side_with_background_hero = ({
    SideBySideWithBackgroundHeroComponent: SideBySideWithBackgroundHeroComponent,
    SideBySideWithBackgroundHeroConfig: side_by_side_with_background_hero_config
});

;// CONCATENATED MODULE: ./segments/desktop/hero/layouts/side-by-side-hero/side-by-side-hero-config.js
function side_by_side_hero_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_hero_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_hero_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_hero_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_hero_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_hero_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_hero_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_hero_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_hero_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var side_by_side_hero_config_swapTextAndAssetPosition = side_by_side_text_and_asset_fields_config/* default.swapTextAndAssetPosition */.Z.swapTextAndAssetPosition, side_by_side_hero_config_background = side_by_side_text_and_asset_fields_config/* default.background */.Z.background, side_by_side_hero_config_selectedSideBySideTextAndAssetFieldsConfig = side_by_side_hero_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "swapTextAndAssetPosition",
    "background"
]);
/* harmony default export */ var side_by_side_hero_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side",
    fields: side_by_side_hero_config_object_spread_props(side_by_side_hero_config_object_spread({}, topbar_config), {
        textAndAsset: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Text And Asset",
            fields: side_by_side_hero_config_selectedSideBySideTextAndAssetFieldsConfig
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/hero/layouts/side-by-side-hero/index.js


var SideBySideHeroComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1882), __webpack_require__.e(7110)]).then(__webpack_require__.bind(__webpack_require__, 74743));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74743)
            ];
        }
    }
});
/* harmony default export */ var side_by_side_hero = ({
    SideBySideHeroComponent: SideBySideHeroComponent,
    SideBySideHeroConfig: side_by_side_hero_config
});

;// CONCATENATED MODULE: ./segments/desktop/hero/layouts/index.js
// plop_marker:layouts_import



/* harmony default export */ var hero_layouts = ({
    // plop_marker:layouts_add_layout
    FullBackgroundHero: full_background_hero,
    SideBySideWithBackgroundHero: side_by_side_with_background_hero,
    SideBySideHero: side_by_side_hero
});

;// CONCATENATED MODULE: ./segments/desktop/hero/index.js

var FullBackgroundHero = hero_layouts.FullBackgroundHero, SideBySideWithBackgroundHero = hero_layouts.SideBySideWithBackgroundHero, SideBySideHero = hero_layouts.SideBySideHero;
/* harmony default export */ var hero = ({
    // plop_marker:segment_index_add_layout
    FullBackgroundHeroComponent: {
        type: "FullBackgroundHeroComponent",
        title: "Full Background",
        imgSrc: "/static/img/segments/layouts/full-background-hero.png",
        config: FullBackgroundHero.FullBackgroundHeroConfig,
        component: FullBackgroundHero.FullBackgroundHeroComponent
    },
    SideBySideWithBackgroundHeroComponent: {
        type: "SideBySideWithBackgroundHeroComponent",
        title: "Side By Side With Background",
        imgSrc: "/static/img/segments/layouts/side-by-side-with-background-hero.png",
        config: SideBySideWithBackgroundHero.SideBySideWithBackgroundHeroConfig,
        component: SideBySideWithBackgroundHero.SideBySideWithBackgroundHeroComponent
    },
    SideBySideHeroComponent: {
        type: "SideBySideHeroComponent",
        title: "Side By Side",
        imgSrc: "/static/img/segments/layouts/side-by-side-hero.png",
        config: SideBySideHero.SideBySideHeroConfig,
        component: SideBySideHero.SideBySideHeroComponent
    }
});

// EXTERNAL MODULE: ./segments/desktop/footer/index.js + 16 modules
var footer = __webpack_require__(31721);
// EXTERNAL MODULE: ./segments/desktop/grid/index.js + 80 modules
var grid = __webpack_require__(67986);
// EXTERNAL MODULE: ./segments/desktop/testimonials/index.js + 8 modules
var testimonials = __webpack_require__(35341);
// EXTERNAL MODULE: ./segments/desktop/logos/index.js + 18 modules
var logos = __webpack_require__(20906);
// EXTERNAL MODULE: ./segments/desktop/reviews/index.js + 17 modules
var reviews = __webpack_require__(80411);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/index.js + 51 modules
var text_and_asset = __webpack_require__(85144);
// EXTERNAL MODULE: ./segments/desktop/paragraph/index.js + 22 modules
var paragraph = __webpack_require__(27185);
;// CONCATENATED MODULE: ./segments/desktop/index.js
// plop_marker:segments_import
function desktop_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function desktop_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            desktop_define_property(target, key, source[key]);
        });
    }
    return target;
}



























/* harmony default export */ var desktop = (desktop_object_spread({}, templates/* default */.Z, careers/* default */.Z, shape/* default */.Z, pricing/* default */.Z, customer_success, desktop_form/* default */.Z, blog/* default */.Z, iframe/* default */.Z, desktop_static, embedded/* default */.Z, banner/* default */.Z, homepage_first_fold/* default */.Z, integrations/* default */.Z, desktop_button/* default */.Z, enterprise/* default */.Z, asset/* default */.Z, security/* default */.Z, tabs/* default */.Z, header/* default */.Z, hero, footer/* default */.Z, grid/* default */.Z, testimonials/* default */.Z, logos/* default */.Z, reviews/* default */.Z, text_and_asset/* default */.Z, paragraph/* default */.Z));


/***/ }),

/***/ 17082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ integrations; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/monday-integrations-connections/monday-integrations-connections-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var monday_integrations_connections_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Monday Integrations",
    fields: _object_spread_props(_object_spread({}, theme_config/* default */.Z), {
        componentTitle: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Title",
            translatable: true
        },
        beforeAnimationSubTitle: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Subtitle- before animation",
            translatable: true
        },
        afterAnimationSubTitle: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Subtitle- after animation",
            translatable: true
        },
        switchRightPhrase: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Right phrase of switch",
            translatable: true
        },
        switchLeftPhrase: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Left phrase of switch",
            translatable: true
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/monday-integrations-connections/monday-integrations-connections-advanced-config.js
function monday_integrations_connections_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function monday_integrations_connections_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            monday_integrations_connections_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var monday_integrations_connections_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: monday_integrations_connections_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/monday-integrations-connections/index.js



var MondayIntegrationsConnectionsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1348).then(__webpack_require__.bind(__webpack_require__, 91348));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91348)
            ];
        }
    }
});
/* harmony default export */ var monday_integrations_connections = ({
    MondayIntegrationsConnectionsComponent: MondayIntegrationsConnectionsComponent,
    MondayIntegrationsConnectionsConfig: monday_integrations_connections_config,
    MondayIntegrationsConnectionsAdvancedConfig: monday_integrations_connections_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/floating-integrations/floating-integrations-config.js

/* harmony default export */ var floating_integrations_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Floating",
    fields: {}
});

;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/floating-integrations/floating-integrations-advanced-config.js
function floating_integrations_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function floating_integrations_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            floating_integrations_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var floating_integrations_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: floating_integrations_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/floating-integrations/index.js



var FloatingIntegrationsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5942).then(__webpack_require__.bind(__webpack_require__, 55942));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55942)
            ];
        }
    }
});
/* harmony default export */ var floating_integrations = ({
    FloatingIntegrationsComponent: FloatingIntegrationsComponent,
    FloatingIntegrationsConfig: floating_integrations_config,
    FloatingIntegrationsAdvancedConfig: floating_integrations_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/index.js
// plop_marker:layouts_import


/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    MondayIntegrationsConnections: monday_integrations_connections,
    FloatingIntegrations: floating_integrations
});

;// CONCATENATED MODULE: ./segments/desktop/integrations/index.js

var MondayIntegrationsConnections = layouts.MondayIntegrationsConnections, FloatingIntegrations = layouts.FloatingIntegrations;
/* harmony default export */ var integrations = ({
    // plop_marker:segment_index_add_layout
    MondayIntegrationsConnectionsComponent: {
        type: "MondayIntegrationsConnectionsComponent",
        title: "Monday Integrations",
        imgSrc: "/static/img/segments/layouts/monday-integrations-connections.png",
        config: MondayIntegrationsConnections.MondayIntegrationsConnectionsConfig,
        advancedConfig: MondayIntegrationsConnections.MondayIntegrationsConnectionsAdvancedConfig,
        component: MondayIntegrationsConnections.MondayIntegrationsConnectionsComponent
    },
    FloatingIntegrationsComponent: {
        type: "FloatingIntegrationsComponent",
        title: "Floating",
        imgSrc: "/static/img/segments/layouts/floating-integrations.png",
        config: FloatingIntegrations.FloatingIntegrationsConfig,
        advancedConfig: FloatingIntegrations.FloatingIntegrationsAdvancedConfig,
        component: FloatingIntegrations.FloatingIntegrationsComponent
    }
});


/***/ }),

/***/ 74606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_title_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65621);
/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77869);
/* harmony import */ var segments_segments_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(861);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, segments_desktop_core_components_title_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
    theme: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Theme",
        possibleColors: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .BACKGROUND_COLOR_OPTIONS */ .L6
    },
    titleSize: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Title Size",
        options: [
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_3__/* .XXS */ .Mp,
                text: "11px (formerly 12px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_3__/* .XS_M */ .g4,
                text: "14px (formerly 16px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_3__.XS,
                text: "22px (formerly 24px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_3__.SM,
                text: "28px (formerly 32px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_3__.MD,
                text: "36px (formerly 40px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_3__.LG,
                text: "44px (formerly 50px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_3__/* .LGR */ .Re,
                text: "54px (formerly 60px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_3__.XL,
                text: "64px (formerly 72px)"
            }
        ]
    },
    textAlign: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Text Align",
        options: [
            {
                value: "left",
                text: "Left"
            },
            {
                value: "center",
                text: "Center"
            },
            {
                value: "right",
                text: "Right"
            }
        ]
    }
}));


/***/ }),

/***/ 20906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ logos; }
});

// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var fields_config = __webpack_require__(24586);
// EXTERNAL MODULE: ./segments/desktop/core-components/logos/fields-config.js
var logos_fields_config = __webpack_require__(97909);
;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/logos-and-paragraph-logos/logos-and-paragraph-logos-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var SUPPORTED_LOGOS_NUMBER_OPTIONS = [
    "12"
];
var numberOfCompaniesConfig = {
    numberOfCompanies: _object_spread_props(_object_spread({}, logos_fields_config/* default.numberOfCompanies */.Z.numberOfCompanies), {
        options: SUPPORTED_LOGOS_NUMBER_OPTIONS
    })
};
/* harmony default export */ var logos_and_paragraph_logos_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Logos and Paragraph",
    fields: {
        logos: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos",
            fields: _object_spread({}, logos_fields_config/* default */.Z, numberOfCompaniesConfig)
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph",
            fields: _object_spread({}, fields_config/* default */.Z)
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/core-components/logos/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(53315);
;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/logos-and-paragraph-logos/logos-and-paragraph-logos-advanced-config.js


/* harmony default export */ var logos_and_paragraph_logos_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Logos And Paragraph",
    fields: {
        logosAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos Advanced Props",
            fields: advanced_fields_config/* default */.Z
        }
    }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/logos-and-paragraph-logos/index.js



var LogosAndParagraphLogosComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9112), __webpack_require__.e(9039)]).then(__webpack_require__.bind(__webpack_require__, 75647));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75647)
            ];
        }
    }
});
/* harmony default export */ var logos_and_paragraph_logos = ({
    LogosAndParagraphLogosComponent: LogosAndParagraphLogosComponent,
    LogosAndParagraphLogosConfig: logos_and_paragraph_logos_config,
    LogosAndParagraphLogosAdvancedConfig: logos_and_paragraph_logos_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/logos/components/logos-title/fields-config.js
var logos_title_fields_config = __webpack_require__(74606);
;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/slim-logos/slim-logos-config.js
function slim_logos_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function slim_logos_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            slim_logos_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function slim_logos_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function slim_logos_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        slim_logos_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var slim_logos_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Slim Logos",
    fields: slim_logos_config_object_spread_props(slim_logos_config_object_spread({}, logos_title_fields_config/* default */.Z), {
        logos: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos",
            fields: logos_fields_config/* default */.Z
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/slim-logos/slim-logos-advanced-config.js
function slim_logos_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function slim_logos_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            slim_logos_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var slim_logos_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: slim_logos_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/slim-logos/index.js



var SlimLogosComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9112), __webpack_require__.e(7201)]).then(__webpack_require__.bind(__webpack_require__, 67858));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67858)
            ];
        }
    }
});
/* harmony default export */ var slim_logos = ({
    SlimLogosComponent: SlimLogosComponent,
    SlimLogosConfig: slim_logos_config,
    SlimLogosAdvancedConfig: slim_logos_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/all-logos-logos/all-logos-logos-config.js

/* harmony default export */ var all_logos_logos_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "All Logos",
    fields: {
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme",
            possibleColors: [
                "riverstone",
                "gradiant-gray"
            ]
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/all-logos-logos/all-logos-logos-advanced-config.js
function all_logos_logos_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function all_logos_logos_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            all_logos_logos_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var all_logos_logos_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: all_logos_logos_advanced_config_object_spread({
        logosAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos Advanced Props",
            fields: advanced_fields_config/* default */.Z
        }
    }, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/all-logos-logos/index.js



var AllLogosLogosComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9112), __webpack_require__.e(7242)]).then(__webpack_require__.bind(__webpack_require__, 38688));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38688)
            ];
        }
    }
});
/* harmony default export */ var all_logos_logos = ({
    AllLogosLogosComponent: AllLogosLogosComponent,
    AllLogosLogosConfig: all_logos_logos_config,
    AllLogosLogosAdvancedConfig: all_logos_logos_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/logos/layouts/top-logos/top-logos-config.js
var top_logos_config = __webpack_require__(63625);
;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/top-logos/top-logos-advanced-config.js
function top_logos_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function top_logos_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            top_logos_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var top_logos_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: top_logos_advanced_config_object_spread({
        textAndLogosMargin: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Space between text and logo"
        },
        logosAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos Advanced Props",
            fields: advanced_fields_config/* default */.Z
        }
    }, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/top-logos/index.js

var TopLogosComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9112), __webpack_require__.e(1222)]).then(__webpack_require__.bind(__webpack_require__, 36238));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36238)
            ];
        }
    }
});


/* harmony default export */ var top_logos = ({
    TopLogosComponent: TopLogosComponent,
    TopLogosConfig: top_logos_config/* default */.Z,
    TopLogosAdvancedConfig: top_logos_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/bottom-logos/bottom-logos-config.js
function bottom_logos_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function bottom_logos_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            bottom_logos_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function bottom_logos_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function bottom_logos_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        bottom_logos_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var bottom_logos_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Bottom",
    fields: bottom_logos_config_object_spread_props(bottom_logos_config_object_spread({}, logos_title_fields_config/* default */.Z), {
        logos: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos",
            fields: logos_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/bottom-logos/bottom-logos-advanced-config.js
function bottom_logos_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function bottom_logos_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            bottom_logos_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var bottom_logos_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: bottom_logos_advanced_config_object_spread({
        textAndLogosMargin: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Space between text and logo"
        },
        logosAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos Advanced Props",
            fields: advanced_fields_config/* default */.Z
        }
    }, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/bottom-logos/index.js



var BottomLogosComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9112), __webpack_require__.e(6030)]).then(__webpack_require__.bind(__webpack_require__, 11486));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11486)
            ];
        }
    }
});
/* harmony default export */ var bottom_logos = ({
    BottomLogosComponent: BottomLogosComponent,
    BottomLogosConfig: bottom_logos_config,
    BottomLogosAdvancedConfig: bottom_logos_advanced_config
});

// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/images-logos/images-logos-config.js



/* harmony default export */ var images_logos_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Images",
    fields: {
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme",
            possibleColors: [
                "riverstone",
                "gradiant-gray",
                color_consts.BACKGROUND_GRAY_COLOR_NAME
            ]
        },
        logos: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos",
            fields: logos_fields_config/* default */.Z
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/images-logos/images-logos-advanced-config.js
function images_logos_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function images_logos_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            images_logos_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var images_logos_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: images_logos_advanced_config_object_spread({
        logosAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos Advanced Props",
            fields: advanced_fields_config/* default */.Z
        }
    }, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/images-logos/index.js



var ImagesLogosComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9112), __webpack_require__.e(4737)]).then(__webpack_require__.bind(__webpack_require__, 24939));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24939)
            ];
        }
    }
});
/* harmony default export */ var images_logos = ({
    ImagesLogosComponent: ImagesLogosComponent,
    ImagesLogosConfig: images_logos_config,
    ImagesLogosAdvancedConfig: images_logos_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/index.js
// plop_marker:layouts_import






/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    LogosAndParagraphLogos: logos_and_paragraph_logos,
    SlimLogos: slim_logos,
    AllLogosLogos: all_logos_logos,
    TopLogos: top_logos,
    BottomLogos: bottom_logos,
    ImagesLogos: images_logos
});

;// CONCATENATED MODULE: ./segments/desktop/logos/index.js

var LogosAndParagraphLogos = layouts.LogosAndParagraphLogos, SlimLogos = layouts.SlimLogos, AllLogosLogos = layouts.AllLogosLogos, TopLogos = layouts.TopLogos, BottomLogos = layouts.BottomLogos, ImagesLogos = layouts.ImagesLogos;
/* harmony default export */ var logos = ({
    // plop_marker:segment_index_add_layout
    LogosAndParagraphLogosComponent: {
        type: "LogosAndParagraphLogosComponent",
        title: "Logos And Paragraph",
        imgSrc: "/static/img/segments/layouts/logos-and-paragraph-logos.png",
        config: LogosAndParagraphLogos.LogosAndParagraphLogosConfig,
        advancedConfig: LogosAndParagraphLogos.LogosAndParagraphLogosAdvancedConfig,
        component: LogosAndParagraphLogos.LogosAndParagraphLogosComponent
    },
    SlimLogosComponent: {
        type: "SlimLogosComponent",
        title: "Slim",
        imgSrc: "/static/img/segments/layouts/slim-logos.png",
        config: SlimLogos.SlimLogosConfig,
        advancedConfig: SlimLogos.SlimLogosAdvancedConfig,
        component: SlimLogos.SlimLogosComponent
    },
    AllLogosLogosComponent: {
        type: "AllLogosLogosComponent",
        title: "All Logos",
        imgSrc: "/static/img/segments/layouts/all-logos-logos.png",
        config: AllLogosLogos.AllLogosLogosConfig,
        advancedConfig: AllLogosLogos.AllLogosLogosAdvancedConfig,
        component: AllLogosLogos.AllLogosLogosComponent
    },
    TopLogosComponent: {
        type: "TopLogosComponent",
        title: "Top",
        imgSrc: "/static/img/segments/layouts/top-logos.png",
        config: TopLogos.TopLogosConfig,
        advancedConfig: TopLogos.TopLogosAdvancedConfig,
        component: TopLogos.TopLogosComponent
    },
    BottomLogosComponent: {
        type: "BottomLogosComponent",
        title: "Bottom",
        imgSrc: "/static/img/segments/layouts/bottom-logos.png",
        config: BottomLogos.BottomLogosConfig,
        advancedConfig: BottomLogos.BottomLogosAdvancedConfig,
        component: BottomLogos.BottomLogosComponent
    },
    ImagesLogosComponent: {
        type: "ImagesLogosComponent",
        title: "Images",
        imgSrc: "/static/img/segments/layouts/images-logos.png",
        config: ImagesLogos.ImagesLogosConfig,
        advancedConfig: ImagesLogos.ImagesLogosAdvancedConfig,
        component: ImagesLogos.ImagesLogosComponent
    }
});


/***/ }),

/***/ 63625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_logos_components_logos_title_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74606);
/* harmony import */ var segments_desktop_core_components_logos_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97909);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Top Logos",
    fields: _object_spread_props(_object_spread({}, segments_desktop_logos_components_logos_title_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
        logos: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
            label: "Logos",
            fields: segments_desktop_core_components_logos_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
        }
    })
});


/***/ }),

/***/ 27185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ paragraph; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/fields-config.js
var fields_config = __webpack_require__(93097);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./constants/color-picker-constants.js
var color_picker_constants = __webpack_require__(95947);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/side-by-side-with-paragraphs-paragraph/side-by-side-with-paragraphs-paragraph-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var fullParagraph = fields_config/* default.fullParagraph */.Z.fullParagraph, asset = fields_config/* default.asset */.Z.asset, titleSize = fields_config/* default.titleSize */.Z.titleSize, selectedSideBySideTextAndAssetFieldsConfig = _object_without_properties(fields_config/* default */.Z, [
    "fullParagraph",
    "asset",
    "titleSize"
]);
var customFullParagraph = _object_spread_props(_object_spread({}, fullParagraph), {
    fields: _object_spread_props(_object_spread({}, fullParagraph.fields), {
        paragraphVerticalColoredLineColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Paragraph vertical colored line color",
            possibleColors: segments_service/* BACKGROUND_COLOR_OPTIONS */.L6
        }
    })
});
/* harmony default export */ var side_by_side_with_paragraphs_paragraph_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side With Paragraphs",
    fields: _object_spread_props(_object_spread({}, selectedSideBySideTextAndAssetFieldsConfig), {
        primaryParagraph: _object_spread_props(_object_spread({}, customFullParagraph), {
            label: "Primary paragraph"
        }),
        leftSectionBottomText: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Left section bottom text"
        },
        leftSectionBottomTextColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Left section bottom text color",
            possibleColors: color_picker_constants.textColorOptions
        },
        paragraphs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Right section paragraphs",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    fullParagraph: _object_spread_props(_object_spread({}, customFullParagraph), {
                        label: "Full paragraph"
                    })
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/side-by-side-with-paragraphs-paragraph/side-by-side-with-paragraphs-paragraph-advanced-config.js
function side_by_side_with_paragraphs_paragraph_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_with_paragraphs_paragraph_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_with_paragraphs_paragraph_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_with_paragraphs_paragraph_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_with_paragraphs_paragraph_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_with_paragraphs_paragraph_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var side_by_side_with_paragraphs_paragraph_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_with_paragraphs_paragraph_advanced_config_object_spread_props(side_by_side_with_paragraphs_paragraph_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        leftSectionParagraphAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Left section paragraph",
            fields: advanced_fields_config/* default */.Z
        },
        rightSectionParagraphAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Right section paragraphs",
            fields: advanced_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/side-by-side-with-paragraphs-paragraph/index.js



var SideBySideWithParagraphsParagraphComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2759).then(__webpack_require__.bind(__webpack_require__, 32759));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32759)
            ];
        }
    }
});
/* harmony default export */ var side_by_side_with_paragraphs_paragraph = ({
    SideBySideWithParagraphsParagraphComponent: SideBySideWithParagraphsParagraphComponent,
    SideBySideWithParagraphsParagraphConfig: side_by_side_with_paragraphs_paragraph_config,
    SideBySideWithParagraphsParagraphAdvancedConfig: side_by_side_with_paragraphs_paragraph_advanced_config
});

// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/two-paragraphs-paragraph/two-paragraphs-paragraph-config.js
function two_paragraphs_paragraph_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function two_paragraphs_paragraph_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            two_paragraphs_paragraph_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function two_paragraphs_paragraph_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function two_paragraphs_paragraph_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        two_paragraphs_paragraph_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function two_paragraphs_paragraph_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = two_paragraphs_paragraph_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function two_paragraphs_paragraph_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var two_paragraphs_paragraph_config_fullParagraph = fields_config/* default.fullParagraph */.Z.fullParagraph, two_paragraphs_paragraph_config_asset = fields_config/* default.asset */.Z.asset, two_paragraphs_paragraph_config_titleSize = fields_config/* default.titleSize */.Z.titleSize, two_paragraphs_paragraph_config_selectedSideBySideTextAndAssetFieldsConfig = two_paragraphs_paragraph_config_object_without_properties(fields_config/* default */.Z, [
    "fullParagraph",
    "asset",
    "titleSize"
]);
var paragraphVerticalColoredLineColor = {
    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
    label: "Paragraph vertical colored line color",
    possibleColors: segments_service/* BACKGROUND_COLOR_OPTIONS */.L6
};
var two_paragraphs_paragraph_config_customFullParagraph = two_paragraphs_paragraph_config_object_spread_props(two_paragraphs_paragraph_config_object_spread({}, two_paragraphs_paragraph_config_fullParagraph), {
    fields: two_paragraphs_paragraph_config_object_spread_props(two_paragraphs_paragraph_config_object_spread({}, two_paragraphs_paragraph_config_fullParagraph.fields), {
        paragraphVerticalColoredLineColor: paragraphVerticalColoredLineColor
    })
});
/* harmony default export */ var two_paragraphs_paragraph_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Two Paragraphs",
    fields: two_paragraphs_paragraph_config_object_spread_props(two_paragraphs_paragraph_config_object_spread({}, theme_config/* default */.Z, two_paragraphs_paragraph_config_selectedSideBySideTextAndAssetFieldsConfig), {
        primaryParagraph: two_paragraphs_paragraph_config_object_spread_props(two_paragraphs_paragraph_config_object_spread({}, two_paragraphs_paragraph_config_customFullParagraph), {
            label: "Primary paragraph"
        }),
        secondaryParagraph: two_paragraphs_paragraph_config_object_spread_props(two_paragraphs_paragraph_config_object_spread({}, two_paragraphs_paragraph_config_customFullParagraph), {
            label: "Secondary paragraph"
        })
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(77374);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/two-paragraphs-paragraph/two-paragraphs-paragraph-advanced-config.js
function two_paragraphs_paragraph_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function two_paragraphs_paragraph_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            two_paragraphs_paragraph_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}




/* harmony default export */ var two_paragraphs_paragraph_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: two_paragraphs_paragraph_advanced_config_object_spread({
        primaryParagraphAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Primary paragraph",
            fields: advanced_fields_config/* default */.Z
        },
        secondaryParagraphAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Secondary paragraph",
            fields: advanced_fields_config/* default */.Z
        }
    }, shared_advanced_fields_config/* default */.Z, advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/two-paragraphs-paragraph/index.js



var TwoParagraphsParagraphComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 518).then(__webpack_require__.bind(__webpack_require__, 60518));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60518)
            ];
        }
    }
});
/* harmony default export */ var two_paragraphs_paragraph = ({
    TwoParagraphsParagraphComponent: TwoParagraphsParagraphComponent,
    TwoParagraphsParagraphConfig: two_paragraphs_paragraph_config,
    TwoParagraphsParagraphAdvancedConfig: two_paragraphs_paragraph_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/universe-paragraph/universe-paragraph-config.js
function universe_paragraph_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function universe_paragraph_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            universe_paragraph_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var universe_paragraph_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Universe Paragraph",
    fields: universe_paragraph_config_object_spread({
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme",
            possibleColors: [
                segments_service/* SPACE_BLUE_VIDEO_THEME_ID */.xn
            ]
        }
    }, full_paragraph_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/universe-paragraph/universe-paragraph-advanced-config.js
function universe_paragraph_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function universe_paragraph_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            universe_paragraph_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var universe_paragraph_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: universe_paragraph_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/universe-paragraph/index.js



var UniverseParagraphComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3885).then(__webpack_require__.bind(__webpack_require__, 63885));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63885)
            ];
        }
    }
});
/* harmony default export */ var universe_paragraph = ({
    UniverseParagraphComponent: UniverseParagraphComponent,
    UniverseParagraphConfig: universe_paragraph_config,
    UniverseParagraphAdvancedConfig: universe_paragraph_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var title_fields_config = __webpack_require__(65621);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/side-by-side-title-paragraph/side-by-side-title-paragraph-config.js
function side_by_side_title_paragraph_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_title_paragraph_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_title_paragraph_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_title_paragraph_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_title_paragraph_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_title_paragraph_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_title_paragraph_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_title_paragraph_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_title_paragraph_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var topic = full_paragraph_fields_config/* default.topic */.Z.topic, title = full_paragraph_fields_config/* default.title */.Z.title, restParagraphProps = side_by_side_title_paragraph_config_object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "topic",
    "title"
]);
/* harmony default export */ var side_by_side_title_paragraph_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side Title and Paragraph",
    fields: side_by_side_title_paragraph_config_object_spread_props(side_by_side_title_paragraph_config_object_spread({}, theme_config/* default */.Z), {
        titleProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Title",
            fields: title_fields_config/* default */.Z
        },
        paragraphProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph",
            fields: restParagraphProps
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var title_advanced_field_config = __webpack_require__(95760);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/advanced-fields-config.js
var paragraph_advanced_fields_config = __webpack_require__(50342);
// EXTERNAL MODULE: ./segments/core-configs/advanced-theme-config.js
var advanced_theme_config = __webpack_require__(42711);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/side-by-side-title-paragraph/side-by-side-title-paragraph-advanced-config.js
function side_by_side_title_paragraph_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_title_paragraph_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_title_paragraph_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_title_paragraph_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_title_paragraph_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_title_paragraph_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_title_paragraph_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_title_paragraph_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_title_paragraph_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var titleWidth = title_advanced_field_config/* default.titleWidth */.Z.titleWidth, restTitleAdvancedProps = side_by_side_title_paragraph_advanced_config_object_without_properties(title_advanced_field_config/* default */.Z, [
    "titleWidth"
]);
/* harmony default export */ var side_by_side_title_paragraph_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_title_paragraph_advanced_config_object_spread_props(side_by_side_title_paragraph_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_theme_config/* default */.Z), {
        titleAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Title",
            fields: restTitleAdvancedProps
        },
        paragraphAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph",
            fields: paragraph_advanced_fields_config/* default */.Z
        },
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        },
        paragraphVerticalAlignment: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Paragraph vertical alignment",
            options: [
                {
                    value: "baseline",
                    text: "Top"
                },
                {
                    value: "center",
                    text: "Center"
                },
                {
                    value: "end",
                    text: "Bottom"
                }
            ]
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/side-by-side-title-paragraph/index.js



var SideBySideTitleParagraphComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 833).then(__webpack_require__.bind(__webpack_require__, 80833));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80833)
            ];
        }
    }
});
/* harmony default export */ var side_by_side_title_paragraph = ({
    SideBySideTitleParagraphComponent: SideBySideTitleParagraphComponent,
    SideBySideTitleParagraphConfig: side_by_side_title_paragraph_config,
    SideBySideTitleParagraphAdvancedConfig: side_by_side_title_paragraph_advanced_config
});

// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/rotating-title-paragraph/rotating-title-paragraph-config.js


/* harmony default export */ var rotating_title_paragraph_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Rotating Title",
    fields: {
        title: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Title",
            textArea: true,
            translatable: true
        },
        titleSize: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Title Size",
            options: [
                {
                    value: sizes.MD,
                    text: "40px"
                },
                {
                    value: sizes.LG,
                    text: "50px"
                },
                {
                    value: sizes/* LGR */.Re,
                    text: "60px"
                },
                {
                    value: sizes.XL,
                    text: "72px"
                }
            ]
        },
        rotatingWords: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Rotating words",
            maxLimit: 10,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    text: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Text",
                        translatable: true
                    },
                    color: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Text Color"
                    }
                }
            }
        },
        infiniteRotation: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "infinite rotationn"
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/rotating-title-paragraph/rotating-title-paragraph-advanced-config.js
function rotating_title_paragraph_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function rotating_title_paragraph_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            rotating_title_paragraph_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var rotating_title_paragraph_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: rotating_title_paragraph_advanced_config_object_spread({
        animationDuration: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Animation Duration"
        }
    }, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/rotating-title-paragraph/index.js



var RotatingTitleParagraphComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5812).then(__webpack_require__.bind(__webpack_require__, 55812));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55812)
            ];
        }
    }
});
/* harmony default export */ var rotating_title_paragraph = ({
    RotatingTitleParagraphComponent: RotatingTitleParagraphComponent,
    RotatingTitleParagraphConfig: rotating_title_paragraph_config,
    RotatingTitleParagraphAdvancedConfig: rotating_title_paragraph_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-config.js
var full_paragraph_config = __webpack_require__(723);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-advanced-config.js
function full_paragraph_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function full_paragraph_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            full_paragraph_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function full_paragraph_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function full_paragraph_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        full_paragraph_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var full_paragraph_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: full_paragraph_advanced_config_object_spread_props(full_paragraph_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_fields_config/* default */.Z), {
        maxWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Wrapper max width"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/full-paragraph/index.js

var FullParagraphComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8461).then(__webpack_require__.bind(__webpack_require__, 98461));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98461)
            ];
        }
    }
});


/* harmony default export */ var full_paragraph = ({
    FullParagraphComponent: FullParagraphComponent,
    FullParagraphConfig: full_paragraph_config/* default */.Z,
    FullParagraphAdvancedConfig: full_paragraph_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/title-only-paragraph/title-only-paragraph-config.js
var title_only_paragraph_config = __webpack_require__(68566);
;// CONCATENATED MODULE: ./segments/desktop/core-components/title-only-paragraph/fields-advanced-config.js
function fields_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fields_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fields_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}

/* harmony default export */ var fields_advanced_config = (fields_advanced_config_object_spread({}, title_advanced_field_config/* default */.Z));

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/title-only-paragraph/title-only-paragraph-advanced-config.js
function title_only_paragraph_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function title_only_paragraph_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            title_only_paragraph_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var title_only_paragraph_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: title_only_paragraph_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, fields_advanced_config)
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/title-only-paragraph/index.js

var TitleOnlyParagraphComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6601).then(__webpack_require__.bind(__webpack_require__, 96601));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96601)
            ];
        }
    }
});


/* harmony default export */ var title_only_paragraph = ({
    TitleOnlyParagraphComponent: TitleOnlyParagraphComponent,
    TitleOnlyParagraphConfig: title_only_paragraph_config/* default */.Z,
    TitleOnlyParagraphAdvancedConfig: title_only_paragraph_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-config.js
var full_with_bullets_paragraph_config = __webpack_require__(87313);
// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-advanced-config.js
var full_with_bullets_paragraph_advanced_config = __webpack_require__(29737);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/full-with-bullets-paragraph/index.js

var FullWithBulletsParagraphComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3174).then(__webpack_require__.bind(__webpack_require__, 53174));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53174)
            ];
        }
    }
});


/* harmony default export */ var full_with_bullets_paragraph = ({
    FullWithBulletsParagraphComponent: FullWithBulletsParagraphComponent,
    FullWithBulletsParagraphConfig: full_with_bullets_paragraph_config/* default */.Z,
    FullWithBulletsParagraphAdvancedConfig: full_with_bullets_paragraph_advanced_config/* default */.Z
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/index.js
// plop_marker:layouts_import








/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    SideBySideWithParagraphsParagraph: side_by_side_with_paragraphs_paragraph,
    TwoParagraphsParagraph: two_paragraphs_paragraph,
    UniverseParagraph: universe_paragraph,
    SideBySideTitleParagraph: side_by_side_title_paragraph,
    RotatingTitleParagraph: rotating_title_paragraph,
    FullParagraph: full_paragraph,
    TitleOnlyParagraph: title_only_paragraph,
    FullWithBulletsParagraph: full_with_bullets_paragraph
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/index.js

var SideBySideWithParagraphsParagraph = layouts.SideBySideWithParagraphsParagraph, TwoParagraphsParagraph = layouts.TwoParagraphsParagraph, UniverseParagraph = layouts.UniverseParagraph, SideBySideTitleParagraph = layouts.SideBySideTitleParagraph, RotatingTitleParagraph = layouts.RotatingTitleParagraph, FullWithBulletsParagraph = layouts.FullWithBulletsParagraph, FullParagraph = layouts.FullParagraph, TitleOnlyParagraph = layouts.TitleOnlyParagraph;
/* harmony default export */ var paragraph = ({
    // plop_marker:segment_index_add_layout
    SideBySideWithParagraphsParagraphComponent: {
        type: "SideBySideWithParagraphsParagraphComponent",
        title: "Side By Side With Paragraphs",
        imgSrc: "/static/img/segments/layouts/side-by-side-with-paragraphs-paragraph.png",
        config: SideBySideWithParagraphsParagraph.SideBySideWithParagraphsParagraphConfig,
        advancedConfig: SideBySideWithParagraphsParagraph.SideBySideWithParagraphsParagraphAdvancedConfig,
        component: SideBySideWithParagraphsParagraph.SideBySideWithParagraphsParagraphComponent
    },
    TwoParagraphsParagraphComponent: {
        type: "TwoParagraphsParagraphComponent",
        title: "Two Paragraphs",
        imgSrc: "/static/img/segments/layouts/two-paragraphs-paragraph.png",
        config: TwoParagraphsParagraph.TwoParagraphsParagraphConfig,
        advancedConfig: TwoParagraphsParagraph.TwoParagraphsParagraphAdvancedConfig,
        component: TwoParagraphsParagraph.TwoParagraphsParagraphComponent
    },
    UniverseParagraphComponent: {
        type: "UniverseParagraphComponent",
        title: "Universe mobile",
        imgSrc: "/static/img/segments/layouts/universe-paragraph.png",
        config: UniverseParagraph.UniverseParagraphConfig,
        advancedConfig: UniverseParagraph.UniverseParagraphAdvancedConfig,
        component: UniverseParagraph.UniverseParagraphComponent
    },
    SideBySideTitleParagraphComponent: {
        type: "SideBySideTitleParagraphComponent",
        title: "Side By Side Title",
        imgSrc: "/static/img/segments/layouts/side-by-side-title-paragraph.png",
        config: SideBySideTitleParagraph.SideBySideTitleParagraphConfig,
        advancedConfig: SideBySideTitleParagraph.SideBySideTitleParagraphAdvancedConfig,
        component: SideBySideTitleParagraph.SideBySideTitleParagraphComponent
    },
    RotatingTitleParagraphComponent: {
        type: "RotatingTitleParagraphComponent",
        title: "Rotating Title",
        imgSrc: "/static/img/segments/layouts/rotating-title-paragraph.png",
        config: RotatingTitleParagraph.RotatingTitleParagraphConfig,
        advancedConfig: RotatingTitleParagraph.RotatingTitleParagraphAdvancedConfig,
        component: RotatingTitleParagraph.RotatingTitleParagraphComponent
    },
    FullWithBulletsParagraphComponent: {
        type: "FullWithBulletsParagraphComponent",
        title: "Full With Bullets",
        imgSrc: "/static/img/segments/layouts/full-with-bullets-paragraph.png",
        config: FullWithBulletsParagraph.FullWithBulletsParagraphConfig,
        advancedConfig: FullWithBulletsParagraph.FullWithBulletsParagraphAdvancedConfig,
        component: FullWithBulletsParagraph.FullWithBulletsParagraphComponent
    },
    FullParagraphComponent: {
        type: "FullParagraphComponent",
        title: "Full",
        imgSrc: "/static/img/segments/layouts/full-paragraph.png",
        config: FullParagraph.FullParagraphConfig,
        advancedConfig: FullParagraph.FullParagraphAdvancedConfig,
        component: FullParagraph.FullParagraphComponent
    },
    TitleOnlyParagraphComponent: {
        type: "TitleOnlyParagraphComponent",
        title: "Title Only",
        imgSrc: "/static/img/segments/layouts/title-only-paragraph.png",
        config: TitleOnlyParagraph.TitleOnlyParagraphConfig,
        advancedConfig: TitleOnlyParagraph.TitleOnlyParagraphAdvancedConfig,
        component: TitleOnlyParagraph.TitleOnlyParagraphComponent
    }
});


/***/ }),

/***/ 723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60633);
/* harmony import */ var segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24586);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var textColor = segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].textColor */ .Z.textColor, selectedFullParagraphFields = _object_without_properties(segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, [
    "textColor"
]);
/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Full Paragraph",
    fields: _object_spread({}, segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, selectedFullParagraphFields)
});


/***/ }),

/***/ 29737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_shared_advanced_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69223);
/* harmony import */ var segments_desktop_core_components_full_paragraph_advanced_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47285);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(_object_spread({}, segments_desktop_shared_advanced_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, segments_desktop_core_components_full_paragraph_advanced_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z), {
        maxWidth: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
            label: "Max Width"
        },
        removeBulletsMobileMarginTop: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
            label: "Remove Bullets Margin Top On Mobile"
        }
    })
});


/***/ }),

/***/ 87313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60633);
/* harmony import */ var segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24586);
/* harmony import */ var segments_desktop_core_components_bullets_fields_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61204);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var textColor = segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].textColor */ .Z.textColor, selectedFullParagraphFields = _object_without_properties(segments_desktop_core_components_full_paragraph_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, [
    "textColor"
]);
/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Full with bullets paragraph",
    fields: _object_spread_props(_object_spread({}, segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, selectedFullParagraphFields), {
        bulletsConfig: segments_desktop_core_components_bullets_fields_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
    })
});


/***/ }),

/***/ 68566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60633);
/* harmony import */ var segments_desktop_core_components_title_only_paragraph_fields_config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17702);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var textColor = segments_desktop_core_components_title_only_paragraph_fields_config_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].textColor */ .Z.textColor, selectedTitleOnlyParagraphFields = _object_without_properties(segments_desktop_core_components_title_only_paragraph_fields_config_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, [
    "textColor"
]);
/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Title Only Paragraph",
    fields: _object_spread({}, segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, selectedTitleOnlyParagraphFields)
});


/***/ }),

/***/ 49643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _layouts_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43548);

var MultiProductsPricing = _layouts_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].MultiProductsPricing */ .Z.MultiProductsPricing, FeaturesTablePricing = _layouts_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FeaturesTablePricing */ .Z.FeaturesTablePricing, PricesAndFeaturesCardsPricing = _layouts_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].PricesAndFeaturesCardsPricing */ .Z.PricesAndFeaturesCardsPricing, FrequentlyAskedQuestionsPricing = _layouts_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FrequentlyAskedQuestionsPricing */ .Z.FrequentlyAskedQuestionsPricing;
/* harmony default export */ __webpack_exports__["Z"] = ({
    // plop_marker:segment_index_add_layout
    MultiProductsPricingComponent: {
        type: "MultiProductsPricingComponent",
        title: "Multi Products Pricing",
        imgSrc: "/static/img/segments/layouts/multi-products-pricing.png",
        config: MultiProductsPricing.MultiProductsPricingConfig,
        advancedConfig: MultiProductsPricing.MultiProductsPricingAdvancedConfig,
        component: MultiProductsPricing.MultiProductsPricingComponent
    },
    FeaturesTablePricingComponent: {
        type: "FeaturesTablePricingComponent",
        title: "Features Table",
        imgSrc: "/static/img/segments/layouts/features-table-pricing.png",
        config: FeaturesTablePricing.FeaturesTablePricingConfig,
        advancedConfig: FeaturesTablePricing.FeaturesTablePricingAdvancedConfig,
        component: FeaturesTablePricing.FeaturesTablePricingComponent
    },
    PricesAndFeaturesCardsPricingComponent: {
        type: "PricesAndFeaturesCardsPricingComponent",
        title: "Prices And Features Cards",
        imgSrc: "/static/img/segments/layouts/prices-and-features-cards-pricing.png",
        config: PricesAndFeaturesCardsPricing.PricesAndFeaturesCardsPricingConfig,
        advancedConfig: PricesAndFeaturesCardsPricing.PricesAndFeaturesCardsPricingAdvancedConfig,
        component: PricesAndFeaturesCardsPricing.PricesAndFeaturesCardsPricingComponent
    },
    FrequentlyAskedQuestionsPricingComponent: {
        type: "FrequentlyAskedQuestionsPricingComponent",
        title: "Frequently Asked Questions",
        imgSrc: "/static/img/segments/layouts/frequently-asked-questions-pricing.png",
        config: FrequentlyAskedQuestionsPricing.FrequentlyAskedQuestionsPricingConfig,
        advancedConfig: FrequentlyAskedQuestionsPricing.FrequentlyAskedQuestionsPricingAdvancedConfig,
        component: FrequentlyAskedQuestionsPricing.FrequentlyAskedQuestionsPricingComponent
    }
});


/***/ }),

/***/ 80411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ reviews; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var fields_config = __webpack_require__(13225);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/review-cards-reviews/review-cards-reviews-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, selectedFullParagraphFields = _object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "textColor"
]);
var review_cards_reviews_config_image = fields_config/* default.image */.Z.image;
/* harmony default export */ var review_cards_reviews_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Review Cards",
    fields: _object_spread_props(_object_spread({}, theme_config/* default */.Z), {
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph",
            fields: selectedFullParagraphFields
        },
        cards: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Cards",
            maxLimit: 4,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    image: review_cards_reviews_config_image,
                    title: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Title"
                    },
                    subtitle: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Subtitle"
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/review-cards-reviews/review-cards-reviews-advanced-config.js
function review_cards_reviews_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function review_cards_reviews_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            review_cards_reviews_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function review_cards_reviews_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function review_cards_reviews_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        review_cards_reviews_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var review_cards_reviews_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: review_cards_reviews_advanced_config_object_spread_props(review_cards_reviews_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_fields_config/* default */.Z), {
        marginAboveCards: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Margin above cards"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/review-cards-reviews/index.js



var ReviewCardsReviewsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9938).then(__webpack_require__.bind(__webpack_require__, 79938));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79938)
            ];
        }
    }
});
/* harmony default export */ var review_cards_reviews = ({
    ReviewCardsReviewsComponent: ReviewCardsReviewsComponent,
    ReviewCardsReviewsConfig: review_cards_reviews_config,
    ReviewCardsReviewsAdvancedConfig: review_cards_reviews_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-config.js
var two_thirds_text_and_asset_config = __webpack_require__(49133);
// EXTERNAL MODULE: ./segments/desktop/core-components/person-textual-info/fields-config.js
var person_textual_info_fields_config = __webpack_require__(81828);
;// CONCATENATED MODULE: ./segments/desktop/core-components/reviews-carousel/fields-config.js
function fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function fields_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function fields_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        fields_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function fields_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = fields_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function fields_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var fields_config_image = fields_config/* default.image */.Z.image;
var color = person_textual_info_fields_config/* default.color */.Z.color, selectedTextualInfoFields = fields_config_object_without_properties(person_textual_info_fields_config/* default */.Z, [
    "color"
]);
/* harmony default export */ var reviews_carousel_fields_config = ({
    autoplay: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Auto-play definitions",
        fields: {
            shouldAutoPlay: {
                type: template_field_type.FIELD_TYPES.BOOLEAN,
                label: "Should auto-play reviews"
            },
            interval: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Interval (number of milliseconds)"
            }
        }
    },
    reviews: {
        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Reviews",
        maxLimit: 15,
        nestedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: fields_config_object_spread_props(fields_config_object_spread({
                quote: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Quote",
                    textArea: true,
                    translatable: true
                }
            }, selectedTextualInfoFields), {
                companyLogo: fields_config_object_spread_props(fields_config_object_spread({}, fields_config_image), {
                    label: "Company Logo"
                }),
                customerImage: fields_config_object_spread_props(fields_config_object_spread({}, fields_config_image), {
                    label: "Customer Image",
                    labelDescription: "Please select an image with 100x100 dimensions."
                })
            })
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/paragraph-and-carousel-reviews/paragraph-and-carousel-reviews-config.js
function paragraph_and_carousel_reviews_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function paragraph_and_carousel_reviews_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            paragraph_and_carousel_reviews_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function paragraph_and_carousel_reviews_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function paragraph_and_carousel_reviews_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        paragraph_and_carousel_reviews_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function paragraph_and_carousel_reviews_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = paragraph_and_carousel_reviews_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function paragraph_and_carousel_reviews_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var _TwoThirdsTextAndAssetConfig_fields = two_thirds_text_and_asset_config/* default.fields */.Z.fields, asset = _TwoThirdsTextAndAssetConfig_fields.asset, selectedTwoThirdsTextAndAssetConfig = paragraph_and_carousel_reviews_config_object_without_properties(_TwoThirdsTextAndAssetConfig_fields, [
    "asset"
]);
/* harmony default export */ var paragraph_and_carousel_reviews_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Paragraph And Carousel",
    fields: paragraph_and_carousel_reviews_config_object_spread_props(paragraph_and_carousel_reviews_config_object_spread({}, selectedTwoThirdsTextAndAssetConfig), {
        carousel: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Carousel",
            fields: paragraph_and_carousel_reviews_config_object_spread({}, reviews_carousel_fields_config)
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(77374);
;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/paragraph-and-carousel-reviews/paragraph-and-carousel-reviews-advanced-config.js
function paragraph_and_carousel_reviews_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function paragraph_and_carousel_reviews_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            paragraph_and_carousel_reviews_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function paragraph_and_carousel_reviews_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function paragraph_and_carousel_reviews_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        paragraph_and_carousel_reviews_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var paragraph_and_carousel_reviews_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: paragraph_and_carousel_reviews_advanced_config_object_spread_props(paragraph_and_carousel_reviews_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_field_config/* default */.Z), {
        removeQuoteSigns: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Remove carousel texts quote signs"
        },
        mobileMarginBetweenParagraphAndCarousel: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Margin above carousel"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/paragraph-and-carousel-reviews/index.js



var ParagraphAndCarouselReviewsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6605).then(__webpack_require__.bind(__webpack_require__, 76605));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76605)
            ];
        }
    }
});
/* harmony default export */ var paragraph_and_carousel_reviews = ({
    ParagraphAndCarouselReviewsComponent: ParagraphAndCarouselReviewsComponent,
    ParagraphAndCarouselReviewsConfig: paragraph_and_carousel_reviews_config,
    ParagraphAndCarouselReviewsAdvancedConfig: paragraph_and_carousel_reviews_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/review-card/fields-config.js
function review_card_fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function review_card_fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            review_card_fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function review_card_fields_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = review_card_fields_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function review_card_fields_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var fields_config_color = person_textual_info_fields_config/* default.color */.Z.color, fields_config_selectedTextualInfoFields = review_card_fields_config_object_without_properties(person_textual_info_fields_config/* default */.Z, [
    "color"
]);
/* harmony default export */ var review_card_fields_config = (review_card_fields_config_object_spread({
    decorationColor: {
        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
        label: "Decoration Color"
    },
    title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Title",
        textArea: true,
        translatable: true
    },
    showStars: {
        type: "boolean",
        label: "Show Stars"
    },
    starsCount: {
        type: template_field_type.FIELD_TYPES.COMBO,
        label: "How many stars",
        options: [
            "1",
            "2",
            "3",
            "4",
            "5"
        ]
    }
}, fields_config_selectedTextualInfoFields));

;// CONCATENATED MODULE: ./segments/desktop/core-components/reviews/fields-config.js


/* harmony default export */ var reviews_fields_config = ({
    reviews: {
        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Reviews",
        maxLimit: 2,
        nestedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: review_card_fields_config
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/regular-reviews/regular-reviews-config.js


/* harmony default export */ var regular_reviews_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Regular",
    fields: reviews_fields_config
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/review-card/shared-advanced-fields-config.js

/* harmony default export */ var review_card_shared_advanced_fields_config = ({
    cardFontSize: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card Font Size"
    },
    reviewCardOverrideHeight: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Override Review Card Height"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/regular-reviews/regular-reviews-advanced-config.js
function regular_reviews_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function regular_reviews_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            regular_reviews_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var regular_reviews_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: regular_reviews_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, review_card_shared_advanced_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/regular-reviews/index.js

var RegularReviewsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3395), __webpack_require__.e(3750)]).then(__webpack_require__.bind(__webpack_require__, 63750));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63750)
            ];
        }
    }
});


/* harmony default export */ var regular_reviews = ({
    RegularReviewsComponent: RegularReviewsComponent,
    RegularReviewsConfig: regular_reviews_config,
    RegularReviewsAdvancedConfig: regular_reviews_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title-only-paragraph/fields-config.js
var title_only_paragraph_fields_config = __webpack_require__(17702);
;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/with-title-reviews/with-title-reviews-config.js
function with_title_reviews_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function with_title_reviews_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            with_title_reviews_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var with_title_reviews_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "With Title",
    fields: with_title_reviews_config_object_spread({
        titleOnlyParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Title Only",
            fields: title_only_paragraph_fields_config/* default */.Z
        }
    }, reviews_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/with-title-reviews/with-title-reviews-advanced-config.js
function with_title_reviews_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function with_title_reviews_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            with_title_reviews_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function with_title_reviews_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function with_title_reviews_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        with_title_reviews_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var with_title_reviews_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: with_title_reviews_advanced_config_object_spread_props(with_title_reviews_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, review_card_shared_advanced_fields_config), {
        minHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Override Minimum Height"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/with-title-reviews/index.js

var WithTitleReviewsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3395), __webpack_require__.e(2660)]).then(__webpack_require__.bind(__webpack_require__, 12660));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12660)
            ];
        }
    }
});


/* harmony default export */ var with_title_reviews = ({
    WithTitleReviewsComponent: WithTitleReviewsComponent,
    WithTitleReviewsConfig: with_title_reviews_config,
    WithTitleReviewsAdvancedConfig: with_title_reviews_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/index.js
// plop_marker:layouts_import




/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    ReviewCardsReviews: review_cards_reviews,
    ParagraphAndCarouselReviews: paragraph_and_carousel_reviews,
    RegularReviews: regular_reviews,
    WithTitleReviews: with_title_reviews
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/index.js

var ReviewCardsReviews = layouts.ReviewCardsReviews, ParagraphAndCarouselReviews = layouts.ParagraphAndCarouselReviews, RegularReviews = layouts.RegularReviews, WithTitleReviews = layouts.WithTitleReviews;
/* harmony default export */ var reviews = ({
    // plop_marker:segment_index_add_layout
    ReviewCardsReviewsComponent: {
        type: "ReviewCardsReviewsComponent",
        title: "Review Cards",
        imgSrc: "/static/img/segments/layouts/review-cards-reviews.png",
        config: ReviewCardsReviews.ReviewCardsReviewsConfig,
        advancedConfig: ReviewCardsReviews.ReviewCardsReviewsAdvancedConfig,
        component: ReviewCardsReviews.ReviewCardsReviewsComponent
    },
    ParagraphAndCarouselReviewsComponent: {
        type: "ParagraphAndCarouselReviewsComponent",
        title: "Paragraph And Carousel",
        imgSrc: "/static/img/segments/layouts/paragraph-and-carousel-reviews.png",
        config: ParagraphAndCarouselReviews.ParagraphAndCarouselReviewsConfig,
        advancedConfig: ParagraphAndCarouselReviews.ParagraphAndCarouselReviewsAdvancedConfig,
        component: ParagraphAndCarouselReviews.ParagraphAndCarouselReviewsComponent
    },
    RegularReviewsComponent: {
        type: "RegularReviewsComponent",
        title: "Regular",
        imgSrc: "/static/img/segments/layouts/regular-reviews.png",
        config: RegularReviews.RegularReviewsConfig,
        advancedConfig: RegularReviews.RegularReviewsAdvancedConfig,
        component: RegularReviews.RegularReviewsComponent
    },
    WithTitleReviewsComponent: {
        type: "WithTitleReviewsComponent",
        title: "With Title",
        imgSrc: "/static/img/segments/layouts/with-title-reviews.png",
        config: WithTitleReviews.WithTitleReviewsConfig,
        advancedConfig: WithTitleReviews.WithTitleReviewsAdvancedConfig,
        component: WithTitleReviews.WithTitleReviewsComponent
    }
});


/***/ }),

/***/ 71380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ security; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var fields_config = __webpack_require__(65621);
;// CONCATENATED MODULE: ./segments/desktop/security/layouts/logos-and-header-security/logos-and-header-security-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var logos_and_header_security_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Logos And Header",
    fields: _object_spread({}, fields_config/* default */.Z)
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/security/layouts/logos-and-header-security/logos-and-header-security-advanced-config.js
function logos_and_header_security_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function logos_and_header_security_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            logos_and_header_security_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var logos_and_header_security_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: logos_and_header_security_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/security/layouts/logos-and-header-security/index.js

var LogosAndHeaderSecurityComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9502).then(__webpack_require__.bind(__webpack_require__, 49502));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49502)
            ];
        }
    }
});


/* harmony default export */ var logos_and_header_security = ({
    LogosAndHeaderSecurityComponent: LogosAndHeaderSecurityComponent,
    LogosAndHeaderSecurityConfig: logos_and_header_security_config,
    LogosAndHeaderSecurityAdvancedConfig: logos_and_header_security_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/security/layouts/index.js
// plop_marker:layouts_import

/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    LogosAndHeaderSecurity: logos_and_header_security
});

;// CONCATENATED MODULE: ./segments/desktop/security/index.js

var LogosAndHeaderSecurity = layouts.LogosAndHeaderSecurity;
/* harmony default export */ var security = ({
    // plop_marker:segment_index_add_layout
    LogosAndHeaderSecurityComponent: {
        type: "LogosAndHeaderSecurityComponent",
        title: "Logos And Header",
        imgSrc: "/static/img/segments/layouts/logos-and-header-security.png",
        config: LogosAndHeaderSecurity.LogosAndHeaderSecurityConfig,
        advancedConfig: LogosAndHeaderSecurity.LogosAndHeaderSecurityAdvancedConfig,
        component: LogosAndHeaderSecurity.LogosAndHeaderSecurityComponent
    }
});


/***/ }),

/***/ 20655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shape; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/hotdog-shape/hotdog-shape-config.js


/* harmony default export */ var hotdog_shape_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Hotdog",
    fields: {
        x: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "X"
        },
        y: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Y"
        },
        width: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Width"
        },
        scale: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Scale"
        },
        rotation: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Rotation (0\xb0-360\xb0)"
        },
        fill: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Fill Color"
        },
        gradientFill: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Linear gradient fill",
            fields: {
                useLinearGradientFill: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Use linear gradient fill"
                },
                color: {
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                    label: "Color",
                    labelDescription: "Second color in the gradient to be mixed with the fill color"
                },
                x: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "X"
                },
                y: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Y"
                }
            }
        },
        align: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Align",
            options: [
                {
                    value: align_types.ALIGN_TYPES.LEFT,
                    text: align_types.ALIGN_LABELS.LEFT
                },
                {
                    value: align_types.ALIGN_TYPES.CENTER,
                    text: align_types.ALIGN_LABELS.CENTER
                },
                {
                    value: align_types.ALIGN_TYPES.RIGHT,
                    text: align_types.ALIGN_LABELS.RIGHT
                }
            ]
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/shape/shared-shape-advanced-config.js

/* harmony default export */ var shared_shape_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: {
        stroke: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Stroke Color"
        },
        strokeWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Stroke Width"
        },
        opacity: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Opacity"
        },
        shadowColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Shadow Color"
        },
        shadowBlur: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Shadow Blur"
        },
        shadowOffsetX: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Shadow Offset X"
        },
        shadowOffsetY: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Shadow Offset Y"
        },
        zIndex: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Z Index"
        },
        relativeTo: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Relative To (Segment ID)"
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/hotdog-shape/hotdog-shape-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}

/* harmony default export */ var hotdog_shape_advanced_config = (_object_spread({}, shared_shape_advanced_config));

;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/hotdog-shape/index.js



var HotdogShapeComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7966).then(__webpack_require__.bind(__webpack_require__, 77966));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77966)
            ];
        }
    }
});
/* harmony default export */ var hotdog_shape = ({
    HotdogShapeComponent: HotdogShapeComponent,
    HotdogShapeConfig: hotdog_shape_config,
    HotdogShapeAdvancedConfig: hotdog_shape_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/ring-shape/ring-shape-config.js


/* harmony default export */ var ring_shape_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Ring",
    fields: {
        innerRadius: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Inner Radius"
        },
        outerRadius: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Outer Radius"
        },
        x: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "X"
        },
        y: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Y"
        },
        scale: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Scale"
        },
        rotation: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Rotation (0\xb0-360\xb0)"
        },
        fill: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Fill Color"
        },
        gradientFill: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Linear gradient fill",
            fields: {
                useLinearGradientFill: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Use linear gradient fill"
                },
                color: {
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                    label: "Color",
                    labelDescription: "Second color in the gradient to be mixed with the fill color"
                },
                x: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "X"
                },
                y: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Y"
                }
            }
        },
        align: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Align",
            options: [
                {
                    value: align_types.ALIGN_TYPES.LEFT,
                    text: align_types.ALIGN_LABELS.LEFT
                },
                {
                    value: align_types.ALIGN_TYPES.CENTER,
                    text: align_types.ALIGN_LABELS.CENTER
                },
                {
                    value: align_types.ALIGN_TYPES.RIGHT,
                    text: align_types.ALIGN_LABELS.RIGHT
                }
            ]
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/ring-shape/ring-shape-advanced-config.js
function ring_shape_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ring_shape_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ring_shape_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}

/* harmony default export */ var ring_shape_advanced_config = (ring_shape_advanced_config_object_spread({}, shared_shape_advanced_config));

;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/ring-shape/index.js



var RingShapeComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6142).then(__webpack_require__.bind(__webpack_require__, 6142));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6142)
            ];
        }
    }
});
/* harmony default export */ var ring_shape = ({
    RingShapeComponent: RingShapeComponent,
    RingShapeConfig: ring_shape_config,
    RingShapeAdvancedConfig: ring_shape_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/star-shape/star-shape-config.js


/* harmony default export */ var star_shape_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Star",
    fields: {
        innerRadius: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Inner Radius"
        },
        outerRadius: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Outer Radius"
        },
        x: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "X"
        },
        y: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Y"
        },
        scale: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Scale"
        },
        rotation: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Rotation (0\xb0-360\xb0)"
        },
        fill: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Fill Color"
        },
        gradientFill: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Linear gradient fill",
            fields: {
                useLinearGradientFill: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Use linear gradient fill"
                },
                color: {
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                    label: "Color"
                },
                x: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "X"
                },
                y: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Y"
                }
            }
        },
        align: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Align",
            options: [
                {
                    value: align_types.ALIGN_TYPES.LEFT,
                    text: align_types.ALIGN_LABELS.LEFT
                },
                {
                    value: align_types.ALIGN_TYPES.CENTER,
                    text: align_types.ALIGN_LABELS.CENTER
                },
                {
                    value: align_types.ALIGN_TYPES.RIGHT,
                    text: align_types.ALIGN_LABELS.RIGHT
                }
            ]
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/star-shape/star-shape-advanced-config.js
function star_shape_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function star_shape_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            star_shape_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}

/* harmony default export */ var star_shape_advanced_config = (star_shape_advanced_config_object_spread({}, shared_shape_advanced_config));

;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/star-shape/index.js



var StarShapeComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9564).then(__webpack_require__.bind(__webpack_require__, 59564));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59564)
            ];
        }
    }
});
/* harmony default export */ var star_shape = ({
    StarShapeComponent: StarShapeComponent,
    StarShapeConfig: star_shape_config,
    StarShapeAdvancedConfig: star_shape_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/rectangle-shape/rectangle-shape-config.js


// Should be moved to BaseShapeConfig
/* harmony default export */ var rectangle_shape_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Rectangle",
    fields: {
        x: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "X"
        },
        y: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Y"
        },
        width: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Width"
        },
        scale: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Scale"
        },
        cornerRadius: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Corner Radius (50 = Circle)"
        },
        rotation: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Rotation (0\xb0-360\xb0)"
        },
        fill: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Fill Color"
        },
        gradientFill: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Linear gradient fill",
            fields: {
                useLinearGradientFill: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Use linear gradient fill"
                },
                color: {
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                    label: "Color",
                    labelDescription: "Second color in the gradient to be mixed with the fill color"
                },
                x: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "X"
                },
                y: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Y"
                }
            }
        },
        align: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Align",
            options: [
                {
                    value: align_types.ALIGN_TYPES.LEFT,
                    text: align_types.ALIGN_LABELS.LEFT
                },
                {
                    value: align_types.ALIGN_TYPES.CENTER,
                    text: align_types.ALIGN_LABELS.CENTER
                },
                {
                    value: align_types.ALIGN_TYPES.RIGHT,
                    text: align_types.ALIGN_LABELS.RIGHT
                }
            ]
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/rectangle-shape/rectangle-shape-advanced-config.js
function rectangle_shape_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function rectangle_shape_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            rectangle_shape_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}

/* harmony default export */ var rectangle_shape_advanced_config = (rectangle_shape_advanced_config_object_spread({}, shared_shape_advanced_config));

;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/rectangle-shape/index.js



var RectangleShapeComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4183).then(__webpack_require__.bind(__webpack_require__, 54183));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(54183)
            ];
        }
    }
});
/* harmony default export */ var rectangle_shape = ({
    RectangleShapeComponent: RectangleShapeComponent,
    RectangleShapeConfig: rectangle_shape_config,
    RectangleShapeAdvancedConfig: rectangle_shape_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/square-shape/square-shape-config.js


// Should be moved to BaseShapeConfig
/* harmony default export */ var square_shape_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Rectangle",
    fields: {
        x: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "X"
        },
        y: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Y"
        },
        scale: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Scale"
        },
        cornerRadius: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Corner Radius (50 = Circle)"
        },
        rotation: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Rotation (0\xb0-360\xb0)"
        },
        fill: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Fill Color"
        },
        gradientFill: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Linear gradient fill",
            fields: {
                useLinearGradientFill: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Use linear gradient fill"
                },
                color: {
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                    label: "Color",
                    labelDescription: "Second color in the gradient to be mixed with the fill color"
                },
                x: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "X"
                },
                y: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Y"
                }
            }
        },
        align: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Align",
            options: [
                {
                    value: align_types.ALIGN_TYPES.LEFT,
                    text: align_types.ALIGN_LABELS.LEFT
                },
                {
                    value: align_types.ALIGN_TYPES.CENTER,
                    text: align_types.ALIGN_LABELS.CENTER
                },
                {
                    value: align_types.ALIGN_TYPES.RIGHT,
                    text: align_types.ALIGN_LABELS.RIGHT
                }
            ]
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/square-shape/square-shape-advanced-config.js
function square_shape_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function square_shape_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            square_shape_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}

/* harmony default export */ var square_shape_advanced_config = (square_shape_advanced_config_object_spread({}, shared_shape_advanced_config));

;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/square-shape/index.js



var SquareShapeComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6536).then(__webpack_require__.bind(__webpack_require__, 66536));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66536)
            ];
        }
    }
});
/* harmony default export */ var square_shape = ({
    SquareShapeComponent: SquareShapeComponent,
    SquareShapeConfig: square_shape_config,
    SquareShapeAdvancedConfig: square_shape_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/index.js
// plop_marker:layouts_import





/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    HotdogShape: hotdog_shape,
    RingShape: ring_shape,
    StarShape: star_shape,
    RectangleShape: rectangle_shape,
    SquareShape: square_shape
});

// EXTERNAL MODULE: ./constants/segment-families.js
var segment_families = __webpack_require__(19971);
;// CONCATENATED MODULE: ./segments/desktop/shape/index.js


var HotdogShape = layouts.HotdogShape, RingShape = layouts.RingShape, StarShape = layouts.StarShape, RectangleShape = layouts.RectangleShape, SquareShape = layouts.SquareShape;
/* harmony default export */ var shape = ({
    // plop_marker:segment_index_add_layout
    HotdogShapeComponent: {
        family: segment_families/* default.SHAPE */.Z.SHAPE,
        type: "HotdogShapeComponent",
        title: "Hotdog",
        imgSrc: "/static/img/segments/layouts/hotdog-shape.png",
        config: HotdogShape.HotdogShapeConfig,
        advancedConfig: HotdogShape.HotdogShapeAdvancedConfig,
        component: HotdogShape.HotdogShapeComponent
    },
    RingShapeComponent: {
        family: segment_families/* default.SHAPE */.Z.SHAPE,
        type: "RingShapeComponent",
        title: "Ring",
        imgSrc: "/static/img/segments/layouts/ring-shape.png",
        config: RingShape.RingShapeConfig,
        advancedConfig: RingShape.RingShapeAdvancedConfig,
        component: RingShape.RingShapeComponent
    },
    StarShapeComponent: {
        family: segment_families/* default.SHAPE */.Z.SHAPE,
        type: "StarShapeComponent",
        title: "Star",
        imgSrc: "/static/img/segments/layouts/star-shape.png",
        config: StarShape.StarShapeConfig,
        advancedConfig: StarShape.StarShapeAdvancedConfig,
        component: StarShape.StarShapeComponent
    },
    RectangleShapeComponent: {
        family: segment_families/* default.SHAPE */.Z.SHAPE,
        type: "RectangleShapeComponent",
        title: "Rectangle",
        imgSrc: "/static/img/segments/layouts/rectangle-shape.png",
        config: RectangleShape.RectangleShapeConfig,
        advancedConfig: RectangleShape.RectangleShapeAdvancedConfig,
        component: RectangleShape.RectangleShapeComponent
    },
    SquareShapeComponent: {
        family: segment_families/* default.SHAPE */.Z.SHAPE,
        type: "SquareShapeComponent",
        title: "Square",
        imgSrc: "/static/img/segments/layouts/square-shape.png",
        config: SquareShape.SquareShapeConfig,
        advancedConfig: SquareShape.SquareShapeAdvancedConfig,
        component: SquareShape.SquareShapeComponent
    }
});


/***/ }),

/***/ 87918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ desktop_tabs; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var fields_config = __webpack_require__(13225);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var title_fields_config = __webpack_require__(65621);
;// CONCATENATED MODULE: ./segments/desktop/core-components/testimonial/fields-config.js



/* harmony default export */ var testimonial_fields_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    fields: {
        quote: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Text",
            fields: title_fields_config/* default */.Z
        },
        author: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Author Name"
        },
        company: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Author Company",
            fields: title_fields_config/* default */.Z
        },
        asset: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Author Picture",
            fields: fields_config/* default.image.fields */.Z.image.fields
        },
        backgroundColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Background Color"
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-config.js
var full_paragraph_config = __webpack_require__(723);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/carousel-tabs/carousel-tabs-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var _FullParagraphConfig_fields = full_paragraph_config/* default.fields */.Z.fields, topic = _FullParagraphConfig_fields.topic, mobileTextAlign = _FullParagraphConfig_fields.mobileTextAlign, theme = _FullParagraphConfig_fields.theme, textAlign = _FullParagraphConfig_fields.textAlign, buttonConfig = _FullParagraphConfig_fields.buttonConfig, restOfParagraphConfig = _object_without_properties(_FullParagraphConfig_fields, [
    "topic",
    "mobileTextAlign",
    "theme",
    "textAlign",
    "buttonConfig"
]);
/* harmony default export */ var carousel_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Carousel Tabs",
    fields: _object_spread_props(_object_spread({}, theme_config/* default */.Z), {
        containerGap: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tabs and carousel gap (default 32px)"
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 8,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tabLabel: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Tab Label",
                        translatable: true
                    },
                    tabContent: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab content",
                        fields: {
                            asset: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Background asset",
                                fields: fields_config/* default */.Z
                            },
                            testimonial: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Testimonial",
                                fields: _object_spread_props(_object_spread({}, testimonial_fields_config.fields), {
                                    button: {
                                        type: template_field_type.FIELD_TYPES.NESTED,
                                        label: "Button",
                                        fields: {
                                            buttonText: {
                                                type: template_field_type.FIELD_TYPES.TEXT,
                                                label: "Button text"
                                            },
                                            color: {
                                                type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                                                label: "Button color"
                                            },
                                            buttonUrl: {
                                                type: template_field_type.FIELD_TYPES.TEXT,
                                                label: "Button url"
                                            }
                                        }
                                    }
                                })
                            },
                            stats: {
                                type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                                label: "Stats",
                                maxLimit: 4,
                                nestedConfig: {
                                    type: template_field_type.FIELD_TYPES.NESTED,
                                    fields: _object_spread_props(_object_spread({}, restOfParagraphConfig), {
                                        lineColor: {
                                            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                                            label: "Line color"
                                        }
                                    })
                                }
                            }
                        }
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./components/core/asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(25289);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
// EXTERNAL MODULE: ./segments/core-configs/advanced-theme-config.js
var advanced_theme_config = __webpack_require__(42711);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/carousel-tabs/carousel-tabs-advanced-config.js
function carousel_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function carousel_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carousel_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function carousel_tabs_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function carousel_tabs_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        carousel_tabs_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function carousel_tabs_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = carousel_tabs_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function carousel_tabs_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var topicBottomMargin = advanced_fields_config/* default.topicBottomMargin */.Z.topicBottomMargin, buttonTopMargin = advanced_fields_config/* default.buttonTopMargin */.Z.buttonTopMargin, withDynamicParagraphSubtitle = advanced_fields_config/* default.withDynamicParagraphSubtitle */.Z.withDynamicParagraphSubtitle, withDynamicParagraphTitle = advanced_fields_config/* default.withDynamicParagraphTitle */.Z.withDynamicParagraphTitle, restOfAdvancedParagraphConfig = carousel_tabs_advanced_config_object_without_properties(advanced_fields_config/* default */.Z, [
    "topicBottomMargin",
    "buttonTopMargin",
    "withDynamicParagraphSubtitle",
    "withDynamicParagraphTitle"
]);
/* harmony default export */ var carousel_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: carousel_tabs_advanced_config_object_spread_props(carousel_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_theme_config/* default */.Z), {
        advancedAssetProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Advanced asset config",
            fields: advanced_field_config/* default */.Z
        },
        progressbarColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Progressbar color"
        },
        tabLabelHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tab label height (default 32px)"
        },
        transitionTime: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Transition time (ms) between slides - also set auto play"
        },
        tabContentGap: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Margin between testimonial and stats (default 40px)"
        },
        autoPlayWhenVisible: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Auto play when visible (make sure visibility sensor config is on)"
        },
        tabAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Tab advanced config",
            fields: {
                testimonialMaxWidth: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Testimonial max width"
                },
                advancedStatsConfig: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    fields: carousel_tabs_advanced_config_object_spread_props(carousel_tabs_advanced_config_object_spread({}, restOfAdvancedParagraphConfig), {
                        lineMargin: {
                            type: template_field_type.FIELD_TYPES.TEXT,
                            label: "Margin between line and stats"
                        }
                    }),
                    label: "Advanced stats config"
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/carousel-tabs/index.js

var CarouselTabsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 642).then(__webpack_require__.bind(__webpack_require__, 10642));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10642)
            ];
        }
    }
});


/* harmony default export */ var carousel_tabs = ({
    CarouselTabsComponent: CarouselTabsComponent,
    CarouselTabsConfig: carousel_tabs_config,
    CarouselTabsAdvancedConfig: carousel_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/scrollable-tabs/fields-config.js


/* harmony default export */ var scrollable_tabs_fields_config = ({
    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
    label: "Use cases",
    nestedConfig: {
        type: template_field_type.FIELD_TYPES.NESTED,
        fields: {
            label: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Case label"
            },
            iconAsset: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                label: "Case icon",
                defaultImagesKeys: []
            },
            asset: {
                type: template_field_type.FIELD_TYPES.NESTED,
                label: "Case asset",
                fields: fields_config/* default */.Z
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/usecases-gallery-tabs/usecases-gallery-tabs-config.js
function usecases_gallery_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function usecases_gallery_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            usecases_gallery_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function usecases_gallery_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function usecases_gallery_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        usecases_gallery_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var usecases_gallery_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Usecases Gallery",
    fields: usecases_gallery_tabs_config_object_spread_props(usecases_gallery_tabs_config_object_spread({}, theme_config/* default */.Z), {
        withDividerLine: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "With divider line"
        },
        selectedIconBackground: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Selected icon background"
        },
        defaultSelectedTabLabel: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Default selected tab label"
        },
        usecases: scrollable_tabs_fields_config
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/usecases-gallery-tabs/usecases-gallery-tabs-advanced-config.js
function usecases_gallery_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function usecases_gallery_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            usecases_gallery_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var usecases_gallery_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: usecases_gallery_tabs_advanced_config_object_spread({
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        },
        maxWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Max width (px)"
        },
        tabWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tab width (px)"
        },
        contentMarginTop: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Content margin top (px)"
        },
        tabContentMaxWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tab content max width"
        },
        iconSize: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Icon size (px)"
        }
    }, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/usecases-gallery-tabs/index.js

var UsecasesGalleryTabsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7908).then(__webpack_require__.bind(__webpack_require__, 97908));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97908)
            ];
        }
    }
});


/* harmony default export */ var usecases_gallery_tabs = ({
    UsecasesGalleryTabsComponent: UsecasesGalleryTabsComponent,
    UsecasesGalleryTabsConfig: usecases_gallery_tabs_config,
    UsecasesGalleryTabsAdvancedConfig: usecases_gallery_tabs_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/fields-config.js
var paragraph_fields_config = __webpack_require__(49496);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/products-tabs/fields-config.js
function fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function fields_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function fields_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        fields_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function fields_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = fields_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function fields_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var titleColor = title_fields_config/* default.titleColor */.Z.titleColor, restOfTitleConfig = fields_config_object_without_properties(title_fields_config/* default */.Z, [
    "titleColor"
]);
var bodyColor = paragraph_fields_config/* default.bodyColor */.Z.bodyColor, fields_config_restOfParagraphConfig = fields_config_object_without_properties(paragraph_fields_config/* default */.Z, [
    "bodyColor"
]);
/* harmony default export */ var products_tabs_fields_config = ({
    tabsTitle: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Title",
        fields: title_fields_config/* default */.Z
    },
    tabs: {
        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Tabs",
        nestedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: {
                productType: {
                    type: template_field_type.FIELD_TYPES.PRODUCTS,
                    label: "Product type"
                },
                title: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Tab title",
                    fields: fields_config_object_spread_props(fields_config_object_spread({
                        productImage: {
                            type: template_field_type.FIELD_TYPES.GALLERY,
                            label: "Product logo image"
                        }
                    }, restOfTitleConfig, fields_config_restOfParagraphConfig), {
                        useCases: {
                            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                            label: "Use cases",
                            nestedConfig: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                fields: {
                                    useCase: {
                                        type: template_field_type.FIELD_TYPES.TEXT,
                                        label: "Use cases"
                                    }
                                }
                            }
                        },
                        useCasesColor: {
                            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                            label: "Use Cases Color"
                        },
                        useCasesTextColor: {
                            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                            label: "Use Cases Text Color",
                            possibleColors: [
                                color_consts.WHITE_COLOR_NAME,
                                color_consts.BRAND_BLACK_TEXT_COLOR
                            ]
                        }
                    })
                },
                content: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Product content",
                    fields: {
                        features: {
                            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                            label: "Features",
                            nestedConfig: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                fields: {
                                    feature: {
                                        type: template_field_type.FIELD_TYPES.TEXT,
                                        label: "Feature"
                                    }
                                }
                            }
                        },
                        ctaText: {
                            type: template_field_type.FIELD_TYPES.TEXT,
                            label: "CTA text"
                        },
                        featursBulltesColor: {
                            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                            label: "Features Bulltes Color"
                        }
                    }
                }
            }
        }
    },
    tabTitleConfig: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tabs titles",
        fields: {
            textWidth: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Text max width"
            },
            titleWidth: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Title max width"
            },
            spaceFromParagraph: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Margin between title and text"
            }
        }
    },
    isV2: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Is V2"
    },
    largerTags: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Larger Tags"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-product-switcher-with-product-tabs/side-by-side-product-switcher-with-product-tabs-config.js
function side_by_side_product_switcher_with_product_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_product_switcher_with_product_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_product_switcher_with_product_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_product_switcher_with_product_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_product_switcher_with_product_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_product_switcher_with_product_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_product_switcher_with_product_tabs_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_product_switcher_with_product_tabs_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_product_switcher_with_product_tabs_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var tabs = products_tabs_fields_config.tabs, ProductTabsRestOfProps = side_by_side_product_switcher_with_product_tabs_config_object_without_properties(products_tabs_fields_config, [
    "tabs"
]);
var side_by_side_product_switcher_with_product_tabs_config_bodyColor = full_paragraph_fields_config/* default.bodyColor */.Z.bodyColor, side_by_side_product_switcher_with_product_tabs_config_titleColor = full_paragraph_fields_config/* default.titleColor */.Z.titleColor, textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, side_by_side_product_switcher_with_product_tabs_config_topic = full_paragraph_fields_config/* default.topic */.Z.topic, side_by_side_product_switcher_with_product_tabs_config_mobileTextAlign = full_paragraph_fields_config/* default.mobileTextAlign */.Z.mobileTextAlign, side_by_side_product_switcher_with_product_tabs_config_textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, side_by_side_product_switcher_with_product_tabs_config_buttonConfig = full_paragraph_fields_config/* default.buttonConfig */.Z.buttonConfig, side_by_side_product_switcher_with_product_tabs_config_restOfParagraphConfig = side_by_side_product_switcher_with_product_tabs_config_object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "bodyColor",
    "titleColor",
    "textColor",
    "topic",
    "mobileTextAlign",
    "textAlign",
    "buttonConfig"
]);
/* harmony default export */ var side_by_side_product_switcher_with_product_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side Product Switcher With Product",
    fields: side_by_side_product_switcher_with_product_tabs_config_object_spread_props(side_by_side_product_switcher_with_product_tabs_config_object_spread({}, theme_config/* default */.Z), {
        reverseOrder: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Reverse side by side order"
        },
        productTabs: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Product tabs",
            fields: side_by_side_product_switcher_with_product_tabs_config_object_spread_props(side_by_side_product_switcher_with_product_tabs_config_object_spread({}, ProductTabsRestOfProps), {
                tabs: {
                    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Tabs",
                    nestedConfig: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: side_by_side_product_switcher_with_product_tabs_config_object_spread_props(side_by_side_product_switcher_with_product_tabs_config_object_spread({
                            productType: {
                                type: template_field_type.FIELD_TYPES.PRODUCTS,
                                label: "Product type"
                            }
                        }, tabs.nestedConfig.fields), {
                            fullParagraph: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Full paragraph",
                                fields: side_by_side_product_switcher_with_product_tabs_config_object_spread_props(side_by_side_product_switcher_with_product_tabs_config_object_spread({
                                    marginTop: {
                                        type: template_field_type.FIELD_TYPES.TEXT,
                                        label: "Margin top"
                                    }
                                }, side_by_side_product_switcher_with_product_tabs_config_restOfParagraphConfig), {
                                    buttonConfig: {
                                        type: template_field_type.FIELD_TYPES.NESTED,
                                        label: "Button",
                                        fields: {
                                            additionalText: {
                                                type: template_field_type.FIELD_TYPES.TEXT,
                                                label: "Additional text (monday markup supported)"
                                            }
                                        }
                                    }
                                })
                            }
                        })
                    }
                }
            })
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-product-switcher-with-product-tabs/side-by-side-product-switcher-with-product-tabs-advanced-config.js
function side_by_side_product_switcher_with_product_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_product_switcher_with_product_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_product_switcher_with_product_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var side_by_side_product_switcher_with_product_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_product_switcher_with_product_tabs_advanced_config_object_spread({
        minHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Min height"
        },
        paragraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph Advanced Config",
            fields: advanced_fields_config/* default */.Z
        }
    }, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-product-switcher-with-product-tabs/index.js

var SideBySideProductSwitcherWithProductTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4069), __webpack_require__.e(4864), __webpack_require__.e(1285), __webpack_require__.e(7458)]).then(__webpack_require__.bind(__webpack_require__, 27458));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27458)
            ];
        }
    }
});


/* harmony default export */ var side_by_side_product_switcher_with_product_tabs = ({
    SideBySideProductSwitcherWithProductTabsComponent: SideBySideProductSwitcherWithProductTabsComponent,
    SideBySideProductSwitcherWithProductTabsConfig: side_by_side_product_switcher_with_product_tabs_config,
    SideBySideProductSwitcherWithProductTabsAdvancedConfig: side_by_side_product_switcher_with_product_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/products-horizontal-timer-tabs/products-horizontal-timer-tabs-config.js
function products_horizontal_timer_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function products_horizontal_timer_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            products_horizontal_timer_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function products_horizontal_timer_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function products_horizontal_timer_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        products_horizontal_timer_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var products_horizontal_timer_tabs_config_restOfTitleConfig = _extends({}, _object_destructuring_empty(title_fields_config/* default */.Z));
var products_horizontal_timer_tabs_config_restOfParagraphConfig = _extends({}, _object_destructuring_empty(paragraph_fields_config/* default */.Z));
/* harmony default export */ var products_horizontal_timer_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Products Horizontal Timer",
    fields: products_horizontal_timer_tabs_config_object_spread_props(products_horizontal_timer_tabs_config_object_spread({}, theme_config/* default */.Z), {
        tabsTitle: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Tabs Title",
            fields: {
                titleText: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Title"
                },
                titleMarginBottom: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Title margin bottom"
                }
            }
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    productType: {
                        type: template_field_type.FIELD_TYPES.PRODUCTS,
                        label: "Product type"
                    },
                    title: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab title",
                        fields: products_horizontal_timer_tabs_config_object_spread({
                            productImage: {
                                type: template_field_type.FIELD_TYPES.GALLERY,
                                label: "Product logo image"
                            },
                            selectedProductImage: {
                                type: template_field_type.FIELD_TYPES.GALLERY,
                                label: "Selected product logo image"
                            }
                        }, products_horizontal_timer_tabs_config_restOfTitleConfig, products_horizontal_timer_tabs_config_restOfParagraphConfig)
                    },
                    tabContent: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab content",
                        fields: {
                            productTags: {
                                type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                                label: "Product tags",
                                nestedConfig: {
                                    type: template_field_type.FIELD_TYPES.NESTED,
                                    fields: {
                                        text: {
                                            type: template_field_type.FIELD_TYPES.TEXT,
                                            label: "Tag"
                                        }
                                    }
                                }
                            },
                            asset: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Asset",
                                fields: fields_config/* default */.Z
                            }
                        }
                    }
                }
            }
        },
        progressbarColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Progress Bar Color"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/two-thirds-text-and-products-horizontal-tabs/two-thirds-text-and-products-horizontal-tabs-config.js
function two_thirds_text_and_products_horizontal_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function two_thirds_text_and_products_horizontal_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            two_thirds_text_and_products_horizontal_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function two_thirds_text_and_products_horizontal_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function two_thirds_text_and_products_horizontal_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        two_thirds_text_and_products_horizontal_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var two_thirds_text_and_products_horizontal_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Two Thirds Text And Products Horizontal",
    fields: two_thirds_text_and_products_horizontal_tabs_config_object_spread_props(two_thirds_text_and_products_horizontal_tabs_config_object_spread({}, theme_config/* default */.Z), {
        gap: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Gap"
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full paragraph",
            fields: two_thirds_text_and_products_horizontal_tabs_config_object_spread({
                marginTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Margin top"
                }
            }, full_paragraph_fields_config/* default */.Z)
        },
        productsTabs: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Products Tabs",
            fields: two_thirds_text_and_products_horizontal_tabs_config_object_spread({
                marginTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Margin top"
                }
            }, products_horizontal_timer_tabs_config.fields)
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/two-thirds-text-and-products-horizontal-tabs/two-thirds-text-and-products-horizontal-tabs-advanced-config.js
function two_thirds_text_and_products_horizontal_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function two_thirds_text_and_products_horizontal_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            two_thirds_text_and_products_horizontal_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function two_thirds_text_and_products_horizontal_tabs_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function two_thirds_text_and_products_horizontal_tabs_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        two_thirds_text_and_products_horizontal_tabs_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var two_thirds_text_and_products_horizontal_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: two_thirds_text_and_products_horizontal_tabs_advanced_config_object_spread_props(two_thirds_text_and_products_horizontal_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        paragraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph Advanced Config",
            fields: advanced_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/two-thirds-text-and-products-horizontal-tabs/index.js

var TwoThirdsTextAndProductsHorizontalTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4069), __webpack_require__.e(4864), __webpack_require__.e(2948), __webpack_require__.e(5424)]).then(__webpack_require__.bind(__webpack_require__, 45424));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45424)
            ];
        }
    }
});


/* harmony default export */ var two_thirds_text_and_products_horizontal_tabs = ({
    TwoThirdsTextAndProductsHorizontalTabsComponent: TwoThirdsTextAndProductsHorizontalTabsComponent,
    TwoThirdsTextAndProductsHorizontalTabsConfig: two_thirds_text_and_products_horizontal_tabs_config,
    TwoThirdsTextAndProductsHorizontalTabsAdvancedConfig: two_thirds_text_and_products_horizontal_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/products-horizontal-timer-tabs/products-horizontal-timer-tabs-advanced-config.js
function products_horizontal_timer_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function products_horizontal_timer_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            products_horizontal_timer_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var products_horizontal_timer_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: products_horizontal_timer_tabs_advanced_config_object_spread({
        timerEnabled: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Timer Enabled"
        }
    }, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/products-horizontal-timer-tabs/index.js

var ProductsHorizontalTimerTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4069), __webpack_require__.e(4864), __webpack_require__.e(2948)]).then(__webpack_require__.bind(__webpack_require__, 32948));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32948)
            ];
        }
    }
});


/* harmony default export */ var products_horizontal_timer_tabs = ({
    ProductsHorizontalTimerTabsComponent: ProductsHorizontalTimerTabsComponent,
    ProductsHorizontalTimerTabsConfig: products_horizontal_timer_tabs_config,
    ProductsHorizontalTimerTabsAdvancedConfig: products_horizontal_timer_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-paragraph-and-products-tabs/side-by-side-paragraph-and-products-tabs-config.js
function side_by_side_paragraph_and_products_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_paragraph_and_products_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_paragraph_and_products_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_paragraph_and_products_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_paragraph_and_products_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_paragraph_and_products_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var side_by_side_paragraph_and_products_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side Paragraph And Products",
    fields: side_by_side_paragraph_and_products_tabs_config_object_spread_props(side_by_side_paragraph_and_products_tabs_config_object_spread({}, theme_config/* default */.Z), {
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full paragraph",
            fields: side_by_side_paragraph_and_products_tabs_config_object_spread({
                marginTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Margin top"
                }
            }, full_paragraph_fields_config/* default */.Z)
        },
        productTabs: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Product tabs",
            fields: products_tabs_fields_config
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-paragraph-and-products-tabs/side-by-side-paragraph-and-products-tabs-advanced-config.js
function side_by_side_paragraph_and_products_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_paragraph_and_products_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_paragraph_and_products_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var side_by_side_paragraph_and_products_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_paragraph_and_products_tabs_advanced_config_object_spread({
        minHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Min height"
        },
        paragraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph Advanced Config",
            fields: advanced_fields_config/* default */.Z
        }
    }, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-paragraph-and-products-tabs/index.js

var SideBySideParagraphAndProductsTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4069), __webpack_require__.e(4864), __webpack_require__.e(1285), __webpack_require__.e(2175)]).then(__webpack_require__.bind(__webpack_require__, 62175));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62175)
            ];
        }
    }
});


/* harmony default export */ var side_by_side_paragraph_and_products_tabs = ({
    SideBySideParagraphAndProductsTabsComponent: SideBySideParagraphAndProductsTabsComponent,
    SideBySideParagraphAndProductsTabsConfig: side_by_side_paragraph_and_products_tabs_config,
    SideBySideParagraphAndProductsTabsAdvancedConfig: side_by_side_paragraph_and_products_tabs_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/fields-config.js
var side_by_side_text_and_asset_fields_config = __webpack_require__(93097);
// EXTERNAL MODULE: ./segments/desktop/core-components/title-only-paragraph/fields-config.js
var title_only_paragraph_fields_config = __webpack_require__(17702);
;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-tabs/fields-config.js
function vertical_tabs_fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function vertical_tabs_fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            vertical_tabs_fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function vertical_tabs_fields_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function vertical_tabs_fields_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        vertical_tabs_fields_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function vertical_tabs_fields_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = vertical_tabs_fields_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function vertical_tabs_fields_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var background = side_by_side_text_and_asset_fields_config/* default.background */.Z.background, selectedSideBySideTextAndAssetFieldsConfig = vertical_tabs_fields_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "background"
]);
var fields_config_textColor = title_only_paragraph_fields_config/* default.textColor */.Z.textColor, fields_config_buttonConfig = title_only_paragraph_fields_config/* default.buttonConfig */.Z.buttonConfig, fields_config_textAlign = title_only_paragraph_fields_config/* default.textAlign */.Z.textAlign, selectedTitleOnlyParagraphFields = vertical_tabs_fields_config_object_without_properties(title_only_paragraph_fields_config/* default */.Z, [
    "textColor",
    "buttonConfig",
    "textAlign"
]);
/* harmony default export */ var vertical_tabs_fields_config = (vertical_tabs_fields_config_object_spread_props(vertical_tabs_fields_config_object_spread({}, theme_config/* default */.Z), {
    title: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Title",
        fields: selectedTitleOnlyParagraphFields
    },
    backgroundColor: {
        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
        label: "Background color"
    },
    tabsColor: {
        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
        label: "Tabs color"
    },
    paddingAboveTabs: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Padding between title and tabs"
    },
    tabs: {
        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Tabs",
        maxLimit: 8,
        nestedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: {
                tabLabel: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Tab Label",
                    translatable: true
                },
                textAndAsset: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Text and asset",
                    fields: selectedSideBySideTextAndAssetFieldsConfig
                }
            }
        }
    }
}));

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timeline-titled-tab-tabs/timeline-titled-tab-tabs-config.js
function timeline_titled_tab_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function timeline_titled_tab_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            timeline_titled_tab_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function timeline_titled_tab_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function timeline_titled_tab_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        timeline_titled_tab_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function timeline_titled_tab_tabs_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = timeline_titled_tab_tabs_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function timeline_titled_tab_tabs_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var backgroundColor = vertical_tabs_fields_config.backgroundColor, timeline_titled_tab_tabs_config_theme = vertical_tabs_fields_config.theme, tabsColor = vertical_tabs_fields_config.tabsColor, timeline_titled_tab_tabs_config_tabs = vertical_tabs_fields_config.tabs, title = vertical_tabs_fields_config.title, restOfConfig = timeline_titled_tab_tabs_config_object_without_properties(vertical_tabs_fields_config, [
    "backgroundColor",
    "theme",
    "tabsColor",
    "tabs",
    "title"
]);
var timeline_titled_tab_tabs_config_topic = full_paragraph_fields_config/* default.topic */.Z.topic, timeline_titled_tab_tabs_config_buttonConfig = full_paragraph_fields_config/* default.buttonConfig */.Z.buttonConfig, timeline_titled_tab_tabs_config_textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, body = full_paragraph_fields_config/* default.body */.Z.body, timeline_titled_tab_tabs_config_textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, timeline_titled_tab_tabs_config_titleColor = full_paragraph_fields_config/* default.titleColor */.Z.titleColor, color = full_paragraph_fields_config/* default.color */.Z.color, restOfParagraphFields = timeline_titled_tab_tabs_config_object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "topic",
    "buttonConfig",
    "textAlign",
    "body",
    "textColor",
    "titleColor",
    "color"
]);
/* harmony default export */ var timeline_titled_tab_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Timeline",
    fields: timeline_titled_tab_tabs_config_object_spread_props(timeline_titled_tab_tabs_config_object_spread({
        theme: timeline_titled_tab_tabs_config_theme,
        tabsColor: tabsColor,
        titlesColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Titles Color"
        },
        lineColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Menu line Color"
        }
    }, restOfConfig), {
        contentHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Content height (optional)"
        },
        contentGap: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Content gap"
        },
        titles: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs Title",
            maxLimit: 4,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tabsTitle: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tabs title"
                    },
                    tabs: {
                        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                        label: "Tabs",
                        maxLimit: 8,
                        nestedConfig: {
                            type: template_field_type.FIELD_TYPES.NESTED,
                            fields: {
                                tabLabel: {
                                    type: template_field_type.FIELD_TYPES.TEXT,
                                    label: "Tab Label",
                                    translatable: true
                                },
                                title: {
                                    type: template_field_type.FIELD_TYPES.NESTED,
                                    label: "Asset text",
                                    fields: restOfParagraphFields
                                },
                                asset: {
                                    type: template_field_type.FIELD_TYPES.NESTED,
                                    label: "Asset",
                                    fields: timeline_titled_tab_tabs_config_object_spread({
                                        assetVerticalPadding: {
                                            type: template_field_type.FIELD_TYPES.TEXT,
                                            label: "Asset Vertical padding",
                                            translatable: true
                                        }
                                    }, fields_config/* default */.Z)
                                }
                            }
                        }
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var title_advanced_field_config = __webpack_require__(95760);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timeline-titled-tab-tabs/timeline-titled-tab-tabs-advanced-config.js
function timeline_titled_tab_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function timeline_titled_tab_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            timeline_titled_tab_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function timeline_titled_tab_tabs_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function timeline_titled_tab_tabs_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        timeline_titled_tab_tabs_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var timeline_titled_tab_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: timeline_titled_tab_tabs_advanced_config_object_spread_props(timeline_titled_tab_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        advancedAssetTitleConfig: {
            label: "Asset title",
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: title_advanced_field_config/* default */.Z
        },
        tabAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Tab Advanced Config",
            fields: {
                tabMaxWidth: {
                    label: "Tab title max width",
                    type: template_field_type.FIELD_TYPES.TEXT
                },
                tabLineHeight: {
                    label: "Tab title line height",
                    type: template_field_type.FIELD_TYPES.TEXT
                },
                tabHeight: {
                    label: "Tab height",
                    type: template_field_type.FIELD_TYPES.TEXT
                }
            }
        },
        advancedAssetConfig: {
            label: "Asset",
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: advanced_field_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timeline-titled-tab-tabs/index.js



var TimelineTitledTabTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4837), __webpack_require__.e(9194)]).then(__webpack_require__.bind(__webpack_require__, 19194));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19194)
            ];
        }
    }
});
/* harmony default export */ var timeline_titled_tab_tabs = ({
    TimelineTitledTabTabsComponent: TimelineTitledTabTabsComponent,
    TimelineTitledTabTabsConfig: timeline_titled_tab_tabs_config,
    TimelineTitledTabTabsAdvancedConfig: timeline_titled_tab_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/process-tabs/fields-config.js



/* harmony default export */ var process_tabs_fields_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    fields: {
        tabsColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Tabs color"
        },
        showProcessIndicator: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Show Process Indicator"
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 8,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tabLabel: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Label",
                        translatable: true
                    },
                    tabId: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Id"
                    },
                    asset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Asset",
                        fields: fields_config/* default */.Z
                    },
                    title: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Asset Title",
                        fields: title_fields_config/* default */.Z
                    }
                }
            }
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/core-components/button/fields-config.js + 5 modules
var button_fields_config = __webpack_require__(75629);
// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid-service.js
var images_grid_service = __webpack_require__(72898);
;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-timer-tabs/fields-config.js




/* harmony default export */ var vertical_timer_tabs_fields_config = ({
    tabs: {
        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Tabs",
        maxLimit: 8,
        nestedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: {
                title: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Tab Title",
                    translatable: true
                },
                content: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Tab Content",
                    textArea: true,
                    rows: 5,
                    translatable: true
                },
                timer: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Tab Timer Length (in milliseconds)"
                },
                badgeText: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Badge text (if needed)",
                    translatable: true
                },
                asset: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Asset",
                    fields: fields_config/* default */.Z
                }
            }
        }
    },
    backgroundColor: {
        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
        label: "Background Color"
    },
    progressbarColor: {
        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
        label: "Progress Bar Color"
    },
    assetPosition: {
        type: template_field_type.FIELD_TYPES.COMBO,
        label: "Asset Position",
        options: [
            {
                value: images_grid_service/* positionTypes.TOP_LEFT */.b.TOP_LEFT,
                text: "Top Left"
            },
            {
                value: images_grid_service/* positionTypes.TOP_CENTER */.b.TOP_CENTER,
                text: "Top Center"
            },
            {
                value: images_grid_service/* positionTypes.TOP_RIGHT */.b.TOP_RIGHT,
                text: "Top Right"
            },
            {
                value: images_grid_service/* positionTypes.CENTER_LEFT */.b.CENTER_LEFT,
                text: "Center Left"
            },
            {
                value: images_grid_service/* positionTypes.CENTER_CENTER */.b.CENTER_CENTER,
                text: "Center Center"
            },
            {
                value: images_grid_service/* positionTypes.CENTER_RIGHT */.b.CENTER_RIGHT,
                text: "Center Right"
            },
            {
                value: images_grid_service/* positionTypes.BOTTOM_LEFT */.b.BOTTOM_LEFT,
                text: "Bottom Left"
            },
            {
                value: images_grid_service/* positionTypes.BOTTOM_CENTER */.b.BOTTOM_CENTER,
                text: "Bottom Center"
            },
            {
                value: images_grid_service/* positionTypes.BOTTOM_RIGHT */.b.BOTTOM_RIGHT,
                text: "Bottom Right"
            }
        ]
    },
    showButton: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Show Button"
    },
    isTabsFullWidth: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Tabs full width"
    },
    buttonConfig: button_fields_config/* default */.Z
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/side-by-side-tabs-and-process-tabs-config.js
function side_by_side_tabs_and_process_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_tabs_and_process_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_tabs_and_process_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_tabs_and_process_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_tabs_and_process_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_tabs_and_process_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_tabs_and_process_tabs_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_tabs_and_process_tabs_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_tabs_and_process_tabs_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var side_by_side_tabs_and_process_tabs_config_buttonConfig = vertical_timer_tabs_fields_config.buttonConfig, showButton = vertical_timer_tabs_fields_config.showButton, progressbarColor = vertical_timer_tabs_fields_config.progressbarColor, side_by_side_tabs_and_process_tabs_config_backgroundColor = vertical_timer_tabs_fields_config.backgroundColor, _tabs = vertical_timer_tabs_fields_config.tabs, _nestedConfig = _tabs.nestedConfig, timer = _nestedConfig.fields.timer, nestedTabsConfig = side_by_side_tabs_and_process_tabs_config_object_without_properties(vertical_timer_tabs_fields_config.tabs.nestedConfig.fields, [
    "timer"
]), tabsConfig = side_by_side_tabs_and_process_tabs_config_object_without_properties(vertical_timer_tabs_fields_config.tabs, [
    "nestedConfig"
]), rest = side_by_side_tabs_and_process_tabs_config_object_without_properties(vertical_timer_tabs_fields_config, [
    "buttonConfig",
    "showButton",
    "progressbarColor",
    "backgroundColor",
    "tabs"
]);
var side_by_side_tabs_and_process_tabs_config_textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, side_by_side_tabs_and_process_tabs_config_mobileTextAlign = full_paragraph_fields_config/* default.mobileTextAlign */.Z.mobileTextAlign, titleButtonConfig = full_paragraph_fields_config/* default.buttonConfig */.Z.buttonConfig, side_by_side_tabs_and_process_tabs_config_title = full_paragraph_fields_config/* default.title */.Z.title, side_by_side_tabs_and_process_tabs_config_titleColor = full_paragraph_fields_config/* default.titleColor */.Z.titleColor, side_by_side_tabs_and_process_tabs_config_textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, side_by_side_tabs_and_process_tabs_config_bodyColor = full_paragraph_fields_config/* default.bodyColor */.Z.bodyColor, side_by_side_tabs_and_process_tabs_config_topic = full_paragraph_fields_config/* default.topic */.Z.topic, resOfParagraphConfig = side_by_side_tabs_and_process_tabs_config_object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "textAlign",
    "mobileTextAlign",
    "buttonConfig",
    "title",
    "titleColor",
    "textColor",
    "bodyColor",
    "topic"
]);
/* harmony default export */ var side_by_side_tabs_and_process_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side Tabs And Process",
    fields: side_by_side_tabs_and_process_tabs_config_object_spread(side_by_side_tabs_and_process_tabs_config_object_spread_props(side_by_side_tabs_and_process_tabs_config_object_spread({}, theme_config/* default */.Z), {
        title: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Title",
            fields: side_by_side_tabs_and_process_tabs_config_object_spread_props(side_by_side_tabs_and_process_tabs_config_object_spread({}, title_fields_config/* default */.Z), {
                titleMargin: {
                    label: "Title bottom margin",
                    type: template_field_type.FIELD_TYPES.TEXT
                }
            })
        },
        selectedTabBackgroundColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Selected tab background color (for mobile)"
        },
        tabs: side_by_side_tabs_and_process_tabs_config_object_spread({
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            nestedConfig: side_by_side_tabs_and_process_tabs_config_object_spread({
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    title: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Title",
                        translatable: true
                    },
                    overrideTabFontColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Title Font Color"
                    },
                    content: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab Full Paragraph",
                        fields: side_by_side_tabs_and_process_tabs_config_object_spread_props(side_by_side_tabs_and_process_tabs_config_object_spread({}, resOfParagraphConfig), {
                            buttonConfig: titleButtonConfig
                        })
                    },
                    processTab: process_tabs_fields_config
                }
            }, nestedTabsConfig)
        }, tabsConfig)
    }), rest)
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-timer-tabs/fields-advanced-config.js
function fields_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fields_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fields_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function fields_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function fields_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        fields_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var fields_advanced_config = (fields_advanced_config_object_spread(fields_advanced_config_object_spread_props(fields_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
    timerEnabled: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Timer enabled"
    },
    alwaysShowProgressbar: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Always show progress bar"
    },
    arrowSize: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Arrow size"
    },
    title: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Title",
        fields: {
            fontSize: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Font size"
            },
            lineHeight: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Line height"
            },
            selectedFontSize: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Selected font size"
            },
            fontColor: {
                type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                label: "Font color"
            },
            selectedFontColor: {
                type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                label: "Selected font color"
            }
        }
    }
}), advanced_field_config/* default */.Z));

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/side-by-side-tabs-and-process-tabs-advanced-config.js
function side_by_side_tabs_and_process_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_tabs_and_process_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_tabs_and_process_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_tabs_and_process_tabs_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_tabs_and_process_tabs_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_tabs_and_process_tabs_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






/* harmony default export */ var side_by_side_tabs_and_process_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_tabs_and_process_tabs_advanced_config_object_spread(side_by_side_tabs_and_process_tabs_advanced_config_object_spread_props(side_by_side_tabs_and_process_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        title: {
            label: "Title",
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: title_advanced_field_config/* default */.Z
        },
        advancedTitleConfig: side_by_side_tabs_and_process_tabs_advanced_config_object_spread_props(side_by_side_tabs_and_process_tabs_advanced_config_object_spread({}, fields_advanced_config.title), {
            label: "Tab Title"
        }),
        tabContent: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Tab Content",
            fields: advanced_fields_config/* default */.Z
        },
        advancedProcessTabs: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Process tabs",
            fields: {
                titleConfig: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Asset Title",
                    fields: title_advanced_field_config/* default */.Z
                },
                autoTransition: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Auto Transition (milliseconds)"
                },
                scrollOnTabClick: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Should scroll to content on tab click"
                },
                scrollSpeed: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Scroll speed on tab click"
                },
                distanceFromTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Distance to stop when scrolling (fixed header height)"
                }
            }
        },
        arrowSize: fields_advanced_config.arrowSize
    }), advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/index.js



var SideBySideTabsAndProcessTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4069), __webpack_require__.e(4864), __webpack_require__.e(9306), __webpack_require__.e(3012), __webpack_require__.e(616)]).then(__webpack_require__.bind(__webpack_require__, 60616));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60616)
            ];
        }
    }
});
/* harmony default export */ var side_by_side_tabs_and_process_tabs = ({
    SideBySideTabsAndProcessTabsComponent: SideBySideTabsAndProcessTabsComponent,
    SideBySideTabsAndProcessTabsConfig: side_by_side_tabs_and_process_tabs_config,
    SideBySideTabsAndProcessTabsAdvancedConfig: side_by_side_tabs_and_process_tabs_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-config.js
var full_with_bullets_paragraph_config = __webpack_require__(87313);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-testimonial-tabs/side-by-side-tabs-and-testimonial-tabs-config.js
function side_by_side_tabs_and_testimonial_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_tabs_and_testimonial_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_tabs_and_testimonial_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_tabs_and_testimonial_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_tabs_and_testimonial_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_tabs_and_testimonial_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_tabs_and_testimonial_tabs_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_tabs_and_testimonial_tabs_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_tabs_and_testimonial_tabs_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var timerEnabled = vertical_timer_tabs_fields_config.timerEnabled, side_by_side_tabs_and_testimonial_tabs_config_buttonConfig = vertical_timer_tabs_fields_config.buttonConfig, side_by_side_tabs_and_testimonial_tabs_config_showButton = vertical_timer_tabs_fields_config.showButton, side_by_side_tabs_and_testimonial_tabs_config_progressbarColor = vertical_timer_tabs_fields_config.progressbarColor, side_by_side_tabs_and_testimonial_tabs_config_backgroundColor = vertical_timer_tabs_fields_config.backgroundColor, side_by_side_tabs_and_testimonial_tabs_config_tabs = vertical_timer_tabs_fields_config.tabs, side_by_side_tabs_and_testimonial_tabs_config_nestedConfig = side_by_side_tabs_and_testimonial_tabs_config_tabs.nestedConfig, side_by_side_tabs_and_testimonial_tabs_config_timer = side_by_side_tabs_and_testimonial_tabs_config_nestedConfig.fields.timer, side_by_side_tabs_and_testimonial_tabs_config_nestedTabsConfig = side_by_side_tabs_and_testimonial_tabs_config_object_without_properties(vertical_timer_tabs_fields_config.tabs.nestedConfig.fields, [
    "timer"
]), side_by_side_tabs_and_testimonial_tabs_config_tabsConfig = side_by_side_tabs_and_testimonial_tabs_config_object_without_properties(vertical_timer_tabs_fields_config.tabs, [
    "nestedConfig"
]), side_by_side_tabs_and_testimonial_tabs_config_rest = side_by_side_tabs_and_testimonial_tabs_config_object_without_properties(vertical_timer_tabs_fields_config, [
    "timerEnabled",
    "buttonConfig",
    "showButton",
    "progressbarColor",
    "backgroundColor",
    "tabs"
]);
var _FullWithBulletsParagraphConfig_fields = full_with_bullets_paragraph_config/* default.fields */.Z.fields, side_by_side_tabs_and_testimonial_tabs_config_textAlign = _FullWithBulletsParagraphConfig_fields.textAlign, side_by_side_tabs_and_testimonial_tabs_config_mobileTextAlign = _FullWithBulletsParagraphConfig_fields.mobileTextAlign, side_by_side_tabs_and_testimonial_tabs_config_title = _FullWithBulletsParagraphConfig_fields.title, side_by_side_tabs_and_testimonial_tabs_config_titleColor = _FullWithBulletsParagraphConfig_fields.titleColor, side_by_side_tabs_and_testimonial_tabs_config_textColor = _FullWithBulletsParagraphConfig_fields.textColor, side_by_side_tabs_and_testimonial_tabs_config_bodyColor = _FullWithBulletsParagraphConfig_fields.bodyColor, side_by_side_tabs_and_testimonial_tabs_config_topic = _FullWithBulletsParagraphConfig_fields.topic, side_by_side_tabs_and_testimonial_tabs_config_restOfParagraphConfig = side_by_side_tabs_and_testimonial_tabs_config_object_without_properties(_FullWithBulletsParagraphConfig_fields, [
    "textAlign",
    "mobileTextAlign",
    "title",
    "titleColor",
    "textColor",
    "bodyColor",
    "topic"
]);
/* harmony default export */ var side_by_side_tabs_and_testimonial_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    fields: side_by_side_tabs_and_testimonial_tabs_config_object_spread(side_by_side_tabs_and_testimonial_tabs_config_object_spread_props(side_by_side_tabs_and_testimonial_tabs_config_object_spread({}, theme_config/* default */.Z), {
        tabsTitle: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Title",
            fields: title_fields_config/* default */.Z
        },
        tabs: side_by_side_tabs_and_testimonial_tabs_config_object_spread({
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            nestedConfig: side_by_side_tabs_and_testimonial_tabs_config_object_spread({
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    title: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Title",
                        translatable: true
                    },
                    overrideTabFontColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Title Font Color"
                    },
                    content: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab Content",
                        fields: side_by_side_tabs_and_testimonial_tabs_config_object_spread({}, side_by_side_tabs_and_testimonial_tabs_config_restOfParagraphConfig)
                    },
                    testimonial: testimonial_fields_config,
                    asset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Asset",
                        fields: fields_config/* default */.Z
                    }
                }
            }, side_by_side_tabs_and_testimonial_tabs_config_nestedTabsConfig)
        }, side_by_side_tabs_and_testimonial_tabs_config_tabsConfig)
    }), side_by_side_tabs_and_testimonial_tabs_config_rest)
});

// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-advanced-config.js
var full_with_bullets_paragraph_advanced_config = __webpack_require__(29737);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-testimonial-tabs/side-by-side-tabs-and-testimonial-tabs-advanced-config.js
function side_by_side_tabs_and_testimonial_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_tabs_and_testimonial_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_tabs_and_testimonial_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_tabs_and_testimonial_tabs_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_tabs_and_testimonial_tabs_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_tabs_and_testimonial_tabs_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






/* harmony default export */ var side_by_side_tabs_and_testimonial_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_tabs_and_testimonial_tabs_advanced_config_object_spread(side_by_side_tabs_and_testimonial_tabs_advanced_config_object_spread_props(side_by_side_tabs_and_testimonial_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        tabsTitle: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Title",
            fields: title_advanced_field_config/* default */.Z
        },
        advancedTitleConfig: side_by_side_tabs_and_testimonial_tabs_advanced_config_object_spread_props(side_by_side_tabs_and_testimonial_tabs_advanced_config_object_spread({}, fields_advanced_config.title), {
            label: "Tab Title"
        }),
        prerenderTabs: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Prerender tabs"
        },
        tabContent: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Tab Content",
            fields: full_with_bullets_paragraph_advanced_config/* default.fields */.Z.fields
        },
        arrowSize: fields_advanced_config.arrowSize
    }), advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-testimonial-tabs/index.js



var SideBySideTabsAndTestimonialTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4069), __webpack_require__.e(4864), __webpack_require__.e(4067)]).then(__webpack_require__.bind(__webpack_require__, 44067));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44067)
            ];
        }
    }
});
/* harmony default export */ var side_by_side_tabs_and_testimonial_tabs = ({
    SideBySideTabsAndTestimonialTabsComponent: SideBySideTabsAndTestimonialTabsComponent,
    SideBySideTabsAndTestimonialTabsConfig: side_by_side_tabs_and_testimonial_tabs_config,
    SideBySideTabsAndTestimonialTabsAdvancedConfig: side_by_side_tabs_and_testimonial_tabs_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-config.js
var two_thirds_text_and_asset_config = __webpack_require__(49133);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/tag-items-grid/tag-items-grid-config.js + 1 modules
var tag_items_grid_config = __webpack_require__(48127);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-grid-config.js
var flexible_cards_grid_config = __webpack_require__(73767);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/personas-tabs/personas-tabs-config.js
function personas_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function personas_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            personas_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function personas_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function personas_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        personas_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






/* harmony default export */ var personas_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Personas",
    fields: personas_tabs_config_object_spread_props(personas_tabs_config_object_spread({}, theme_config/* default */.Z), {
        tabsColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Tabs color"
        },
        tabsBackgroundColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Tabs background color"
        },
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        },
        swapTagsWithTextAndAssets: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Swap Tags with Text and Asset  (Temporary for test)"
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 6,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tabLabel: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Label",
                        translatable: true
                    },
                    tabId: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Id"
                    },
                    timer: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Timer Length (in milliseconds)"
                    },
                    textAndAssetTwoThirds: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Text and asset",
                        fields: personas_tabs_config_object_spread({
                            textAndAssetPaddingTop: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Padding top"
                            }
                        }, two_thirds_text_and_asset_config/* default.fields */.Z.fields)
                    },
                    fullParagraph: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Full Paragraph",
                        fields: personas_tabs_config_object_spread({
                            fullParagraphPaddingTop: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Padding top"
                            }
                        }, full_paragraph_config/* default.fields */.Z.fields)
                    },
                    tagItems: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tag Items",
                        fields: personas_tabs_config_object_spread({
                            tagItemsPaddingTop: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Padding top"
                            }
                        }, tag_items_grid_config/* default.fields */.Z.fields)
                    },
                    flexibleCards: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Flexible Cards",
                        fields: personas_tabs_config_object_spread({
                            flexibleCardsPaddingTop: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Padding top"
                            },
                            imagePaddingBottom: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Padding Bottom (under the image)"
                            }
                        }, flexible_cards_grid_config/* default.fields */.Z.fields)
                    }
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/regular-tabs/regular-tabs-advanced-config.js
function regular_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function regular_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            regular_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function regular_tabs_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function regular_tabs_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        regular_tabs_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var regular_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: regular_tabs_advanced_config_object_spread_props(regular_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        autoTransition: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Auto Transition (milliseconds)"
        },
        scrollOnTabClick: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Should scroll to content on tab click"
        },
        scrollSpeed: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Scroll speed on tab click"
        },
        distanceFromTop: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Distance to stop when scrolling (fixed header height)"
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/tag-items-grid/tag-items-grid-advanced-config.js
var tag_items_grid_advanced_config = __webpack_require__(14061);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/advanced-field-config.js
var side_by_side_text_and_asset_advanced_field_config = __webpack_require__(77374);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/personas-tabs/personas-tabs-advanced-config.js
function personas_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function personas_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            personas_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function personas_tabs_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function personas_tabs_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        personas_tabs_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var width = tag_items_grid_advanced_config/* default.fields.width */.Z.fields.width;
/* harmony default export */ var personas_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: personas_tabs_advanced_config_object_spread_props(personas_tabs_advanced_config_object_spread({}, regular_tabs_advanced_config.fields), {
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 5,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    textAndAssetTwoThirds: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Text and asset",
                        fields: personas_tabs_advanced_config_object_spread({}, advanced_fields_config/* default */.Z, advanced_field_config/* default */.Z, side_by_side_text_and_asset_advanced_field_config/* default */.Z)
                    },
                    fullParagraph: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Full Paragraph",
                        fields: personas_tabs_advanced_config_object_spread({}, advanced_fields_config/* default */.Z)
                    },
                    tagItems: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tag Items",
                        fields: {
                            width: width
                        }
                    },
                    flexibleCards: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Flexible Cards",
                        fields: personas_tabs_advanced_config_object_spread({}, advanced_fields_config/* default */.Z)
                    }
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/personas-tabs/index.js



var PersonasTabsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8663).then(__webpack_require__.bind(__webpack_require__, 88663));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88663)
            ];
        }
    }
});
/* harmony default export */ var personas_tabs = ({
    PersonasTabsComponent: PersonasTabsComponent,
    PersonasTabsConfig: personas_tabs_config,
    PersonasTabsAdvancedConfig: personas_tabs_advanced_config
});

// EXTERNAL MODULE: ./components/templates-generator/config/components/asset/asset-config.js
var asset_config = __webpack_require__(81338);
;// CONCATENATED MODULE: ./segments/desktop/core-components/board-views-tab/fields-config.js
function board_views_tab_fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function board_views_tab_fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            board_views_tab_fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function board_views_tab_fields_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function board_views_tab_fields_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        board_views_tab_fields_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var fields_config_image = asset_config/* asset.fields.image */.p.fields.image;
/* harmony default export */ var board_views_tab_fields_config = (board_views_tab_fields_config_object_spread_props(board_views_tab_fields_config_object_spread({}, theme_config/* default */.Z), {
    tabs: {
        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Tabs",
        maxLimit: 5,
        nestedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: {
                image: board_views_tab_fields_config_object_spread_props(board_views_tab_fields_config_object_spread({}, fields_config_image), {
                    label: "Icon Image"
                }),
                tabLabel: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Tab Label",
                    translatable: true
                },
                tabId: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Tab Id"
                },
                asset: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Asset",
                    fields: fields_config/* default */.Z
                }
            }
        }
    }
}));

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-board-views-component-tabs/side-by-side-board-views-component-tabs-config.js
function side_by_side_board_views_component_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_board_views_component_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_board_views_component_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var side_by_side_board_views_component_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side Board Views Component",
    fields: side_by_side_board_views_component_tabs_config_object_spread({
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: full_paragraph_fields_config/* default */.Z
        }
    }, board_views_tab_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-board-views-component-tabs/side-by-side-board-views-component-tabs-advanced-config.js
function side_by_side_board_views_component_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_board_views_component_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_board_views_component_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var side_by_side_board_views_component_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_board_views_component_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-board-views-component-tabs/index.js



var SideBySideBoardViewsComponentTabsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1652).then(__webpack_require__.bind(__webpack_require__, 11652));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11652)
            ];
        }
    }
});
/* harmony default export */ var side_by_side_board_views_component_tabs = ({
    SideBySideBoardViewsComponentTabsComponent: SideBySideBoardViewsComponentTabsComponent,
    SideBySideBoardViewsComponentTabsConfig: side_by_side_board_views_component_tabs_config,
    SideBySideBoardViewsComponentTabsAdvancedConfig: side_by_side_board_views_component_tabs_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/fields-config.js
var carousel_fields_config = __webpack_require__(33751);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/use-cases-tabs-config.js
function use_cases_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function use_cases_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            use_cases_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}







var autoplay = carousel_fields_config/* default.autoplay */.Z.autoplay, autoplaySpeed = carousel_fields_config/* default.autoplaySpeed */.Z.autoplaySpeed;
var use_cases_tabs_config_image = fields_config/* default.image */.Z.image; // videos will be supported in the future
/* harmony default export */ var use_cases_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Use Cases",
    fields: {
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme"
        },
        buttonsColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Buttons color",
            possibleColors: [
                color_consts.WHITE_COLOR_NAME,
                color_consts.CRM_DARK_TINT_01_COLOR_NAME,
                color_consts.CRM_DARKER_TINT_02_COLOR_NAME,
                color_consts.DEV_LIGHTER_TINT_01_COLOR_NAME
            ]
        },
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        scrollWhenButtonClicked: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Scroll when a tab button is clicked"
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 10,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tabLabel: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Label",
                        translatable: true
                    },
                    tabId: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Id"
                    },
                    tabContent: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab Content",
                        fields: {
                            asset: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Asset",
                                fields: {
                                    image: use_cases_tabs_config_image
                                }
                            },
                            mobileAsset: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Mobile asset",
                                fields: {
                                    image: use_cases_tabs_config_image
                                }
                            },
                            mobileTextAlign: {
                                type: template_field_type.FIELD_TYPES.COMBO,
                                label: "Paragraphs Mobile Text Align",
                                options: [
                                    {
                                        value: "left",
                                        text: "Left"
                                    },
                                    {
                                        value: "center",
                                        text: "Center"
                                    },
                                    {
                                        value: "right",
                                        text: "Right"
                                    }
                                ]
                            },
                            images: {
                                type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                                label: "Paragraphs",
                                maxLimit: 3,
                                nestedConfig: {
                                    type: template_field_type.FIELD_TYPES.NESTED,
                                    fields: {
                                        fullParagraph: {
                                            type: template_field_type.FIELD_TYPES.NESTED,
                                            label: "Full Paragraph",
                                            fields: use_cases_tabs_config_object_spread({}, title_fields_config/* default */.Z, paragraph_fields_config/* default */.Z)
                                        }
                                    }
                                }
                            },
                            banner: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Banner",
                                fields: {
                                    productType: {
                                        label: "Product",
                                        type: template_field_type.FIELD_TYPES.COMBO,
                                        options: products/* PRODUCT_OPTIONS */.ey
                                    },
                                    title: {
                                        type: template_field_type.FIELD_TYPES.TEXT,
                                        label: "Title",
                                        translatable: true
                                    },
                                    body: {
                                        type: template_field_type.FIELD_TYPES.TEXT,
                                        label: "Body",
                                        translatable: true
                                    },
                                    buttonText: {
                                        type: template_field_type.FIELD_TYPES.TEXT,
                                        label: "Button Text",
                                        translatable: true
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/use-cases-tabs-advanced-config.js
function use_cases_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function use_cases_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            use_cases_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var use_cases_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: use_cases_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/index.js



var UseCasesTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9306), __webpack_require__.e(3012), __webpack_require__.e(5512)]).then(__webpack_require__.bind(__webpack_require__, 93012));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93012)
            ];
        }
    }
});
/* harmony default export */ var use_cases_tabs = ({
    UseCasesTabsComponent: UseCasesTabsComponent,
    UseCasesTabsConfig: use_cases_tabs_config,
    UseCasesTabsAdvancedConfig: use_cases_tabs_advanced_config
});

// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/monday-demo-tabs/monday-demo-tabs-config.js
function monday_demo_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function monday_demo_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            monday_demo_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function monday_demo_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function monday_demo_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        monday_demo_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function monday_demo_tabs_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = monday_demo_tabs_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function monday_demo_tabs_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var video = fields_config/* default.video */.Z.video;
var fields = video.fields;
var loop = fields.loop, playWhenVisible = fields.playWhenVisible, restVideoFields = monday_demo_tabs_config_object_without_properties(fields, [
    "loop",
    "playWhenVisible"
]);
/* harmony default export */ var monday_demo_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Monday Demo",
    fields: {
        theme: monday_demo_tabs_config_object_spread({}, theme_config/* default.theme */.Z.theme),
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph",
            fields: full_paragraph_fields_config/* default */.Z
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 8,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tabLabel: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Label",
                        translatable: true
                    },
                    asset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Asset",
                        fields: {
                            video: monday_demo_tabs_config_object_spread_props(monday_demo_tabs_config_object_spread({}, video), {
                                fields: monday_demo_tabs_config_object_spread({}, restVideoFields)
                            })
                        }
                    }
                }
            }
        },
        buttonConfig: button_fields_config/* default */.Z
    }
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/monday-demo-tabs/monday-demo-tabs-advanced-config.js
function monday_demo_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function monday_demo_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            monday_demo_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var monday_demo_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: monday_demo_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/monday-demo-tabs/index.js



var MondayDemoTabsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 968).then(__webpack_require__.bind(__webpack_require__, 20968));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20968)
            ];
        }
    }
});
/* harmony default export */ var monday_demo_tabs = ({
    MondayDemoTabsComponent: MondayDemoTabsComponent,
    MondayDemoTabsConfig: monday_demo_tabs_config,
    MondayDemoTabsAdvancedConfig: monday_demo_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/building-blocks-tabs/building-blocks-tabs-config.js
function building_blocks_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function building_blocks_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            building_blocks_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function building_blocks_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function building_blocks_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        building_blocks_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function building_blocks_tabs_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = building_blocks_tabs_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function building_blocks_tabs_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var _TwoThirdsTextAndAssetConfig_fields_fullParagraph_fields = two_thirds_text_and_asset_config/* default.fields.fullParagraph.fields */.Z.fields.fullParagraph.fields, building_blocks_tabs_config_titleColor = _TwoThirdsTextAndAssetConfig_fields_fullParagraph_fields.titleColor, fullParagraphFields = building_blocks_tabs_config_object_without_properties(_TwoThirdsTextAndAssetConfig_fields_fullParagraph_fields, [
    "titleColor"
]); // title color is controlled from theme
var textAndAssetFields = building_blocks_tabs_config_object_spread_props(building_blocks_tabs_config_object_spread({}, two_thirds_text_and_asset_config/* default.fields */.Z.fields), {
    asset: building_blocks_tabs_config_object_spread_props(building_blocks_tabs_config_object_spread({}, two_thirds_text_and_asset_config/* default.fields.asset */.Z.fields.asset), {
        fields: building_blocks_tabs_config_object_spread_props(building_blocks_tabs_config_object_spread({}, two_thirds_text_and_asset_config/* default.fields.asset.fields */.Z.fields.asset.fields), {
            useWindowMask: {
                type: template_field_type.FIELD_TYPES.BOOLEAN,
                label: "Use window mask"
            }
        })
    }),
    fullParagraph: building_blocks_tabs_config_object_spread_props(building_blocks_tabs_config_object_spread({}, two_thirds_text_and_asset_config/* default.fields.fullParagraph */.Z.fields.fullParagraph), {
        fields: building_blocks_tabs_config_object_spread({}, fullParagraphFields)
    })
});
/* harmony default export */ var building_blocks_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Building Blocks",
    fields: {
        buildingBlocksTabsTheme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme"
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 8,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tabLabel: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Label",
                        translatable: true
                    },
                    // Should be added after cloudinary-service.js is refactored
                    // tabIcon: {
                    //   type: FIELD_TYPES.GALLERY,
                    //   defaultImagesKeys: [],
                    //   label: "Select an Icon"
                    // },
                    textAndAsset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Text and asset",
                        fields: textAndAssetFields
                    }
                }
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/building-blocks-tabs/building-blocks-tabs-advanced-config.js
function building_blocks_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function building_blocks_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            building_blocks_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var building_blocks_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: building_blocks_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/building-blocks-tabs/index.js



var BuildingBlocksTabsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4188).then(__webpack_require__.bind(__webpack_require__, 54188));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(54188)
            ];
        }
    }
});
/* harmony default export */ var building_blocks_tabs = ({
    BuildingBlocksTabsComponent: BuildingBlocksTabsComponent,
    BuildingBlocksTabsConfig: building_blocks_tabs_config,
    BuildingBlocksTabsAdvancedConfig: building_blocks_tabs_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/board-tabs/fields-config.js
var board_tabs_fields_config = __webpack_require__(55209);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/board-tabs/board-tabs-config.js
function board_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function board_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            board_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var board_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Board",
    fields: board_tabs_config_object_spread({}, board_tabs_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/board-tabs/board-tabs-advanced-config.js
function board_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function board_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            board_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var board_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: board_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/board-tabs/index.js



var BoardTabsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6661).then(__webpack_require__.bind(__webpack_require__, 76661));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76661)
            ];
        }
    }
});
/* harmony default export */ var board_tabs = ({
    BoardTabsComponent: BoardTabsComponent,
    BoardTabsConfig: board_tabs_config,
    BoardTabsAdvancedConfig: board_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timeline-tabs/timeline-tabs-config.js
function timeline_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function timeline_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            timeline_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function timeline_tabs_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = timeline_tabs_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function timeline_tabs_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var timeline_tabs_config_backgroundColor = vertical_tabs_fields_config.backgroundColor, timeline_tabs_config_theme = vertical_tabs_fields_config.theme, timeline_tabs_config_tabsColor = vertical_tabs_fields_config.tabsColor, resconfig = timeline_tabs_config_object_without_properties(vertical_tabs_fields_config, [
    "backgroundColor",
    "theme",
    "tabsColor"
]);
/* harmony default export */ var timeline_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Timeline",
    fields: timeline_tabs_config_object_spread({
        theme: timeline_tabs_config_theme,
        tabsColor: timeline_tabs_config_tabsColor,
        lineColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Menu line Color"
        }
    }, resconfig)
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-tabs/advanced-fields-config.js

/* harmony default export */ var vertical_tabs_advanced_fields_config = ({
    autoTransition: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Auto Transition (milliseconds)"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timeline-tabs/timeline-tabs-advanced-config.js
function timeline_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function timeline_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            timeline_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var timeline_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: timeline_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, vertical_tabs_advanced_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timeline-tabs/index.js



var TimelineTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4837), __webpack_require__.e(1534)]).then(__webpack_require__.bind(__webpack_require__, 21534));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21534)
            ];
        }
    }
});
/* harmony default export */ var timeline_tabs = ({
    TimelineTabsComponent: TimelineTabsComponent,
    TimelineTabsConfig: timeline_tabs_config,
    TimelineTabsAdvancedConfig: timeline_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/colored-timer-vertical-tabs/colored-timer-vertical-tabs-config.js
function colored_timer_vertical_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function colored_timer_vertical_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            colored_timer_vertical_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function colored_timer_vertical_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function colored_timer_vertical_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        colored_timer_vertical_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var colored_timer_vertical_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Colored Timer Vertical",
    fields: colored_timer_vertical_tabs_config_object_spread_props(colored_timer_vertical_tabs_config_object_spread({}, vertical_timer_tabs_fields_config), {
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 5,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    title: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Title",
                        translatable: true
                    },
                    content: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab Full Paragraph",
                        fields: full_paragraph_fields_config/* default */.Z
                    },
                    timer: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Timer Length (in milliseconds)"
                    },
                    badgeText: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Badge text (if needed)",
                        translatable: true
                    },
                    asset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Asset",
                        fields: fields_config/* default */.Z
                    }
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/colored-timer-vertical-tabs/colored-timer-vertical-tabs-advanced-config.js
function colored_timer_vertical_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function colored_timer_vertical_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            colored_timer_vertical_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var colored_timer_vertical_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: colored_timer_vertical_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, fields_advanced_config)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/colored-timer-vertical-tabs/index.js



var ColoredTimerVerticalTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4069), __webpack_require__.e(4864), __webpack_require__.e(1365)]).then(__webpack_require__.bind(__webpack_require__, 71365));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71365)
            ];
        }
    }
});
/* harmony default export */ var colored_timer_vertical_tabs = ({
    ColoredTimerVerticalTabsComponent: ColoredTimerVerticalTabsComponent,
    ColoredTimerVerticalTabsConfig: colored_timer_vertical_tabs_config,
    ColoredTimerVerticalTabsAdvancedConfig: colored_timer_vertical_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timer-vertical-tabs/timer-vertical-tabs-config.js
function timer_vertical_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function timer_vertical_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            timer_vertical_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var timer_vertical_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Timer Vertical",
    fields: timer_vertical_tabs_config_object_spread({}, vertical_timer_tabs_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timer-vertical-tabs/timer-vertical-tabs-advanced-config.js
function timer_vertical_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function timer_vertical_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            timer_vertical_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function timer_vertical_tabs_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function timer_vertical_tabs_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        timer_vertical_tabs_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var timer_vertical_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: timer_vertical_tabs_advanced_config_object_spread_props(timer_vertical_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, fields_advanced_config), {
        isAlignedToCenter: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to center"
        },
        tabsSpace: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tabs space"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timer-vertical-tabs/index.js



var TimerVerticalTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4069), __webpack_require__.e(4864), __webpack_require__.e(9918)]).then(__webpack_require__.bind(__webpack_require__, 99918));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99918)
            ];
        }
    }
});
/* harmony default export */ var timer_vertical_tabs = ({
    TimerVerticalTabsComponent: TimerVerticalTabsComponent,
    TimerVerticalTabsConfig: timer_vertical_tabs_config,
    TimerVerticalTabsAdvancedConfig: timer_vertical_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/vertical-tabs/vertical-tabs-config.js
function vertical_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function vertical_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            vertical_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var vertical_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Vertical",
    fields: vertical_tabs_config_object_spread({}, vertical_tabs_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/vertical-tabs/vertical-tabs-advanced-config.js
function vertical_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function vertical_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            vertical_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var vertical_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: vertical_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, vertical_tabs_advanced_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/vertical-tabs/index.js



var VerticalTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4837), __webpack_require__.e(4316)]).then(__webpack_require__.bind(__webpack_require__, 94316));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94316)
            ];
        }
    }
});
/* harmony default export */ var vertical_tabs = ({
    VerticalTabsComponent: VerticalTabsComponent,
    VerticalTabsConfig: vertical_tabs_config,
    VerticalTabsAdvancedConfig: vertical_tabs_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/bullets/fields-config.js
var bullets_fields_config = __webpack_require__(61204);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/regular-tabs/regular-tabs-config.js
function regular_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function regular_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            regular_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function regular_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function regular_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        regular_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var regular_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Regular",
    fields: {
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme"
        },
        tabsBackgroundColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Tabs background color"
        },
        tabsColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Tabs color"
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 8,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tabLabel: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Label",
                        translatable: true
                    },
                    tabId: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Id"
                    },
                    textAndAsset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Text and asset",
                        fields: regular_tabs_config_object_spread_props(regular_tabs_config_object_spread({}, two_thirds_text_and_asset_config/* default.fields */.Z.fields), {
                            bulletsConfig: bullets_fields_config/* default */.Z
                        })
                    }
                }
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/regular-tabs/index.js

var RegularTabsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2776).then(__webpack_require__.bind(__webpack_require__, 52776));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52776)
            ];
        }
    }
});


/* harmony default export */ var regular_tabs = ({
    RegularTabsComponent: RegularTabsComponent,
    RegularTabsConfig: regular_tabs_config,
    RegularTabsAdvancedConfig: regular_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/index.js
// plop_marker:layouts_import




















/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    CarouselTabs: carousel_tabs,
    UsecasesGalleryTabs: usecases_gallery_tabs,
    SideBySideProductSwitcherWithProductTabs: side_by_side_product_switcher_with_product_tabs,
    TwoThirdsTextAndProductsHorizontalTabs: two_thirds_text_and_products_horizontal_tabs,
    ProductsHorizontalTimerTabs: products_horizontal_timer_tabs,
    SideBySideParagraphAndProductsTabs: side_by_side_paragraph_and_products_tabs,
    TimelineTitledTabTabs: timeline_titled_tab_tabs,
    SideBySideTabsAndProcessTabs: side_by_side_tabs_and_process_tabs,
    SideBySideTabsAndTestimonialTabs: side_by_side_tabs_and_testimonial_tabs,
    PersonasTabs: personas_tabs,
    SideBySideBoardViewsComponentTabs: side_by_side_board_views_component_tabs,
    UseCasesTabs: use_cases_tabs,
    MondayDemoTabs: monday_demo_tabs,
    BuildingBlocksTabs: building_blocks_tabs,
    BoardTabs: board_tabs,
    TimelineTabs: timeline_tabs,
    ColoredTimerVerticalTabs: colored_timer_vertical_tabs,
    TimerVerticalTabs: timer_vertical_tabs,
    VerticalTabs: vertical_tabs,
    RegularTabs: regular_tabs
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/index.js

var CarouselTabs = layouts.CarouselTabs, UsecasesGalleryTabs = layouts.UsecasesGalleryTabs, SideBySideProductSwitcherWithProductTabs = layouts.SideBySideProductSwitcherWithProductTabs, TwoThirdsTextAndProductsHorizontalTabs = layouts.TwoThirdsTextAndProductsHorizontalTabs, ProductsHorizontalTimerTabs = layouts.ProductsHorizontalTimerTabs, SideBySideParagraphAndProductsTabs = layouts.SideBySideParagraphAndProductsTabs, TimelineTitledTabTabs = layouts.TimelineTitledTabTabs, SideBySideTabsAndProcessTabs = layouts.SideBySideTabsAndProcessTabs, SideBySideTabsAndTestimonialTabs = layouts.SideBySideTabsAndTestimonialTabs, PersonasTabs = layouts.PersonasTabs, SideBySideBoardViewsComponentTabs = layouts.SideBySideBoardViewsComponentTabs, UseCasesTabs = layouts.UseCasesTabs, MondayDemoTabs = layouts.MondayDemoTabs, BuildingBlocksTabs = layouts.BuildingBlocksTabs, BoardTabs = layouts.BoardTabs, TimelineTabs = layouts.TimelineTabs, ColoredTimerVerticalTabs = layouts.ColoredTimerVerticalTabs, TimerVerticalTabs = layouts.TimerVerticalTabs, VerticalTabs = layouts.VerticalTabs, RegularTabs = layouts.RegularTabs;
/* harmony default export */ var desktop_tabs = ({
    // plop_marker:segment_index_add_layout
    CarouselTabsComponent: {
        type: "CarouselTabsComponent",
        title: "Carousel",
        imgSrc: "/static/img/segments/layouts/carousel-tabs.png",
        config: CarouselTabs.CarouselTabsConfig,
        advancedConfig: CarouselTabs.CarouselTabsAdvancedConfig,
        component: CarouselTabs.CarouselTabsComponent
    },
    UsecasesGalleryTabsComponent: {
        type: "UsecasesGalleryTabsComponent",
        title: "Usecases Gallery",
        imgSrc: "/static/img/segments/layouts/usecases-gallery-tabs.png",
        config: UsecasesGalleryTabs.UsecasesGalleryTabsConfig,
        advancedConfig: UsecasesGalleryTabs.UsecasesGalleryTabsAdvancedConfig,
        component: UsecasesGalleryTabs.UsecasesGalleryTabsComponent
    },
    SideBySideProductSwitcherWithProductTabsComponent: {
        type: "SideBySideProductSwitcherWithProductTabsComponent",
        title: "Side By Side Product Switcher With Product",
        imgSrc: "/static/img/segments/layouts/side-by-side-product-switcher-with-product-tabs.png",
        config: SideBySideProductSwitcherWithProductTabs.SideBySideProductSwitcherWithProductTabsConfig,
        advancedConfig: SideBySideProductSwitcherWithProductTabs.SideBySideProductSwitcherWithProductTabsAdvancedConfig,
        component: SideBySideProductSwitcherWithProductTabs.SideBySideProductSwitcherWithProductTabsComponent
    },
    TwoThirdsTextAndProductsHorizontalTabsComponent: {
        type: "TwoThirdsTextAndProductsHorizontalTabsComponent",
        title: "Two Thirds Text And Products Horizontal",
        imgSrc: "/static/img/segments/layouts/two-thirds-text-and-products-horizontal-tabs.png",
        config: TwoThirdsTextAndProductsHorizontalTabs.TwoThirdsTextAndProductsHorizontalTabsConfig,
        advancedConfig: TwoThirdsTextAndProductsHorizontalTabs.TwoThirdsTextAndProductsHorizontalTabsAdvancedConfig,
        component: TwoThirdsTextAndProductsHorizontalTabs.TwoThirdsTextAndProductsHorizontalTabsComponent
    },
    ProductsHorizontalTimerTabsComponent: {
        type: "ProductsHorizontalTimerTabsComponent",
        title: "Products Horizontal Timer",
        imgSrc: "/static/img/segments/layouts/products-horizontal-timer-tabs.png",
        config: ProductsHorizontalTimerTabs.ProductsHorizontalTimerTabsConfig,
        advancedConfig: ProductsHorizontalTimerTabs.ProductsHorizontalTimerTabsAdvancedConfig,
        component: ProductsHorizontalTimerTabs.ProductsHorizontalTimerTabsComponent
    },
    SideBySideParagraphAndProductsTabsComponent: {
        type: "SideBySideParagraphAndProductsTabsComponent",
        title: "Side By Side Paragraph And Products",
        imgSrc: "/static/img/segments/layouts/side-by-side-paragraph-and-products-tabs.png",
        config: SideBySideParagraphAndProductsTabs.SideBySideParagraphAndProductsTabsConfig,
        advancedConfig: SideBySideParagraphAndProductsTabs.SideBySideParagraphAndProductsTabsAdvancedConfig,
        component: SideBySideParagraphAndProductsTabs.SideBySideParagraphAndProductsTabsComponent
    },
    TimelineTitledTabTabsComponent: {
        type: "TimelineTitledTabTabsComponent",
        title: "Timeline Titled Tab",
        imgSrc: "/static/img/segments/layouts/timeline-titled-tab-tabs.png",
        config: TimelineTitledTabTabs.TimelineTitledTabTabsConfig,
        advancedConfig: TimelineTitledTabTabs.TimelineTitledTabTabsAdvancedConfig,
        component: TimelineTitledTabTabs.TimelineTitledTabTabsComponent
    },
    SideBySideTabsAndProcessTabsComponent: {
        type: "SideBySideTabsAndProcessTabsComponent",
        title: "Side By Side Tabs And Process",
        imgSrc: "/static/img/segments/layouts/side-by-side-tabs-and-process-tabs.png",
        config: SideBySideTabsAndProcessTabs.SideBySideTabsAndProcessTabsConfig,
        advancedConfig: SideBySideTabsAndProcessTabs.SideBySideTabsAndProcessTabsAdvancedConfig,
        component: SideBySideTabsAndProcessTabs.SideBySideTabsAndProcessTabsComponent
    },
    SideBySideTabsAndTestimonialTabsComponent: {
        type: "SideBySideTabsAndTestimonialTabsComponent",
        title: "Side By Side Tabs And Testimonial",
        imgSrc: "/static/img/segments/layouts/side-by-side-tabs-and-testimonial-tabs.png",
        config: SideBySideTabsAndTestimonialTabs.SideBySideTabsAndTestimonialTabsConfig,
        advancedConfig: SideBySideTabsAndTestimonialTabs.SideBySideTabsAndTestimonialTabsAdvancedConfig,
        component: SideBySideTabsAndTestimonialTabs.SideBySideTabsAndTestimonialTabsComponent
    },
    PersonasTabsComponent: {
        type: "PersonasTabsComponent",
        title: "Personas",
        imgSrc: "/static/img/segments/layouts/personas-tabs.png",
        config: PersonasTabs.PersonasTabsConfig,
        advancedConfig: PersonasTabs.PersonasTabsAdvancedConfig,
        component: PersonasTabs.PersonasTabsComponent
    },
    SideBySideBoardViewsComponentTabsComponent: {
        type: "SideBySideBoardViewsComponentTabsComponent",
        title: "Side By Side Board Views Component",
        imgSrc: "/static/img/segments/layouts/side-by-side-board-views-component-tabs.png",
        config: SideBySideBoardViewsComponentTabs.SideBySideBoardViewsComponentTabsConfig,
        advancedConfig: SideBySideBoardViewsComponentTabs.SideBySideBoardViewsComponentTabsAdvancedConfig,
        component: SideBySideBoardViewsComponentTabs.SideBySideBoardViewsComponentTabsComponent
    },
    UseCasesTabsComponent: {
        type: "UseCasesTabsComponent",
        title: "Use Cases",
        imgSrc: "/static/img/segments/layouts/use-cases-tabs.png",
        config: UseCasesTabs.UseCasesTabsConfig,
        advancedConfig: UseCasesTabs.UseCasesTabsAdvancedConfig,
        component: UseCasesTabs.UseCasesTabsComponent
    },
    MondayDemoTabsComponent: {
        type: "MondayDemoTabsComponent",
        title: "Monday Demo",
        imgSrc: "/static/img/segments/layouts/monday-demo-tabs.png",
        config: MondayDemoTabs.MondayDemoTabsConfig,
        advancedConfig: MondayDemoTabs.MondayDemoTabsAdvancedConfig,
        component: MondayDemoTabs.MondayDemoTabsComponent
    },
    BuildingBlocksTabsComponent: {
        type: "BuildingBlocksTabsComponent",
        title: "Building Blocks",
        imgSrc: "/static/img/segments/layouts/building-blocks-tabs.png",
        config: BuildingBlocksTabs.BuildingBlocksTabsConfig,
        advancedConfig: BuildingBlocksTabs.BuildingBlocksTabsAdvancedConfig,
        component: BuildingBlocksTabs.BuildingBlocksTabsComponent
    },
    BoardTabsComponent: {
        type: "BoardTabsComponent",
        title: "Board",
        imgSrc: "/static/img/segments/layouts/board-tabs.png",
        config: BoardTabs.BoardTabsConfig,
        advancedConfig: BoardTabs.BoardTabsAdvancedConfig,
        component: BoardTabs.BoardTabsComponent
    },
    TimelineTabsComponent: {
        type: "TimelineTabsComponent",
        title: "Timeline",
        imgSrc: "/static/img/segments/layouts/timeline-tabs.png",
        config: TimelineTabs.TimelineTabsConfig,
        advancedConfig: TimelineTabs.TimelineTabsAdvancedConfig,
        component: TimelineTabs.TimelineTabsComponent
    },
    ColoredTimerVerticalTabsComponent: {
        type: "ColoredTimerVerticalTabsComponent",
        title: "Colored Timer Vertical",
        imgSrc: "/static/img/segments/layouts/colored-timer-vertical-tabs.png",
        config: ColoredTimerVerticalTabs.ColoredTimerVerticalTabsConfig,
        advancedConfig: ColoredTimerVerticalTabs.ColoredTimerVerticalTabsAdvancedConfig,
        component: ColoredTimerVerticalTabs.ColoredTimerVerticalTabsComponent
    },
    TimerVerticalTabsComponent: {
        type: "TimerVerticalTabsComponent",
        title: "Timer Vertical",
        imgSrc: "/static/img/segments/layouts/timer-vertical-tabs.png",
        config: TimerVerticalTabs.TimerVerticalTabsConfig,
        advancedConfig: TimerVerticalTabs.TimerVerticalTabsAdvancedConfig,
        component: TimerVerticalTabs.TimerVerticalTabsComponent
    },
    VerticalTabsComponent: {
        type: "VerticalTabsComponent",
        title: "Vertical",
        imgSrc: "/static/img/segments/layouts/vertical-tabs.png",
        config: VerticalTabs.VerticalTabsConfig,
        advancedConfig: VerticalTabs.VerticalTabsAdvancedConfig,
        component: VerticalTabs.VerticalTabsComponent
    },
    RegularTabsComponent: {
        type: "RegularTabsComponent",
        title: "Regular",
        imgSrc: "/static/img/segments/layouts/regular-tabs.png",
        config: RegularTabs.RegularTabsConfig,
        advancedConfig: RegularTabs.RegularTabsAdvancedConfig,
        component: RegularTabs.RegularTabsComponent
    }
});


/***/ }),

/***/ 34102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ templates; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(50342);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/fields-config.js
var fields_config = __webpack_require__(93097);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(77374);
// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var asset_fields_config = __webpack_require__(13225);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/core-configs/template-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var selectTemplateConfig = {
    solutionId: {
        type: template_field_type.FIELD_TYPES.SOLUTION,
        label: "Template"
    },
    showTitle: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Show title"
    },
    showDescription: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Show description"
    },
    showImageShadow: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Show image shadow"
    },
    overrideTitle: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Override Default Template Title"
    },
    overrideDescription: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Override Default Template Description",
        textArea: true
    },
    overrideImage: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Override Default Image",
        fields: asset_fields_config/* default */.Z
    },
    topicText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Topic"
    },
    buttonSelect: {
        type: template_field_type.FIELD_TYPES.CONDITIONAL_NESTED,
        label: "Button",
        conditionalKeyName: "buttonType",
        options: [
            {
                type: template_field_type.FIELD_TYPES.NESTED,
                text: button_consts/* SIGNUP_BUTTON_TYPE */.ge,
                fieldsConfig: {
                    signupButtonText: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Signup Button Text"
                    }
                }
            },
            {
                type: template_field_type.FIELD_TYPES.NESTED,
                text: button_consts/* SIGNUP_COMBO_BUTTONS_TYPE */.ae,
                fieldsConfig: {
                    signupButtonText: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Signup Button Text"
                    },
                    seconderyButtonText: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Secondery Button Text"
                    }
                }
            }
        ]
    }
};
var advancedTemplateConfig = {
    textSize: _object_spread_props(_object_spread({}, advanced_fields_config/* default.textSize */.Z.textSize), {
        label: "Template Description Text Size"
    }),
    titleSize: _object_spread_props(_object_spread({}, fields_config/* default.titleSize */.Z.titleSize), {
        label: "Template Title Text Size"
    }),
    mobileTextAlign: full_paragraph_fields_config/* default.mobileTextAlign */.Z.mobileTextAlign,
    hideOnMobile: shared_advanced_fields_config/* default.hideOnMobile */.Z.hideOnMobile,
    alignToLogo: _object_spread({}, advanced_field_config/* default.alignToLogo */.Z.alignToLogo)
};

;// CONCATENATED MODULE: ./segments/desktop/templates/layouts/multi-templates-templates/multi-templates-templates-config.js
function multi_templates_templates_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function multi_templates_templates_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            multi_templates_templates_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function multi_templates_templates_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function multi_templates_templates_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        multi_templates_templates_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var multi_templates_templates_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Multi Templates",
    fields: {
        solutionsInfo: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Templates",
            maxLimit: 3,
            minLimit: 1,
            defaultValue: {
                buttonSelect: {
                    buttonType: button_consts/* SIGNUP_BUTTON_TYPE */.ge,
                    signupButtonText: "Use template",
                    seconderyButtonText: "Learn more"
                },
                showTitle: true,
                showDescription: true,
                showImageShadow: true
            },
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: multi_templates_templates_config_object_spread_props(multi_templates_templates_config_object_spread({}, selectTemplateConfig), {
                    overrideImage: multi_templates_templates_config_object_spread_props(multi_templates_templates_config_object_spread({}, selectTemplateConfig.overrideImage), {
                        fields: {
                            image: asset_fields_config/* default.image */.Z.image
                        }
                    })
                })
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/templates/layouts/multi-templates-templates/multi-templates-templates-advanced-config.js
function multi_templates_templates_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function multi_templates_templates_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            multi_templates_templates_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var multi_templates_templates_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: multi_templates_templates_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advancedTemplateConfig)
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./server/services/solutions/solutions-api-service.js
var solutions_api_service = __webpack_require__(40469);
// EXTERNAL MODULE: ./services/templates-generator/api-service.js
var api_service = __webpack_require__(90215);
;// CONCATENATED MODULE: ./segments/desktop/templates/layouts/multi-templates-templates/multi-templates-templates-dynamics-fetch.js

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


var hasSameIds = function(solutionsInfo, prevSolutionsInfo) {
    return !solutionsInfo.find(function(param) {
        var solutionId = param.solutionId;
        return !prevSolutionsInfo.find(function(param) {
            var prevSolutionId = param.solutionId;
            return solutionId === prevSolutionId;
        });
    });
};
/* harmony default export */ var multi_templates_templates_dynamics_fetch = ([
    {
        propsPropertyName: "solutions",
        shouldFetch: function(param) {
            var props = param.props, previousProps = param.previousProps, pageConfig = param.pageConfig, previousPageConfig = param.previousPageConfig;
            var _props_solutionsInfo;
            var res = false;
            // Has ids
            if (((_props_solutionsInfo = props.solutionsInfo) === null || _props_solutionsInfo === void 0 ? void 0 : _props_solutionsInfo.length) > 0) {
                var _previousProps_solutionsInfo;
                // Add/Remove ids
                if (props.solutionsInfo.length !== ((_previousProps_solutionsInfo = previousProps.solutionsInfo) === null || _previousProps_solutionsInfo === void 0 ? void 0 : _previousProps_solutionsInfo.length)) {
                    res = true;
                // Id has changed
                } else if (!hasSameIds(props.solutionsInfo, previousProps.solutionsInfo)) {
                    res = true;
                // Locale has changed
                } else if (pageConfig.localeId !== previousPageConfig.localeId) {
                    res = true;
                }
            }
            return res;
        },
        fetch: function() {
            var _ref = _async_to_generator(function(param) {
                var props, pageConfig, isClientFetch, solutionsInfo, localeId, path, solutionRequests, solutions;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            props = param.props, pageConfig = param.pageConfig, isClientFetch = param.isClientFetch;
                            solutionsInfo = props.solutionsInfo;
                            localeId = pageConfig.localeId, path = pageConfig.path;
                            solutionRequests = solutionsInfo.map(function() {
                                var _ref = _async_to_generator(function(info) {
                                    var solutionId, solution, res;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                solutionId = info.solutionId;
                                                if (!solutionId) return [
                                                    3,
                                                    5
                                                ];
                                                if (!isClientFetch) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    (0,api_service/* getSolutionById */.zt)({
                                                        solutionId: solutionId,
                                                        localeId: localeId
                                                    })
                                                ];
                                            case 1:
                                                res = _state.sent();
                                                solution = res.solution;
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 2:
                                                return [
                                                    4,
                                                    (0,solutions_api_service.getMondaySolutionById)({
                                                        solutionId: solutionId,
                                                        localeId: localeId
                                                    })
                                                ];
                                            case 3:
                                                solution = _state.sent();
                                                _state.label = 4;
                                            case 4:
                                                if (!solution) {
                                                    throw new Error("solution (id: ".concat(solutionId, ") can't be found in page ").concat(path));
                                                }
                                                return [
                                                    2,
                                                    solution
                                                ];
                                            case 5:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(info) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                            return [
                                4,
                                Promise.all(solutionRequests)
                            ];
                        case 1:
                            solutions = _state.sent();
                            return [
                                2,
                                solutions
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()
    }
]);

;// CONCATENATED MODULE: ./segments/desktop/templates/layouts/multi-templates-templates/index.js




var MultiTemplatesTemplatesComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4296).then(__webpack_require__.bind(__webpack_require__, 14296));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14296)
            ];
        }
    }
});
/* harmony default export */ var multi_templates_templates = ({
    MultiTemplatesTemplatesComponent: MultiTemplatesTemplatesComponent,
    MultiTemplatesTemplatesConfig: multi_templates_templates_config,
    MultiTemplatesTemplatesAdvancedConfig: multi_templates_templates_advanced_config,
    MultiTemplatesTemplatesDynamicsFetch: multi_templates_templates_dynamics_fetch
});

;// CONCATENATED MODULE: ./segments/desktop/templates/layouts/single-template-templates/single-template-templates-config.js
function single_template_templates_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function single_template_templates_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            single_template_templates_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var single_template_templates_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Single Template",
    fields: single_template_templates_config_object_spread({}, selectTemplateConfig)
});

;// CONCATENATED MODULE: ./segments/desktop/templates/layouts/single-template-templates/single-template-templates-advanced-config.js
function single_template_templates_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function single_template_templates_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            single_template_templates_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var single_template_templates_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: single_template_templates_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advancedTemplateConfig)
});

;// CONCATENATED MODULE: ./segments/desktop/templates/layouts/single-template-templates/single-template-templates-dynamics-fetch.js

function single_template_templates_dynamics_fetch_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function single_template_templates_dynamics_fetch_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                single_template_templates_dynamics_fetch_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                single_template_templates_dynamics_fetch_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/* harmony default export */ var single_template_templates_dynamics_fetch = ([
    {
        propsPropertyName: "solution",
        shouldFetch: function(param) {
            var props = param.props, previousProps = param.previousProps, pageConfig = param.pageConfig, previousPageConfig = param.previousPageConfig;
            return props.solutionId && (props.solutionId !== previousProps.solutionId || pageConfig.localeId !== previousPageConfig.localeId);
        },
        fetch: function() {
            var _ref = single_template_templates_dynamics_fetch_async_to_generator(function(param) {
                var props, pageConfig, isClientFetch, solutionId, localeId, path, solution, res;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            props = param.props, pageConfig = param.pageConfig, isClientFetch = param.isClientFetch;
                            solutionId = props.solutionId;
                            localeId = pageConfig.localeId, path = pageConfig.path;
                            if (!isClientFetch) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0,api_service/* getSolutionById */.zt)({
                                    solutionId: solutionId,
                                    localeId: localeId
                                })
                            ];
                        case 1:
                            res = _state.sent();
                            solution = res.solution;
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                (0,solutions_api_service.getMondaySolutionById)({
                                    solutionId: solutionId,
                                    localeId: localeId
                                })
                            ];
                        case 3:
                            solution = _state.sent();
                            _state.label = 4;
                        case 4:
                            if (!solution) {
                                throw new Error("solution (id: ".concat(solutionId, ") can't be found in page ").concat(path));
                            }
                            return [
                                2,
                                solution
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()
    }
]);

;// CONCATENATED MODULE: ./segments/desktop/templates/layouts/single-template-templates/index.js




var SingleTemplateTemplatesComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7595).then(__webpack_require__.bind(__webpack_require__, 97595));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97595)
            ];
        }
    }
});
/* harmony default export */ var single_template_templates = ({
    SingleTemplateTemplatesComponent: SingleTemplateTemplatesComponent,
    SingleTemplateTemplatesConfig: single_template_templates_config,
    SingleTemplateTemplatesAdvancedConfig: single_template_templates_advanced_config,
    SingleTemplateTemplatesDynamicsFetch: single_template_templates_dynamics_fetch
});

;// CONCATENATED MODULE: ./segments/desktop/templates/layouts/index.js
// plop_marker:layouts_import


/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    MultiTemplatesTemplates: multi_templates_templates,
    SingleTemplateTemplates: single_template_templates
});

;// CONCATENATED MODULE: ./segments/desktop/templates/index.js

var MultiTemplatesTemplates = layouts.MultiTemplatesTemplates, SingleTemplateTemplates = layouts.SingleTemplateTemplates;
/* harmony default export */ var templates = ({
    // plop_marker:segment_index_add_layout
    MultiTemplatesTemplatesComponent: {
        type: "MultiTemplatesTemplatesComponent",
        title: "Multi Templates",
        imgSrc: "/static/img/segments/layouts/multi-templates-templates.png",
        config: MultiTemplatesTemplates.MultiTemplatesTemplatesConfig,
        advancedConfig: MultiTemplatesTemplates.MultiTemplatesTemplatesAdvancedConfig,
        component: MultiTemplatesTemplates.MultiTemplatesTemplatesComponent,
        dynamicsFetch: MultiTemplatesTemplates.MultiTemplatesTemplatesDynamicsFetch
    },
    SingleTemplateTemplatesComponent: {
        type: "SingleTemplateTemplatesComponent",
        title: "Single Template",
        imgSrc: "/static/img/segments/layouts/single-template-templates.png",
        config: SingleTemplateTemplates.SingleTemplateTemplatesConfig,
        advancedConfig: SingleTemplateTemplates.SingleTemplateTemplatesAdvancedConfig,
        component: SingleTemplateTemplates.SingleTemplateTemplatesComponent,
        dynamicsFetch: SingleTemplateTemplates.SingleTemplateTemplatesDynamicsFetch
    }
});


/***/ }),

/***/ 35341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ testimonials; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/carousel-testimonials/carousel-testimonials-config.js

var testimonialConfig = {
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Single company testimonial",
    fields: {
        name: {
            label: "Company name",
            type: template_field_type.FIELD_TYPES.TEXT
        },
        testimonialText: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Testimonial text",
            translatable: true
        },
        personName: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Quote sayer's name"
        },
        personRole: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Quote sayer's role",
            translatable: true
        },
        image: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Company logo",
            fields: {
                src: {
                    type: template_field_type.FIELD_TYPES.GALLERY,
                    defaultImagesKeys: [
                        "static/img/templates/long-template/boards/"
                    ],
                    label: "Select an image (max 290px width, 90px height)"
                },
                alt: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Image description (alt)",
                    translatable: true
                },
                isDecorative: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Decorative image(no alt)"
                }
            }
        }
    }
};
/* harmony default export */ var carousel_testimonials_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Testimonials carousel",
    fields: {
        textNote: {
            type: template_field_type.FIELD_TYPES.CONSTANT,
            label: "Note about texts:",
            text: "You can either use translation keys for translated text, or enter English text directly, which will be untranslated."
        },
        autoplay: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Auto-play definitions",
            fields: {
                shouldAutoPlay: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Should auto-play testimonial slides"
                },
                interval: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Interval (number of milliseconds)"
                }
            }
        },
        testimonials: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Testimonials",
            nestedConfig: testimonialConfig
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/carousel-testimonials/carousel-testimonials-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var carousel_testimonials_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/carousel-testimonials/index.js

var CarouselTestimonialsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6499), __webpack_require__.e(1997)]).then(__webpack_require__.bind(__webpack_require__, 51997));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51997)
            ];
        }
    }
});


/* harmony default export */ var carousel_testimonials = ({
    CarouselTestimonialsComponent: CarouselTestimonialsComponent,
    CarouselTestimonialsConfig: carousel_testimonials_config,
    CarouselTestimonialsAdvancedConfig: carousel_testimonials_advanced_config
});

// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
// EXTERNAL MODULE: ./segments/desktop/core-components/person-textual-info/fields-config.js
var fields_config = __webpack_require__(81828);
;// CONCATENATED MODULE: ./segments/desktop/testimonials/components/fields-config.js
function fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var color = fields_config/* default.color */.Z.color, selectedTextualInfoFields = _object_without_properties(fields_config/* default */.Z, [
    "color"
]);
/* harmony default export */ var components_fields_config = (fields_config_object_spread(_object_spread_props(fields_config_object_spread({}, theme_config/* default */.Z), {
    companyImage: {
        type: template_field_type.FIELD_TYPES.GALLERY,
        defaultImagesKeys: [],
        label: "Select an Image"
    },
    alt: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Image description (alt)",
        translatable: true
    },
    quote: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Quote",
        textArea: true,
        translatable: true
    }
}), selectedTextualInfoFields));

;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/plain-classic-testimonials/plain-classic-testimonials-config.js


/* harmony default export */ var plain_classic_testimonials_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Plain Classic",
    fields: {
        testimonialCard: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Testominal Card",
            fields: components_fields_config
        }
    }
});

// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/plain-classic-testimonials/plain-classic-testimonials-advanced-config.js
function plain_classic_testimonials_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function plain_classic_testimonials_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            plain_classic_testimonials_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function plain_classic_testimonials_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function plain_classic_testimonials_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        plain_classic_testimonials_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var plain_classic_testimonials_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: plain_classic_testimonials_advanced_config_object_spread_props(plain_classic_testimonials_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z), {
        titleSize: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Title Size",
            options: [
                {
                    value: sizes.XS,
                    text: "24px"
                },
                {
                    value: sizes.SM,
                    text: "32px"
                },
                {
                    value: sizes.MD,
                    text: "40px"
                },
                {
                    value: sizes.LG,
                    text: "50px"
                },
                {
                    value: sizes/* LGR */.Re,
                    text: "60px"
                },
                {
                    value: sizes.XL,
                    text: "72px"
                }
            ]
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/plain-classic-testimonials/index.js

var PlainClassicTestimonialsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4124).then(__webpack_require__.bind(__webpack_require__, 69799));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69799)
            ];
        }
    }
});


/* harmony default export */ var plain_classic_testimonials = ({
    PlainClassicTestimonialsComponent: PlainClassicTestimonialsComponent,
    PlainClassicTestimonialsConfig: plain_classic_testimonials_config,
    PlainClassicTestimonialsAdvancedConfig: plain_classic_testimonials_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/index.js
// plop_marker:layouts_import


/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    CarouselTestimonials: carousel_testimonials,
    PlainClassicTestimonials: plain_classic_testimonials
});

;// CONCATENATED MODULE: ./segments/desktop/testimonials/index.js

var CarouselTestimonials = layouts.CarouselTestimonials, PlainClassicTestimonials = layouts.PlainClassicTestimonials;
/* harmony default export */ var testimonials = ({
    // plop_marker:segment_index_add_layout
    CarouselTestimonialsComponent: {
        type: "CarouselTestimonialsComponent",
        title: "Testimonials Carousel",
        imgSrc: "/static/img/segments/layouts/carousel-testimonials.png",
        config: CarouselTestimonials.CarouselTestimonialsConfig,
        advancedConfig: CarouselTestimonials.CarouselTestimonialsAdvancedConfig,
        component: CarouselTestimonials.CarouselTestimonialsComponent
    },
    PlainClassicTestimonialsComponent: {
        type: "PlainClassicTestimonialsComponent",
        title: "Plain Classic",
        imgSrc: "/static/img/segments/layouts/plain-classic-testimonials.png",
        config: PlainClassicTestimonials.PlainClassicTestimonialsConfig,
        advancedConfig: PlainClassicTestimonials.PlainClassicTestimonialsAdvancedConfig,
        component: PlainClassicTestimonials.PlainClassicTestimonialsComponent
    }
});


/***/ }),

/***/ 85144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ text_and_asset; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var fields_config = __webpack_require__(65621);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/fields-config.js
var paragraph_fields_config = __webpack_require__(49496);
;// CONCATENATED MODULE: ./segments/desktop/core-components/product-card/fields-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var titleColor = fields_config/* default.titleColor */.Z.titleColor, restOfTitleConfig = _object_without_properties(fields_config/* default */.Z, [
    "titleColor"
]);
var bodyColor = paragraph_fields_config/* default.bodyColor */.Z.bodyColor, restOfParagraphConfig = _object_without_properties(paragraph_fields_config/* default */.Z, [
    "bodyColor"
]);
/* harmony default export */ var product_card_fields_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Products Cards",
    fields: {
        cardBackgroundColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Card background color"
        },
        productType: {
            type: template_field_type.FIELD_TYPES.PRODUCTS,
            label: "Product type"
        },
        cardTitle: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Card title",
            fields: _object_spread({
                productImage: {
                    type: template_field_type.FIELD_TYPES.GALLERY,
                    label: "Product logo image"
                }
            }, restOfTitleConfig, restOfParagraphConfig)
        },
        cardContent: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Card content",
            fields: _object_spread_props(_object_spread({}, restOfTitleConfig, restOfParagraphConfig), {
                textWidth: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Text max width"
                },
                titleWidth: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Title max width"
                },
                useCasesWidth: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Use case max width"
                },
                isUseCasesReadonly: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Is use cases read only"
                },
                showUseCasesVertically: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Show Use Cases Vertically"
                },
                cardPaddingTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Card Padding Top"
                },
                cardPaddingBottom: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Card Padding Bottom"
                },
                spaceUnderTitle: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Space Under Title"
                },
                useCases: {
                    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Use cases",
                    nestedConfig: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: {
                            useCase: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Use cases"
                            },
                            overridePageCluster: {
                                type: template_field_type.FIELD_TYPES.CLUSTERS,
                                label: "Cluster key",
                                labelDescription: "Key which represents the selected tag cluster"
                            },
                            overridePageSubCluster: {
                                type: template_field_type.FIELD_TYPES.SUB_CLUSTERS,
                                label: "Use Case key",
                                labelDescription: "Key which represents the selected tag use case"
                            }
                        }
                    }
                },
                features: {
                    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Features",
                    nestedConfig: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: {
                            feature: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Feature"
                            }
                        }
                    }
                }
            })
        },
        cardAsset: {
            type: template_field_type.FIELD_TYPES.GALLERY,
            label: "Card asset"
        }
    }
});

// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/product-cards-side-by-side-text-and-asset/product-cards-side-by-side-text-and-asset-config.js
function product_cards_side_by_side_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_cards_side_by_side_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_cards_side_by_side_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function product_cards_side_by_side_text_and_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_cards_side_by_side_text_and_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_cards_side_by_side_text_and_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var product_cards_side_by_side_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Products Cards",
    fields: product_cards_side_by_side_text_and_asset_config_object_spread_props(product_cards_side_by_side_text_and_asset_config_object_spread({}, theme_config/* default */.Z), {
        cards: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Use cases",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: product_card_fields_config.fields
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/product-cards-side-by-side-text-and-asset/product-cards-side-by-side-text-and-asset-advanced-config.js
function product_cards_side_by_side_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_cards_side_by_side_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_cards_side_by_side_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var product_cards_side_by_side_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: product_cards_side_by_side_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/product-cards-side-by-side-text-and-asset/index.js

var ProductCardsSideBySideTextAndAssetComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4222), __webpack_require__.e(6)]).then(__webpack_require__.bind(__webpack_require__, 80006));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80006)
            ];
        }
    }
});


/* harmony default export */ var product_cards_side_by_side_text_and_asset = ({
    ProductCardsSideBySideTextAndAssetComponent: ProductCardsSideBySideTextAndAssetComponent,
    ProductCardsSideBySideTextAndAssetConfig: product_cards_side_by_side_text_and_asset_config,
    ProductCardsSideBySideTextAndAssetAdvancedConfig: product_cards_side_by_side_text_and_asset_advanced_config
});

// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var asset_fields_config = __webpack_require__(13225);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
;// CONCATENATED MODULE: ./segments/desktop/core-components/card-tag/fields-config.js

/* harmony default export */ var card_tag_fields_config = ({
    tagText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tag Text"
    },
    tagColor: {
        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
        label: "Tag Color"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/whats-new-inner-page-side-by-side-text-and-asset/whats-new-inner-page-side-by-side-text-and-asset-config.js
function whats_new_inner_page_side_by_side_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function whats_new_inner_page_side_by_side_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            whats_new_inner_page_side_by_side_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function whats_new_inner_page_side_by_side_text_and_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function whats_new_inner_page_side_by_side_text_and_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        whats_new_inner_page_side_by_side_text_and_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var whats_new_inner_page_side_by_side_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Whats New Inner Page Side By Side",
    fields: whats_new_inner_page_side_by_side_text_and_asset_config_object_spread_props(whats_new_inner_page_side_by_side_text_and_asset_config_object_spread({}, full_paragraph_fields_config/* default */.Z), {
        date: {
            type: template_field_type.FIELD_TYPES.CALENDAR,
            label: "Date"
        },
        tags: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tags",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: whats_new_inner_page_side_by_side_text_and_asset_config_object_spread({}, card_tag_fields_config)
            }
        },
        rightSectionPaddingTop: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Left Section Padding Top"
        },
        asset: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Asset",
            fields: whats_new_inner_page_side_by_side_text_and_asset_config_object_spread({}, asset_fields_config/* default */.Z)
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/whats-new-inner-page-side-by-side-text-and-asset/whats-new-inner-page-side-by-side-text-and-asset-advanced-config.js
function whats_new_inner_page_side_by_side_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function whats_new_inner_page_side_by_side_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            whats_new_inner_page_side_by_side_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var whats_new_inner_page_side_by_side_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: whats_new_inner_page_side_by_side_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/whats-new-inner-page-side-by-side-text-and-asset/index.js



var WhatsNewInnerPageSideBySideTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3139).then(__webpack_require__.bind(__webpack_require__, 83139));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83139)
            ];
        }
    }
});
/* harmony default export */ var whats_new_inner_page_side_by_side_text_and_asset = ({
    WhatsNewInnerPageSideBySideTextAndAssetComponent: WhatsNewInnerPageSideBySideTextAndAssetComponent,
    WhatsNewInnerPageSideBySideTextAndAssetConfig: whats_new_inner_page_side_by_side_text_and_asset_config,
    WhatsNewInnerPageSideBySideTextAndAssetAdvancedConfig: whats_new_inner_page_side_by_side_text_and_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/fields-config.js
var side_by_side_text_and_asset_fields_config = __webpack_require__(93097);
// EXTERNAL MODULE: ./components/core/youtube-video-with-poster/fields-config.js
var youtube_video_with_poster_fields_config = __webpack_require__(93494);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/youtube-text-and-asset/youtube-text-and-asset-config.js
function youtube_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function youtube_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            youtube_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function youtube_text_and_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function youtube_text_and_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        youtube_text_and_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function youtube_text_and_asset_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = youtube_text_and_asset_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function youtube_text_and_asset_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var asset = side_by_side_text_and_asset_fields_config/* default.asset */.Z.asset, selectedSideBySideTextAndAssetFieldsConfig = youtube_text_and_asset_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "asset"
]);
/* harmony default export */ var youtube_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Youtube",
    fields: youtube_text_and_asset_config_object_spread_props(youtube_text_and_asset_config_object_spread({}, theme_config/* default */.Z, selectedSideBySideTextAndAssetFieldsConfig), {
        youtubeWithPosterProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Youtube video",
            fields: youtube_video_with_poster_fields_config/* default */.Z
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(77374);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/youtube-text-and-asset/youtube-text-and-asset-advanced-config.js
function youtube_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function youtube_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            youtube_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var youtube_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: youtube_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/youtube-text-and-asset/index.js



var YoutubeTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6121).then(__webpack_require__.bind(__webpack_require__, 76121));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76121)
            ];
        }
    }
});
/* harmony default export */ var youtube_text_and_asset = ({
    YoutubeTextAndAssetComponent: YoutubeTextAndAssetComponent,
    YoutubeTextAndAssetConfig: youtube_text_and_asset_config,
    YoutubeTextAndAssetAdvancedConfig: youtube_text_and_asset_advanced_config
});

// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-component.js
var side_by_side_text_and_asset_component = __webpack_require__(8150);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-icons-text-and-asset/side-by-side-with-icons-text-and-asset-dekstop-component.scss.js

var StyledSideBySideWithIconsTextAndAssetDekstopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1jcgcfs0"
})("display:flex;.side-by-side-asset-wrapper{flex-grow:1;.side-by-side-text-and-asset-component{height:100%;}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/icons/default-props.js
var default_props = __webpack_require__(80564);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-icons-text-and-asset/default-props.js
function default_props_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function default_props_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            default_props_define_property(target, key, source[key]);
        });
    }
    return target;
}
function default_props_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function default_props_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        default_props_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





/* harmony default export */ var side_by_side_with_icons_text_and_asset_default_props = (default_props_object_spread_props(default_props_object_spread({
    iconsConfig: default_props/* default */.Z
}, side_by_side_text_and_asset_component["default"].defaultProps), {
    asset: {
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/customer-support/support_globe.png"
        }
    },
    fullParagraph: {
        topic: {},
        title: "Supporting <light>your growth<br>every step of the way</light>",
        body: "Our support superheroes are a click away to help you get the most out of monday.com, so you can focus on working without limits.",
        buttonConfig: {
            buttonType: button_consts/* TWO_LINK_BUTTONS_TYPE */.Q_,
            swapButtonsOrder: true,
            regularButtonConfig: {
                color: color_consts.WORK_OS_IRIS_COLOR_NAME,
                buttonText: "Get in touch",
                url: "https://monday.com/helpcenter/contact-support"
            },
            secondaryButtonConfig: {
                color: color_consts.WORK_OS_IRIS_COLOR_NAME,
                buttonText: "Visit our support center",
                url: "https://support.monday.com/hc/en-us"
            }
        }
    },
    titleSize: sizes.LG,
    leftSizeWidth: "60%",
    rightSizeWidth: "40%",
    mobileMarginBetweenAssetAndButton: "48px"
}));

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-icons-text-and-asset/side-by-side-with-icons-text-and-asset-dekstop-component.js
function side_by_side_with_icons_text_and_asset_dekstop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_with_icons_text_and_asset_dekstop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_with_icons_text_and_asset_dekstop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}




var SideBySideWithIconsTextAndAssetDekstopComponent = function(props) {
    var getStyle = function() {
        var minHeight = props.minHeight;
        if (!minHeight) return {};
        return {
            minHeight: minHeight
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSideBySideWithIconsTextAndAssetDekstopComponent, {
        className: "side-by-side-with-icons-text-and-asset-component",
        style: getStyle(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "side-by-side-asset-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset_component["default"], side_by_side_with_icons_text_and_asset_dekstop_component_object_spread({}, props))
        })
    });
};
SideBySideWithIconsTextAndAssetDekstopComponent.defaultProps = side_by_side_with_icons_text_and_asset_default_props;
/* harmony default export */ var side_by_side_with_icons_text_and_asset_dekstop_component = (SideBySideWithIconsTextAndAssetDekstopComponent);

// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button.js + 17 modules
var button_button = __webpack_require__(11068);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-icons-text-and-asset/side-by-side-with-icons-text-and-asset-mobile-component.scss.js

var StyledSideBySideWithIconsTextAndAssetMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eetub0m0"
})("display:flex;flex-direction:column;align-items:center;padding:0 32px 40px;.full-paragraph{.icons-wrapper{margin-bottom:8px;}}.button-wrapper{margin-top:var(--margin-between-asset-and-button);}.two-link-buttons-button.swap-buttons-order{flex-direction:column-reverse;}");

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-icons-text-and-asset/side-by-side-with-icons-text-and-asset-mobile-component.js
function side_by_side_with_icons_text_and_asset_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_with_icons_text_and_asset_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_with_icons_text_and_asset_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_with_icons_text_and_asset_mobile_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_with_icons_text_and_asset_mobile_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_with_icons_text_and_asset_mobile_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_with_icons_text_and_asset_mobile_component_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_with_icons_text_and_asset_mobile_component_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_with_icons_text_and_asset_mobile_component_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var SideBySideWithIconsTextAndAssetMobileComponent = function(props) {
    var iconsConfig = props.iconsConfig, asset = props.asset, fullParagraph = props.fullParagraph, mobileMarginBetweenAssetAndButton = props.mobileMarginBetweenAssetAndButton, mobileMarginUnderButton = props.mobileMarginUnderButton;
    var buttonConfig = fullParagraph.buttonConfig, fullParagraphRest = side_by_side_with_icons_text_and_asset_mobile_component_object_without_properties(fullParagraph, [
        "buttonConfig"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSideBySideWithIconsTextAndAssetMobileComponent, {
        className: "side-by-side-with-icons-text-and-asset-mobile-component",
        style: {
            "--margin-between-asset-and-button": mobileMarginBetweenAssetAndButton
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "full-paragraph",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, side_by_side_with_icons_text_and_asset_mobile_component_object_spread_props(side_by_side_with_icons_text_and_asset_mobile_component_object_spread({}, fullParagraphRest), {
                    textAlign: "center",
                    titleSize: sizes.XS,
                    textSize: sizes/* XXS */.Mp,
                    iconsConfig: iconsConfig
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, side_by_side_with_icons_text_and_asset_mobile_component_object_spread({}, asset)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "button-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, side_by_side_with_icons_text_and_asset_mobile_component_object_spread({}, buttonConfig))
            })
        ]
    });
};
SideBySideWithIconsTextAndAssetMobileComponent.defaultProps = side_by_side_with_icons_text_and_asset_default_props;
/* harmony default export */ var side_by_side_with_icons_text_and_asset_mobile_component = (SideBySideWithIconsTextAndAssetMobileComponent);

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-icons-text-and-asset/side-by-side-with-icons-text-and-asset-component.js




var SideBySideWithIconsTextAndAsset = (0,responsive_hoc_component/* default */.Z)(side_by_side_with_icons_text_and_asset_dekstop_component, side_by_side_with_icons_text_and_asset_mobile_component);
/* harmony default export */ var side_by_side_with_icons_text_and_asset_component = (SideBySideWithIconsTextAndAsset);
SideBySideWithIconsTextAndAsset.defaultProps = side_by_side_with_icons_text_and_asset_default_props;

;// CONCATENATED MODULE: ./segments/desktop/core-components/icons/fields-config.js


var fields_config_image = asset_fields_config/* default.image */.Z.image;
/* harmony default export */ var icons_fields_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Icons",
    fields: {
        icons: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Icons",
            maxLimit: 3,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    image: fields_config_image,
                    title: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Title",
                        translatable: true
                    },
                    subtitle: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Subtitle",
                        translatable: true
                    }
                }
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-icons-text-and-asset/side-by-side-with-icons-text-and-asset-config.js
function side_by_side_with_icons_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_with_icons_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_with_icons_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_with_icons_text_and_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_with_icons_text_and_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_with_icons_text_and_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_with_icons_text_and_asset_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_with_icons_text_and_asset_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_with_icons_text_and_asset_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var background = side_by_side_text_and_asset_fields_config/* default.background */.Z.background, side_by_side_with_icons_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig = side_by_side_with_icons_text_and_asset_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "background"
]);
/* harmony default export */ var side_by_side_with_icons_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side With Icons",
    fields: side_by_side_with_icons_text_and_asset_config_object_spread_props(side_by_side_with_icons_text_and_asset_config_object_spread({}, side_by_side_with_icons_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig), {
        iconsConfig: icons_fields_config
    })
});

// EXTERNAL MODULE: ./components/core/asset/advanced-field-config.js
var asset_advanced_field_config = __webpack_require__(25289);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-icons-text-and-asset/side-by-side-with-icons-text-and-asset-advanced-config.js
function side_by_side_with_icons_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_with_icons_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_with_icons_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_with_icons_text_and_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_with_icons_text_and_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_with_icons_text_and_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_with_icons_text_and_asset_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_with_icons_text_and_asset_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_with_icons_text_and_asset_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var swapTextAndAssetPosition = side_by_side_text_and_asset_fields_config/* default.swapTextAndAssetPosition */.Z.swapTextAndAssetPosition, fullParagraph = side_by_side_text_and_asset_fields_config/* default.fullParagraph */.Z.fullParagraph, side_by_side_with_icons_text_and_asset_advanced_config_asset = side_by_side_text_and_asset_fields_config/* default.asset */.Z.asset, side_by_side_with_icons_text_and_asset_advanced_config_selectedSideBySideTextAndAssetFieldsConfig = side_by_side_with_icons_text_and_asset_advanced_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "swapTextAndAssetPosition",
    "fullParagraph",
    "asset"
]);
/* harmony default export */ var side_by_side_with_icons_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_with_icons_text_and_asset_advanced_config_object_spread_props(side_by_side_with_icons_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_fields_config/* default */.Z, asset_advanced_field_config/* default */.Z, side_by_side_with_icons_text_and_asset_advanced_config_selectedSideBySideTextAndAssetFieldsConfig, advanced_field_config/* default */.Z), {
        mobileMarginBetweenAssetAndButton: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Margin above button in mobile version"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-icons-text-and-asset/index.js



/* harmony default export */ var side_by_side_with_icons_text_and_asset = ({
    SideBySideWithIconsTextAndAssetComponent: side_by_side_with_icons_text_and_asset_component,
    SideBySideWithIconsTextAndAssetConfig: side_by_side_with_icons_text_and_asset_config,
    SideBySideWithIconsTextAndAssetAdvancedConfig: side_by_side_with_icons_text_and_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/board-tabs/fields-config.js
var board_tabs_fields_config = __webpack_require__(55209);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/board-tab-text-and-asset/board-tab-text-and-asset-config.js
function board_tab_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function board_tab_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            board_tab_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function board_tab_text_and_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function board_tab_text_and_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        board_tab_text_and_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function board_tab_text_and_asset_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = board_tab_text_and_asset_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function board_tab_text_and_asset_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var board_tab_text_and_asset_config_asset = side_by_side_text_and_asset_fields_config/* default.asset */.Z.asset, board_tab_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig = board_tab_text_and_asset_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "asset"
]);
/* harmony default export */ var board_tab_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Board tab side by side",
    fields: board_tab_text_and_asset_config_object_spread_props(board_tab_text_and_asset_config_object_spread({}, theme_config/* default */.Z, board_tab_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig), {
        boardTabsProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Board tabs",
            fields: board_tabs_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/board-tab-text-and-asset/board-tab-text-and-asset-advanced-config.js
function board_tab_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function board_tab_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            board_tab_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}




/* harmony default export */ var board_tab_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: board_tab_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_field_config/* default */.Z, advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/board-tab-text-and-asset/index.js



var BoardTabTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3663).then(__webpack_require__.bind(__webpack_require__, 13663));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(13663)
            ];
        }
    }
});
/* harmony default export */ var board_tab_text_and_asset = ({
    BoardTabTextAndAssetComponent: BoardTabTextAndAssetComponent,
    BoardTabTextAndAssetConfig: board_tab_text_and_asset_config,
    BoardTabTextAndAssetAdvancedConfig: board_tab_text_and_asset_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/youtube-two-thirds-text-and-asset/youtube-two-thirds-text-and-asset-config.js
function youtube_two_thirds_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function youtube_two_thirds_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            youtube_two_thirds_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function youtube_two_thirds_text_and_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function youtube_two_thirds_text_and_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        youtube_two_thirds_text_and_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function youtube_two_thirds_text_and_asset_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = youtube_two_thirds_text_and_asset_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function youtube_two_thirds_text_and_asset_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var youtube_two_thirds_text_and_asset_config_asset = side_by_side_text_and_asset_fields_config/* default.asset */.Z.asset, youtube_two_thirds_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig = youtube_two_thirds_text_and_asset_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "asset"
]);
/* harmony default export */ var youtube_two_thirds_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Youtube Two Thirds",
    fields: youtube_two_thirds_text_and_asset_config_object_spread_props(youtube_two_thirds_text_and_asset_config_object_spread({}, theme_config/* default */.Z, youtube_two_thirds_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig), {
        youtubeWithPosterProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Youtube video",
            fields: youtube_video_with_poster_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/youtube-two-thirds-text-and-asset/youtube-two-thirds-text-and-asset-advanced-config.js
function youtube_two_thirds_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function youtube_two_thirds_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            youtube_two_thirds_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var youtube_two_thirds_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: youtube_two_thirds_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/youtube-two-thirds-text-and-asset/index.js

var YoutubeTwoThirdsTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9129).then(__webpack_require__.bind(__webpack_require__, 79129));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79129)
            ];
        }
    }
});


/* harmony default export */ var youtube_two_thirds_text_and_asset = ({
    YoutubeTwoThirdsTextAndAssetComponent: YoutubeTwoThirdsTextAndAssetComponent,
    YoutubeTwoThirdsTextAndAssetConfig: youtube_two_thirds_text_and_asset_config,
    YoutubeTwoThirdsTextAndAssetAdvancedConfig: youtube_two_thirds_text_and_asset_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/asymmetric-side-by-side-text-and-asset/asymmetric-side-by-side-text-and-asset-config.js
function asymmetric_side_by_side_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function asymmetric_side_by_side_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            asymmetric_side_by_side_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function asymmetric_side_by_side_text_and_asset_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = asymmetric_side_by_side_text_and_asset_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function asymmetric_side_by_side_text_and_asset_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var asymmetric_side_by_side_text_and_asset_config_background = side_by_side_text_and_asset_fields_config/* default.background */.Z.background, asymmetric_side_by_side_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig = asymmetric_side_by_side_text_and_asset_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "background"
]);
/* harmony default export */ var asymmetric_side_by_side_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Asymmetric Side By Side",
    fields: asymmetric_side_by_side_text_and_asset_config_object_spread({}, theme_config/* default */.Z, asymmetric_side_by_side_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/asymmetric-side-by-side-text-and-asset/asymmetric-side-by-side-text-and-asset-advanced-config.js
function asymmetric_side_by_side_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function asymmetric_side_by_side_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            asymmetric_side_by_side_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}





/* harmony default export */ var asymmetric_side_by_side_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: asymmetric_side_by_side_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_fields_config/* default */.Z, asset_advanced_field_config/* default */.Z, advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/asymmetric-side-by-side-text-and-asset/index.js

var AsymmetricSideBySideTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6071).then(__webpack_require__.bind(__webpack_require__, 56071));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56071)
            ];
        }
    }
});


/* harmony default export */ var asymmetric_side_by_side_text_and_asset = ({
    AsymmetricSideBySideTextAndAssetComponent: AsymmetricSideBySideTextAndAssetComponent,
    AsymmetricSideBySideTextAndAssetConfig: asymmetric_side_by_side_text_and_asset_config,
    AsymmetricSideBySideTextAndAssetAdvancedConfig: asymmetric_side_by_side_text_and_asset_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/person-info/fields-config.js

/* harmony default export */ var person_info_fields_config = ({
    name: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Person Name"
    },
    jobDescription: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Job Description",
        translatable: true
    },
    personImg: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Person Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select Person Image"
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)"
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/testimonials-quote/fields-config.js

/* harmony default export */ var testimonials_quote_fields_config = ({
    testimonial: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Testimonials",
        textArea: true,
        translatable: true
    },
    removeQuote: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Remove quote background"
    },
    quoteFontSize: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Testimonial font size"
    },
    quoteLineHeight: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Testimonial line height"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/full-testimonials-quote/fields-config.js
function fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function fields_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function fields_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        fields_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var full_testimonials_quote_fields_config = (fields_config_object_spread_props(fields_config_object_spread({}, fields_config/* default */.Z), {
    testimonialsConfig: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Testimonials config",
        fields: testimonials_quote_fields_config
    },
    personConfig: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Person config",
        fields: person_info_fields_config
    },
    maxWidth: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Testimonial max width"
    }
}));

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/testimonials-text-and-asset/testimonials-text-and-asset-config.js
function testimonials_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function testimonials_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            testimonials_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function testimonials_text_and_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function testimonials_text_and_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        testimonials_text_and_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var testimonials_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Testimonials Side By Side",
    fields: testimonials_text_and_asset_config_object_spread_props(testimonials_text_and_asset_config_object_spread({}, side_by_side_text_and_asset_fields_config/* default */.Z), {
        youtubeWithPosterProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Youtube video",
            fields: youtube_video_with_poster_fields_config/* default */.Z
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "FullTestimonialsQuoteFieldsConfig",
            fields: full_testimonials_quote_fields_config
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var title_advanced_field_config = __webpack_require__(95760);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/testimonials-text-and-asset/testimonials-text-and-asset-advanced-config.js
function testimonials_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function testimonials_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            testimonials_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}




/* harmony default export */ var testimonials_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: testimonials_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, title_advanced_field_config/* default */.Z, asset_advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/testimonials-text-and-asset/index.js

var TestimonialsTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7979).then(__webpack_require__.bind(__webpack_require__, 17979));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17979)
            ];
        }
    }
});


/* harmony default export */ var testimonials_text_and_asset = ({
    TestimonialsTextAndAssetComponent: TestimonialsTextAndAssetComponent,
    TestimonialsTextAndAssetConfig: testimonials_text_and_asset_config,
    TestimonialsTextAndAssetAdvancedConfig: testimonials_text_and_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/bullets/fields-config.js
var bullets_fields_config = __webpack_require__(61204);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-bullets-text-and-asset/side-by-side-with-bullets-text-and-asset-config.js
function side_by_side_with_bullets_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_with_bullets_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_with_bullets_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_with_bullets_text_and_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_with_bullets_text_and_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_with_bullets_text_and_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_with_bullets_text_and_asset_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_with_bullets_text_and_asset_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_with_bullets_text_and_asset_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var side_by_side_with_bullets_text_and_asset_config_background = side_by_side_text_and_asset_fields_config/* default.background */.Z.background, side_by_side_with_bullets_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig = side_by_side_with_bullets_text_and_asset_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "background"
]);
/* harmony default export */ var side_by_side_with_bullets_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side with Bullets",
    fields: side_by_side_with_bullets_text_and_asset_config_object_spread_props(side_by_side_with_bullets_text_and_asset_config_object_spread({}, side_by_side_with_bullets_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig), {
        bulletsConfig: bullets_fields_config/* default */.Z
    })
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-bullets-text-and-asset/side-by-side-with-bullets-text-and-asset-advanced-config.js
function side_by_side_with_bullets_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_with_bullets_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_with_bullets_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_with_bullets_text_and_asset_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_with_bullets_text_and_asset_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_with_bullets_text_and_asset_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var side_by_side_with_bullets_text_and_asset_advanced_config_swapTextAndAssetPosition = side_by_side_text_and_asset_fields_config/* default.swapTextAndAssetPosition */.Z.swapTextAndAssetPosition, side_by_side_with_bullets_text_and_asset_advanced_config_fullParagraph = side_by_side_text_and_asset_fields_config/* default.fullParagraph */.Z.fullParagraph, side_by_side_with_bullets_text_and_asset_advanced_config_asset = side_by_side_text_and_asset_fields_config/* default.asset */.Z.asset, side_by_side_with_bullets_text_and_asset_advanced_config_selectedSideBySideTextAndAssetFieldsConfig = side_by_side_with_bullets_text_and_asset_advanced_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "swapTextAndAssetPosition",
    "fullParagraph",
    "asset"
]);
/* harmony default export */ var side_by_side_with_bullets_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_with_bullets_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_fields_config/* default */.Z, asset_advanced_field_config/* default */.Z, side_by_side_with_bullets_text_and_asset_advanced_config_selectedSideBySideTextAndAssetFieldsConfig, advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-bullets-text-and-asset/index.js

var SideBySideWithBulletsTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7095).then(__webpack_require__.bind(__webpack_require__, 97095));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97095)
            ];
        }
    }
});


/* harmony default export */ var side_by_side_with_bullets_text_and_asset = ({
    SideBySideWithBulletsTextAndAssetComponent: SideBySideWithBulletsTextAndAssetComponent,
    SideBySideWithBulletsTextAndAssetConfig: side_by_side_with_bullets_text_and_asset_config,
    SideBySideWithBulletsTextAndAssetAdvancedConfig: side_by_side_with_bullets_text_and_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-config.js
var two_thirds_text_and_asset_config = __webpack_require__(49133);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-advanced-config.js
function two_thirds_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function two_thirds_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            two_thirds_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function two_thirds_text_and_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function two_thirds_text_and_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        two_thirds_text_and_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var two_thirds_text_and_asset_advanced_config_background = side_by_side_text_and_asset_fields_config/* default.background */.Z.background;
/* harmony default export */ var two_thirds_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: two_thirds_text_and_asset_advanced_config_object_spread_props(two_thirds_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_fields_config/* default */.Z, asset_advanced_field_config/* default */.Z, advanced_field_config/* default */.Z), {
        background: two_thirds_text_and_asset_advanced_config_background
    })
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/index.js

var TwoThirdsTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2968).then(__webpack_require__.bind(__webpack_require__, 32968));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32968)
            ];
        }
    }
});


/* harmony default export */ var two_thirds_text_and_asset = ({
    TwoThirdsTextAndAssetComponent: TwoThirdsTextAndAssetComponent,
    TwoThirdsTextAndAssetConfig: two_thirds_text_and_asset_config/* default */.Z,
    TwoThirdsTextAndAssetAdvancedConfig: two_thirds_text_and_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/full-background-text-and-asset/fields-config.js
var full_background_text_and_asset_fields_config = __webpack_require__(55782);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/full-background-text-and-asset/full-background-text-and-asset-config.js
function full_background_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function full_background_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            full_background_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var full_background_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Full Background",
    fields: full_background_text_and_asset_config_object_spread({
        paragraphVerticalAlignment: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Paragraph Vertical Alignment",
            options: [
                "top",
                "center",
                "bottom"
            ]
        }
    }, theme_config/* default */.Z, full_background_text_and_asset_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/full-background-text-and-asset/full-background-text-and-asset-advanced-config.js
function full_background_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function full_background_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            full_background_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function full_background_text_and_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function full_background_text_and_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        full_background_text_and_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var full_background_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: full_background_text_and_asset_advanced_config_object_spread(full_background_text_and_asset_advanced_config_object_spread_props(full_background_text_and_asset_advanced_config_object_spread({
        height: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Height"
        }
    }, shared_advanced_fields_config/* default */.Z), {
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: advanced_fields_config/* default */.Z
        },
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        }
    }), asset_advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/full-background-text-and-asset/index.js

var FullBackgroundTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4925).then(__webpack_require__.bind(__webpack_require__, 54925));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(54925)
            ];
        }
    }
});


/* harmony default export */ var full_background_text_and_asset = ({
    FullBackgroundTextAndAssetComponent: FullBackgroundTextAndAssetComponent,
    FullBackgroundTextAndAssetConfig: full_background_text_and_asset_config,
    FullBackgroundTextAndAssetAdvancedConfig: full_background_text_and_asset_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-background-text-and-asset/side-by-side-with-background-text-and-asset-config.js


/* harmony default export */ var side_by_side_with_background_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side With Background",
    fields: side_by_side_text_and_asset_fields_config/* default */.Z
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-background-text-and-asset/side-by-side-with-background-text-and-asset-advanced-config.js
function side_by_side_with_background_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_with_background_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_with_background_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}





/* harmony default export */ var side_by_side_with_background_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_with_background_text_and_asset_advanced_config_object_spread({
        minHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Min Height (new)"
        }
    }, shared_advanced_fields_config/* default */.Z, advanced_fields_config/* default */.Z, asset_advanced_field_config/* default */.Z, advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-background-text-and-asset/index.js

var SideBySideWithBackgroundTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5600).then(__webpack_require__.bind(__webpack_require__, 95600));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95600)
            ];
        }
    }
});


/* harmony default export */ var side_by_side_with_background_text_and_asset = ({
    SideBySideWithBackgroundTextAndAssetComponent: SideBySideWithBackgroundTextAndAssetComponent,
    SideBySideWithBackgroundTextAndAssetConfig: side_by_side_with_background_text_and_asset_config,
    SideBySideWithBackgroundTextAndAssetAdvancedConfig: side_by_side_with_background_text_and_asset_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-config.js
function side_by_side_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_text_and_asset_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_text_and_asset_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_text_and_asset_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var side_by_side_text_and_asset_config_background = side_by_side_text_and_asset_fields_config/* default.background */.Z.background, side_by_side_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig = side_by_side_text_and_asset_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "background"
]);
/* harmony default export */ var side_by_side_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side",
    fields: side_by_side_text_and_asset_config_object_spread({}, theme_config/* default */.Z, side_by_side_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-advanced-config.js
function side_by_side_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_text_and_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_text_and_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_text_and_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






/* harmony default export */ var side_by_side_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_text_and_asset_advanced_config_object_spread_props(side_by_side_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.Z, advanced_fields_config/* default */.Z, asset_advanced_field_config/* default */.Z, advanced_field_config/* default */.Z), {
        nestedBoardItems: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Embedded Board",
            fields: {
                addLiveBoardTextAndAsset: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Add Live Board Experience"
                },
                boardBannerText: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Board Banner Text",
                    translatable: true
                },
                embeddedBoardTitle: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Embedded Board Title",
                    translatable: true
                },
                addSecondLiveBoardSignUpButton: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Add Second Sign Up Button In The Live Board"
                },
                liveBoardToolTipText: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Live Board Tooltip Text"
                },
                parallaxAsset: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Parallax Asset- IN TEST - DON'T USE",
                    fields: side_by_side_text_and_asset_advanced_config_object_spread({
                        position: {
                            type: template_field_type.FIELD_TYPES.COMBO,
                            label: "Position",
                            options: [
                                "top",
                                "center",
                                "bottom"
                            ]
                        },
                        fitToContainer: {
                            type: template_field_type.FIELD_TYPES.BOOLEAN,
                            label: "Fit to container"
                        }
                    }, asset_fields_config/* default */.Z)
                },
                gapBetweenAssets: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Gap Between Assets(px)"
                },
                fullParagraphMarginTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Full Paragraph Margin Top"
                },
                fullParagraphMarginBottom: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Full Paragraph Margin Bottom"
                },
                fullParagraphDistanceFromTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Full Paragraph Distance From Top When Parallax"
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/index.js

var SideBySideTextAndAssetComponent = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 8150));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8150)
            ];
        }
    }
});


/* harmony default export */ var side_by_side_text_and_asset = ({
    SideBySideTextAndAssetComponent: SideBySideTextAndAssetComponent,
    SideBySideTextAndAssetConfig: side_by_side_text_and_asset_config,
    SideBySideTextAndAssetAdvancedConfig: side_by_side_text_and_asset_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/index.js
// plop_marker:layouts_import













/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    ProductCardsSideBySideTextAndAsset: product_cards_side_by_side_text_and_asset,
    WhatsNewInnerPageSideBySideTextAndAsset: whats_new_inner_page_side_by_side_text_and_asset,
    YoutubeTextAndAsset: youtube_text_and_asset,
    SideBySideWithIconsTextAndAsset: side_by_side_with_icons_text_and_asset,
    BoardTabTextAndAsset: board_tab_text_and_asset,
    TwoThirdsTextAndAsset: two_thirds_text_and_asset,
    FullBackgroundTextAndAsset: full_background_text_and_asset,
    SideBySideWithBackgroundTextAndAsset: side_by_side_with_background_text_and_asset,
    SideBySideTextAndAsset: side_by_side_text_and_asset,
    YoutubeTwoThirdsTextAndAsset: youtube_two_thirds_text_and_asset,
    AsymmetricSideBySideTextAndAsset: asymmetric_side_by_side_text_and_asset,
    SideBySideWithBulletsTextAndAsset: side_by_side_with_bullets_text_and_asset,
    TestimonialsTextAndAsset: testimonials_text_and_asset
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/index.js

var ProductCardsSideBySideTextAndAsset = layouts.ProductCardsSideBySideTextAndAsset, WhatsNewInnerPageSideBySideTextAndAsset = layouts.WhatsNewInnerPageSideBySideTextAndAsset, YoutubeTextAndAsset = layouts.YoutubeTextAndAsset, text_and_asset_SideBySideWithIconsTextAndAsset = layouts.SideBySideWithIconsTextAndAsset, BoardTabTextAndAsset = layouts.BoardTabTextAndAsset, YoutubeTwoThirdsTextAndAsset = layouts.YoutubeTwoThirdsTextAndAsset, AsymmetricSideBySideTextAndAsset = layouts.AsymmetricSideBySideTextAndAsset, TestimonialsTextAndAsset = layouts.TestimonialsTextAndAsset, SideBySideWithBulletsTextAndAsset = layouts.SideBySideWithBulletsTextAndAsset, TwoThirdsTextAndAsset = layouts.TwoThirdsTextAndAsset, FullBackgroundTextAndAsset = layouts.FullBackgroundTextAndAsset, SideBySideWithBackgroundTextAndAsset = layouts.SideBySideWithBackgroundTextAndAsset, SideBySideTextAndAsset = layouts.SideBySideTextAndAsset;
/* harmony default export */ var text_and_asset = ({
    // plop_marker:segment_index_add_layout
    ProductCardsSideBySideTextAndAssetComponent: {
        type: "ProductCardsSideBySideTextAndAssetComponent",
        title: "Product Cards Side By Side",
        imgSrc: "/static/img/segments/layouts/product-cards-side-by-side-text-and-asset.png",
        config: ProductCardsSideBySideTextAndAsset.ProductCardsSideBySideTextAndAssetConfig,
        advancedConfig: ProductCardsSideBySideTextAndAsset.ProductCardsSideBySideTextAndAssetAdvancedConfig,
        component: ProductCardsSideBySideTextAndAsset.ProductCardsSideBySideTextAndAssetComponent
    },
    WhatsNewInnerPageSideBySideTextAndAssetComponent: {
        type: "WhatsNewInnerPageSideBySideTextAndAssetComponent",
        title: "Whats New Inner Page Side By Side",
        imgSrc: "/static/img/segments/layouts/whats-new-inner-page-side-by-side-text-and-asset.png",
        config: WhatsNewInnerPageSideBySideTextAndAsset.WhatsNewInnerPageSideBySideTextAndAssetConfig,
        advancedConfig: WhatsNewInnerPageSideBySideTextAndAsset.WhatsNewInnerPageSideBySideTextAndAssetAdvancedConfig,
        component: WhatsNewInnerPageSideBySideTextAndAsset.WhatsNewInnerPageSideBySideTextAndAssetComponent
    },
    YoutubeTextAndAssetComponent: {
        type: "YoutubeTextAndAssetComponent",
        title: "Youtube",
        imgSrc: "/static/img/segments/layouts/youtube-text-and-asset.png",
        config: YoutubeTextAndAsset.YoutubeTextAndAssetConfig,
        advancedConfig: YoutubeTextAndAsset.YoutubeTextAndAssetAdvancedConfig,
        component: YoutubeTextAndAsset.YoutubeTextAndAssetComponent
    },
    SideBySideWithIconsTextAndAssetComponent: {
        type: "SideBySideWithIconsTextAndAssetComponent",
        title: "Side By Side With Icons",
        imgSrc: "/static/img/segments/layouts/side-by-side-with-icons-text-and-asset.png",
        config: text_and_asset_SideBySideWithIconsTextAndAsset.SideBySideWithIconsTextAndAssetConfig,
        advancedConfig: text_and_asset_SideBySideWithIconsTextAndAsset.SideBySideWithIconsTextAndAssetAdvancedConfig,
        component: text_and_asset_SideBySideWithIconsTextAndAsset.SideBySideWithIconsTextAndAssetComponent
    },
    BoardTabTextAndAssetComponent: {
        type: "BoardTabTextAndAssetComponent",
        title: "Board Tab",
        imgSrc: "/static/img/segments/layouts/board-tab-text-and-asset.png",
        config: BoardTabTextAndAsset.BoardTabTextAndAssetConfig,
        advancedConfig: BoardTabTextAndAsset.BoardTabTextAndAssetAdvancedConfig,
        component: BoardTabTextAndAsset.BoardTabTextAndAssetComponent
    },
    YoutubeTwoThirdsTextAndAssetComponent: {
        type: "YoutubeTwoThirdsTextAndAssetComponent",
        title: "Youtube Two Thirds",
        imgSrc: "/static/img/segments/layouts/youtube-two-thirds-text-and-asset.png",
        config: YoutubeTwoThirdsTextAndAsset.YoutubeTwoThirdsTextAndAssetConfig,
        advancedConfig: YoutubeTwoThirdsTextAndAsset.YoutubeTwoThirdsTextAndAssetAdvancedConfig,
        component: YoutubeTwoThirdsTextAndAsset.YoutubeTwoThirdsTextAndAssetComponent
    },
    AsymmetricSideBySideTextAndAssetComponent: {
        type: "AsymmetricSideBySideTextAndAssetComponent",
        title: "Asymmetric Side By Side",
        imgSrc: "/static/img/segments/layouts/asymmetric-side-by-side-text-and-asset.png",
        config: AsymmetricSideBySideTextAndAsset.AsymmetricSideBySideTextAndAssetConfig,
        advancedConfig: AsymmetricSideBySideTextAndAsset.AsymmetricSideBySideTextAndAssetAdvancedConfig,
        component: AsymmetricSideBySideTextAndAsset.AsymmetricSideBySideTextAndAssetComponent
    },
    TestimonialsTextAndAssetComponent: {
        type: "TestimonialsTextAndAssetComponent",
        title: "Testimonials",
        imgSrc: "/static/img/segments/layouts/testimonials-text-and-asset.png",
        config: TestimonialsTextAndAsset.TestimonialsTextAndAssetConfig,
        advancedConfig: TestimonialsTextAndAsset.TestimonialsTextAndAssetAdvancedConfig,
        component: TestimonialsTextAndAsset.TestimonialsTextAndAssetComponent
    },
    SideBySideWithBulletsTextAndAssetComponent: {
        type: "SideBySideWithBulletsTextAndAssetComponent",
        title: "Side By Side With Bullets",
        imgSrc: "/static/img/segments/layouts/side-by-side-with-bullets-text-and-asset.png",
        config: SideBySideWithBulletsTextAndAsset.SideBySideWithBulletsTextAndAssetConfig,
        advancedConfig: SideBySideWithBulletsTextAndAsset.SideBySideWithBulletsTextAndAssetAdvancedConfig,
        component: SideBySideWithBulletsTextAndAsset.SideBySideWithBulletsTextAndAssetComponent
    },
    TwoThirdsTextAndAssetComponent: {
        type: "TwoThirdsTextAndAssetComponent",
        title: "Two Thirds",
        imgSrc: "/static/img/segments/layouts/two-thirds-text-and-asset.png",
        config: TwoThirdsTextAndAsset.TwoThirdsTextAndAssetConfig,
        advancedConfig: TwoThirdsTextAndAsset.TwoThirdsTextAndAssetAdvancedConfig,
        component: TwoThirdsTextAndAsset.TwoThirdsTextAndAssetComponent
    },
    FullBackgroundTextAndAssetComponent: {
        type: "FullBackgroundTextAndAssetComponent",
        title: "Full Background",
        imgSrc: "/static/img/segments/layouts/full-background-text-and-asset.png",
        config: FullBackgroundTextAndAsset.FullBackgroundTextAndAssetConfig,
        advancedConfig: FullBackgroundTextAndAsset.FullBackgroundTextAndAssetAdvancedConfig,
        component: FullBackgroundTextAndAsset.FullBackgroundTextAndAssetComponent
    },
    SideBySideWithBackgroundTextAndAssetComponent: {
        type: "SideBySideWithBackgroundTextAndAssetComponent",
        title: "Side By Side With Background",
        imgSrc: "/static/img/segments/layouts/side-by-side-with-background-text-and-asset.png",
        config: SideBySideWithBackgroundTextAndAsset.SideBySideWithBackgroundTextAndAssetConfig,
        advancedConfig: SideBySideWithBackgroundTextAndAsset.SideBySideWithBackgroundTextAndAssetAdvancedConfig,
        component: SideBySideWithBackgroundTextAndAsset.SideBySideWithBackgroundTextAndAssetComponent
    },
    SideBySideTextAndAssetComponent: {
        type: "SideBySideTextAndAssetComponent",
        title: "Side By Side",
        imgSrc: "/static/img/segments/layouts/side-by-side-text-and-asset.png",
        config: SideBySideTextAndAsset.SideBySideTextAndAssetConfig,
        advancedConfig: SideBySideTextAndAsset.SideBySideTextAndAssetAdvancedConfig,
        component: SideBySideTextAndAsset.SideBySideTextAndAssetComponent
    }
});


/***/ }),

/***/ 38305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77869);
/* harmony import */ var constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65832);
/* harmony import */ var segments_desktop_core_components_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91841);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, segments_desktop_core_components_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z), {
    paddingTop: "64px",
    paddingBottom: "64px",
    titleSize: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD,
    textSize: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD,
    assetQuality: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_2__.AUTO,
    nestedBoardItems: {
        //props that are relevant only if the live board experience is added
        addLiveBoardTextAndAsset: false,
        boardBannerText: "Sign up for free to gain full access to all features",
        embeddedBoardTitle: "Project plan",
        addSecondLiveBoardSignUpButton: false
    }
}));


/***/ }),

/***/ 8150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SideBySideTextAndAssetComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var segments_desktop_core_components_side_by_side_text_and_asset_side_by_side_text_and_asset__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25641);
/* harmony import */ var _default_props__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38305);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




var SideBySideTextAndAssetComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(SideBySideTextAndAssetComponent, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(SideBySideTextAndAssetComponent);
    function SideBySideTextAndAssetComponent() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, SideBySideTextAndAssetComponent);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(SideBySideTextAndAssetComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "side-by-side-text-and-asset-component",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(segments_desktop_core_components_side_by_side_text_and_asset_side_by_side_text_and_asset__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, this.props))
                });
            }
        }
    ]);
    return SideBySideTextAndAssetComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

SideBySideTextAndAssetComponent.defaultProps = _default_props__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;


/***/ }),

/***/ 49133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_side_by_side_text_and_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93097);
/* harmony import */ var segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60633);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var background = segments_desktop_core_components_side_by_side_text_and_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"].background */ .Z.background, selectedSideBySideTextAndAssetFieldsConfig = _object_without_properties(segments_desktop_core_components_side_by_side_text_and_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, [
    "background"
]);
/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Two Thirds",
    fields: _object_spread({}, segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, selectedSideBySideTextAndAssetFieldsConfig)
});


/***/ }),

/***/ 28586:
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(79658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
var _inherits = (__webpack_require__(97788)/* ["default"] */ .Z);
var _createSuper = (__webpack_require__(37735)/* ["default"] */ .Z);
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var trackBigBrainEventOnServer = (__webpack_require__(75422).trackBigBrainEventOnServer);
var BaseDataProvider = (__webpack_require__(73645).BaseDataProvider);
var ProviderKeys = __webpack_require__(15071);
var PLATFORM_SERVICE_HOST = "https://auth.monday.com";
var MONDAY_SOLUTIONS_ENDPOINT = "monday_solutions";
var MONDAY_SOLUTIONS_FETCH_SUCCESS = "monday_solutions_fetch_success";
var MONDAY_SOLUTIONS_FETCH_ERROR = "monday_solutions_fetch_error";
var LOCALE_PARAM_NAME = "locale";
var SolutionsDataProvider = /*#__PURE__*/ function(BaseDataProvider) {
    "use strict";
    _inherits(SolutionsDataProvider, BaseDataProvider);
    var _super = _createSuper(SolutionsDataProvider);
    function SolutionsDataProvider(params) {
        _classCallCheck(this, SolutionsDataProvider);
        return _super.call(this, params);
    }
    _createClass(SolutionsDataProvider, [
        {
            key: "key",
            value: function key() {
                var localeId = this.params().localeId;
                return "".concat(ProviderKeys.SOLUTIONS_DATA, "_locale_").concat(localeId);
            }
        },
        {
            key: "getData",
            value: function getData() {
                var _this = this;
                return _async_to_generator(function() {
                    var localeId, options, url, res, response, e;
                    return _tsGenerator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                localeId = _this.params().localeId;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                options = {
                                    headers: {
                                        "Content-Type": "application/json"
                                    },
                                    method: "GET"
                                };
                                url = new URL("".concat(MONDAY_SOLUTIONS_ENDPOINT, "?").concat(LOCALE_PARAM_NAME, "=").concat(localeId), PLATFORM_SERVICE_HOST).href;
                                return [
                                    4,
                                    fetch(url, options)
                                ];
                            case 2:
                                res = _state.sent();
                                if (!(res.status === 200)) return [
                                    3,
                                    4
                                ];
                                trackBigBrainEventOnServer(MONDAY_SOLUTIONS_FETCH_SUCCESS);
                                return [
                                    4,
                                    res.json()
                                ];
                            case 3:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                            case 4:
                                throw new Error(res.statusText);
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e = _state.sent();
                                trackBigBrainEventOnServer(MONDAY_SOLUTIONS_FETCH_ERROR, {
                                    direct_object: e.message
                                });
                                console.error(e.message);
                                throw e;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return SolutionsDataProvider;
}(BaseDataProvider);
module.exports = SolutionsDataProvider;


/***/ }),

/***/ 40469:
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var SolutionsDataProvider = __webpack_require__(28586);
var getCachedData = (__webpack_require__(73645).getCachedData);
var getMondaySolutionData = function() {
    var _ref = _async_to_generator(function(localeId) {
        var provider, data;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    provider = new SolutionsDataProvider({
                        localeId: localeId
                    });
                    return [
                        4,
                        getCachedData(provider)
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getMondaySolutionData(localeId) {
        return _ref.apply(this, arguments);
    };
}();
var getMondaySolutionById = function() {
    var _ref = _async_to_generator(function(param) {
        var localeId, solutionId, solutions, solution;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    localeId = param.localeId, solutionId = param.solutionId;
                    return [
                        4,
                        getMondaySolutionData(localeId)
                    ];
                case 1:
                    solutions = _state.sent().solutions;
                    solution = solutions.find(function(param) {
                        var id = param.id;
                        return "".concat(id) === "".concat(solutionId);
                    });
                    return [
                        2,
                        solution
                    ];
            }
        });
    });
    return function getMondaySolutionById(_) {
        return _ref.apply(this, arguments);
    };
}();
module.exports = {
    getMondaySolutionData: getMondaySolutionData,
    getMondaySolutionById: getMondaySolutionById
};


/***/ }),

/***/ 90215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Aq": function() { return /* binding */ migrateExistingTranslations; },
/* harmony export */   "Ed": function() { return /* binding */ getPageExists; },
/* harmony export */   "IS": function() { return /* binding */ restorePage; },
/* harmony export */   "OP": function() { return /* binding */ fetchAbTestsData; },
/* harmony export */   "Po": function() { return /* binding */ startAbTest; },
/* harmony export */   "RC": function() { return /* binding */ createAbTest; },
/* harmony export */   "Sz": function() { return /* binding */ getSolutions; },
/* harmony export */   "U$": function() { return /* binding */ fetchTranslatedPages; },
/* harmony export */   "YS": function() { return /* binding */ createTranslationJobs; },
/* harmony export */   "fD": function() { return /* binding */ removePage; },
/* harmony export */   "fx": function() { return /* binding */ getPage; },
/* harmony export */   "r7": function() { return /* binding */ refreshTranslationJobsStatus; },
/* harmony export */   "rK": function() { return /* binding */ getOrCreatePageModel; },
/* harmony export */   "st": function() { return /* binding */ publishPage; },
/* harmony export */   "xK": function() { return /* binding */ stopAbTest; },
/* harmony export */   "zM": function() { return /* binding */ fetchDraftConfig; },
/* harmony export */   "zd": function() { return /* binding */ getClusters; },
/* harmony export */   "zt": function() { return /* binding */ getSolutionById; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10092);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var URL_BASE = "https://monday.com";
var LOCAL_URL_BASE = "http://localhost:5000";
var DEFAULT_FETCH_OPTIONS = {
    credentials: "same-origin",
    headers: {
        "Content-Type": "application/json"
    }
};
var baseFetch = function(url, options) {
    return fetch(url, _object_spread({}, DEFAULT_FETCH_OPTIONS, options));
};
var getPage = function(path, options) {
    var isServer = !true;
    var baseUrl = isServer ? LOCAL_URL_BASE : URL_BASE;
    return baseFetch("".concat(baseUrl, "/get-page-config?path=").concat(path));
};
var getPageExists = function(path, options) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/generated-page-exists?path=").concat(path));
};
var removePage = function(path) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/remove-page?path=").concat(path), {
        method: "POST"
    });
};
var publishPage = function(pageConfig) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/publish"), {
        method: "POST",
        body: JSON.stringify({
            pageConfig: pageConfig
        })
    });
};
var restorePage = function(path, historyIndex) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/restore-page"), {
        method: "POST",
        body: JSON.stringify({
            path: path,
            historyIndex: historyIndex
        })
    });
};
var getOrCreatePageModel = function(path) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/get-or-create-page"), {
        method: "POST",
        body: JSON.stringify({
            path: path
        })
    });
};
var migrateExistingTranslations = function(path) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/migrate-existing-translations"), {
        method: "POST",
        body: JSON.stringify({
            path: path
        })
    });
};
var fetchTranslatedPages = function(filter) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/get-translated-pages?filter=").concat(filter), {
        method: "GET"
    });
};
var createTranslationJobs = function(path, languages, translationStrategy) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/create-translation-jobs"), {
        method: "POST",
        body: JSON.stringify({
            path: path,
            languages: languages,
            translationStrategy: translationStrategy
        })
    });
};
var refreshTranslationJobsStatus = function() {
    var _ref = _async_to_generator(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function(_state) {
            return [
                2,
                baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/refresh-translation-jobs-status"), {
                    method: "POST"
                })
            ];
        });
    });
    return function refreshTranslationJobsStatus() {
        return _ref.apply(this, arguments);
    };
}();
var fetchDraftConfig = function(translationJobId) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/get-translation-job/").concat(translationJobId, "/draft-config"), {
        method: "GET"
    });
};
var createAbTest = function(abTestData) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/create-ab-test"), {
        method: "POST",
        body: JSON.stringify({
            abTestData: abTestData
        })
    });
};
var fetchAbTestsData = function() {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/fetch-ab-tests-data"), {
        method: "GET"
    });
};
var startAbTest = function(abTestId) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/start-ab-test"), {
        method: "POST",
        body: JSON.stringify({
            abTestId: abTestId
        })
    });
};
var stopAbTest = function(abTestId) {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/stop-ab-test"), {
        method: "POST",
        body: JSON.stringify({
            abTestId: abTestId
        })
    });
};
var getClusters = function() {
    return baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/get-clusters"), {
        method: "GET"
    });
};
var getSolutions = function() {
    var _ref = _async_to_generator(function() {
        var res, solutions;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/get-solutions"), {
                            method: "GET"
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    solutions = _state.sent();
                    return [
                        2,
                        solutions
                    ];
            }
        });
    });
    return function getSolutions() {
        return _ref.apply(this, arguments);
    };
}();
var getSolutionById = function() {
    var _ref = _async_to_generator(function(param) {
        var solutionId, localeId, res, solution;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    solutionId = param.solutionId, localeId = param.localeId;
                    return [
                        4,
                        baseFetch("".concat(URL_BASE, "/dynamic/templates-generator/get-solution?localeId=").concat(localeId, "&solutionId=").concat(solutionId), {
                            method: "GET"
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    solution = _state.sent();
                    return [
                        2,
                        solution
                    ];
            }
        });
    });
    return function getSolutionById(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 34949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ap": function() { return /* binding */ fetchDynamicSegmentsRequestFromClient; },
/* harmony export */   "Fb": function() { return /* binding */ getDynamicPropsBySegmentLayoutId; }
/* harmony export */ });
/* unused harmony exports fetchDynamicSegmentsRequestFromServer, getFaqData */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10092);
/* harmony import */ var _server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24730);
/* harmony import */ var _server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_0__);



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var fetchAllRequestsAndPopulateDynamicData = function() {
    var _ref = _async_to_generator(function(param) {
        var segmentsRequest, dynamicData, hasUpdated;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    segmentsRequest = param.segmentsRequest, dynamicData = param.dynamicData;
                    hasUpdated = false;
                    return [
                        4,
                        Promise.all(segmentsRequest)
                    ];
                case 1:
                    _state.sent().forEach(function(param) {
                        var id = param.id, fetchRes = param.fetchRes, error = param.error, propsPropertyName = param.propsPropertyName;
                        if (!error) {
                            hasUpdated = true;
                            dynamicData[id] = _object_spread_props(_object_spread({}, dynamicData[id] || {}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, propsPropertyName, fetchRes));
                        }
                    });
                    return [
                        2,
                        hasUpdated
                    ];
            }
        });
    });
    return function fetchAllRequestsAndPopulateDynamicData(_) {
        return _ref.apply(this, arguments);
    };
}();
var getAllAvailableDynamicRequestsData = function(param) {
    var pageConfig = param.pageConfig, segmentsDynamicsFetchMapper = param.segmentsDynamicsFetchMapper;
    var requests = (pageConfig.segments || []).reduce(function(accRequests, segment) {
        var segmentLayoutType = segment.type, segmentLayoutProps = segment.props, segmentLayoutId = segment.id;
        var dynamicFetchRequests = segmentsDynamicsFetchMapper[segmentLayoutType];
        if (dynamicFetchRequests) {
            dynamicFetchRequests.forEach(function(fetchRequest) {
                var shouldFetch = fetchRequest.shouldFetch, fetch = fetchRequest.fetch, propsPropertyName = fetchRequest.propsPropertyName;
                accRequests.push({
                    shouldFetch: shouldFetch,
                    fetch: fetch,
                    propsPropertyName: propsPropertyName,
                    segmentLayoutProps: segmentLayoutProps,
                    segmentLayoutId: segmentLayoutId,
                    segmentLayoutType: segmentLayoutType
                });
            });
        }
        ;
        return accRequests;
    }, []);
    return requests;
};
var collectAllRequestsForClient = function(param) {
    var pageConfig = param.pageConfig, segmentsDynamicsFetchMapper = param.segmentsDynamicsFetchMapper, previousPageConfig = param.previousPageConfig;
    var previousPropsBySegmentIds = (previousPageConfig.segments || []).reduce(function(acc, param) {
        var id = param.id, props = param.props;
        acc[id] = props;
        return acc;
    }, {});
    var allRequests = getAllAvailableDynamicRequestsData({
        pageConfig: pageConfig,
        segmentsDynamicsFetchMapper: segmentsDynamicsFetchMapper
    });
    var segmentsRequest = allRequests.reduce(function(accRequests, request) {
        var shouldFetch = request.shouldFetch, fetch = request.fetch, propsPropertyName = request.propsPropertyName, segmentLayoutProps = request.segmentLayoutProps, segmentLayoutId = request.segmentLayoutId;
        if (shouldFetch({
            props: segmentLayoutProps,
            previousProps: previousPropsBySegmentIds[segmentLayoutId] || {},
            pageConfig: pageConfig,
            previousPageConfig: previousPageConfig
        })) {
            accRequests.push(_async_to_generator(function() {
                var fetchRes, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                fetch({
                                    props: segmentLayoutProps,
                                    pageConfig: pageConfig,
                                    isClientFetch: true
                                })
                            ];
                        case 1:
                            fetchRes = _state.sent();
                            return [
                                2,
                                {
                                    id: segmentLayoutId,
                                    fetchRes: fetchRes,
                                    propsPropertyName: propsPropertyName
                                }
                            ];
                        case 2:
                            error = _state.sent();
                            return [
                                2,
                                {
                                    error: error
                                }
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })());
        }
        return accRequests;
    }, []);
    return segmentsRequest;
};
var collectAllRequestsForServer = function(param) {
    var pageConfig = param.pageConfig, segmentsDynamicsFetchMapper = param.segmentsDynamicsFetchMapper, req = param.req, res = param.res;
    var allRequests = getAllAvailableDynamicRequestsData({
        pageConfig: pageConfig,
        segmentsDynamicsFetchMapper: segmentsDynamicsFetchMapper
    });
    var segmentsRequest = allRequests.reduce(function(accRequests, request) {
        var fetch = request.fetch, propsPropertyName = request.propsPropertyName, segmentLayoutProps = request.segmentLayoutProps, segmentLayoutId = request.segmentLayoutId, segmentLayoutType = request.segmentLayoutType;
        accRequests.push(_async_to_generator(function() {
            var fetchRes, error, extraLogParams;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            fetch({
                                props: segmentLayoutProps,
                                pageConfig: pageConfig,
                                isClientFetch: false
                            })
                        ];
                    case 1:
                        fetchRes = _state.sent();
                        return [
                            2,
                            {
                                id: segmentLayoutId,
                                fetchRes: fetchRes,
                                propsPropertyName: propsPropertyName
                            }
                        ];
                    case 2:
                        error = _state.sent();
                        extraLogParams = {
                            segmentLayoutType: segmentLayoutType,
                            segmentLayoutId: segmentLayoutId,
                            fetchProperty: propsPropertyName
                        };
                        (0,_server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_0__.handleServerException)({
                            externalMessage: "Faild to fetch dynamic data on template generator",
                            e: error,
                            req: req,
                            res: res,
                            extraLogParams: extraLogParams
                        });
                        return [
                            2,
                            {
                                error: error
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })());
        return accRequests;
    }, []);
    return segmentsRequest;
};
var fetchDynamicSegmentsRequestFromServer = function() {
    var _ref = _async_to_generator(function(param) {
        var _pageConfig, pageConfig, segmentsDynamicsFetchMapper, req, res, dynamicData, segmentsRequest, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _pageConfig = param.pageConfig, pageConfig = _pageConfig === void 0 ? {} : _pageConfig, segmentsDynamicsFetchMapper = param.segmentsDynamicsFetchMapper, req = param.req, res = param.res;
                    dynamicData = {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    segmentsRequest = collectAllRequestsForServer({
                        pageConfig: pageConfig,
                        segmentsDynamicsFetchMapper: segmentsDynamicsFetchMapper,
                        req: req,
                        res: res
                    });
                    return [
                        4,
                        fetchAllRequestsAndPopulateDynamicData({
                            segmentsRequest: segmentsRequest,
                            dynamicData: dynamicData
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    (0,_server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_0__.handleServerException)({
                        externalMessage: "Fatal error: Faild in the proccess of fetching dynamic data on template generator",
                        e: error,
                        req: req,
                        res: res
                    });
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        {
                            dynamicData: dynamicData
                        }
                    ];
            }
        });
    });
    return function fetchDynamicSegmentsRequestFromServer(_) {
        return _ref.apply(this, arguments);
    };
}();
var fetchDynamicSegmentsRequestFromClient = function() {
    var _ref = _async_to_generator(function(param) {
        var _pageConfig, pageConfig, _previousPageConfig, previousPageConfig, segmentsDynamicsFetchMapper, _previousDynamicData, previousDynamicData, dynamicData, segmentsRequest, hasUpdated;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _pageConfig = param.pageConfig, pageConfig = _pageConfig === void 0 ? {} : _pageConfig, _previousPageConfig = param.previousPageConfig, previousPageConfig = _previousPageConfig === void 0 ? {} : _previousPageConfig, segmentsDynamicsFetchMapper = param.segmentsDynamicsFetchMapper, _previousDynamicData = param.previousDynamicData, previousDynamicData = _previousDynamicData === void 0 ? {} : _previousDynamicData;
                    dynamicData = _object_spread({}, previousDynamicData);
                    segmentsRequest = collectAllRequestsForClient({
                        pageConfig: pageConfig,
                        segmentsDynamicsFetchMapper: segmentsDynamicsFetchMapper,
                        previousPageConfig: previousPageConfig
                    });
                    return [
                        4,
                        fetchAllRequestsAndPopulateDynamicData({
                            segmentsRequest: segmentsRequest,
                            dynamicData: dynamicData
                        })
                    ];
                case 1:
                    hasUpdated = _state.sent();
                    return [
                        2,
                        {
                            hasUpdated: hasUpdated,
                            dynamicData: dynamicData
                        }
                    ];
            }
        });
    });
    return function fetchDynamicSegmentsRequestFromClient(_) {
        return _ref.apply(this, arguments);
    };
}();
var getDynamicPropsBySegmentLayoutId = function(dynamicData, id) {
    return dynamicData && dynamicData[id] || {};
};
var getFaqData = function(param) {
    var pageConfig = param.pageConfig, req = param.req, res = param.res;
    var faq = [];
    try {
        faq = (pageConfig.segments || []).reduce(function(accFaq, segment) {
            var type = segment.type, props = segment.props;
            if (type === "FrequentlyAskedQuestionsPricingComponent") {
                var _accFaq;
                (_accFaq = accFaq).push.apply(_accFaq, _to_consumable_array(props.questions));
            }
            return accFaq;
        }, []);
    } catch (error) {
        handleServerException({
            externalMessage: "Faild to get FAQ data from segments",
            e: error,
            req: req,
            res: res
        });
    }
    return faq;
};


/***/ }),

/***/ 70942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MH": function() { return /* binding */ randomNumber; },
/* harmony export */   "Yr": function() { return /* binding */ toRadians; },
/* harmony export */   "sI": function() { return /* binding */ lineDistance; }
/* harmony export */ });
var toRadians = function(angle) {
    return angle * (Math.PI / 180);
};
var lineDistance = function(x1, y1, x2, y2) {
    var a = x1 - x2;
    var b = y1 - y2;
    var distance = Math.sqrt(a * a + b * b);
    return distance;
};
var randomNumber = function(min, max) {
    return Math.random() * (max - min) + min;
};


/***/ })

}]);